//#region \0rolldown/runtime.js
var e = Object.create, t = Object.defineProperty, __name = (e, n) => t(e, "name", {
	value: n,
	configurable: !0
}), n = Object.getOwnPropertyDescriptor, r = Object.getOwnPropertyNames, i = Object.getPrototypeOf, a = Object.prototype.hasOwnProperty, __commonJSMin = (e, t) => () => (t || (e((t = { exports: {} }).exports, t), e = null), t.exports), __exportAll = (e, n) => {
	let r = {};
	for (var i in e) t(r, i, {
		get: e[i],
		enumerable: !0
	});
	return n || t(r, Symbol.toStringTag, { value: "Module" }), r;
}, __copyProps = (e, i, o, s) => {
	if (i && typeof i == "object" || typeof i == "function") for (var c = r(i), l = 0, u = c.length, d; l < u; l++) d = c[l], !a.call(e, d) && d !== o && t(e, d, {
		get: ((e) => i[e]).bind(null, d),
		enumerable: !(s = n(i, d)) || s.enumerable
	});
	return e;
}, __toESM = (n, r, o) => (o = n == null ? {} : e(i(n)), __copyProps(r || !n || !n.__esModule || !a.call(n, "default") ? t(o, "default", {
	value: n,
	enumerable: !0
}) : o, n)), o;
(function(e) {
	e.assertEqual = (e) => {};
	function assertIs(e) {}
	e.assertIs = assertIs;
	function assertNever(e) {
		throw Error();
	}
	e.assertNever = assertNever, e.arrayToEnum = (e) => {
		let t = {};
		for (let n of e) t[n] = n;
		return t;
	}, e.getValidEnumValues = (t) => {
		let n = e.objectKeys(t).filter((e) => typeof t[t[e]] != "number"), r = {};
		for (let e of n) r[e] = t[e];
		return e.objectValues(r);
	}, e.objectValues = (t) => e.objectKeys(t).map(function(e) {
		return t[e];
	}), e.objectKeys = typeof Object.keys == "function" ? (e) => Object.keys(e) : (e) => {
		let t = [];
		for (let n in e) Object.prototype.hasOwnProperty.call(e, n) && t.push(n);
		return t;
	}, e.find = (e, t) => {
		for (let n of e) if (t(n)) return n;
	}, e.isInteger = typeof Number.isInteger == "function" ? (e) => Number.isInteger(e) : (e) => typeof e == "number" && Number.isFinite(e) && Math.floor(e) === e;
	function joinValues(e, t = " | ") {
		return e.map((e) => typeof e == "string" ? `'${e}'` : e).join(t);
	}
	e.joinValues = joinValues, e.jsonStringifyReplacer = (e, t) => typeof t == "bigint" ? t.toString() : t;
})(o ||= {});
var s;
(function(e) {
	e.mergeShapes = (e, t) => ({
		...e,
		...t
	});
})(s ||= {});
var c = o.arrayToEnum([
	"string",
	"nan",
	"number",
	"integer",
	"float",
	"boolean",
	"date",
	"bigint",
	"symbol",
	"function",
	"undefined",
	"null",
	"array",
	"object",
	"unknown",
	"promise",
	"void",
	"never",
	"map",
	"set"
]), getParsedType = (e) => {
	switch (typeof e) {
		case "undefined": return c.undefined;
		case "string": return c.string;
		case "number": return Number.isNaN(e) ? c.nan : c.number;
		case "boolean": return c.boolean;
		case "function": return c.function;
		case "bigint": return c.bigint;
		case "symbol": return c.symbol;
		case "object": return Array.isArray(e) ? c.array : e === null ? c.null : e.then && typeof e.then == "function" && e.catch && typeof e.catch == "function" ? c.promise : typeof Map < "u" && e instanceof Map ? c.map : typeof Set < "u" && e instanceof Set ? c.set : typeof Date < "u" && e instanceof Date ? c.date : c.object;
		default: return c.unknown;
	}
}, l = o.arrayToEnum([
	"invalid_type",
	"invalid_literal",
	"custom",
	"invalid_union",
	"invalid_union_discriminator",
	"invalid_enum_value",
	"unrecognized_keys",
	"invalid_arguments",
	"invalid_return_type",
	"invalid_date",
	"invalid_string",
	"too_small",
	"too_big",
	"invalid_intersection_types",
	"not_multiple_of",
	"not_finite"
]), u = class ZodError extends Error {
	get errors() {
		return this.issues;
	}
	constructor(e) {
		super(), this.issues = [], this.addIssue = (e) => {
			this.issues = [...this.issues, e];
		}, this.addIssues = (e = []) => {
			this.issues = [...this.issues, ...e];
		};
		let t = new.target.prototype;
		Object.setPrototypeOf ? Object.setPrototypeOf(this, t) : this.__proto__ = t, this.name = "ZodError", this.issues = e;
	}
	format(e) {
		let t = e || function(e) {
			return e.message;
		}, n = { _errors: [] }, processError = (e) => {
			for (let r of e.issues) if (r.code === "invalid_union") r.unionErrors.map(processError);
			else if (r.code === "invalid_return_type") processError(r.returnTypeError);
			else if (r.code === "invalid_arguments") processError(r.argumentsError);
			else if (r.path.length === 0) n._errors.push(t(r));
			else {
				let e = n, i = 0;
				for (; i < r.path.length;) {
					let n = r.path[i];
					i === r.path.length - 1 ? (e[n] = e[n] || { _errors: [] }, e[n]._errors.push(t(r))) : e[n] = e[n] || { _errors: [] }, e = e[n], i++;
				}
			}
		};
		return processError(this), n;
	}
	static assert(e) {
		if (!(e instanceof ZodError)) throw Error(`Not a ZodError: ${e}`);
	}
	toString() {
		return this.message;
	}
	get message() {
		return JSON.stringify(this.issues, o.jsonStringifyReplacer, 2);
	}
	get isEmpty() {
		return this.issues.length === 0;
	}
	flatten(e = (e) => e.message) {
		let t = {}, n = [];
		for (let r of this.issues) if (r.path.length > 0) {
			let n = r.path[0];
			t[n] = t[n] || [], t[n].push(e(r));
		} else n.push(e(r));
		return {
			formErrors: n,
			fieldErrors: t
		};
	}
	get formErrors() {
		return this.flatten();
	}
};
u.create = (e) => new u(e);
//#endregion
//#region ../../../node_modules/.pnpm/zod@3.25.76/node_modules/zod/v3/locales/en.js
var errorMap = (e, t) => {
	let n;
	switch (e.code) {
		case l.invalid_type:
			n = e.received === c.undefined ? "Required" : `Expected ${e.expected}, received ${e.received}`;
			break;
		case l.invalid_literal:
			n = `Invalid literal value, expected ${JSON.stringify(e.expected, o.jsonStringifyReplacer)}`;
			break;
		case l.unrecognized_keys:
			n = `Unrecognized key(s) in object: ${o.joinValues(e.keys, ", ")}`;
			break;
		case l.invalid_union:
			n = "Invalid input";
			break;
		case l.invalid_union_discriminator:
			n = `Invalid discriminator value. Expected ${o.joinValues(e.options)}`;
			break;
		case l.invalid_enum_value:
			n = `Invalid enum value. Expected ${o.joinValues(e.options)}, received '${e.received}'`;
			break;
		case l.invalid_arguments:
			n = "Invalid function arguments";
			break;
		case l.invalid_return_type:
			n = "Invalid function return type";
			break;
		case l.invalid_date:
			n = "Invalid date";
			break;
		case l.invalid_string:
			typeof e.validation == "object" ? "includes" in e.validation ? (n = `Invalid input: must include "${e.validation.includes}"`, typeof e.validation.position == "number" && (n = `${n} at one or more positions greater than or equal to ${e.validation.position}`)) : "startsWith" in e.validation ? n = `Invalid input: must start with "${e.validation.startsWith}"` : "endsWith" in e.validation ? n = `Invalid input: must end with "${e.validation.endsWith}"` : o.assertNever(e.validation) : n = e.validation === "regex" ? "Invalid" : `Invalid ${e.validation}`;
			break;
		case l.too_small:
			n = e.type === "array" ? `Array must contain ${e.exact ? "exactly" : e.inclusive ? "at least" : "more than"} ${e.minimum} element(s)` : e.type === "string" ? `String must contain ${e.exact ? "exactly" : e.inclusive ? "at least" : "over"} ${e.minimum} character(s)` : e.type === "number" || e.type === "bigint" ? `Number must be ${e.exact ? "exactly equal to " : e.inclusive ? "greater than or equal to " : "greater than "}${e.minimum}` : e.type === "date" ? `Date must be ${e.exact ? "exactly equal to " : e.inclusive ? "greater than or equal to " : "greater than "}${new Date(Number(e.minimum))}` : "Invalid input";
			break;
		case l.too_big:
			n = e.type === "array" ? `Array must contain ${e.exact ? "exactly" : e.inclusive ? "at most" : "less than"} ${e.maximum} element(s)` : e.type === "string" ? `String must contain ${e.exact ? "exactly" : e.inclusive ? "at most" : "under"} ${e.maximum} character(s)` : e.type === "number" ? `Number must be ${e.exact ? "exactly" : e.inclusive ? "less than or equal to" : "less than"} ${e.maximum}` : e.type === "bigint" ? `BigInt must be ${e.exact ? "exactly" : e.inclusive ? "less than or equal to" : "less than"} ${e.maximum}` : e.type === "date" ? `Date must be ${e.exact ? "exactly" : e.inclusive ? "smaller than or equal to" : "smaller than"} ${new Date(Number(e.maximum))}` : "Invalid input";
			break;
		case l.custom:
			n = "Invalid input";
			break;
		case l.invalid_intersection_types:
			n = "Intersection results could not be merged";
			break;
		case l.not_multiple_of:
			n = `Number must be a multiple of ${e.multipleOf}`;
			break;
		case l.not_finite:
			n = "Number must be finite";
			break;
		default: n = t.defaultError, o.assertNever(e);
	}
	return { message: n };
}, d = errorMap;
function setErrorMap(e) {
	d = e;
}
function getErrorMap() {
	return d;
}
//#endregion
//#region ../../../node_modules/.pnpm/zod@3.25.76/node_modules/zod/v3/helpers/parseUtil.js
var makeIssue = (e) => {
	let { data: t, path: n, errorMaps: r, issueData: i } = e, a = [...n, ...i.path || []], o = {
		...i,
		path: a
	};
	if (i.message !== void 0) return {
		...i,
		path: a,
		message: i.message
	};
	let s = "", c = r.filter((e) => !!e).slice().reverse();
	for (let e of c) s = e(o, {
		data: t,
		defaultError: s
	}).message;
	return {
		...i,
		path: a,
		message: s
	};
};
function addIssueToContext(e, t) {
	let n = getErrorMap(), r = makeIssue({
		issueData: t,
		data: e.data,
		path: e.path,
		errorMaps: [
			e.common.contextualErrorMap,
			e.schemaErrorMap,
			n,
			n === errorMap ? void 0 : errorMap
		].filter((e) => !!e)
	});
	e.common.issues.push(r);
}
var f = class ParseStatus {
	constructor() {
		this.value = "valid";
	}
	dirty() {
		this.value === "valid" && (this.value = "dirty");
	}
	abort() {
		this.value !== "aborted" && (this.value = "aborted");
	}
	static mergeArray(e, t) {
		let n = [];
		for (let r of t) {
			if (r.status === "aborted") return p;
			r.status === "dirty" && e.dirty(), n.push(r.value);
		}
		return {
			status: e.value,
			value: n
		};
	}
	static async mergeObjectAsync(e, t) {
		let n = [];
		for (let e of t) {
			let t = await e.key, r = await e.value;
			n.push({
				key: t,
				value: r
			});
		}
		return ParseStatus.mergeObjectSync(e, n);
	}
	static mergeObjectSync(e, t) {
		let n = {};
		for (let r of t) {
			let { key: t, value: i } = r;
			if (t.status === "aborted" || i.status === "aborted") return p;
			t.status === "dirty" && e.dirty(), i.status === "dirty" && e.dirty(), t.value !== "__proto__" && (i.value !== void 0 || r.alwaysSet) && (n[t.value] = i.value);
		}
		return {
			status: e.value,
			value: n
		};
	}
}, p = Object.freeze({ status: "aborted" }), DIRTY = (e) => ({
	status: "dirty",
	value: e
}), OK = (e) => ({
	status: "valid",
	value: e
}), isAborted = (e) => e.status === "aborted", isDirty = (e) => e.status === "dirty", m = /* @__PURE__ */ __name((e) => e.status === "valid", "isValid"), isAsync = (e) => typeof Promise < "u" && e instanceof Promise, h;
(function(e) {
	e.errToObj = (e) => typeof e == "string" ? { message: e } : e || {}, e.toString = (e) => typeof e == "string" ? e : e?.message;
})(h ||= {});
//#endregion
//#region ../../../node_modules/.pnpm/zod@3.25.76/node_modules/zod/v3/types.js
var ParseInputLazyPath = class {
	constructor(e, t, n, r) {
		this._cachedPath = [], this.parent = e, this.data = t, this._path = n, this._key = r;
	}
	get path() {
		return this._cachedPath.length || (Array.isArray(this._key) ? this._cachedPath.push(...this._path, ...this._key) : this._cachedPath.push(...this._path, this._key)), this._cachedPath;
	}
}, handleResult = (e, t) => {
	if (m(t)) return {
		success: !0,
		data: t.value
	};
	if (!e.common.issues.length) throw Error("Validation failed but no issues detected.");
	return {
		success: !1,
		get error() {
			if (this._error) return this._error;
			let t = new u(e.common.issues);
			return this._error = t, this._error;
		}
	};
};
function processCreateParams(e) {
	if (!e) return {};
	let { errorMap: t, invalid_type_error: n, required_error: r, description: i } = e;
	if (t && (n || r)) throw Error("Can't use \"invalid_type_error\" or \"required_error\" in conjunction with custom error map.");
	if (t) return {
		errorMap: t,
		description: i
	};
	let customMap = (t, i) => {
		let { message: a } = e;
		return t.code === "invalid_enum_value" ? { message: a ?? i.defaultError } : i.data === void 0 ? { message: a ?? r ?? i.defaultError } : t.code === "invalid_type" ? { message: a ?? n ?? i.defaultError } : { message: i.defaultError };
	};
	return {
		errorMap: customMap,
		description: i
	};
}
var ZodType = class {
	get description() {
		return this._def.description;
	}
	_getType(e) {
		return getParsedType(e.data);
	}
	_getOrReturnCtx(e, t) {
		return t || {
			common: e.parent.common,
			data: e.data,
			parsedType: getParsedType(e.data),
			schemaErrorMap: this._def.errorMap,
			path: e.path,
			parent: e.parent
		};
	}
	_processInputParams(e) {
		return {
			status: new f(),
			ctx: {
				common: e.parent.common,
				data: e.data,
				parsedType: getParsedType(e.data),
				schemaErrorMap: this._def.errorMap,
				path: e.path,
				parent: e.parent
			}
		};
	}
	_parseSync(e) {
		let t = this._parse(e);
		if (isAsync(t)) throw Error("Synchronous parse encountered promise.");
		return t;
	}
	_parseAsync(e) {
		let t = this._parse(e);
		return Promise.resolve(t);
	}
	parse(e, t) {
		let n = this.safeParse(e, t);
		if (n.success) return n.data;
		throw n.error;
	}
	safeParse(e, t) {
		let n = {
			common: {
				issues: [],
				async: t?.async ?? !1,
				contextualErrorMap: t?.errorMap
			},
			path: t?.path || [],
			schemaErrorMap: this._def.errorMap,
			parent: null,
			data: e,
			parsedType: getParsedType(e)
		};
		return handleResult(n, this._parseSync({
			data: e,
			path: n.path,
			parent: n
		}));
	}
	"~validate"(e) {
		let t = {
			common: {
				issues: [],
				async: !!this["~standard"].async
			},
			path: [],
			schemaErrorMap: this._def.errorMap,
			parent: null,
			data: e,
			parsedType: getParsedType(e)
		};
		if (!this["~standard"].async) try {
			let n = this._parseSync({
				data: e,
				path: [],
				parent: t
			});
			return m(n) ? { value: n.value } : { issues: t.common.issues };
		} catch (e) {
			e?.message?.toLowerCase()?.includes("encountered") && (this["~standard"].async = !0), t.common = {
				issues: [],
				async: !0
			};
		}
		return this._parseAsync({
			data: e,
			path: [],
			parent: t
		}).then((e) => m(e) ? { value: e.value } : { issues: t.common.issues });
	}
	async parseAsync(e, t) {
		let n = await this.safeParseAsync(e, t);
		if (n.success) return n.data;
		throw n.error;
	}
	async safeParseAsync(e, t) {
		let n = {
			common: {
				issues: [],
				contextualErrorMap: t?.errorMap,
				async: !0
			},
			path: t?.path || [],
			schemaErrorMap: this._def.errorMap,
			parent: null,
			data: e,
			parsedType: getParsedType(e)
		}, r = this._parse({
			data: e,
			path: n.path,
			parent: n
		});
		return handleResult(n, await (isAsync(r) ? r : Promise.resolve(r)));
	}
	refine(e, t) {
		let getIssueProperties = (e) => typeof t == "string" || t === void 0 ? { message: t } : typeof t == "function" ? t(e) : t;
		return this._refinement((t, n) => {
			let r = e(t), setError = () => n.addIssue({
				code: l.custom,
				...getIssueProperties(t)
			});
			return typeof Promise < "u" && r instanceof Promise ? r.then((e) => e ? !0 : (setError(), !1)) : r ? !0 : (setError(), !1);
		});
	}
	refinement(e, t) {
		return this._refinement((n, r) => e(n) ? !0 : (r.addIssue(typeof t == "function" ? t(n, r) : t), !1));
	}
	_refinement(e) {
		return new ZodEffects({
			schema: this,
			typeName: S.ZodEffects,
			effect: {
				type: "refinement",
				refinement: e
			}
		});
	}
	superRefine(e) {
		return this._refinement(e);
	}
	constructor(e) {
		this.spa = this.safeParseAsync, this._def = e, this.parse = this.parse.bind(this), this.safeParse = this.safeParse.bind(this), this.parseAsync = this.parseAsync.bind(this), this.safeParseAsync = this.safeParseAsync.bind(this), this.spa = this.spa.bind(this), this.refine = this.refine.bind(this), this.refinement = this.refinement.bind(this), this.superRefine = this.superRefine.bind(this), this.optional = this.optional.bind(this), this.nullable = this.nullable.bind(this), this.nullish = this.nullish.bind(this), this.array = this.array.bind(this), this.promise = this.promise.bind(this), this.or = this.or.bind(this), this.and = this.and.bind(this), this.transform = this.transform.bind(this), this.brand = this.brand.bind(this), this.default = this.default.bind(this), this.catch = this.catch.bind(this), this.describe = this.describe.bind(this), this.pipe = this.pipe.bind(this), this.readonly = this.readonly.bind(this), this.isNullable = this.isNullable.bind(this), this.isOptional = this.isOptional.bind(this), this["~standard"] = {
			version: 1,
			vendor: "zod",
			validate: (e) => this["~validate"](e)
		};
	}
	optional() {
		return ZodOptional.create(this, this._def);
	}
	nullable() {
		return ZodNullable.create(this, this._def);
	}
	nullish() {
		return this.nullable().optional();
	}
	array() {
		return y.create(this);
	}
	promise() {
		return ZodPromise.create(this, this._def);
	}
	or(e) {
		return ZodUnion.create([this, e], this._def);
	}
	and(e) {
		return ZodIntersection.create(this, e, this._def);
	}
	transform(e) {
		return new ZodEffects({
			...processCreateParams(this._def),
			schema: this,
			typeName: S.ZodEffects,
			effect: {
				type: "transform",
				transform: e
			}
		});
	}
	default(e) {
		let t = typeof e == "function" ? e : () => e;
		return new ZodDefault({
			...processCreateParams(this._def),
			innerType: this,
			defaultValue: t,
			typeName: S.ZodDefault
		});
	}
	brand() {
		return new ZodBranded({
			typeName: S.ZodBranded,
			type: this,
			...processCreateParams(this._def)
		});
	}
	catch(e) {
		let t = typeof e == "function" ? e : () => e;
		return new ZodCatch({
			...processCreateParams(this._def),
			innerType: this,
			catchValue: t,
			typeName: S.ZodCatch
		});
	}
	describe(e) {
		let t = this.constructor;
		return new t({
			...this._def,
			description: e
		});
	}
	pipe(e) {
		return we.create(this, e);
	}
	readonly() {
		return ZodReadonly.create(this);
	}
	isOptional() {
		return this.safeParse(void 0).success;
	}
	isNullable() {
		return this.safeParse(null).success;
	}
}, ee = /^c[^\s-]{8,}$/i, g = /^[0-9a-z]+$/, te = /^[0-9A-HJKMNP-TV-Z]{26}$/i, _ = /^[0-9a-fA-F]{8}\b-[0-9a-fA-F]{4}\b-[0-9a-fA-F]{4}\b-[0-9a-fA-F]{4}\b-[0-9a-fA-F]{12}$/i, ne = /^[a-z0-9_-]{21}$/i, v = /^[A-Za-z0-9-_]+\.[A-Za-z0-9-_]+\.[A-Za-z0-9-_]*$/, re = /^[-+]?P(?!$)(?:(?:[-+]?\d+Y)|(?:[-+]?\d+[.,]\d+Y$))?(?:(?:[-+]?\d+M)|(?:[-+]?\d+[.,]\d+M$))?(?:(?:[-+]?\d+W)|(?:[-+]?\d+[.,]\d+W$))?(?:(?:[-+]?\d+D)|(?:[-+]?\d+[.,]\d+D$))?(?:T(?=[\d+-])(?:(?:[-+]?\d+H)|(?:[-+]?\d+[.,]\d+H$))?(?:(?:[-+]?\d+M)|(?:[-+]?\d+[.,]\d+M$))?(?:[-+]?\d+(?:[.,]\d+)?S)?)??$/, ie = /^(?!\.)(?!.*\.\.)([A-Z0-9_'+\-\.]*)[A-Z0-9_+-]@([A-Z0-9][A-Z0-9\-]*\.)+[A-Z]{2,}$/i, ae = "^(\\p{Extended_Pictographic}|\\p{Emoji_Component})+$", oe, se = /^(?:(?:25[0-5]|2[0-4][0-9]|1[0-9][0-9]|[1-9][0-9]|[0-9])\.){3}(?:25[0-5]|2[0-4][0-9]|1[0-9][0-9]|[1-9][0-9]|[0-9])$/, ce = /^(?:(?:25[0-5]|2[0-4][0-9]|1[0-9][0-9]|[1-9][0-9]|[0-9])\.){3}(?:25[0-5]|2[0-4][0-9]|1[0-9][0-9]|[1-9][0-9]|[0-9])\/(3[0-2]|[12]?[0-9])$/, le = /^(([0-9a-fA-F]{1,4}:){7,7}[0-9a-fA-F]{1,4}|([0-9a-fA-F]{1,4}:){1,7}:|([0-9a-fA-F]{1,4}:){1,6}:[0-9a-fA-F]{1,4}|([0-9a-fA-F]{1,4}:){1,5}(:[0-9a-fA-F]{1,4}){1,2}|([0-9a-fA-F]{1,4}:){1,4}(:[0-9a-fA-F]{1,4}){1,3}|([0-9a-fA-F]{1,4}:){1,3}(:[0-9a-fA-F]{1,4}){1,4}|([0-9a-fA-F]{1,4}:){1,2}(:[0-9a-fA-F]{1,4}){1,5}|[0-9a-fA-F]{1,4}:((:[0-9a-fA-F]{1,4}){1,6})|:((:[0-9a-fA-F]{1,4}){1,7}|:)|fe80:(:[0-9a-fA-F]{0,4}){0,4}%[0-9a-zA-Z]{1,}|::(ffff(:0{1,4}){0,1}:){0,1}((25[0-5]|(2[0-4]|1{0,1}[0-9]){0,1}[0-9])\.){3,3}(25[0-5]|(2[0-4]|1{0,1}[0-9]){0,1}[0-9])|([0-9a-fA-F]{1,4}:){1,4}:((25[0-5]|(2[0-4]|1{0,1}[0-9]){0,1}[0-9])\.){3,3}(25[0-5]|(2[0-4]|1{0,1}[0-9]){0,1}[0-9]))$/, ue = /^(([0-9a-fA-F]{1,4}:){7,7}[0-9a-fA-F]{1,4}|([0-9a-fA-F]{1,4}:){1,7}:|([0-9a-fA-F]{1,4}:){1,6}:[0-9a-fA-F]{1,4}|([0-9a-fA-F]{1,4}:){1,5}(:[0-9a-fA-F]{1,4}){1,2}|([0-9a-fA-F]{1,4}:){1,4}(:[0-9a-fA-F]{1,4}){1,3}|([0-9a-fA-F]{1,4}:){1,3}(:[0-9a-fA-F]{1,4}){1,4}|([0-9a-fA-F]{1,4}:){1,2}(:[0-9a-fA-F]{1,4}){1,5}|[0-9a-fA-F]{1,4}:((:[0-9a-fA-F]{1,4}){1,6})|:((:[0-9a-fA-F]{1,4}){1,7}|:)|fe80:(:[0-9a-fA-F]{0,4}){0,4}%[0-9a-zA-Z]{1,}|::(ffff(:0{1,4}){0,1}:){0,1}((25[0-5]|(2[0-4]|1{0,1}[0-9]){0,1}[0-9])\.){3,3}(25[0-5]|(2[0-4]|1{0,1}[0-9]){0,1}[0-9])|([0-9a-fA-F]{1,4}:){1,4}:((25[0-5]|(2[0-4]|1{0,1}[0-9]){0,1}[0-9])\.){3,3}(25[0-5]|(2[0-4]|1{0,1}[0-9]){0,1}[0-9]))\/(12[0-8]|1[01][0-9]|[1-9]?[0-9])$/, de = /^([0-9a-zA-Z+/]{4})*(([0-9a-zA-Z+/]{2}==)|([0-9a-zA-Z+/]{3}=))?$/, fe = /^([0-9a-zA-Z-_]{4})*(([0-9a-zA-Z-_]{2}(==)?)|([0-9a-zA-Z-_]{3}(=)?))?$/, pe = "((\\d\\d[2468][048]|\\d\\d[13579][26]|\\d\\d0[48]|[02468][048]00|[13579][26]00)-02-29|\\d{4}-((0[13578]|1[02])-(0[1-9]|[12]\\d|3[01])|(0[469]|11)-(0[1-9]|[12]\\d|30)|(02)-(0[1-9]|1\\d|2[0-8])))", me = RegExp(`^${pe}$`);
function timeRegexSource(e) {
	let t = "[0-5]\\d";
	e.precision ? t = `${t}\\.\\d{${e.precision}}` : e.precision ?? (t = `${t}(\\.\\d+)?`);
	let n = e.precision ? "+" : "?";
	return `([01]\\d|2[0-3]):[0-5]\\d(:${t})${n}`;
}
function timeRegex$1(e) {
	return RegExp(`^${timeRegexSource(e)}$`);
}
__name(timeRegex$1, "timeRegex");
function datetimeRegex(e) {
	let t = `${pe}T${timeRegexSource(e)}`, n = [];
	return n.push(e.local ? "Z?" : "Z"), e.offset && n.push("([+-]\\d{2}:?\\d{2})"), t = `${t}(${n.join("|")})`, RegExp(`^${t}$`);
}
function isValidIP(e, t) {
	return !((t !== "v4" && t || !se.test(e)) && (t !== "v6" && t || !le.test(e)));
}
function isValidJWT(e, t) {
	if (!v.test(e)) return !1;
	try {
		let [n] = e.split(".");
		if (!n) return !1;
		let r = n.replace(/-/g, "+").replace(/_/g, "/").padEnd(n.length + (4 - n.length % 4) % 4, "="), i = JSON.parse(atob(r));
		return !(typeof i != "object" || !i || "typ" in i && i?.typ !== "JWT" || !i.alg || t && i.alg !== t);
	} catch {
		return !1;
	}
}
function isValidCidr(e, t) {
	return !((t !== "v4" && t || !ce.test(e)) && (t !== "v6" && t || !ue.test(e)));
}
var he = class ZodString extends ZodType {
	_parse(e) {
		if (this._def.coerce && (e.data = String(e.data)), this._getType(e) !== c.string) {
			let t = this._getOrReturnCtx(e);
			return addIssueToContext(t, {
				code: l.invalid_type,
				expected: c.string,
				received: t.parsedType
			}), p;
		}
		let t = new f(), n;
		for (let r of this._def.checks) if (r.kind === "min") e.data.length < r.value && (n = this._getOrReturnCtx(e, n), addIssueToContext(n, {
			code: l.too_small,
			minimum: r.value,
			type: "string",
			inclusive: !0,
			exact: !1,
			message: r.message
		}), t.dirty());
		else if (r.kind === "max") e.data.length > r.value && (n = this._getOrReturnCtx(e, n), addIssueToContext(n, {
			code: l.too_big,
			maximum: r.value,
			type: "string",
			inclusive: !0,
			exact: !1,
			message: r.message
		}), t.dirty());
		else if (r.kind === "length") {
			let i = e.data.length > r.value, a = e.data.length < r.value;
			(i || a) && (n = this._getOrReturnCtx(e, n), i ? addIssueToContext(n, {
				code: l.too_big,
				maximum: r.value,
				type: "string",
				inclusive: !0,
				exact: !0,
				message: r.message
			}) : a && addIssueToContext(n, {
				code: l.too_small,
				minimum: r.value,
				type: "string",
				inclusive: !0,
				exact: !0,
				message: r.message
			}), t.dirty());
		} else if (r.kind === "email") ie.test(e.data) || (n = this._getOrReturnCtx(e, n), addIssueToContext(n, {
			validation: "email",
			code: l.invalid_string,
			message: r.message
		}), t.dirty());
		else if (r.kind === "emoji") oe ||= new RegExp(ae, "u"), oe.test(e.data) || (n = this._getOrReturnCtx(e, n), addIssueToContext(n, {
			validation: "emoji",
			code: l.invalid_string,
			message: r.message
		}), t.dirty());
		else if (r.kind === "uuid") _.test(e.data) || (n = this._getOrReturnCtx(e, n), addIssueToContext(n, {
			validation: "uuid",
			code: l.invalid_string,
			message: r.message
		}), t.dirty());
		else if (r.kind === "nanoid") ne.test(e.data) || (n = this._getOrReturnCtx(e, n), addIssueToContext(n, {
			validation: "nanoid",
			code: l.invalid_string,
			message: r.message
		}), t.dirty());
		else if (r.kind === "cuid") ee.test(e.data) || (n = this._getOrReturnCtx(e, n), addIssueToContext(n, {
			validation: "cuid",
			code: l.invalid_string,
			message: r.message
		}), t.dirty());
		else if (r.kind === "cuid2") g.test(e.data) || (n = this._getOrReturnCtx(e, n), addIssueToContext(n, {
			validation: "cuid2",
			code: l.invalid_string,
			message: r.message
		}), t.dirty());
		else if (r.kind === "ulid") te.test(e.data) || (n = this._getOrReturnCtx(e, n), addIssueToContext(n, {
			validation: "ulid",
			code: l.invalid_string,
			message: r.message
		}), t.dirty());
		else if (r.kind === "url") try {
			new URL(e.data);
		} catch {
			n = this._getOrReturnCtx(e, n), addIssueToContext(n, {
				validation: "url",
				code: l.invalid_string,
				message: r.message
			}), t.dirty();
		}
		else r.kind === "regex" ? (r.regex.lastIndex = 0, r.regex.test(e.data) || (n = this._getOrReturnCtx(e, n), addIssueToContext(n, {
			validation: "regex",
			code: l.invalid_string,
			message: r.message
		}), t.dirty())) : r.kind === "trim" ? e.data = e.data.trim() : r.kind === "includes" ? e.data.includes(r.value, r.position) || (n = this._getOrReturnCtx(e, n), addIssueToContext(n, {
			code: l.invalid_string,
			validation: {
				includes: r.value,
				position: r.position
			},
			message: r.message
		}), t.dirty()) : r.kind === "toLowerCase" ? e.data = e.data.toLowerCase() : r.kind === "toUpperCase" ? e.data = e.data.toUpperCase() : r.kind === "startsWith" ? e.data.startsWith(r.value) || (n = this._getOrReturnCtx(e, n), addIssueToContext(n, {
			code: l.invalid_string,
			validation: { startsWith: r.value },
			message: r.message
		}), t.dirty()) : r.kind === "endsWith" ? e.data.endsWith(r.value) || (n = this._getOrReturnCtx(e, n), addIssueToContext(n, {
			code: l.invalid_string,
			validation: { endsWith: r.value },
			message: r.message
		}), t.dirty()) : r.kind === "datetime" ? datetimeRegex(r).test(e.data) || (n = this._getOrReturnCtx(e, n), addIssueToContext(n, {
			code: l.invalid_string,
			validation: "datetime",
			message: r.message
		}), t.dirty()) : r.kind === "date" ? me.test(e.data) || (n = this._getOrReturnCtx(e, n), addIssueToContext(n, {
			code: l.invalid_string,
			validation: "date",
			message: r.message
		}), t.dirty()) : r.kind === "time" ? timeRegex$1(r).test(e.data) || (n = this._getOrReturnCtx(e, n), addIssueToContext(n, {
			code: l.invalid_string,
			validation: "time",
			message: r.message
		}), t.dirty()) : r.kind === "duration" ? re.test(e.data) || (n = this._getOrReturnCtx(e, n), addIssueToContext(n, {
			validation: "duration",
			code: l.invalid_string,
			message: r.message
		}), t.dirty()) : r.kind === "ip" ? isValidIP(e.data, r.version) || (n = this._getOrReturnCtx(e, n), addIssueToContext(n, {
			validation: "ip",
			code: l.invalid_string,
			message: r.message
		}), t.dirty()) : r.kind === "jwt" ? isValidJWT(e.data, r.alg) || (n = this._getOrReturnCtx(e, n), addIssueToContext(n, {
			validation: "jwt",
			code: l.invalid_string,
			message: r.message
		}), t.dirty()) : r.kind === "cidr" ? isValidCidr(e.data, r.version) || (n = this._getOrReturnCtx(e, n), addIssueToContext(n, {
			validation: "cidr",
			code: l.invalid_string,
			message: r.message
		}), t.dirty()) : r.kind === "base64" ? de.test(e.data) || (n = this._getOrReturnCtx(e, n), addIssueToContext(n, {
			validation: "base64",
			code: l.invalid_string,
			message: r.message
		}), t.dirty()) : r.kind === "base64url" ? fe.test(e.data) || (n = this._getOrReturnCtx(e, n), addIssueToContext(n, {
			validation: "base64url",
			code: l.invalid_string,
			message: r.message
		}), t.dirty()) : o.assertNever(r);
		return {
			status: t.value,
			value: e.data
		};
	}
	_regex(e, t, n) {
		return this.refinement((t) => e.test(t), {
			validation: t,
			code: l.invalid_string,
			...h.errToObj(n)
		});
	}
	_addCheck(e) {
		return new ZodString({
			...this._def,
			checks: [...this._def.checks, e]
		});
	}
	email(e) {
		return this._addCheck({
			kind: "email",
			...h.errToObj(e)
		});
	}
	url(e) {
		return this._addCheck({
			kind: "url",
			...h.errToObj(e)
		});
	}
	emoji(e) {
		return this._addCheck({
			kind: "emoji",
			...h.errToObj(e)
		});
	}
	uuid(e) {
		return this._addCheck({
			kind: "uuid",
			...h.errToObj(e)
		});
	}
	nanoid(e) {
		return this._addCheck({
			kind: "nanoid",
			...h.errToObj(e)
		});
	}
	cuid(e) {
		return this._addCheck({
			kind: "cuid",
			...h.errToObj(e)
		});
	}
	cuid2(e) {
		return this._addCheck({
			kind: "cuid2",
			...h.errToObj(e)
		});
	}
	ulid(e) {
		return this._addCheck({
			kind: "ulid",
			...h.errToObj(e)
		});
	}
	base64(e) {
		return this._addCheck({
			kind: "base64",
			...h.errToObj(e)
		});
	}
	base64url(e) {
		return this._addCheck({
			kind: "base64url",
			...h.errToObj(e)
		});
	}
	jwt(e) {
		return this._addCheck({
			kind: "jwt",
			...h.errToObj(e)
		});
	}
	ip(e) {
		return this._addCheck({
			kind: "ip",
			...h.errToObj(e)
		});
	}
	cidr(e) {
		return this._addCheck({
			kind: "cidr",
			...h.errToObj(e)
		});
	}
	datetime(e) {
		return typeof e == "string" ? this._addCheck({
			kind: "datetime",
			precision: null,
			offset: !1,
			local: !1,
			message: e
		}) : this._addCheck({
			kind: "datetime",
			precision: e?.precision === void 0 ? null : e?.precision,
			offset: e?.offset ?? !1,
			local: e?.local ?? !1,
			...h.errToObj(e?.message)
		});
	}
	date(e) {
		return this._addCheck({
			kind: "date",
			message: e
		});
	}
	time(e) {
		return typeof e == "string" ? this._addCheck({
			kind: "time",
			precision: null,
			message: e
		}) : this._addCheck({
			kind: "time",
			precision: e?.precision === void 0 ? null : e?.precision,
			...h.errToObj(e?.message)
		});
	}
	duration(e) {
		return this._addCheck({
			kind: "duration",
			...h.errToObj(e)
		});
	}
	regex(e, t) {
		return this._addCheck({
			kind: "regex",
			regex: e,
			...h.errToObj(t)
		});
	}
	includes(e, t) {
		return this._addCheck({
			kind: "includes",
			value: e,
			position: t?.position,
			...h.errToObj(t?.message)
		});
	}
	startsWith(e, t) {
		return this._addCheck({
			kind: "startsWith",
			value: e,
			...h.errToObj(t)
		});
	}
	endsWith(e, t) {
		return this._addCheck({
			kind: "endsWith",
			value: e,
			...h.errToObj(t)
		});
	}
	min(e, t) {
		return this._addCheck({
			kind: "min",
			value: e,
			...h.errToObj(t)
		});
	}
	max(e, t) {
		return this._addCheck({
			kind: "max",
			value: e,
			...h.errToObj(t)
		});
	}
	length(e, t) {
		return this._addCheck({
			kind: "length",
			value: e,
			...h.errToObj(t)
		});
	}
	nonempty(e) {
		return this.min(1, h.errToObj(e));
	}
	trim() {
		return new ZodString({
			...this._def,
			checks: [...this._def.checks, { kind: "trim" }]
		});
	}
	toLowerCase() {
		return new ZodString({
			...this._def,
			checks: [...this._def.checks, { kind: "toLowerCase" }]
		});
	}
	toUpperCase() {
		return new ZodString({
			...this._def,
			checks: [...this._def.checks, { kind: "toUpperCase" }]
		});
	}
	get isDatetime() {
		return !!this._def.checks.find((e) => e.kind === "datetime");
	}
	get isDate() {
		return !!this._def.checks.find((e) => e.kind === "date");
	}
	get isTime() {
		return !!this._def.checks.find((e) => e.kind === "time");
	}
	get isDuration() {
		return !!this._def.checks.find((e) => e.kind === "duration");
	}
	get isEmail() {
		return !!this._def.checks.find((e) => e.kind === "email");
	}
	get isURL() {
		return !!this._def.checks.find((e) => e.kind === "url");
	}
	get isEmoji() {
		return !!this._def.checks.find((e) => e.kind === "emoji");
	}
	get isUUID() {
		return !!this._def.checks.find((e) => e.kind === "uuid");
	}
	get isNANOID() {
		return !!this._def.checks.find((e) => e.kind === "nanoid");
	}
	get isCUID() {
		return !!this._def.checks.find((e) => e.kind === "cuid");
	}
	get isCUID2() {
		return !!this._def.checks.find((e) => e.kind === "cuid2");
	}
	get isULID() {
		return !!this._def.checks.find((e) => e.kind === "ulid");
	}
	get isIP() {
		return !!this._def.checks.find((e) => e.kind === "ip");
	}
	get isCIDR() {
		return !!this._def.checks.find((e) => e.kind === "cidr");
	}
	get isBase64() {
		return !!this._def.checks.find((e) => e.kind === "base64");
	}
	get isBase64url() {
		return !!this._def.checks.find((e) => e.kind === "base64url");
	}
	get minLength() {
		let e = null;
		for (let t of this._def.checks) t.kind === "min" && (e === null || t.value > e) && (e = t.value);
		return e;
	}
	get maxLength() {
		let e = null;
		for (let t of this._def.checks) t.kind === "max" && (e === null || t.value < e) && (e = t.value);
		return e;
	}
};
he.create = (e) => new he({
	checks: [],
	typeName: S.ZodString,
	coerce: e?.coerce ?? !1,
	...processCreateParams(e)
});
function floatSafeRemainder(e, t) {
	let n = (e.toString().split(".")[1] || "").length, r = (t.toString().split(".")[1] || "").length, i = n > r ? n : r;
	return Number.parseInt(e.toFixed(i).replace(".", "")) % Number.parseInt(t.toFixed(i).replace(".", "")) / 10 ** i;
}
var ge = class ZodNumber extends ZodType {
	constructor() {
		super(...arguments), this.min = this.gte, this.max = this.lte, this.step = this.multipleOf;
	}
	_parse(e) {
		if (this._def.coerce && (e.data = Number(e.data)), this._getType(e) !== c.number) {
			let t = this._getOrReturnCtx(e);
			return addIssueToContext(t, {
				code: l.invalid_type,
				expected: c.number,
				received: t.parsedType
			}), p;
		}
		let t, n = new f();
		for (let r of this._def.checks) r.kind === "int" ? o.isInteger(e.data) || (t = this._getOrReturnCtx(e, t), addIssueToContext(t, {
			code: l.invalid_type,
			expected: "integer",
			received: "float",
			message: r.message
		}), n.dirty()) : r.kind === "min" ? (r.inclusive ? e.data < r.value : e.data <= r.value) && (t = this._getOrReturnCtx(e, t), addIssueToContext(t, {
			code: l.too_small,
			minimum: r.value,
			type: "number",
			inclusive: r.inclusive,
			exact: !1,
			message: r.message
		}), n.dirty()) : r.kind === "max" ? (r.inclusive ? e.data > r.value : e.data >= r.value) && (t = this._getOrReturnCtx(e, t), addIssueToContext(t, {
			code: l.too_big,
			maximum: r.value,
			type: "number",
			inclusive: r.inclusive,
			exact: !1,
			message: r.message
		}), n.dirty()) : r.kind === "multipleOf" ? floatSafeRemainder(e.data, r.value) !== 0 && (t = this._getOrReturnCtx(e, t), addIssueToContext(t, {
			code: l.not_multiple_of,
			multipleOf: r.value,
			message: r.message
		}), n.dirty()) : r.kind === "finite" ? Number.isFinite(e.data) || (t = this._getOrReturnCtx(e, t), addIssueToContext(t, {
			code: l.not_finite,
			message: r.message
		}), n.dirty()) : o.assertNever(r);
		return {
			status: n.value,
			value: e.data
		};
	}
	gte(e, t) {
		return this.setLimit("min", e, !0, h.toString(t));
	}
	gt(e, t) {
		return this.setLimit("min", e, !1, h.toString(t));
	}
	lte(e, t) {
		return this.setLimit("max", e, !0, h.toString(t));
	}
	lt(e, t) {
		return this.setLimit("max", e, !1, h.toString(t));
	}
	setLimit(e, t, n, r) {
		return new ZodNumber({
			...this._def,
			checks: [...this._def.checks, {
				kind: e,
				value: t,
				inclusive: n,
				message: h.toString(r)
			}]
		});
	}
	_addCheck(e) {
		return new ZodNumber({
			...this._def,
			checks: [...this._def.checks, e]
		});
	}
	int(e) {
		return this._addCheck({
			kind: "int",
			message: h.toString(e)
		});
	}
	positive(e) {
		return this._addCheck({
			kind: "min",
			value: 0,
			inclusive: !1,
			message: h.toString(e)
		});
	}
	negative(e) {
		return this._addCheck({
			kind: "max",
			value: 0,
			inclusive: !1,
			message: h.toString(e)
		});
	}
	nonpositive(e) {
		return this._addCheck({
			kind: "max",
			value: 0,
			inclusive: !0,
			message: h.toString(e)
		});
	}
	nonnegative(e) {
		return this._addCheck({
			kind: "min",
			value: 0,
			inclusive: !0,
			message: h.toString(e)
		});
	}
	multipleOf(e, t) {
		return this._addCheck({
			kind: "multipleOf",
			value: e,
			message: h.toString(t)
		});
	}
	finite(e) {
		return this._addCheck({
			kind: "finite",
			message: h.toString(e)
		});
	}
	safe(e) {
		return this._addCheck({
			kind: "min",
			inclusive: !0,
			value: -(2 ** 53 - 1),
			message: h.toString(e)
		})._addCheck({
			kind: "max",
			inclusive: !0,
			value: 2 ** 53 - 1,
			message: h.toString(e)
		});
	}
	get minValue() {
		let e = null;
		for (let t of this._def.checks) t.kind === "min" && (e === null || t.value > e) && (e = t.value);
		return e;
	}
	get maxValue() {
		let e = null;
		for (let t of this._def.checks) t.kind === "max" && (e === null || t.value < e) && (e = t.value);
		return e;
	}
	get isInt() {
		return !!this._def.checks.find((e) => e.kind === "int" || e.kind === "multipleOf" && o.isInteger(e.value));
	}
	get isFinite() {
		let e = null, t = null;
		for (let n of this._def.checks) if (n.kind === "finite" || n.kind === "int" || n.kind === "multipleOf") return !0;
		else n.kind === "min" ? (t === null || n.value > t) && (t = n.value) : n.kind === "max" && (e === null || n.value < e) && (e = n.value);
		return Number.isFinite(t) && Number.isFinite(e);
	}
};
ge.create = (e) => new ge({
	checks: [],
	typeName: S.ZodNumber,
	coerce: e?.coerce || !1,
	...processCreateParams(e)
});
var _e = class ZodBigInt extends ZodType {
	constructor() {
		super(...arguments), this.min = this.gte, this.max = this.lte;
	}
	_parse(e) {
		if (this._def.coerce) try {
			e.data = BigInt(e.data);
		} catch {
			return this._getInvalidInput(e);
		}
		if (this._getType(e) !== c.bigint) return this._getInvalidInput(e);
		let t, n = new f();
		for (let r of this._def.checks) r.kind === "min" ? (r.inclusive ? e.data < r.value : e.data <= r.value) && (t = this._getOrReturnCtx(e, t), addIssueToContext(t, {
			code: l.too_small,
			type: "bigint",
			minimum: r.value,
			inclusive: r.inclusive,
			message: r.message
		}), n.dirty()) : r.kind === "max" ? (r.inclusive ? e.data > r.value : e.data >= r.value) && (t = this._getOrReturnCtx(e, t), addIssueToContext(t, {
			code: l.too_big,
			type: "bigint",
			maximum: r.value,
			inclusive: r.inclusive,
			message: r.message
		}), n.dirty()) : r.kind === "multipleOf" ? e.data % r.value !== BigInt(0) && (t = this._getOrReturnCtx(e, t), addIssueToContext(t, {
			code: l.not_multiple_of,
			multipleOf: r.value,
			message: r.message
		}), n.dirty()) : o.assertNever(r);
		return {
			status: n.value,
			value: e.data
		};
	}
	_getInvalidInput(e) {
		let t = this._getOrReturnCtx(e);
		return addIssueToContext(t, {
			code: l.invalid_type,
			expected: c.bigint,
			received: t.parsedType
		}), p;
	}
	gte(e, t) {
		return this.setLimit("min", e, !0, h.toString(t));
	}
	gt(e, t) {
		return this.setLimit("min", e, !1, h.toString(t));
	}
	lte(e, t) {
		return this.setLimit("max", e, !0, h.toString(t));
	}
	lt(e, t) {
		return this.setLimit("max", e, !1, h.toString(t));
	}
	setLimit(e, t, n, r) {
		return new ZodBigInt({
			...this._def,
			checks: [...this._def.checks, {
				kind: e,
				value: t,
				inclusive: n,
				message: h.toString(r)
			}]
		});
	}
	_addCheck(e) {
		return new ZodBigInt({
			...this._def,
			checks: [...this._def.checks, e]
		});
	}
	positive(e) {
		return this._addCheck({
			kind: "min",
			value: BigInt(0),
			inclusive: !1,
			message: h.toString(e)
		});
	}
	negative(e) {
		return this._addCheck({
			kind: "max",
			value: BigInt(0),
			inclusive: !1,
			message: h.toString(e)
		});
	}
	nonpositive(e) {
		return this._addCheck({
			kind: "max",
			value: BigInt(0),
			inclusive: !0,
			message: h.toString(e)
		});
	}
	nonnegative(e) {
		return this._addCheck({
			kind: "min",
			value: BigInt(0),
			inclusive: !0,
			message: h.toString(e)
		});
	}
	multipleOf(e, t) {
		return this._addCheck({
			kind: "multipleOf",
			value: e,
			message: h.toString(t)
		});
	}
	get minValue() {
		let e = null;
		for (let t of this._def.checks) t.kind === "min" && (e === null || t.value > e) && (e = t.value);
		return e;
	}
	get maxValue() {
		let e = null;
		for (let t of this._def.checks) t.kind === "max" && (e === null || t.value < e) && (e = t.value);
		return e;
	}
};
_e.create = (e) => new _e({
	checks: [],
	typeName: S.ZodBigInt,
	coerce: e?.coerce ?? !1,
	...processCreateParams(e)
});
var ZodBoolean = class extends ZodType {
	_parse(e) {
		if (this._def.coerce && (e.data = !!e.data), this._getType(e) !== c.boolean) {
			let t = this._getOrReturnCtx(e);
			return addIssueToContext(t, {
				code: l.invalid_type,
				expected: c.boolean,
				received: t.parsedType
			}), p;
		}
		return OK(e.data);
	}
};
ZodBoolean.create = (e) => new ZodBoolean({
	typeName: S.ZodBoolean,
	coerce: e?.coerce || !1,
	...processCreateParams(e)
});
var ve = class ZodDate extends ZodType {
	_parse(e) {
		if (this._def.coerce && (e.data = new Date(e.data)), this._getType(e) !== c.date) {
			let t = this._getOrReturnCtx(e);
			return addIssueToContext(t, {
				code: l.invalid_type,
				expected: c.date,
				received: t.parsedType
			}), p;
		}
		if (Number.isNaN(e.data.getTime())) return addIssueToContext(this._getOrReturnCtx(e), { code: l.invalid_date }), p;
		let t = new f(), n;
		for (let r of this._def.checks) r.kind === "min" ? e.data.getTime() < r.value && (n = this._getOrReturnCtx(e, n), addIssueToContext(n, {
			code: l.too_small,
			message: r.message,
			inclusive: !0,
			exact: !1,
			minimum: r.value,
			type: "date"
		}), t.dirty()) : r.kind === "max" ? e.data.getTime() > r.value && (n = this._getOrReturnCtx(e, n), addIssueToContext(n, {
			code: l.too_big,
			message: r.message,
			inclusive: !0,
			exact: !1,
			maximum: r.value,
			type: "date"
		}), t.dirty()) : o.assertNever(r);
		return {
			status: t.value,
			value: new Date(e.data.getTime())
		};
	}
	_addCheck(e) {
		return new ZodDate({
			...this._def,
			checks: [...this._def.checks, e]
		});
	}
	min(e, t) {
		return this._addCheck({
			kind: "min",
			value: e.getTime(),
			message: h.toString(t)
		});
	}
	max(e, t) {
		return this._addCheck({
			kind: "max",
			value: e.getTime(),
			message: h.toString(t)
		});
	}
	get minDate() {
		let e = null;
		for (let t of this._def.checks) t.kind === "min" && (e === null || t.value > e) && (e = t.value);
		return e == null ? null : new Date(e);
	}
	get maxDate() {
		let e = null;
		for (let t of this._def.checks) t.kind === "max" && (e === null || t.value < e) && (e = t.value);
		return e == null ? null : new Date(e);
	}
};
ve.create = (e) => new ve({
	checks: [],
	coerce: e?.coerce || !1,
	typeName: S.ZodDate,
	...processCreateParams(e)
});
var ZodSymbol = class extends ZodType {
	_parse(e) {
		if (this._getType(e) !== c.symbol) {
			let t = this._getOrReturnCtx(e);
			return addIssueToContext(t, {
				code: l.invalid_type,
				expected: c.symbol,
				received: t.parsedType
			}), p;
		}
		return OK(e.data);
	}
};
ZodSymbol.create = (e) => new ZodSymbol({
	typeName: S.ZodSymbol,
	...processCreateParams(e)
});
var ZodUndefined = class extends ZodType {
	_parse(e) {
		if (this._getType(e) !== c.undefined) {
			let t = this._getOrReturnCtx(e);
			return addIssueToContext(t, {
				code: l.invalid_type,
				expected: c.undefined,
				received: t.parsedType
			}), p;
		}
		return OK(e.data);
	}
};
ZodUndefined.create = (e) => new ZodUndefined({
	typeName: S.ZodUndefined,
	...processCreateParams(e)
});
var ZodNull = class extends ZodType {
	_parse(e) {
		if (this._getType(e) !== c.null) {
			let t = this._getOrReturnCtx(e);
			return addIssueToContext(t, {
				code: l.invalid_type,
				expected: c.null,
				received: t.parsedType
			}), p;
		}
		return OK(e.data);
	}
};
ZodNull.create = (e) => new ZodNull({
	typeName: S.ZodNull,
	...processCreateParams(e)
});
var ZodAny = class extends ZodType {
	constructor() {
		super(...arguments), this._any = !0;
	}
	_parse(e) {
		return OK(e.data);
	}
};
ZodAny.create = (e) => new ZodAny({
	typeName: S.ZodAny,
	...processCreateParams(e)
});
var ZodUnknown = class extends ZodType {
	constructor() {
		super(...arguments), this._unknown = !0;
	}
	_parse(e) {
		return OK(e.data);
	}
};
ZodUnknown.create = (e) => new ZodUnknown({
	typeName: S.ZodUnknown,
	...processCreateParams(e)
});
var ZodNever = class extends ZodType {
	_parse(e) {
		let t = this._getOrReturnCtx(e);
		return addIssueToContext(t, {
			code: l.invalid_type,
			expected: c.never,
			received: t.parsedType
		}), p;
	}
};
ZodNever.create = (e) => new ZodNever({
	typeName: S.ZodNever,
	...processCreateParams(e)
});
var ZodVoid = class extends ZodType {
	_parse(e) {
		if (this._getType(e) !== c.undefined) {
			let t = this._getOrReturnCtx(e);
			return addIssueToContext(t, {
				code: l.invalid_type,
				expected: c.void,
				received: t.parsedType
			}), p;
		}
		return OK(e.data);
	}
};
ZodVoid.create = (e) => new ZodVoid({
	typeName: S.ZodVoid,
	...processCreateParams(e)
});
var y = class ZodArray extends ZodType {
	_parse(e) {
		let { ctx: t, status: n } = this._processInputParams(e), r = this._def;
		if (t.parsedType !== c.array) return addIssueToContext(t, {
			code: l.invalid_type,
			expected: c.array,
			received: t.parsedType
		}), p;
		if (r.exactLength !== null) {
			let e = t.data.length > r.exactLength.value, i = t.data.length < r.exactLength.value;
			(e || i) && (addIssueToContext(t, {
				code: e ? l.too_big : l.too_small,
				minimum: i ? r.exactLength.value : void 0,
				maximum: e ? r.exactLength.value : void 0,
				type: "array",
				inclusive: !0,
				exact: !0,
				message: r.exactLength.message
			}), n.dirty());
		}
		if (r.minLength !== null && t.data.length < r.minLength.value && (addIssueToContext(t, {
			code: l.too_small,
			minimum: r.minLength.value,
			type: "array",
			inclusive: !0,
			exact: !1,
			message: r.minLength.message
		}), n.dirty()), r.maxLength !== null && t.data.length > r.maxLength.value && (addIssueToContext(t, {
			code: l.too_big,
			maximum: r.maxLength.value,
			type: "array",
			inclusive: !0,
			exact: !1,
			message: r.maxLength.message
		}), n.dirty()), t.common.async) return Promise.all([...t.data].map((e, n) => r.type._parseAsync(new ParseInputLazyPath(t, e, t.path, n)))).then((e) => f.mergeArray(n, e));
		let i = [...t.data].map((e, n) => r.type._parseSync(new ParseInputLazyPath(t, e, t.path, n)));
		return f.mergeArray(n, i);
	}
	get element() {
		return this._def.type;
	}
	min(e, t) {
		return new ZodArray({
			...this._def,
			minLength: {
				value: e,
				message: h.toString(t)
			}
		});
	}
	max(e, t) {
		return new ZodArray({
			...this._def,
			maxLength: {
				value: e,
				message: h.toString(t)
			}
		});
	}
	length(e, t) {
		return new ZodArray({
			...this._def,
			exactLength: {
				value: e,
				message: h.toString(t)
			}
		});
	}
	nonempty(e) {
		return this.min(1, e);
	}
};
y.create = (e, t) => new y({
	type: e,
	minLength: null,
	maxLength: null,
	exactLength: null,
	typeName: S.ZodArray,
	...processCreateParams(t)
});
function deepPartialify(e) {
	if (e instanceof b) {
		let t = {};
		for (let n in e.shape) {
			let r = e.shape[n];
			t[n] = ZodOptional.create(deepPartialify(r));
		}
		return new b({
			...e._def,
			shape: () => t
		});
	}
	return e instanceof y ? new y({
		...e._def,
		type: deepPartialify(e.element)
	}) : e instanceof ZodOptional ? ZodOptional.create(deepPartialify(e.unwrap())) : e instanceof ZodNullable ? ZodNullable.create(deepPartialify(e.unwrap())) : e instanceof x ? x.create(e.items.map((e) => deepPartialify(e))) : e;
}
var b = class ZodObject extends ZodType {
	constructor() {
		super(...arguments), this._cached = null, this.nonstrict = this.passthrough, this.augment = this.extend;
	}
	_getCached() {
		if (this._cached !== null) return this._cached;
		let e = this._def.shape(), t = o.objectKeys(e);
		return this._cached = {
			shape: e,
			keys: t
		}, this._cached;
	}
	_parse(e) {
		if (this._getType(e) !== c.object) {
			let t = this._getOrReturnCtx(e);
			return addIssueToContext(t, {
				code: l.invalid_type,
				expected: c.object,
				received: t.parsedType
			}), p;
		}
		let { status: t, ctx: n } = this._processInputParams(e), { shape: r, keys: i } = this._getCached(), a = [];
		if (!(this._def.catchall instanceof ZodNever && this._def.unknownKeys === "strip")) for (let e in n.data) i.includes(e) || a.push(e);
		let o = [];
		for (let e of i) {
			let t = r[e], i = n.data[e];
			o.push({
				key: {
					status: "valid",
					value: e
				},
				value: t._parse(new ParseInputLazyPath(n, i, n.path, e)),
				alwaysSet: e in n.data
			});
		}
		if (this._def.catchall instanceof ZodNever) {
			let e = this._def.unknownKeys;
			if (e === "passthrough") for (let e of a) o.push({
				key: {
					status: "valid",
					value: e
				},
				value: {
					status: "valid",
					value: n.data[e]
				}
			});
			else if (e === "strict") a.length > 0 && (addIssueToContext(n, {
				code: l.unrecognized_keys,
				keys: a
			}), t.dirty());
			else if (e !== "strip") throw Error("Internal ZodObject error: invalid unknownKeys value.");
		} else {
			let e = this._def.catchall;
			for (let t of a) {
				let r = n.data[t];
				o.push({
					key: {
						status: "valid",
						value: t
					},
					value: e._parse(new ParseInputLazyPath(n, r, n.path, t)),
					alwaysSet: t in n.data
				});
			}
		}
		return n.common.async ? Promise.resolve().then(async () => {
			let e = [];
			for (let t of o) {
				let n = await t.key, r = await t.value;
				e.push({
					key: n,
					value: r,
					alwaysSet: t.alwaysSet
				});
			}
			return e;
		}).then((e) => f.mergeObjectSync(t, e)) : f.mergeObjectSync(t, o);
	}
	get shape() {
		return this._def.shape();
	}
	strict(e) {
		return h.errToObj, new ZodObject({
			...this._def,
			unknownKeys: "strict",
			...e === void 0 ? {} : { errorMap: (t, n) => {
				let r = this._def.errorMap?.(t, n).message ?? n.defaultError;
				return t.code === "unrecognized_keys" ? { message: h.errToObj(e).message ?? r } : { message: r };
			} }
		});
	}
	strip() {
		return new ZodObject({
			...this._def,
			unknownKeys: "strip"
		});
	}
	passthrough() {
		return new ZodObject({
			...this._def,
			unknownKeys: "passthrough"
		});
	}
	extend(e) {
		return new ZodObject({
			...this._def,
			shape: () => ({
				...this._def.shape(),
				...e
			})
		});
	}
	merge(e) {
		return new ZodObject({
			unknownKeys: e._def.unknownKeys,
			catchall: e._def.catchall,
			shape: () => ({
				...this._def.shape(),
				...e._def.shape()
			}),
			typeName: S.ZodObject
		});
	}
	setKey(e, t) {
		return this.augment({ [e]: t });
	}
	catchall(e) {
		return new ZodObject({
			...this._def,
			catchall: e
		});
	}
	pick(e) {
		let t = {};
		for (let n of o.objectKeys(e)) e[n] && this.shape[n] && (t[n] = this.shape[n]);
		return new ZodObject({
			...this._def,
			shape: () => t
		});
	}
	omit(e) {
		let t = {};
		for (let n of o.objectKeys(this.shape)) e[n] || (t[n] = this.shape[n]);
		return new ZodObject({
			...this._def,
			shape: () => t
		});
	}
	deepPartial() {
		return deepPartialify(this);
	}
	partial(e) {
		let t = {};
		for (let n of o.objectKeys(this.shape)) {
			let r = this.shape[n];
			t[n] = e && !e[n] ? r : r.optional();
		}
		return new ZodObject({
			...this._def,
			shape: () => t
		});
	}
	required(e) {
		let t = {};
		for (let n of o.objectKeys(this.shape)) if (e && !e[n]) t[n] = this.shape[n];
		else {
			let e = this.shape[n];
			for (; e instanceof ZodOptional;) e = e._def.innerType;
			t[n] = e;
		}
		return new ZodObject({
			...this._def,
			shape: () => t
		});
	}
	keyof() {
		return createZodEnum(o.objectKeys(this.shape));
	}
};
b.create = (e, t) => new b({
	shape: () => e,
	unknownKeys: "strip",
	catchall: ZodNever.create(),
	typeName: S.ZodObject,
	...processCreateParams(t)
}), b.strictCreate = (e, t) => new b({
	shape: () => e,
	unknownKeys: "strict",
	catchall: ZodNever.create(),
	typeName: S.ZodObject,
	...processCreateParams(t)
}), b.lazycreate = (e, t) => new b({
	shape: e,
	unknownKeys: "strip",
	catchall: ZodNever.create(),
	typeName: S.ZodObject,
	...processCreateParams(t)
});
var ZodUnion = class extends ZodType {
	_parse(e) {
		let { ctx: t } = this._processInputParams(e), n = this._def.options;
		function handleResults(e) {
			for (let t of e) if (t.result.status === "valid") return t.result;
			for (let n of e) if (n.result.status === "dirty") return t.common.issues.push(...n.ctx.common.issues), n.result;
			let n = e.map((e) => new u(e.ctx.common.issues));
			return addIssueToContext(t, {
				code: l.invalid_union,
				unionErrors: n
			}), p;
		}
		if (t.common.async) return Promise.all(n.map(async (e) => {
			let n = {
				...t,
				common: {
					...t.common,
					issues: []
				},
				parent: null
			};
			return {
				result: await e._parseAsync({
					data: t.data,
					path: t.path,
					parent: n
				}),
				ctx: n
			};
		})).then(handleResults);
		{
			let e, r = [];
			for (let i of n) {
				let n = {
					...t,
					common: {
						...t.common,
						issues: []
					},
					parent: null
				}, a = i._parseSync({
					data: t.data,
					path: t.path,
					parent: n
				});
				if (a.status === "valid") return a;
				a.status === "dirty" && !e && (e = {
					result: a,
					ctx: n
				}), n.common.issues.length && r.push(n.common.issues);
			}
			if (e) return t.common.issues.push(...e.ctx.common.issues), e.result;
			let i = r.map((e) => new u(e));
			return addIssueToContext(t, {
				code: l.invalid_union,
				unionErrors: i
			}), p;
		}
	}
	get options() {
		return this._def.options;
	}
};
ZodUnion.create = (e, t) => new ZodUnion({
	options: e,
	typeName: S.ZodUnion,
	...processCreateParams(t)
});
var getDiscriminator = (e) => e instanceof ZodLazy ? getDiscriminator(e.schema) : e instanceof ZodEffects ? getDiscriminator(e.innerType()) : e instanceof ZodLiteral ? [e.value] : e instanceof Ce ? e.options : e instanceof ZodNativeEnum ? o.objectValues(e.enum) : e instanceof ZodDefault ? getDiscriminator(e._def.innerType) : e instanceof ZodUndefined ? [void 0] : e instanceof ZodNull ? [null] : e instanceof ZodOptional ? [void 0, ...getDiscriminator(e.unwrap())] : e instanceof ZodNullable ? [null, ...getDiscriminator(e.unwrap())] : e instanceof ZodBranded || e instanceof ZodReadonly ? getDiscriminator(e.unwrap()) : e instanceof ZodCatch ? getDiscriminator(e._def.innerType) : [], ye = class ZodDiscriminatedUnion extends ZodType {
	_parse(e) {
		let { ctx: t } = this._processInputParams(e);
		if (t.parsedType !== c.object) return addIssueToContext(t, {
			code: l.invalid_type,
			expected: c.object,
			received: t.parsedType
		}), p;
		let n = this.discriminator, r = t.data[n], i = this.optionsMap.get(r);
		return i ? t.common.async ? i._parseAsync({
			data: t.data,
			path: t.path,
			parent: t
		}) : i._parseSync({
			data: t.data,
			path: t.path,
			parent: t
		}) : (addIssueToContext(t, {
			code: l.invalid_union_discriminator,
			options: Array.from(this.optionsMap.keys()),
			path: [n]
		}), p);
	}
	get discriminator() {
		return this._def.discriminator;
	}
	get options() {
		return this._def.options;
	}
	get optionsMap() {
		return this._def.optionsMap;
	}
	static create(e, t, n) {
		let r = /* @__PURE__ */ new Map();
		for (let n of t) {
			let t = getDiscriminator(n.shape[e]);
			if (!t.length) throw Error(`A discriminator value for key \`${e}\` could not be extracted from all schema options`);
			for (let i of t) {
				if (r.has(i)) throw Error(`Discriminator property ${String(e)} has duplicate value ${String(i)}`);
				r.set(i, n);
			}
		}
		return new ZodDiscriminatedUnion({
			typeName: S.ZodDiscriminatedUnion,
			discriminator: e,
			options: t,
			optionsMap: r,
			...processCreateParams(n)
		});
	}
};
function mergeValues(e, t) {
	let n = getParsedType(e), r = getParsedType(t);
	if (e === t) return {
		valid: !0,
		data: e
	};
	if (n === c.object && r === c.object) {
		let n = o.objectKeys(t), r = o.objectKeys(e).filter((e) => n.indexOf(e) !== -1), i = {
			...e,
			...t
		};
		for (let n of r) {
			let r = mergeValues(e[n], t[n]);
			if (!r.valid) return { valid: !1 };
			i[n] = r.data;
		}
		return {
			valid: !0,
			data: i
		};
	}
	if (n === c.array && r === c.array) {
		if (e.length !== t.length) return { valid: !1 };
		let n = [];
		for (let r = 0; r < e.length; r++) {
			let i = e[r], a = t[r], o = mergeValues(i, a);
			if (!o.valid) return { valid: !1 };
			n.push(o.data);
		}
		return {
			valid: !0,
			data: n
		};
	}
	return n === c.date && r === c.date && +e == +t ? {
		valid: !0,
		data: e
	} : { valid: !1 };
}
var ZodIntersection = class extends ZodType {
	_parse(e) {
		let { status: t, ctx: n } = this._processInputParams(e), handleParsed = (e, r) => {
			if (isAborted(e) || isAborted(r)) return p;
			let i = mergeValues(e.value, r.value);
			return i.valid ? ((isDirty(e) || isDirty(r)) && t.dirty(), {
				status: t.value,
				value: i.data
			}) : (addIssueToContext(n, { code: l.invalid_intersection_types }), p);
		};
		return n.common.async ? Promise.all([this._def.left._parseAsync({
			data: n.data,
			path: n.path,
			parent: n
		}), this._def.right._parseAsync({
			data: n.data,
			path: n.path,
			parent: n
		})]).then(([e, t]) => handleParsed(e, t)) : handleParsed(this._def.left._parseSync({
			data: n.data,
			path: n.path,
			parent: n
		}), this._def.right._parseSync({
			data: n.data,
			path: n.path,
			parent: n
		}));
	}
};
ZodIntersection.create = (e, t, n) => new ZodIntersection({
	left: e,
	right: t,
	typeName: S.ZodIntersection,
	...processCreateParams(n)
});
var x = class ZodTuple extends ZodType {
	_parse(e) {
		let { status: t, ctx: n } = this._processInputParams(e);
		if (n.parsedType !== c.array) return addIssueToContext(n, {
			code: l.invalid_type,
			expected: c.array,
			received: n.parsedType
		}), p;
		if (n.data.length < this._def.items.length) return addIssueToContext(n, {
			code: l.too_small,
			minimum: this._def.items.length,
			inclusive: !0,
			exact: !1,
			type: "array"
		}), p;
		!this._def.rest && n.data.length > this._def.items.length && (addIssueToContext(n, {
			code: l.too_big,
			maximum: this._def.items.length,
			inclusive: !0,
			exact: !1,
			type: "array"
		}), t.dirty());
		let r = [...n.data].map((e, t) => {
			let r = this._def.items[t] || this._def.rest;
			return r ? r._parse(new ParseInputLazyPath(n, e, n.path, t)) : null;
		}).filter((e) => !!e);
		return n.common.async ? Promise.all(r).then((e) => f.mergeArray(t, e)) : f.mergeArray(t, r);
	}
	get items() {
		return this._def.items;
	}
	rest(e) {
		return new ZodTuple({
			...this._def,
			rest: e
		});
	}
};
x.create = (e, t) => {
	if (!Array.isArray(e)) throw Error("You must pass an array of schemas to z.tuple([ ... ])");
	return new x({
		items: e,
		typeName: S.ZodTuple,
		rest: null,
		...processCreateParams(t)
	});
};
var be = class ZodRecord extends ZodType {
	get keySchema() {
		return this._def.keyType;
	}
	get valueSchema() {
		return this._def.valueType;
	}
	_parse(e) {
		let { status: t, ctx: n } = this._processInputParams(e);
		if (n.parsedType !== c.object) return addIssueToContext(n, {
			code: l.invalid_type,
			expected: c.object,
			received: n.parsedType
		}), p;
		let r = [], i = this._def.keyType, a = this._def.valueType;
		for (let e in n.data) r.push({
			key: i._parse(new ParseInputLazyPath(n, e, n.path, e)),
			value: a._parse(new ParseInputLazyPath(n, n.data[e], n.path, e)),
			alwaysSet: e in n.data
		});
		return n.common.async ? f.mergeObjectAsync(t, r) : f.mergeObjectSync(t, r);
	}
	get element() {
		return this._def.valueType;
	}
	static create(e, t, n) {
		return t instanceof ZodType ? new ZodRecord({
			keyType: e,
			valueType: t,
			typeName: S.ZodRecord,
			...processCreateParams(n)
		}) : new ZodRecord({
			keyType: he.create(),
			valueType: e,
			typeName: S.ZodRecord,
			...processCreateParams(t)
		});
	}
}, ZodMap = class extends ZodType {
	get keySchema() {
		return this._def.keyType;
	}
	get valueSchema() {
		return this._def.valueType;
	}
	_parse(e) {
		let { status: t, ctx: n } = this._processInputParams(e);
		if (n.parsedType !== c.map) return addIssueToContext(n, {
			code: l.invalid_type,
			expected: c.map,
			received: n.parsedType
		}), p;
		let r = this._def.keyType, i = this._def.valueType, a = [...n.data.entries()].map(([e, t], a) => ({
			key: r._parse(new ParseInputLazyPath(n, e, n.path, [a, "key"])),
			value: i._parse(new ParseInputLazyPath(n, t, n.path, [a, "value"]))
		}));
		if (n.common.async) {
			let e = /* @__PURE__ */ new Map();
			return Promise.resolve().then(async () => {
				for (let n of a) {
					let r = await n.key, i = await n.value;
					if (r.status === "aborted" || i.status === "aborted") return p;
					(r.status === "dirty" || i.status === "dirty") && t.dirty(), e.set(r.value, i.value);
				}
				return {
					status: t.value,
					value: e
				};
			});
		}
		{
			let e = /* @__PURE__ */ new Map();
			for (let n of a) {
				let r = n.key, i = n.value;
				if (r.status === "aborted" || i.status === "aborted") return p;
				(r.status === "dirty" || i.status === "dirty") && t.dirty(), e.set(r.value, i.value);
			}
			return {
				status: t.value,
				value: e
			};
		}
	}
};
ZodMap.create = (e, t, n) => new ZodMap({
	valueType: t,
	keyType: e,
	typeName: S.ZodMap,
	...processCreateParams(n)
});
var xe = class ZodSet extends ZodType {
	_parse(e) {
		let { status: t, ctx: n } = this._processInputParams(e);
		if (n.parsedType !== c.set) return addIssueToContext(n, {
			code: l.invalid_type,
			expected: c.set,
			received: n.parsedType
		}), p;
		let r = this._def;
		r.minSize !== null && n.data.size < r.minSize.value && (addIssueToContext(n, {
			code: l.too_small,
			minimum: r.minSize.value,
			type: "set",
			inclusive: !0,
			exact: !1,
			message: r.minSize.message
		}), t.dirty()), r.maxSize !== null && n.data.size > r.maxSize.value && (addIssueToContext(n, {
			code: l.too_big,
			maximum: r.maxSize.value,
			type: "set",
			inclusive: !0,
			exact: !1,
			message: r.maxSize.message
		}), t.dirty());
		let i = this._def.valueType;
		function finalizeSet(e) {
			let n = /* @__PURE__ */ new Set();
			for (let r of e) {
				if (r.status === "aborted") return p;
				r.status === "dirty" && t.dirty(), n.add(r.value);
			}
			return {
				status: t.value,
				value: n
			};
		}
		let a = [...n.data.values()].map((e, t) => i._parse(new ParseInputLazyPath(n, e, n.path, t)));
		return n.common.async ? Promise.all(a).then((e) => finalizeSet(e)) : finalizeSet(a);
	}
	min(e, t) {
		return new ZodSet({
			...this._def,
			minSize: {
				value: e,
				message: h.toString(t)
			}
		});
	}
	max(e, t) {
		return new ZodSet({
			...this._def,
			maxSize: {
				value: e,
				message: h.toString(t)
			}
		});
	}
	size(e, t) {
		return this.min(e, t).max(e, t);
	}
	nonempty(e) {
		return this.min(1, e);
	}
};
xe.create = (e, t) => new xe({
	valueType: e,
	minSize: null,
	maxSize: null,
	typeName: S.ZodSet,
	...processCreateParams(t)
});
var Se = class ZodFunction extends ZodType {
	constructor() {
		super(...arguments), this.validate = this.implement;
	}
	_parse(e) {
		let { ctx: t } = this._processInputParams(e);
		if (t.parsedType !== c.function) return addIssueToContext(t, {
			code: l.invalid_type,
			expected: c.function,
			received: t.parsedType
		}), p;
		function makeArgsIssue(e, n) {
			return makeIssue({
				data: e,
				path: t.path,
				errorMaps: [
					t.common.contextualErrorMap,
					t.schemaErrorMap,
					getErrorMap(),
					errorMap
				].filter((e) => !!e),
				issueData: {
					code: l.invalid_arguments,
					argumentsError: n
				}
			});
		}
		function makeReturnsIssue(e, n) {
			return makeIssue({
				data: e,
				path: t.path,
				errorMaps: [
					t.common.contextualErrorMap,
					t.schemaErrorMap,
					getErrorMap(),
					errorMap
				].filter((e) => !!e),
				issueData: {
					code: l.invalid_return_type,
					returnTypeError: n
				}
			});
		}
		let n = { errorMap: t.common.contextualErrorMap }, r = t.data;
		if (this._def.returns instanceof ZodPromise) {
			let e = this;
			return OK(async function(...t) {
				let i = new u([]), a = await e._def.args.parseAsync(t, n).catch((e) => {
					throw i.addIssue(makeArgsIssue(t, e)), i;
				}), o = await Reflect.apply(r, this, a);
				return await e._def.returns._def.type.parseAsync(o, n).catch((e) => {
					throw i.addIssue(makeReturnsIssue(o, e)), i;
				});
			});
		}
		{
			let e = this;
			return OK(function(...t) {
				let i = e._def.args.safeParse(t, n);
				if (!i.success) throw new u([makeArgsIssue(t, i.error)]);
				let a = Reflect.apply(r, this, i.data), o = e._def.returns.safeParse(a, n);
				if (!o.success) throw new u([makeReturnsIssue(a, o.error)]);
				return o.data;
			});
		}
	}
	parameters() {
		return this._def.args;
	}
	returnType() {
		return this._def.returns;
	}
	args(...e) {
		return new ZodFunction({
			...this._def,
			args: x.create(e).rest(ZodUnknown.create())
		});
	}
	returns(e) {
		return new ZodFunction({
			...this._def,
			returns: e
		});
	}
	implement(e) {
		return this.parse(e);
	}
	strictImplement(e) {
		return this.parse(e);
	}
	static create(e, t, n) {
		return new ZodFunction({
			args: e || x.create([]).rest(ZodUnknown.create()),
			returns: t || ZodUnknown.create(),
			typeName: S.ZodFunction,
			...processCreateParams(n)
		});
	}
}, ZodLazy = class extends ZodType {
	get schema() {
		return this._def.getter();
	}
	_parse(e) {
		let { ctx: t } = this._processInputParams(e);
		return this._def.getter()._parse({
			data: t.data,
			path: t.path,
			parent: t
		});
	}
};
ZodLazy.create = (e, t) => new ZodLazy({
	getter: e,
	typeName: S.ZodLazy,
	...processCreateParams(t)
});
var ZodLiteral = class extends ZodType {
	_parse(e) {
		if (e.data !== this._def.value) {
			let t = this._getOrReturnCtx(e);
			return addIssueToContext(t, {
				received: t.data,
				code: l.invalid_literal,
				expected: this._def.value
			}), p;
		}
		return {
			status: "valid",
			value: e.data
		};
	}
	get value() {
		return this._def.value;
	}
};
ZodLiteral.create = (e, t) => new ZodLiteral({
	value: e,
	typeName: S.ZodLiteral,
	...processCreateParams(t)
});
function createZodEnum(e, t) {
	return new Ce({
		values: e,
		typeName: S.ZodEnum,
		...processCreateParams(t)
	});
}
var Ce = class ZodEnum extends ZodType {
	_parse(e) {
		if (typeof e.data != "string") {
			let t = this._getOrReturnCtx(e), n = this._def.values;
			return addIssueToContext(t, {
				expected: o.joinValues(n),
				received: t.parsedType,
				code: l.invalid_type
			}), p;
		}
		if (this._cache ||= new Set(this._def.values), !this._cache.has(e.data)) {
			let t = this._getOrReturnCtx(e), n = this._def.values;
			return addIssueToContext(t, {
				received: t.data,
				code: l.invalid_enum_value,
				options: n
			}), p;
		}
		return OK(e.data);
	}
	get options() {
		return this._def.values;
	}
	get enum() {
		let e = {};
		for (let t of this._def.values) e[t] = t;
		return e;
	}
	get Values() {
		let e = {};
		for (let t of this._def.values) e[t] = t;
		return e;
	}
	get Enum() {
		let e = {};
		for (let t of this._def.values) e[t] = t;
		return e;
	}
	extract(e, t = this._def) {
		return ZodEnum.create(e, {
			...this._def,
			...t
		});
	}
	exclude(e, t = this._def) {
		return ZodEnum.create(this.options.filter((t) => !e.includes(t)), {
			...this._def,
			...t
		});
	}
};
Ce.create = createZodEnum;
var ZodNativeEnum = class extends ZodType {
	_parse(e) {
		let t = o.getValidEnumValues(this._def.values), n = this._getOrReturnCtx(e);
		if (n.parsedType !== c.string && n.parsedType !== c.number) {
			let e = o.objectValues(t);
			return addIssueToContext(n, {
				expected: o.joinValues(e),
				received: n.parsedType,
				code: l.invalid_type
			}), p;
		}
		if (this._cache ||= new Set(o.getValidEnumValues(this._def.values)), !this._cache.has(e.data)) {
			let e = o.objectValues(t);
			return addIssueToContext(n, {
				received: n.data,
				code: l.invalid_enum_value,
				options: e
			}), p;
		}
		return OK(e.data);
	}
	get enum() {
		return this._def.values;
	}
};
ZodNativeEnum.create = (e, t) => new ZodNativeEnum({
	values: e,
	typeName: S.ZodNativeEnum,
	...processCreateParams(t)
});
var ZodPromise = class extends ZodType {
	unwrap() {
		return this._def.type;
	}
	_parse(e) {
		let { ctx: t } = this._processInputParams(e);
		return t.parsedType !== c.promise && t.common.async === !1 ? (addIssueToContext(t, {
			code: l.invalid_type,
			expected: c.promise,
			received: t.parsedType
		}), p) : OK((t.parsedType === c.promise ? t.data : Promise.resolve(t.data)).then((e) => this._def.type.parseAsync(e, {
			path: t.path,
			errorMap: t.common.contextualErrorMap
		})));
	}
};
ZodPromise.create = (e, t) => new ZodPromise({
	type: e,
	typeName: S.ZodPromise,
	...processCreateParams(t)
});
var ZodEffects = class extends ZodType {
	innerType() {
		return this._def.schema;
	}
	sourceType() {
		return this._def.schema._def.typeName === S.ZodEffects ? this._def.schema.sourceType() : this._def.schema;
	}
	_parse(e) {
		let { status: t, ctx: n } = this._processInputParams(e), r = this._def.effect || null, i = {
			addIssue: (e) => {
				addIssueToContext(n, e), e.fatal ? t.abort() : t.dirty();
			},
			get path() {
				return n.path;
			}
		};
		if (i.addIssue = i.addIssue.bind(i), r.type === "preprocess") {
			let e = r.transform(n.data, i);
			if (n.common.async) return Promise.resolve(e).then(async (e) => {
				if (t.value === "aborted") return p;
				let r = await this._def.schema._parseAsync({
					data: e,
					path: n.path,
					parent: n
				});
				return r.status === "aborted" ? p : r.status === "dirty" || t.value === "dirty" ? DIRTY(r.value) : r;
			});
			{
				if (t.value === "aborted") return p;
				let r = this._def.schema._parseSync({
					data: e,
					path: n.path,
					parent: n
				});
				return r.status === "aborted" ? p : r.status === "dirty" || t.value === "dirty" ? DIRTY(r.value) : r;
			}
		}
		if (r.type === "refinement") {
			let executeRefinement = (e) => {
				let t = r.refinement(e, i);
				if (n.common.async) return Promise.resolve(t);
				if (t instanceof Promise) throw Error("Async refinement encountered during synchronous parse operation. Use .parseAsync instead.");
				return e;
			};
			if (n.common.async === !1) {
				let e = this._def.schema._parseSync({
					data: n.data,
					path: n.path,
					parent: n
				});
				return e.status === "aborted" ? p : (e.status === "dirty" && t.dirty(), executeRefinement(e.value), {
					status: t.value,
					value: e.value
				});
			}
			return this._def.schema._parseAsync({
				data: n.data,
				path: n.path,
				parent: n
			}).then((e) => e.status === "aborted" ? p : (e.status === "dirty" && t.dirty(), executeRefinement(e.value).then(() => ({
				status: t.value,
				value: e.value
			}))));
		}
		if (r.type === "transform") {
			if (n.common.async === !1) {
				let e = this._def.schema._parseSync({
					data: n.data,
					path: n.path,
					parent: n
				});
				if (!m(e)) return p;
				let a = r.transform(e.value, i);
				if (a instanceof Promise) throw Error("Asynchronous transform encountered during synchronous parse operation. Use .parseAsync instead.");
				return {
					status: t.value,
					value: a
				};
			}
			return this._def.schema._parseAsync({
				data: n.data,
				path: n.path,
				parent: n
			}).then((e) => m(e) ? Promise.resolve(r.transform(e.value, i)).then((e) => ({
				status: t.value,
				value: e
			})) : p);
		}
		o.assertNever(r);
	}
};
ZodEffects.create = (e, t, n) => new ZodEffects({
	schema: e,
	typeName: S.ZodEffects,
	effect: t,
	...processCreateParams(n)
}), ZodEffects.createWithPreprocess = (e, t, n) => new ZodEffects({
	schema: t,
	effect: {
		type: "preprocess",
		transform: e
	},
	typeName: S.ZodEffects,
	...processCreateParams(n)
});
var ZodOptional = class extends ZodType {
	_parse(e) {
		return this._getType(e) === c.undefined ? OK(void 0) : this._def.innerType._parse(e);
	}
	unwrap() {
		return this._def.innerType;
	}
};
ZodOptional.create = (e, t) => new ZodOptional({
	innerType: e,
	typeName: S.ZodOptional,
	...processCreateParams(t)
});
var ZodNullable = class extends ZodType {
	_parse(e) {
		return this._getType(e) === c.null ? OK(null) : this._def.innerType._parse(e);
	}
	unwrap() {
		return this._def.innerType;
	}
};
ZodNullable.create = (e, t) => new ZodNullable({
	innerType: e,
	typeName: S.ZodNullable,
	...processCreateParams(t)
});
var ZodDefault = class extends ZodType {
	_parse(e) {
		let { ctx: t } = this._processInputParams(e), n = t.data;
		return t.parsedType === c.undefined && (n = this._def.defaultValue()), this._def.innerType._parse({
			data: n,
			path: t.path,
			parent: t
		});
	}
	removeDefault() {
		return this._def.innerType;
	}
};
ZodDefault.create = (e, t) => new ZodDefault({
	innerType: e,
	typeName: S.ZodDefault,
	defaultValue: typeof t.default == "function" ? t.default : () => t.default,
	...processCreateParams(t)
});
var ZodCatch = class extends ZodType {
	_parse(e) {
		let { ctx: t } = this._processInputParams(e), n = {
			...t,
			common: {
				...t.common,
				issues: []
			}
		}, r = this._def.innerType._parse({
			data: n.data,
			path: n.path,
			parent: { ...n }
		});
		return isAsync(r) ? r.then((e) => ({
			status: "valid",
			value: e.status === "valid" ? e.value : this._def.catchValue({
				get error() {
					return new u(n.common.issues);
				},
				input: n.data
			})
		})) : {
			status: "valid",
			value: r.status === "valid" ? r.value : this._def.catchValue({
				get error() {
					return new u(n.common.issues);
				},
				input: n.data
			})
		};
	}
	removeCatch() {
		return this._def.innerType;
	}
};
ZodCatch.create = (e, t) => new ZodCatch({
	innerType: e,
	typeName: S.ZodCatch,
	catchValue: typeof t.catch == "function" ? t.catch : () => t.catch,
	...processCreateParams(t)
});
var ZodNaN = class extends ZodType {
	_parse(e) {
		if (this._getType(e) !== c.nan) {
			let t = this._getOrReturnCtx(e);
			return addIssueToContext(t, {
				code: l.invalid_type,
				expected: c.nan,
				received: t.parsedType
			}), p;
		}
		return {
			status: "valid",
			value: e.data
		};
	}
};
ZodNaN.create = (e) => new ZodNaN({
	typeName: S.ZodNaN,
	...processCreateParams(e)
});
var ZodBranded = class extends ZodType {
	_parse(e) {
		let { ctx: t } = this._processInputParams(e), n = t.data;
		return this._def.type._parse({
			data: n,
			path: t.path,
			parent: t
		});
	}
	unwrap() {
		return this._def.type;
	}
}, we = class ZodPipeline extends ZodType {
	_parse(e) {
		let { status: t, ctx: n } = this._processInputParams(e);
		if (n.common.async) {
			let handleAsync = async () => {
				let e = await this._def.in._parseAsync({
					data: n.data,
					path: n.path,
					parent: n
				});
				return e.status === "aborted" ? p : e.status === "dirty" ? (t.dirty(), DIRTY(e.value)) : this._def.out._parseAsync({
					data: e.value,
					path: n.path,
					parent: n
				});
			};
			return handleAsync();
		}
		{
			let e = this._def.in._parseSync({
				data: n.data,
				path: n.path,
				parent: n
			});
			return e.status === "aborted" ? p : e.status === "dirty" ? (t.dirty(), {
				status: "dirty",
				value: e.value
			}) : this._def.out._parseSync({
				data: e.value,
				path: n.path,
				parent: n
			});
		}
	}
	static create(e, t) {
		return new ZodPipeline({
			in: e,
			out: t,
			typeName: S.ZodPipeline
		});
	}
}, ZodReadonly = class extends ZodType {
	_parse(e) {
		let t = this._def.innerType._parse(e), freeze = (e) => (m(e) && (e.value = Object.freeze(e.value)), e);
		return isAsync(t) ? t.then((e) => freeze(e)) : freeze(t);
	}
	unwrap() {
		return this._def.innerType;
	}
};
ZodReadonly.create = (e, t) => new ZodReadonly({
	innerType: e,
	typeName: S.ZodReadonly,
	...processCreateParams(t)
}), b.lazycreate;
var S;
(function(e) {
	e.ZodString = "ZodString", e.ZodNumber = "ZodNumber", e.ZodNaN = "ZodNaN", e.ZodBigInt = "ZodBigInt", e.ZodBoolean = "ZodBoolean", e.ZodDate = "ZodDate", e.ZodSymbol = "ZodSymbol", e.ZodUndefined = "ZodUndefined", e.ZodNull = "ZodNull", e.ZodAny = "ZodAny", e.ZodUnknown = "ZodUnknown", e.ZodNever = "ZodNever", e.ZodVoid = "ZodVoid", e.ZodArray = "ZodArray", e.ZodObject = "ZodObject", e.ZodUnion = "ZodUnion", e.ZodDiscriminatedUnion = "ZodDiscriminatedUnion", e.ZodIntersection = "ZodIntersection", e.ZodTuple = "ZodTuple", e.ZodRecord = "ZodRecord", e.ZodMap = "ZodMap", e.ZodSet = "ZodSet", e.ZodFunction = "ZodFunction", e.ZodLazy = "ZodLazy", e.ZodLiteral = "ZodLiteral", e.ZodEnum = "ZodEnum", e.ZodEffects = "ZodEffects", e.ZodNativeEnum = "ZodNativeEnum", e.ZodOptional = "ZodOptional", e.ZodNullable = "ZodNullable", e.ZodDefault = "ZodDefault", e.ZodCatch = "ZodCatch", e.ZodPromise = "ZodPromise", e.ZodBranded = "ZodBranded", e.ZodPipeline = "ZodPipeline", e.ZodReadonly = "ZodReadonly";
})(S ||= {});
var C = he.create, w = ge.create;
ZodNaN.create, _e.create;
var T = ZodBoolean.create, Te = ve.create;
ZodSymbol.create, ZodUndefined.create, ZodNull.create, ZodAny.create, ZodUnknown.create, ZodNever.create, ZodVoid.create;
var E = y.create, D = b.create;
b.strictCreate;
var Ee = ZodUnion.create, O = ye.create;
ZodIntersection.create, x.create;
var k = be.create;
ZodMap.create, xe.create, Se.create, ZodLazy.create;
var A = ZodLiteral.create, j = Ce.create;
ZodNativeEnum.create, ZodPromise.create, ZodEffects.create, ZodOptional.create;
var De = ZodNullable.create, Oe = ZodEffects.createWithPreprocess;
we.create;
//#endregion
//#region lib/core/Zod.ts
var customErrorMap = (e, t) => e.code === l.invalid_type ? e.received === "undefined" || e.received === "null" ? { message: "入力は必須です" } : { message: "不正な入力です" } : { message: t.defaultError }, createErrorMessages = (e) => e.error.errors.flatMap(({ path: e, message: t }) => e.map((e) => `${e}: ${t}`)), ke = 7, Ae = C().length(7, { message: "7ケタで入力してください" }).regex(/^[0-9]+$/, { message: "ハイフンを含まない数字で入力してください" }).describe("郵便番号"), je = {
	version: 4,
	country_calling_codes: {
		1: [
			"US",
			"AG",
			"AI",
			"AS",
			"BB",
			"BM",
			"BS",
			"CA",
			"DM",
			"DO",
			"GD",
			"GU",
			"JM",
			"KN",
			"KY",
			"LC",
			"MP",
			"MS",
			"PR",
			"SX",
			"TC",
			"TT",
			"VC",
			"VG",
			"VI"
		],
		7: ["RU", "KZ"],
		20: ["EG"],
		27: ["ZA"],
		30: ["GR"],
		31: ["NL"],
		32: ["BE"],
		33: ["FR"],
		34: ["ES"],
		36: ["HU"],
		39: ["IT", "VA"],
		40: ["RO"],
		41: ["CH"],
		43: ["AT"],
		44: [
			"GB",
			"GG",
			"IM",
			"JE"
		],
		45: ["DK"],
		46: ["SE"],
		47: ["NO", "SJ"],
		48: ["PL"],
		49: ["DE"],
		51: ["PE"],
		52: ["MX"],
		53: ["CU"],
		54: ["AR"],
		55: ["BR"],
		56: ["CL"],
		57: ["CO"],
		58: ["VE"],
		60: ["MY"],
		61: [
			"AU",
			"CC",
			"CX"
		],
		62: ["ID"],
		63: ["PH"],
		64: ["NZ"],
		65: ["SG"],
		66: ["TH"],
		81: ["JP"],
		82: ["KR"],
		84: ["VN"],
		86: ["CN"],
		90: ["TR"],
		91: ["IN"],
		92: ["PK"],
		93: ["AF"],
		94: ["LK"],
		95: ["MM"],
		98: ["IR"],
		211: ["SS"],
		212: ["MA", "EH"],
		213: ["DZ"],
		216: ["TN"],
		218: ["LY"],
		220: ["GM"],
		221: ["SN"],
		222: ["MR"],
		223: ["ML"],
		224: ["GN"],
		225: ["CI"],
		226: ["BF"],
		227: ["NE"],
		228: ["TG"],
		229: ["BJ"],
		230: ["MU"],
		231: ["LR"],
		232: ["SL"],
		233: ["GH"],
		234: ["NG"],
		235: ["TD"],
		236: ["CF"],
		237: ["CM"],
		238: ["CV"],
		239: ["ST"],
		240: ["GQ"],
		241: ["GA"],
		242: ["CG"],
		243: ["CD"],
		244: ["AO"],
		245: ["GW"],
		246: ["IO"],
		247: ["AC"],
		248: ["SC"],
		249: ["SD"],
		250: ["RW"],
		251: ["ET"],
		252: ["SO"],
		253: ["DJ"],
		254: ["KE"],
		255: ["TZ"],
		256: ["UG"],
		257: ["BI"],
		258: ["MZ"],
		260: ["ZM"],
		261: ["MG"],
		262: ["RE", "YT"],
		263: ["ZW"],
		264: ["NA"],
		265: ["MW"],
		266: ["LS"],
		267: ["BW"],
		268: ["SZ"],
		269: ["KM"],
		290: ["SH", "TA"],
		291: ["ER"],
		297: ["AW"],
		298: ["FO"],
		299: ["GL"],
		350: ["GI"],
		351: ["PT"],
		352: ["LU"],
		353: ["IE"],
		354: ["IS"],
		355: ["AL"],
		356: ["MT"],
		357: ["CY"],
		358: ["FI", "AX"],
		359: ["BG"],
		370: ["LT"],
		371: ["LV"],
		372: ["EE"],
		373: ["MD"],
		374: ["AM"],
		375: ["BY"],
		376: ["AD"],
		377: ["MC"],
		378: ["SM"],
		380: ["UA"],
		381: ["RS"],
		382: ["ME"],
		383: ["XK"],
		385: ["HR"],
		386: ["SI"],
		387: ["BA"],
		389: ["MK"],
		420: ["CZ"],
		421: ["SK"],
		423: ["LI"],
		500: ["FK"],
		501: ["BZ"],
		502: ["GT"],
		503: ["SV"],
		504: ["HN"],
		505: ["NI"],
		506: ["CR"],
		507: ["PA"],
		508: ["PM"],
		509: ["HT"],
		590: [
			"GP",
			"BL",
			"MF"
		],
		591: ["BO"],
		592: ["GY"],
		593: ["EC"],
		594: ["GF"],
		595: ["PY"],
		596: ["MQ"],
		597: ["SR"],
		598: ["UY"],
		599: ["CW", "BQ"],
		670: ["TL"],
		672: ["NF"],
		673: ["BN"],
		674: ["NR"],
		675: ["PG"],
		676: ["TO"],
		677: ["SB"],
		678: ["VU"],
		679: ["FJ"],
		680: ["PW"],
		681: ["WF"],
		682: ["CK"],
		683: ["NU"],
		685: ["WS"],
		686: ["KI"],
		687: ["NC"],
		688: ["TV"],
		689: ["PF"],
		690: ["TK"],
		691: ["FM"],
		692: ["MH"],
		850: ["KP"],
		852: ["HK"],
		853: ["MO"],
		855: ["KH"],
		856: ["LA"],
		880: ["BD"],
		886: ["TW"],
		960: ["MV"],
		961: ["LB"],
		962: ["JO"],
		963: ["SY"],
		964: ["IQ"],
		965: ["KW"],
		966: ["SA"],
		967: ["YE"],
		968: ["OM"],
		970: ["PS"],
		971: ["AE"],
		972: ["IL"],
		973: ["BH"],
		974: ["QA"],
		975: ["BT"],
		976: ["MN"],
		977: ["NP"],
		992: ["TJ"],
		993: ["TM"],
		994: ["AZ"],
		995: ["GE"],
		996: ["KG"],
		998: ["UZ"]
	},
	countries: {
		AC: [
			"247",
			"00",
			"(?:[01589]\\d|[2-467])\\d{4}",
			[5, 6]
		],
		AD: [
			"376",
			"00",
			"(?:1|6\\d)\\d{7}|[135-9]\\d{5}",
			[
				6,
				8,
				9
			],
			[
				[
					"(\\d{3})(\\d{3})",
					"$1 $2",
					["[135-9]"]
				],
				[
					"(\\d{4})(\\d{4})",
					"$1 $2",
					["1"]
				],
				[
					"(\\d{3})(\\d{3})(\\d{3})",
					"$1 $2 $3",
					["6"]
				]
			]
		],
		AE: [
			"971",
			"00",
			"(?:[4-7]\\d|9[0-689])\\d{7}|800\\d{2,9}|[2-4679]\\d{7}",
			[
				5,
				6,
				7,
				8,
				9,
				10,
				11,
				12
			],
			[
				[
					"(\\d{3})(\\d{2,9})",
					"$1 $2",
					["60|8"]
				],
				[
					"(\\d)(\\d{3})(\\d{4})",
					"$1 $2 $3",
					["[236]|[479][2-8]"],
					"0$1"
				],
				[
					"(\\d{3})(\\d)(\\d{5})",
					"$1 $2 $3",
					["[479]"]
				],
				[
					"(\\d{2})(\\d{3})(\\d{4})",
					"$1 $2 $3",
					["5"],
					"0$1"
				]
			],
			"0"
		],
		AF: [
			"93",
			"00",
			"[2-7]\\d{8}",
			[9],
			[[
				"(\\d{2})(\\d{3})(\\d{4})",
				"$1 $2 $3",
				["[2-7]"],
				"0$1"
			]],
			"0"
		],
		AG: [
			"1",
			"011",
			"(?:268|[58]\\d\\d|900)\\d{7}",
			[10],
			0,
			"1",
			0,
			"([457]\\d{6})$|1",
			"268$1",
			0,
			"268"
		],
		AI: [
			"1",
			"011",
			"(?:264|[58]\\d\\d|900)\\d{7}",
			[10],
			0,
			"1",
			0,
			"([2457]\\d{6})$|1",
			"264$1",
			0,
			"264"
		],
		AL: [
			"355",
			"00",
			"(?:700\\d\\d|900)\\d{3}|8\\d{5,7}|(?:[2-5]|6\\d)\\d{7}",
			[
				6,
				7,
				8,
				9
			],
			[
				[
					"(\\d{3})(\\d{3,4})",
					"$1 $2",
					["80|9"],
					"0$1"
				],
				[
					"(\\d)(\\d{3})(\\d{4})",
					"$1 $2 $3",
					["4[2-6]"],
					"0$1"
				],
				[
					"(\\d{2})(\\d{3})(\\d{3})",
					"$1 $2 $3",
					["[2358][2-5]|4"],
					"0$1"
				],
				[
					"(\\d{3})(\\d{5})",
					"$1 $2",
					["[23578]"],
					"0$1"
				],
				[
					"(\\d{2})(\\d{3})(\\d{4})",
					"$1 $2 $3",
					["6"],
					"0$1"
				]
			],
			"0"
		],
		AM: [
			"374",
			"00",
			"(?:[1-489]\\d|55|60|77)\\d{6}",
			[8],
			[
				[
					"(\\d{3})(\\d{2})(\\d{3})",
					"$1 $2 $3",
					["[89]0"],
					"0 $1"
				],
				[
					"(\\d{3})(\\d{5})",
					"$1 $2",
					["2|3[12]"],
					"(0$1)"
				],
				[
					"(\\d{2})(\\d{6})",
					"$1 $2",
					["1|47"],
					"(0$1)"
				],
				[
					"(\\d{2})(\\d{6})",
					"$1 $2",
					["[3-9]"],
					"0$1"
				]
			],
			"0"
		],
		AO: [
			"244",
			"00",
			"[29]\\d{8}",
			[9],
			[[
				"(\\d{3})(\\d{3})(\\d{3})",
				"$1 $2 $3",
				["[29]"]
			]]
		],
		AR: [
			"54",
			"00",
			"(?:11|[89]\\d\\d)\\d{8}|[2368]\\d{9}",
			[10, 11],
			[
				[
					"(\\d{4})(\\d{2})(\\d{4})",
					"$1 $2-$3",
					[
						"2(?:2[024-9]|3[0-59]|47|6[245]|9[02-8])|3(?:3[28]|4[03-9]|5[2-46-8]|7[1-578]|8[2-9])",
						"2(?:[23]02|6(?:[25]|4[6-8])|9(?:[02356]|4[02568]|72|8[23]))|3(?:3[28]|4(?:[04679]|3[5-8]|5[4-68]|8[2379])|5(?:[2467]|3[237]|8[2-5])|7[1-578]|8(?:[2469]|3[2578]|5[4-8]|7[36-8]|8[5-8]))|2(?:2[24-9]|3[1-59]|47)",
						"2(?:[23]02|6(?:[25]|4(?:64|[78]))|9(?:[02356]|4(?:[0268]|5[2-6])|72|8[23]))|3(?:3[28]|4(?:[04679]|3[78]|5(?:4[46]|8)|8[2379])|5(?:[2467]|3[237]|8[23])|7[1-578]|8(?:[2469]|3[278]|5[56][46]|86[3-6]))|2(?:2[24-9]|3[1-59]|47)|38(?:[58][78]|7[378])|3(?:4[35][56]|58[45]|8(?:[38]5|54|76))[4-6]",
						"2(?:[23]02|6(?:[25]|4(?:64|[78]))|9(?:[02356]|4(?:[0268]|5[2-6])|72|8[23]))|3(?:3[28]|4(?:[04679]|3(?:5(?:4[0-25689]|[56])|[78])|58|8[2379])|5(?:[2467]|3[237]|8(?:[23]|4(?:[45]|60)|5(?:4[0-39]|5|64)))|7[1-578]|8(?:[2469]|3[278]|54(?:4|5[13-7]|6[89])|86[3-6]))|2(?:2[24-9]|3[1-59]|47)|38(?:[58][78]|7[378])|3(?:454|85[56])[46]|3(?:4(?:36|5[56])|8(?:[38]5|76))[4-6]"
					],
					"0$1",
					1
				],
				[
					"(\\d{2})(\\d{4})(\\d{4})",
					"$1 $2-$3",
					["1"],
					"0$1",
					1
				],
				[
					"(\\d{3})(\\d{3})(\\d{4})",
					"$1-$2-$3",
					["[68]"],
					"0$1"
				],
				[
					"(\\d{3})(\\d{3})(\\d{4})",
					"$1 $2-$3",
					["[23]"],
					"0$1",
					1
				],
				[
					"(\\d)(\\d{4})(\\d{2})(\\d{4})",
					"$2 15-$3-$4",
					[
						"9(?:2[2-469]|3[3-578])",
						"9(?:2(?:2[024-9]|3[0-59]|47|6[245]|9[02-8])|3(?:3[28]|4[03-9]|5[2-46-8]|7[1-578]|8[2-9]))",
						"9(?:2(?:[23]02|6(?:[25]|4[6-8])|9(?:[02356]|4[02568]|72|8[23]))|3(?:3[28]|4(?:[04679]|3[5-8]|5[4-68]|8[2379])|5(?:[2467]|3[237]|8[2-5])|7[1-578]|8(?:[2469]|3[2578]|5[4-8]|7[36-8]|8[5-8])))|92(?:2[24-9]|3[1-59]|47)",
						"9(?:2(?:[23]02|6(?:[25]|4(?:64|[78]))|9(?:[02356]|4(?:[0268]|5[2-6])|72|8[23]))|3(?:3[28]|4(?:[04679]|3[78]|5(?:4[46]|8)|8[2379])|5(?:[2467]|3[237]|8[23])|7[1-578]|8(?:[2469]|3[278]|5(?:[56][46]|[78])|7[378]|8(?:6[3-6]|[78]))))|92(?:2[24-9]|3[1-59]|47)|93(?:4[35][56]|58[45]|8(?:[38]5|54|76))[4-6]",
						"9(?:2(?:[23]02|6(?:[25]|4(?:64|[78]))|9(?:[02356]|4(?:[0268]|5[2-6])|72|8[23]))|3(?:3[28]|4(?:[04679]|3(?:5(?:4[0-25689]|[56])|[78])|5(?:4[46]|8)|8[2379])|5(?:[2467]|3[237]|8(?:[23]|4(?:[45]|60)|5(?:4[0-39]|5|64)))|7[1-578]|8(?:[2469]|3[278]|5(?:4(?:4|5[13-7]|6[89])|[56][46]|[78])|7[378]|8(?:6[3-6]|[78]))))|92(?:2[24-9]|3[1-59]|47)|93(?:4(?:36|5[56])|8(?:[38]5|76))[4-6]"
					],
					"0$1",
					0,
					"$1 $2 $3-$4"
				],
				[
					"(\\d)(\\d{2})(\\d{4})(\\d{4})",
					"$2 15-$3-$4",
					["91"],
					"0$1",
					0,
					"$1 $2 $3-$4"
				],
				[
					"(\\d{3})(\\d{3})(\\d{5})",
					"$1-$2-$3",
					["8"],
					"0$1"
				],
				[
					"(\\d)(\\d{3})(\\d{3})(\\d{4})",
					"$2 15-$3-$4",
					["9"],
					"0$1",
					0,
					"$1 $2 $3-$4"
				]
			],
			"0",
			0,
			"0?(?:(11|2(?:2(?:02?|[13]|2[13-79]|4[1-6]|5[2457]|6[124-8]|7[1-4]|8[13-6]|9[1267])|3(?:02?|1[467]|2[03-6]|3[13-8]|[49][2-6]|5[2-8]|[67])|4(?:7[3-578]|9)|6(?:[0136]|2[24-6]|4[6-8]?|5[15-8])|80|9(?:0[1-3]|[19]|2\\d|3[1-6]|4[02568]?|5[2-4]|6[2-46]|72?|8[23]?))|3(?:3(?:2[79]|6|8[2578])|4(?:0[0-24-9]|[12]|3[5-8]?|4[24-7]|5[4-68]?|6[02-9]|7[126]|8[2379]?|9[1-36-8])|5(?:1|2[1245]|3[237]?|4[1-46-9]|6[2-4]|7[1-6]|8[2-5]?)|6[24]|7(?:[069]|1[1568]|2[15]|3[145]|4[13]|5[14-8]|7[2-57]|8[126])|8(?:[01]|2[15-7]|3[2578]?|4[13-6]|5[4-8]?|6[1-357-9]|7[36-8]?|8[5-8]?|9[124])))15)?",
			"9$1"
		],
		AS: [
			"1",
			"011",
			"(?:[58]\\d\\d|684|900)\\d{7}",
			[10],
			0,
			"1",
			0,
			"([267]\\d{6})$|1",
			"684$1",
			0,
			"684"
		],
		AT: [
			"43",
			"00",
			"1\\d{3,12}|2\\d{6,12}|43(?:(?:0\\d|5[02-9])\\d{3,9}|2\\d{4,5}|[3467]\\d{4}|8\\d{4,6}|9\\d{4,7})|5\\d{4,12}|8\\d{7,12}|9\\d{8,12}|(?:[367]\\d|4[0-24-9])\\d{4,11}",
			[
				4,
				5,
				6,
				7,
				8,
				9,
				10,
				11,
				12,
				13
			],
			[
				[
					"(\\d)(\\d{3,12})",
					"$1 $2",
					["1(?:11|[2-9])"],
					"0$1"
				],
				[
					"(\\d{3})(\\d{2})",
					"$1 $2",
					["517"],
					"0$1"
				],
				[
					"(\\d{2})(\\d{3,5})",
					"$1 $2",
					["5[079]"],
					"0$1"
				],
				[
					"(\\d{3})(\\d{3,10})",
					"$1 $2",
					["(?:31|4)6|51|6(?:48|5[0-3579]|[6-9])|7(?:20|32|8)|[89]", "(?:31|4)6|51|6(?:485|5[0-3579]|[6-9])|7(?:20|32|8)|[89]"],
					"0$1"
				],
				[
					"(\\d{4})(\\d{3,9})",
					"$1 $2",
					["[2-467]|5[2-6]"],
					"0$1"
				],
				[
					"(\\d{2})(\\d{3})(\\d{3,4})",
					"$1 $2 $3",
					["5"],
					"0$1"
				],
				[
					"(\\d{2})(\\d{4})(\\d{4,7})",
					"$1 $2 $3",
					["5"],
					"0$1"
				]
			],
			"0"
		],
		AU: [
			"61",
			"001[14-689]|14(?:1[14]|34|4[17]|[56]6|7[47]|88)0011",
			"1(?:[0-79]\\d{7}(?:\\d(?:\\d{2})?)?|8[0-24-9]\\d{7})|[2-478]\\d{8}|1\\d{4,7}",
			[
				5,
				6,
				7,
				8,
				9,
				10,
				12
			],
			[
				[
					"(\\d{2})(\\d{3,4})",
					"$1 $2",
					["16"],
					"0$1"
				],
				[
					"(\\d{2})(\\d{3})(\\d{2,4})",
					"$1 $2 $3",
					["16"],
					"0$1"
				],
				[
					"(\\d{3})(\\d{3})(\\d{3})",
					"$1 $2 $3",
					["14|4"],
					"0$1"
				],
				[
					"(\\d)(\\d{4})(\\d{4})",
					"$1 $2 $3",
					["[2378]"],
					"(0$1)"
				],
				[
					"(\\d{4})(\\d{3})(\\d{3})",
					"$1 $2 $3",
					["1(?:30|[89])"]
				]
			],
			"0",
			0,
			"(183[12])|0",
			0,
			0,
			0,
			[
				["(?:(?:241|349)0\\d\\d|8(?:51(?:0(?:0[03-9]|[12479]\\d|3[2-9]|5[0-8]|6[1-9]|8[0-7])|1(?:[0235689]\\d|1[0-69]|4[0-589]|7[0-47-9])|2(?:0[0-79]|[18][13579]|2[14-9]|3[0-46-9]|[4-6]\\d|7[89]|9[0-4])|[34]\\d\\d)|91(?:(?:[0-58]\\d|6[0135-9])\\d|7(?:0[0-24-9]|[1-9]\\d)|9(?:[0-46-9]\\d|5[0-79]))))\\d{3}|(?:2(?:[0-26-9]\\d|3[0-8]|4[02-9]|5[0135-9])|3(?:[0-3589]\\d|4[0-578]|6[1-9]|7[0-35-9])|7(?:[013-57-9]\\d|2[0-8])|8(?:55|6[0-8]|[78]\\d|9[02-9]))\\d{6}", [9]],
				["4(?:79[01]|83[0-36-9]|95[0-3])\\d{5}|4(?:[0-36]\\d|4[047-9]|[58][0-24-9]|7[02-8]|9[0-47-9])\\d{6}", [9]],
				["180(?:0\\d{3}|2)\\d{3}", [7, 10]],
				["190[0-26]\\d{6}", [10]],
				0,
				0,
				0,
				["163\\d{2,6}", [
					5,
					6,
					7,
					8,
					9
				]],
				["14(?:5(?:1[0458]|[23][458])|71\\d)\\d{4}", [9]],
				["13(?:00\\d{6}(?:\\d{2})?|45[0-4]\\d{3})|13\\d{4}", [
					6,
					8,
					10,
					12
				]]
			],
			"0011"
		],
		AW: [
			"297",
			"00",
			"(?:[25-79]\\d\\d|800)\\d{4}",
			[7],
			[[
				"(\\d{3})(\\d{4})",
				"$1 $2",
				["[25-9]"]
			]]
		],
		AX: [
			"358",
			"00|99(?:[01469]|5(?:[14]1|3[23]|5[59]|77|88|9[09]))",
			"2\\d{4,9}|35\\d{4,5}|(?:60\\d\\d|800)\\d{4,6}|7\\d{5,11}|(?:[14]\\d|3[0-46-9]|50)\\d{4,8}",
			[
				5,
				6,
				7,
				8,
				9,
				10,
				11,
				12
			],
			0,
			"0",
			0,
			0,
			0,
			0,
			"18",
			0,
			"00"
		],
		AZ: [
			"994",
			"00",
			"365\\d{6}|(?:[124579]\\d|60|88)\\d{7}",
			[9],
			[
				[
					"(\\d{3})(\\d{2})(\\d{2})(\\d{2})",
					"$1 $2 $3 $4",
					["90"],
					"0$1"
				],
				[
					"(\\d{2})(\\d{3})(\\d{2})(\\d{2})",
					"$1 $2 $3 $4",
					[
						"1[28]|2|365|46",
						"1[28]|2|365[45]|46",
						"1[28]|2|365(?:4|5[02])|46"
					],
					"(0$1)"
				],
				[
					"(\\d{2})(\\d{3})(\\d{2})(\\d{2})",
					"$1 $2 $3 $4",
					["[13-9]"],
					"0$1"
				]
			],
			"0"
		],
		BA: [
			"387",
			"00",
			"6\\d{8}|(?:[35689]\\d|49|70)\\d{6}",
			[8, 9],
			[
				[
					"(\\d{2})(\\d{3})(\\d{3})",
					"$1 $2 $3",
					["6[1-3]|[7-9]"],
					"0$1"
				],
				[
					"(\\d{2})(\\d{3})(\\d{3})",
					"$1 $2-$3",
					["[3-5]|6[56]"],
					"0$1"
				],
				[
					"(\\d{2})(\\d{2})(\\d{2})(\\d{3})",
					"$1 $2 $3 $4",
					["6"],
					"0$1"
				]
			],
			"0"
		],
		BB: [
			"1",
			"011",
			"(?:246|[58]\\d\\d|900)\\d{7}",
			[10],
			0,
			"1",
			0,
			"([2-9]\\d{6})$|1",
			"246$1",
			0,
			"246"
		],
		BD: [
			"880",
			"00",
			"[1-469]\\d{9}|8[0-79]\\d{7,8}|[2-79]\\d{8}|[2-9]\\d{7}|[3-9]\\d{6}|[57-9]\\d{5}",
			[
				6,
				7,
				8,
				9,
				10
			],
			[
				[
					"(\\d{2})(\\d{4,6})",
					"$1-$2",
					["31[5-8]|[459]1"],
					"0$1"
				],
				[
					"(\\d{3})(\\d{3,7})",
					"$1-$2",
					["3(?:[67]|8[013-9])|4(?:6[168]|7|[89][18])|5(?:6[128]|9)|6(?:[15]|28)|7[2-589]|8(?:0[014-9]|[12])|9[358]|(?:3[2-5]|4[235]|5[2-578]|6[0389]|76|8[3-7]|9[24])1|(?:44|66)[01346-9]"],
					"0$1"
				],
				[
					"(\\d{4})(\\d{3,6})",
					"$1-$2",
					["[13-9]|2[23]"],
					"0$1"
				],
				[
					"(\\d)(\\d{7,8})",
					"$1-$2",
					["2"],
					"0$1"
				]
			],
			"0"
		],
		BE: [
			"32",
			"00",
			"4\\d{8}|[1-9]\\d{7}",
			[8, 9],
			[
				[
					"(\\d{3})(\\d{2})(\\d{3})",
					"$1 $2 $3",
					["(?:80|9)0"],
					"0$1"
				],
				[
					"(\\d)(\\d{3})(\\d{2})(\\d{2})",
					"$1 $2 $3 $4",
					["[239]|4[23]"],
					"0$1"
				],
				[
					"(\\d{2})(\\d{2})(\\d{2})(\\d{2})",
					"$1 $2 $3 $4",
					["[15-8]"],
					"0$1"
				],
				[
					"(\\d{3})(\\d{2})(\\d{2})(\\d{2})",
					"$1 $2 $3 $4",
					["4"],
					"0$1"
				]
			],
			"0"
		],
		BF: [
			"226",
			"00",
			"[024-7]\\d{7}",
			[8],
			[[
				"(\\d{2})(\\d{2})(\\d{2})(\\d{2})",
				"$1 $2 $3 $4",
				["[024-7]"]
			]]
		],
		BG: [
			"359",
			"00",
			"00800\\d{7}|[2-7]\\d{6,7}|[89]\\d{6,8}|2\\d{5}",
			[
				6,
				7,
				8,
				9,
				12
			],
			[
				[
					"(\\d)(\\d)(\\d{2})(\\d{2})",
					"$1 $2 $3 $4",
					["2"],
					"0$1"
				],
				[
					"(\\d{3})(\\d{4})",
					"$1 $2",
					["43[1-6]|70[1-9]"],
					"0$1"
				],
				[
					"(\\d)(\\d{3})(\\d{3,4})",
					"$1 $2 $3",
					["2"],
					"0$1"
				],
				[
					"(\\d{2})(\\d{3})(\\d{2,3})",
					"$1 $2 $3",
					["[356]|4[124-7]|7[1-9]|8[1-6]|9[1-7]"],
					"0$1"
				],
				[
					"(\\d{3})(\\d{2})(\\d{3})",
					"$1 $2 $3",
					["(?:70|8)0"],
					"0$1"
				],
				[
					"(\\d{3})(\\d{3})(\\d{2})",
					"$1 $2 $3",
					["43[1-7]|7"],
					"0$1"
				],
				[
					"(\\d{2})(\\d{3})(\\d{3,4})",
					"$1 $2 $3",
					["[48]|9[08]"],
					"0$1"
				],
				[
					"(\\d{3})(\\d{3})(\\d{3})",
					"$1 $2 $3",
					["9"],
					"0$1"
				]
			],
			"0"
		],
		BH: [
			"973",
			"00",
			"[136-9]\\d{7}",
			[8],
			[[
				"(\\d{4})(\\d{4})",
				"$1 $2",
				["[13679]|8[02-4679]"]
			]]
		],
		BI: [
			"257",
			"00",
			"(?:[267]\\d|31)\\d{6}",
			[8],
			[[
				"(\\d{2})(\\d{2})(\\d{2})(\\d{2})",
				"$1 $2 $3 $4",
				["[2367]"]
			]]
		],
		BJ: [
			"229",
			"00",
			"(?:01\\d|8)\\d{7}",
			[8, 10],
			[[
				"(\\d{2})(\\d{2})(\\d{2})(\\d{2})",
				"$1 $2 $3 $4",
				["8"]
			], [
				"(\\d{2})(\\d{2})(\\d{2})(\\d{2})(\\d{2})",
				"$1 $2 $3 $4 $5",
				["0"]
			]]
		],
		BL: [
			"590",
			"00",
			"7090\\d{5}|(?:[56]9|[89]\\d)\\d{7}",
			[9],
			0,
			"0",
			0,
			0,
			0,
			0,
			0,
			[
				["(?:59(?:0(?:2[7-9]|3[3-7]|5[12]|87)|87\\d)|80[6-9]\\d\\d)\\d{4}"],
				["(?:69(?:0\\d\\d|1(?:2[2-9]|3[0-5]))|7090[0-4])\\d{4}"],
				["80[0-5]\\d{6}"],
				["8[129]\\d{7}"],
				0,
				0,
				0,
				0,
				["9(?:(?:39[5-7]|76[018])\\d|475[0-6])\\d{4}"]
			]
		],
		BM: [
			"1",
			"011",
			"(?:441|[58]\\d\\d|900)\\d{7}",
			[10],
			0,
			"1",
			0,
			"([2-9]\\d{6})$|1",
			"441$1",
			0,
			"441"
		],
		BN: [
			"673",
			"00",
			"[2-578]\\d{6}",
			[7],
			[[
				"(\\d{3})(\\d{4})",
				"$1 $2",
				["[2-578]"]
			]]
		],
		BO: [
			"591",
			"00(?:1\\d)?",
			"(?:[2-7]\\d\\d|8001)\\d{5}",
			[8, 9],
			[
				[
					"(\\d)(\\d{7})",
					"$1 $2",
					["[23]|4[46]|50"]
				],
				[
					"(\\d{8})",
					"$1",
					["[5-7]"]
				],
				[
					"(\\d{3})(\\d{2})(\\d{4})",
					"$1 $2 $3",
					["8"]
				]
			],
			"0",
			0,
			"0(1\\d)?"
		],
		BQ: [
			"599",
			"00",
			"(?:[34]1|7\\d)\\d{5}",
			[7],
			0,
			0,
			0,
			0,
			0,
			0,
			"[347]"
		],
		BR: [
			"55",
			"00(?:1[245]|2[1-35]|31|4[13]|[56]5|99)",
			"[1-467]\\d{9,10}|55[0-46-9]\\d{8}|[34]\\d{7}|55\\d{7,8}|(?:5[0-46-9]|[89]\\d)\\d{7,9}",
			[
				8,
				9,
				10,
				11
			],
			[
				[
					"(\\d{4})(\\d{4})",
					"$1-$2",
					["300|4(?:0[02]|37|86)", "300|4(?:0(?:0|20)|370|864)"]
				],
				[
					"(\\d{3})(\\d{2,3})(\\d{4})",
					"$1 $2 $3",
					["(?:[358]|90)0"],
					"0$1"
				],
				[
					"(\\d{2})(\\d{4})(\\d{4})",
					"$1 $2-$3",
					["(?:[14689][1-9]|2[12478]|3[1-578]|5[13-5]|7[13-579])[2-57]"],
					"($1)"
				],
				[
					"(\\d{2})(\\d{5})(\\d{4})",
					"$1 $2-$3",
					["[16][1-9]|[2-57-9]"],
					"($1)"
				]
			],
			"0",
			0,
			"(?:0|90)(?:(1[245]|2[1-35]|31|4[13]|[56]5|99)(\\d{10,11}))?",
			"$2"
		],
		BS: [
			"1",
			"011",
			"(?:242|[58]\\d\\d|900)\\d{7}",
			[10],
			0,
			"1",
			0,
			"([3-8]\\d{6})$|1",
			"242$1",
			0,
			"242"
		],
		BT: [
			"975",
			"00",
			"[178]\\d{7}|[2-8]\\d{6}",
			[7, 8],
			[[
				"(\\d)(\\d{3})(\\d{3})",
				"$1 $2 $3",
				["[2-6]|7[246]|8[2-4]"]
			], [
				"(\\d{2})(\\d{2})(\\d{2})(\\d{2})",
				"$1 $2 $3 $4",
				["1[67]|[78]"]
			]]
		],
		BW: [
			"267",
			"00",
			"(?:0800|(?:[37]|800)\\d)\\d{6}|(?:[2-6]\\d|90)\\d{5}",
			[
				7,
				8,
				10
			],
			[
				[
					"(\\d{2})(\\d{5})",
					"$1 $2",
					["90"]
				],
				[
					"(\\d{3})(\\d{4})",
					"$1 $2",
					["[24-6]|3[15-9]"]
				],
				[
					"(\\d{2})(\\d{3})(\\d{3})",
					"$1 $2 $3",
					["[37]"]
				],
				[
					"(\\d{4})(\\d{3})(\\d{3})",
					"$1 $2 $3",
					["0"]
				],
				[
					"(\\d{3})(\\d{4})(\\d{3})",
					"$1 $2 $3",
					["8"]
				]
			]
		],
		BY: [
			"375",
			"810",
			"(?:[12]\\d|33|44|902)\\d{7}|8(?:0[0-79]\\d{5,7}|[1-7]\\d{9})|8(?:1[0-489]|[5-79]\\d)\\d{7}|8[1-79]\\d{6,7}|8[0-79]\\d{5}|8\\d{5}",
			[
				6,
				7,
				8,
				9,
				10,
				11
			],
			[
				[
					"(\\d{3})(\\d{3})",
					"$1 $2",
					["800"],
					"8 $1"
				],
				[
					"(\\d{3})(\\d{2})(\\d{2,4})",
					"$1 $2 $3",
					["800"],
					"8 $1"
				],
				[
					"(\\d{4})(\\d{2})(\\d{3})",
					"$1 $2-$3",
					["1(?:5[169]|6[3-5]|7[179])|2(?:1[35]|2[34]|3[3-5])", "1(?:5[169]|6(?:3[1-3]|4|5[125])|7(?:1[3-9]|7[0-24-6]|9[2-7]))|2(?:1[35]|2[34]|3[3-5])"],
					"8 0$1"
				],
				[
					"(\\d{3})(\\d{2})(\\d{2})(\\d{2})",
					"$1 $2-$3-$4",
					["1(?:[56]|7[467])|2[1-3]"],
					"8 0$1"
				],
				[
					"(\\d{2})(\\d{3})(\\d{2})(\\d{2})",
					"$1 $2-$3-$4",
					["[1-4]"],
					"8 0$1"
				],
				[
					"(\\d{3})(\\d{3,4})(\\d{4})",
					"$1 $2 $3",
					["[89]"],
					"8 $1"
				]
			],
			"8",
			0,
			"0|80?",
			0,
			0,
			0,
			0,
			"8~10"
		],
		BZ: [
			"501",
			"00",
			"(?:0800\\d|[2-8])\\d{6}",
			[7, 11],
			[[
				"(\\d{3})(\\d{4})",
				"$1-$2",
				["[2-8]"]
			], [
				"(\\d)(\\d{3})(\\d{4})(\\d{3})",
				"$1-$2-$3-$4",
				["0"]
			]]
		],
		CA: [
			"1",
			"011",
			"[2-9]\\d{9}|3\\d{6}",
			[7, 10],
			0,
			"1",
			0,
			0,
			0,
			0,
			0,
			[
				["(?:2(?:04|[23]6|[48]9|5[07]|[67]3)|3(?:06|43|54|6[578]|82)|4(?:03|1[68]|[26]8|3[178]|50|74)|5(?:06|1[49]|48|79|8[147])|6(?:04|[18]3|39|47|72)|7(?:0[59]|42|53|78|8[02])|8(?:[06]7|19|25|7[39])|9(?:0[25]|42))[2-9]\\d{6}", [10]],
				["", [10]],
				["8(?:00|33|44|55|66|77|88)[2-9]\\d{6}", [10]],
				["900[2-9]\\d{6}", [10]],
				["52(?:3(?:[2-46-9][02-9]\\d|5(?:[02-46-9]\\d|5[0-46-9]))|4(?:[2-478][02-9]\\d|5(?:[034]\\d|2[024-9]|5[0-46-9])|6(?:0[1-9]|[2-9]\\d)|9(?:[05-9]\\d|2[0-5]|49)))\\d{4}|52[34][2-9]1[02-9]\\d{4}|(?:5(?:2[125-9]|3[23]|44|66|77|88)|6(?:22|33))[2-9]\\d{6}", [10]],
				0,
				["310\\d{4}", [7]],
				0,
				["600[2-9]\\d{6}", [10]]
			]
		],
		CC: [
			"61",
			"001[14-689]|14(?:1[14]|34|4[17]|[56]6|7[47]|88)0011",
			"1(?:[0-79]\\d{8}(?:\\d{2})?|8[0-24-9]\\d{7})|[148]\\d{8}|1\\d{5,7}",
			[
				6,
				7,
				8,
				9,
				10,
				12
			],
			0,
			"0",
			0,
			"([59]\\d{7})$|0",
			"8$1",
			0,
			0,
			[
				["8(?:51(?:0(?:02|31|60|89)|1(?:18|76)|223)|91(?:0(?:1[0-2]|29)|1(?:[28]2|50|79)|2(?:10|64)|3(?:[06]8|22)|4[29]8|62\\d|70[23]|959))\\d{3}", [9]],
				["4(?:79[01]|83[0-36-9]|95[0-3])\\d{5}|4(?:[0-36]\\d|4[047-9]|[58][0-24-9]|7[02-8]|9[0-47-9])\\d{6}", [9]],
				["180(?:0\\d{3}|2)\\d{3}", [7, 10]],
				["190[0-26]\\d{6}", [10]],
				0,
				0,
				0,
				0,
				["14(?:5(?:1[0458]|[23][458])|71\\d)\\d{4}", [9]],
				["13(?:00\\d{6}(?:\\d{2})?|45[0-4]\\d{3})|13\\d{4}", [
					6,
					8,
					10,
					12
				]]
			],
			"0011"
		],
		CD: [
			"243",
			"00",
			"(?:(?:[189]|5\\d)\\d|2)\\d{7}|[1-68]\\d{6}",
			[
				7,
				8,
				9,
				10
			],
			[
				[
					"(\\d{2})(\\d{2})(\\d{3})",
					"$1 $2 $3",
					["88"],
					"0$1"
				],
				[
					"(\\d{2})(\\d{5})",
					"$1 $2",
					["[1-6]"],
					"0$1"
				],
				[
					"(\\d{2})(\\d{2})(\\d{4})",
					"$1 $2 $3",
					["2"],
					"0$1"
				],
				[
					"(\\d{2})(\\d{3})(\\d{4})",
					"$1 $2 $3",
					["1"],
					"0$1"
				],
				[
					"(\\d{3})(\\d{3})(\\d{3})",
					"$1 $2 $3",
					["[89]"],
					"0$1"
				],
				[
					"(\\d{2})(\\d{2})(\\d{3})(\\d{3})",
					"$1 $2 $3 $4",
					["5"],
					"0$1"
				]
			],
			"0"
		],
		CF: [
			"236",
			"00",
			"8776\\d{4}|(?:[27]\\d|61)\\d{6}",
			[8],
			[[
				"(\\d{2})(\\d{2})(\\d{2})(\\d{2})",
				"$1 $2 $3 $4",
				["[26-8]"]
			]]
		],
		CG: [
			"242",
			"00",
			"222\\d{6}|(?:0\\d|80)\\d{7}",
			[9],
			[[
				"(\\d)(\\d{4})(\\d{4})",
				"$1 $2 $3",
				["8"]
			], [
				"(\\d{2})(\\d{3})(\\d{4})",
				"$1 $2 $3",
				["[02]"]
			]]
		],
		CH: [
			"41",
			"00",
			"8\\d{11}|[2-9]\\d{8}",
			[9, 12],
			[
				[
					"(\\d{3})(\\d{3})(\\d{3})",
					"$1 $2 $3",
					["8[047]|90"],
					"0$1"
				],
				[
					"(\\d{2})(\\d{3})(\\d{2})(\\d{2})",
					"$1 $2 $3 $4",
					["[2-79]|81"],
					"0$1"
				],
				[
					"(\\d{3})(\\d{2})(\\d{3})(\\d{2})(\\d{2})",
					"$1 $2 $3 $4 $5",
					["8"],
					"0$1"
				]
			],
			"0"
		],
		CI: [
			"225",
			"00",
			"[02]\\d{9}",
			[10],
			[[
				"(\\d{2})(\\d{2})(\\d)(\\d{5})",
				"$1 $2 $3 $4",
				["2"]
			], [
				"(\\d{2})(\\d{2})(\\d{2})(\\d{4})",
				"$1 $2 $3 $4",
				["0"]
			]]
		],
		CK: [
			"682",
			"00",
			"[2-578]\\d{4}",
			[5],
			[[
				"(\\d{2})(\\d{3})",
				"$1 $2",
				["[2-578]"]
			]]
		],
		CL: [
			"56",
			"(?:0|1(?:1[0-69]|2[02-5]|5[13-58]|69|7[0167]|8[018]))0",
			"12300\\d{6}|6\\d{9,10}|[2-9]\\d{8}",
			[
				9,
				10,
				11
			],
			[
				[
					"(\\d{5})(\\d{4})",
					"$1 $2",
					["219", "2196"],
					"($1)"
				],
				[
					"(\\d{3})(\\d{3})(\\d{3})",
					"$1 $2 $3",
					["60|809"]
				],
				[
					"(\\d{2})(\\d{3})(\\d{4})",
					"$1 $2 $3",
					["44"]
				],
				[
					"(\\d)(\\d{4})(\\d{4})",
					"$1 $2 $3",
					["2[1-36]"],
					"($1)"
				],
				[
					"(\\d)(\\d{4})(\\d{4})",
					"$1 $2 $3",
					["9(?:10|[2-9])"]
				],
				[
					"(\\d{2})(\\d{3})(\\d{4})",
					"$1 $2 $3",
					["3[2-5]|[47]|5[1-3578]|6[13-57]|8(?:0[1-8]|[1-9])"],
					"($1)"
				],
				[
					"(\\d{3})(\\d{3})(\\d{3,4})",
					"$1 $2 $3",
					["60|8"]
				],
				[
					"(\\d{4})(\\d{3})(\\d{4})",
					"$1 $2 $3",
					["1"]
				],
				[
					"(\\d{3})(\\d{3})(\\d{2})(\\d{3})",
					"$1 $2 $3 $4",
					["60"]
				]
			]
		],
		CM: [
			"237",
			"00",
			"[26]\\d{8}|88\\d{6,7}",
			[8, 9],
			[[
				"(\\d{2})(\\d{2})(\\d{2})(\\d{2})",
				"$1 $2 $3 $4",
				["88"]
			], [
				"(\\d)(\\d{2})(\\d{2})(\\d{2})(\\d{2})",
				"$1 $2 $3 $4 $5",
				["[26]|88"]
			]]
		],
		CN: [
			"86",
			"00|1(?:[12]\\d|79)\\d\\d00",
			"(?:(?:1[03-689]|2\\d)\\d\\d|6)\\d{8}|1\\d{10}|[126]\\d{6}(?:\\d(?:\\d{2})?)?|86\\d{5,6}|(?:[3-579]\\d|8[0-57-9])\\d{5,9}",
			[
				7,
				8,
				9,
				10,
				11,
				12
			],
			[
				[
					"(\\d{2})(\\d{5,6})",
					"$1 $2",
					[
						"(?:10|2[0-57-9])[19]|3(?:[157]|35|49|9[1-68])|4(?:1[124-9]|2[179]|6[47-9]|7|8[23])|5(?:[1357]|2[37]|4[36]|6[1-46]|80)|6(?:3[1-5]|6[0238]|9[12])|7(?:01|[1579]|2[248]|3[014-9]|4[3-6]|6[023689])|8(?:07|1[236-8]|2[5-7]|[37]|8[36-8]|9[1-8])|9(?:0[1-3689]|1[1-79]|3|4[13]|5[1-5]|7[0-79]|9[0-35-9])|(?:4[35]|59|85)[1-9]",
						"(?:10|2[0-57-9])(?:1[02]|9[56])|8078|(?:3(?:[157]\\d|35|49|9[1-68])|4(?:1[124-9]|2[179]|[35][1-9]|6[47-9]|7\\d|8[23])|5(?:[1357]\\d|2[37]|4[36]|6[1-46]|80|9[1-9])|6(?:3[1-5]|6[0238]|9[12])|7(?:01|[1579]\\d|2[248]|3[014-9]|4[3-6]|6[023689])|8(?:1[236-8]|2[5-7]|[37]\\d|5[1-9]|8[36-8]|9[1-8])|9(?:0[1-3689]|1[1-79]|3\\d|4[13]|5[1-5]|7[0-79]|9[0-35-9]))1",
						"10(?:1(?:0|23)|9[56])|2[0-57-9](?:1(?:00|23)|9[56])|80781|(?:3(?:[157]\\d|35|49|9[1-68])|4(?:1[124-9]|2[179]|[35][1-9]|6[47-9]|7\\d|8[23])|5(?:[1357]\\d|2[37]|4[36]|6[1-46]|80|9[1-9])|6(?:3[1-5]|6[0238]|9[12])|7(?:01|[1579]\\d|2[248]|3[014-9]|4[3-6]|6[023689])|8(?:1[236-8]|2[5-7]|[37]\\d|5[1-9]|8[36-8]|9[1-8])|9(?:0[1-3689]|1[1-79]|3\\d|4[13]|5[1-5]|7[0-79]|9[0-35-9]))12",
						"10(?:1(?:0|23)|9[56])|2[0-57-9](?:1(?:00|23)|9[56])|807812|(?:3(?:[157]\\d|35|49|9[1-68])|4(?:1[124-9]|2[179]|[35][1-9]|6[47-9]|7\\d|8[23])|5(?:[1357]\\d|2[37]|4[36]|6[1-46]|80|9[1-9])|6(?:3[1-5]|6[0238]|9[12])|7(?:01|[1579]\\d|2[248]|3[014-9]|4[3-6]|6[023689])|8(?:1[236-8]|2[5-7]|[37]\\d|5[1-9]|8[36-8]|9[1-8])|9(?:0[1-3689]|1[1-79]|3\\d|4[13]|5[1-5]|7[0-79]|9[0-35-9]))123",
						"10(?:1(?:0|23)|9[56])|2[0-57-9](?:1(?:00|23)|9[56])|(?:3(?:[157]\\d|35|49|9[1-68])|4(?:1[124-9]|2[179]|[35][1-9]|6[47-9]|7\\d|8[23])|5(?:[1357]\\d|2[37]|4[36]|6[1-46]|80|9[1-9])|6(?:3[1-5]|6[0238]|9[12])|7(?:01|[1579]\\d|2[248]|3[014-9]|4[3-6]|6[023689])|8(?:078|1[236-8]|2[5-7]|[37]\\d|5[1-9]|8[36-8]|9[1-8])|9(?:0[1-3689]|1[1-79]|3\\d|4[13]|5[1-5]|7[0-79]|9[0-35-9]))123"
					],
					"0$1"
				],
				[
					"(\\d{3})(\\d{5,6})",
					"$1 $2",
					[
						"3(?:[157]|35|49|9[1-68])|4(?:[17]|2[179]|6[47-9]|8[23])|5(?:[1357]|2[37]|4[36]|6[1-46]|80)|6(?:3[1-5]|6[0238]|9[12])|7(?:01|[1579]|2[248]|3[014-9]|4[3-6]|6[023689])|8(?:1[236-8]|2[5-7]|[37]|8[36-8]|9[1-8])|9(?:0[1-3689]|1[1-79]|[379]|4[13]|5[1-5])|(?:4[35]|59|85)[1-9]",
						"(?:3(?:[157]\\d|35|49|9[1-68])|4(?:[17]\\d|2[179]|[35][1-9]|6[47-9]|8[23])|5(?:[1357]\\d|2[37]|4[36]|6[1-46]|80|9[1-9])|6(?:3[1-5]|6[0238]|9[12])|7(?:01|[1579]\\d|2[248]|3[014-9]|4[3-6]|6[023689])|8(?:1[236-8]|2[5-7]|[37]\\d|5[1-9]|8[36-8]|9[1-8])|9(?:0[1-3689]|1[1-79]|[379]\\d|4[13]|5[1-5]))[19]",
						"85[23](?:10|95)|(?:3(?:[157]\\d|35|49|9[1-68])|4(?:[17]\\d|2[179]|[35][1-9]|6[47-9]|8[23])|5(?:[1357]\\d|2[37]|4[36]|6[1-46]|80|9[1-9])|6(?:3[1-5]|6[0238]|9[12])|7(?:01|[1579]\\d|2[248]|3[014-9]|4[3-6]|6[023689])|8(?:1[236-8]|2[5-7]|[37]\\d|5[14-9]|8[36-8]|9[1-8])|9(?:0[1-3689]|1[1-79]|[379]\\d|4[13]|5[1-5]))(?:10|9[56])",
						"85[23](?:100|95)|(?:3(?:[157]\\d|35|49|9[1-68])|4(?:[17]\\d|2[179]|[35][1-9]|6[47-9]|8[23])|5(?:[1357]\\d|2[37]|4[36]|6[1-46]|80|9[1-9])|6(?:3[1-5]|6[0238]|9[12])|7(?:01|[1579]\\d|2[248]|3[014-9]|4[3-6]|6[023689])|8(?:1[236-8]|2[5-7]|[37]\\d|5[14-9]|8[36-8]|9[1-8])|9(?:0[1-3689]|1[1-79]|[379]\\d|4[13]|5[1-5]))(?:100|9[56])"
					],
					"0$1"
				],
				[
					"(\\d{3})(\\d{3})(\\d{4})",
					"$1 $2 $3",
					["(?:4|80)0"]
				],
				[
					"(\\d{2})(\\d{4})(\\d{4})",
					"$1 $2 $3",
					[
						"10|2(?:[02-57-9]|1[1-9])",
						"10|2(?:[02-57-9]|1[1-9])",
						"10[0-79]|2(?:[02-57-9]|1[1-79])|(?:10|21)8(?:0[1-9]|[1-9])"
					],
					"0$1",
					1
				],
				[
					"(\\d{3})(\\d{3})(\\d{4})",
					"$1 $2 $3",
					["3(?:[3-59]|7[02-68])|4(?:[26-8]|3[3-9]|5[2-9])|5(?:3[03-9]|[468]|7[028]|9[2-46-9])|6|7(?:[0-247]|3[04-9]|5[0-4689]|6[2368])|8(?:[1-358]|9[1-7])|9(?:[013479]|5[1-5])|(?:[34]1|55|79|87)[02-9]"],
					"0$1",
					1
				],
				[
					"(\\d{3})(\\d{7,8})",
					"$1 $2",
					["9"]
				],
				[
					"(\\d{4})(\\d{3})(\\d{4})",
					"$1 $2 $3",
					["80"],
					"0$1",
					1
				],
				[
					"(\\d{3})(\\d{4})(\\d{4})",
					"$1 $2 $3",
					["[3-578]"],
					"0$1",
					1
				],
				[
					"(\\d{3})(\\d{4})(\\d{4})",
					"$1 $2 $3",
					["1[3-9]"]
				],
				[
					"(\\d{2})(\\d{3})(\\d{3})(\\d{4})",
					"$1 $2 $3 $4",
					["[12]"],
					"0$1",
					1
				]
			],
			"0",
			0,
			"(1(?:[12]\\d|79)\\d\\d)|0",
			0,
			0,
			0,
			0,
			"00"
		],
		CO: [
			"57",
			"00(?:4(?:[14]4|56)|[579])",
			"(?:46|60\\d\\d)\\d{6}|(?:1\\d|[39])\\d{9}",
			[
				8,
				10,
				11
			],
			[
				[
					"(\\d{4})(\\d{4})",
					"$1 $2",
					["46"]
				],
				[
					"(\\d{3})(\\d{7})",
					"$1 $2",
					["6|90"],
					"($1)"
				],
				[
					"(\\d{3})(\\d{7})",
					"$1 $2",
					["3[0-357]|9[14]"]
				],
				[
					"(\\d)(\\d{3})(\\d{7})",
					"$1-$2-$3",
					["1"],
					"0$1",
					0,
					"$1 $2 $3"
				]
			],
			"0",
			0,
			"0([3579]|4(?:[14]4|56))?"
		],
		CR: [
			"506",
			"00",
			"(?:8\\d|90)\\d{8}|(?:[24-8]\\d{3}|3005)\\d{4}",
			[8, 10],
			[[
				"(\\d{4})(\\d{4})",
				"$1 $2",
				["[2-7]|8[3-9]"]
			], [
				"(\\d{3})(\\d{3})(\\d{4})",
				"$1-$2-$3",
				["[89]"]
			]],
			0,
			0,
			"(19(?:0[0-2468]|1[09]|20|66|77|99))"
		],
		CU: [
			"53",
			"119",
			"(?:[2-7]|8\\d\\d)\\d{7}|[2-47]\\d{6}|[34]\\d{5}",
			[
				6,
				7,
				8,
				10
			],
			[
				[
					"(\\d{2})(\\d{4,6})",
					"$1 $2",
					["2[1-4]|[34]"],
					"(0$1)"
				],
				[
					"(\\d)(\\d{6,7})",
					"$1 $2",
					["7"],
					"(0$1)"
				],
				[
					"(\\d)(\\d{7})",
					"$1 $2",
					["[56]"],
					"0$1"
				],
				[
					"(\\d{3})(\\d{7})",
					"$1 $2",
					["8"],
					"0$1"
				]
			],
			"0"
		],
		CV: [
			"238",
			"0",
			"(?:[2-59]\\d\\d|800)\\d{4}",
			[7],
			[[
				"(\\d{3})(\\d{2})(\\d{2})",
				"$1 $2 $3",
				["[2-589]"]
			]]
		],
		CW: [
			"599",
			"00",
			"(?:[34]1|60|(?:7|9\\d)\\d)\\d{5}",
			[7, 8],
			[[
				"(\\d{3})(\\d{4})",
				"$1 $2",
				["[3467]"]
			], [
				"(\\d)(\\d{3})(\\d{4})",
				"$1 $2 $3",
				["9[4-8]"]
			]],
			0,
			0,
			0,
			0,
			0,
			"[69]"
		],
		CX: [
			"61",
			"001[14-689]|14(?:1[14]|34|4[17]|[56]6|7[47]|88)0011",
			"1(?:[0-79]\\d{8}(?:\\d{2})?|8[0-24-9]\\d{7})|[148]\\d{8}|1\\d{5,7}",
			[
				6,
				7,
				8,
				9,
				10,
				12
			],
			0,
			"0",
			0,
			"([59]\\d{7})$|0",
			"8$1",
			0,
			0,
			[
				["8(?:51(?:0(?:01|30|59|88)|1(?:17|46|75)|2(?:22|35))|91(?:00[6-9]|1(?:[28]1|49|78)|2(?:09|63)|3(?:12|26|75)|4(?:56|97)|64\\d|7(?:0[01]|1[0-2])|958))\\d{3}", [9]],
				["4(?:79[01]|83[0-36-9]|95[0-3])\\d{5}|4(?:[0-36]\\d|4[047-9]|[58][0-24-9]|7[02-8]|9[0-47-9])\\d{6}", [9]],
				["180(?:0\\d{3}|2)\\d{3}", [7, 10]],
				["190[0-26]\\d{6}", [10]],
				0,
				0,
				0,
				0,
				["14(?:5(?:1[0458]|[23][458])|71\\d)\\d{4}", [9]],
				["13(?:00\\d{6}(?:\\d{2})?|45[0-4]\\d{3})|13\\d{4}", [
					6,
					8,
					10,
					12
				]]
			],
			"0011"
		],
		CY: [
			"357",
			"00",
			"(?:[279]\\d|[58]0)\\d{6}",
			[8],
			[[
				"(\\d{2})(\\d{6})",
				"$1 $2",
				["[257-9]"]
			]]
		],
		CZ: [
			"420",
			"00",
			"(?:[2-578]\\d|60)\\d{7}|9\\d{8,11}",
			[
				9,
				10,
				11,
				12
			],
			[
				[
					"(\\d{3})(\\d{3})(\\d{3})",
					"$1 $2 $3",
					["[2-8]|9[015-7]"]
				],
				[
					"(\\d{2})(\\d{3})(\\d{3})(\\d{2})",
					"$1 $2 $3 $4",
					["96"]
				],
				[
					"(\\d{2})(\\d{3})(\\d{3})(\\d{3})",
					"$1 $2 $3 $4",
					["9"]
				],
				[
					"(\\d{3})(\\d{3})(\\d{3})(\\d{3})",
					"$1 $2 $3 $4",
					["9"]
				]
			]
		],
		DE: [
			"49",
			"00",
			"[2579]\\d{5,14}|49(?:[34]0|69|8\\d)\\d\\d?|49(?:37|49|60|7[089]|9\\d)\\d{1,3}|49(?:2[024-9]|3[2-689]|7[1-7])\\d{1,8}|(?:1|[368]\\d|4[0-8])\\d{3,13}|49(?:[015]\\d|2[13]|31|[46][1-8])\\d{1,9}",
			[
				4,
				5,
				6,
				7,
				8,
				9,
				10,
				11,
				12,
				13,
				14,
				15
			],
			[
				[
					"(\\d{2})(\\d{3,13})",
					"$1 $2",
					["3[02]|40|[68]9"],
					"0$1"
				],
				[
					"(\\d{3})(\\d{3,12})",
					"$1 $2",
					["2(?:0[1-389]|1[124]|2[18]|3[14])|3(?:[35-9][15]|4[015])|906|(?:2[4-9]|4[2-9]|[579][1-9]|[68][1-8])1", "2(?:0[1-389]|12[0-8])|3(?:[35-9][15]|4[015])|906|2(?:[13][14]|2[18])|(?:2[4-9]|4[2-9]|[579][1-9]|[68][1-8])1"],
					"0$1"
				],
				[
					"(\\d{4})(\\d{2,11})",
					"$1 $2",
					["[24-6]|3(?:[3569][02-46-9]|4[2-4679]|7[2-467]|8[2-46-8])|70[2-8]|8(?:0[2-9]|[1-8])|90[7-9]|[79][1-9]", "[24-6]|3(?:3(?:0[1-467]|2[127-9]|3[124578]|7[1257-9]|8[1256]|9[145])|4(?:2[135]|4[13578]|9[1346])|5(?:0[14]|2[1-3589]|6[1-4]|7[13468]|8[13568])|6(?:2[1-489]|3[124-6]|6[13]|7[12579]|8[1-356]|9[135])|7(?:2[1-7]|4[145]|6[1-5]|7[1-4])|8(?:21|3[1468]|6|7[1467]|8[136])|9(?:0[12479]|2[1358]|4[134679]|6[1-9]|7[136]|8[147]|9[1468]))|70[2-8]|8(?:0[2-9]|[1-8])|90[7-9]|[79][1-9]|3[68]4[1347]|3(?:47|60)[1356]|3(?:3[46]|46|5[49])[1246]|3[4579]3[1357]"],
					"0$1"
				],
				[
					"(\\d{3})(\\d{4})",
					"$1 $2",
					["138"],
					"0$1"
				],
				[
					"(\\d{5})(\\d{2,10})",
					"$1 $2",
					["3"],
					"0$1"
				],
				[
					"(\\d{3})(\\d{5,11})",
					"$1 $2",
					["181"],
					"0$1"
				],
				[
					"(\\d{3})(\\d)(\\d{4,10})",
					"$1 $2 $3",
					["1(?:3|80)|9"],
					"0$1"
				],
				[
					"(\\d{3})(\\d{7,8})",
					"$1 $2",
					["1[67]"],
					"0$1"
				],
				[
					"(\\d{3})(\\d{7,12})",
					"$1 $2",
					["8"],
					"0$1"
				],
				[
					"(\\d{5})(\\d{6})",
					"$1 $2",
					[
						"185",
						"1850",
						"18500"
					],
					"0$1"
				],
				[
					"(\\d{3})(\\d{4})(\\d{4})",
					"$1 $2 $3",
					["7"],
					"0$1"
				],
				[
					"(\\d{4})(\\d{7})",
					"$1 $2",
					["18[68]"],
					"0$1"
				],
				[
					"(\\d{4})(\\d{7})",
					"$1 $2",
					["15[1279]"],
					"0$1"
				],
				[
					"(\\d{5})(\\d{6})",
					"$1 $2",
					["15[03568]", "15(?:[0568]|3[13])"],
					"0$1"
				],
				[
					"(\\d{3})(\\d{8})",
					"$1 $2",
					["18"],
					"0$1"
				],
				[
					"(\\d{3})(\\d{2})(\\d{7,8})",
					"$1 $2 $3",
					["1(?:6[023]|7)"],
					"0$1"
				],
				[
					"(\\d{4})(\\d{2})(\\d{7})",
					"$1 $2 $3",
					["15[279]"],
					"0$1"
				],
				[
					"(\\d{3})(\\d{2})(\\d{8})",
					"$1 $2 $3",
					["15"],
					"0$1"
				]
			],
			"0"
		],
		DJ: [
			"253",
			"00",
			"(?:2\\d|77)\\d{6}",
			[8],
			[[
				"(\\d{2})(\\d{2})(\\d{2})(\\d{2})",
				"$1 $2 $3 $4",
				["[27]"]
			]]
		],
		DK: [
			"45",
			"00",
			"[2-9]\\d{7}",
			[8],
			[[
				"(\\d{2})(\\d{2})(\\d{2})(\\d{2})",
				"$1 $2 $3 $4",
				["[2-9]"]
			]]
		],
		DM: [
			"1",
			"011",
			"(?:[58]\\d\\d|767|900)\\d{7}",
			[10],
			0,
			"1",
			0,
			"([2-7]\\d{6})$|1",
			"767$1",
			0,
			"767"
		],
		DO: [
			"1",
			"011",
			"(?:[58]\\d\\d|900)\\d{7}",
			[10],
			0,
			"1",
			0,
			0,
			0,
			0,
			"8001|8[024]9"
		],
		DZ: [
			"213",
			"00",
			"(?:[1-4]|[5-79]\\d|80)\\d{7}",
			[8, 9],
			[
				[
					"(\\d{2})(\\d{2})(\\d{2})(\\d{2})",
					"$1 $2 $3 $4",
					["[1-4]"],
					"0$1"
				],
				[
					"(\\d{2})(\\d{3})(\\d{2})(\\d{2})",
					"$1 $2 $3 $4",
					["9"],
					"0$1"
				],
				[
					"(\\d{3})(\\d{2})(\\d{2})(\\d{2})",
					"$1 $2 $3 $4",
					["[5-8]"],
					"0$1"
				]
			],
			"0"
		],
		EC: [
			"593",
			"00",
			"1\\d{9,10}|(?:[2-7]|9\\d)\\d{7}",
			[
				8,
				9,
				10,
				11
			],
			[
				[
					"(\\d)(\\d{3})(\\d{4})",
					"$1 $2-$3",
					["[2-7]"],
					"(0$1)",
					0,
					"$1-$2-$3"
				],
				[
					"(\\d{2})(\\d{3})(\\d{4})",
					"$1 $2 $3",
					["9"],
					"0$1"
				],
				[
					"(\\d{4})(\\d{3})(\\d{3,4})",
					"$1 $2 $3",
					["1"]
				]
			],
			"0"
		],
		EE: [
			"372",
			"00",
			"8\\d{9}|[4578]\\d{7}|(?:[3-8]\\d|90)\\d{5}",
			[
				7,
				8,
				10
			],
			[
				[
					"(\\d{3})(\\d{4})",
					"$1 $2",
					["[369]|4[3-8]|5(?:[0-2]|5[0-478]|6[45])|7[1-9]|88", "[369]|4[3-8]|5(?:[02]|1(?:[0-8]|95)|5[0-478]|6(?:4[0-4]|5[1-589]))|7[1-9]|88"]
				],
				[
					"(\\d{4})(\\d{3,4})",
					"$1 $2",
					["[45]|8(?:00|[1-49])", "[45]|8(?:00[1-9]|[1-49])"]
				],
				[
					"(\\d{2})(\\d{2})(\\d{4})",
					"$1 $2 $3",
					["7"]
				],
				[
					"(\\d{4})(\\d{3})(\\d{3})",
					"$1 $2 $3",
					["8"]
				]
			]
		],
		EG: [
			"20",
			"00",
			"[189]\\d{8,9}|[24-6]\\d{8}|[135]\\d{7}",
			[
				8,
				9,
				10
			],
			[
				[
					"(\\d)(\\d{7,8})",
					"$1 $2",
					["[23]"],
					"0$1"
				],
				[
					"(\\d{2})(\\d{6,7})",
					"$1 $2",
					["1[35]|[4-6]|8[2468]|9[235-7]"],
					"0$1"
				],
				[
					"(\\d{3})(\\d{3})(\\d{4})",
					"$1 $2 $3",
					["[89]"],
					"0$1"
				],
				[
					"(\\d{2})(\\d{8})",
					"$1 $2",
					["1"],
					"0$1"
				]
			],
			"0"
		],
		EH: [
			"212",
			"00",
			"[5-8]\\d{8}",
			[9],
			0,
			"0",
			0,
			0,
			0,
			0,
			0,
			[
				["528[89]\\d{5}"],
				["(?:6(?:[0-79]\\d|8[0-247-9])|7(?:[016-8]\\d|2[0-8]|3[01]|5[0-5]))\\d{6}"],
				["80[0-7]\\d{6}"],
				["89\\d{7}"],
				0,
				0,
				0,
				0,
				["(?:592(?:4[0-2]|93)|80[89]\\d\\d)\\d{4}"]
			]
		],
		ER: [
			"291",
			"00",
			"[178]\\d{6}",
			[7],
			[[
				"(\\d)(\\d{3})(\\d{3})",
				"$1 $2 $3",
				["[178]"],
				"0$1"
			]],
			"0"
		],
		ES: [
			"34",
			"00",
			"(?:400|[5-9]\\d\\d)\\d{6}",
			[9],
			[[
				"(\\d{3})(\\d{3})(\\d{3})",
				"$1 $2 $3",
				["[89]00"]
			], [
				"(\\d{3})(\\d{2})(\\d{2})(\\d{2})",
				"$1 $2 $3 $4",
				["[4-9]"]
			]]
		],
		ET: [
			"251",
			"00",
			"(?:11|[2-57-9]\\d)\\d{7}",
			[9],
			[[
				"(\\d{2})(\\d{3})(\\d{4})",
				"$1 $2 $3",
				["[1-57-9]"],
				"0$1"
			]],
			"0"
		],
		FI: [
			"358",
			"00|99(?:[01469]|5(?:[14]1|3[23]|5[59]|77|88|9[09]))",
			"[1-35689]\\d{4}|7\\d{10,11}|(?:[124-7]\\d|3[0-46-9])\\d{8}|[1-9]\\d{5,8}",
			[
				5,
				6,
				7,
				8,
				9,
				10,
				11,
				12
			],
			[
				[
					"(\\d{5})",
					"$1",
					["20[2-59]"],
					"0$1"
				],
				[
					"(\\d{3})(\\d{3,7})",
					"$1 $2",
					["(?:[1-3]0|[68])0|70[07-9]"],
					"0$1"
				],
				[
					"(\\d{2})(\\d{4,8})",
					"$1 $2",
					["[14]|2[09]|50|7[135]"],
					"0$1"
				],
				[
					"(\\d{2})(\\d{6,10})",
					"$1 $2",
					["7"],
					"0$1"
				],
				[
					"(\\d)(\\d{4,9})",
					"$1 $2",
					["(?:19|[2568])[1-8]|3(?:0[1-9]|[1-9])|9"],
					"0$1"
				]
			],
			"0",
			0,
			0,
			0,
			0,
			"1[03-79]|[2-9]",
			0,
			"00"
		],
		FJ: [
			"679",
			"0(?:0|52)",
			"45\\d{5}|(?:0800\\d|[235-9])\\d{6}",
			[7, 11],
			[[
				"(\\d{3})(\\d{4})",
				"$1 $2",
				["[235-9]|45"]
			], [
				"(\\d{4})(\\d{3})(\\d{4})",
				"$1 $2 $3",
				["0"]
			]],
			0,
			0,
			0,
			0,
			0,
			0,
			0,
			"00"
		],
		FK: [
			"500",
			"00",
			"[2-7]\\d{4}",
			[5]
		],
		FM: [
			"691",
			"00",
			"(?:[39]\\d\\d|820)\\d{4}",
			[7],
			[[
				"(\\d{3})(\\d{4})",
				"$1 $2",
				["[389]"]
			]]
		],
		FO: [
			"298",
			"00",
			"[2-9]\\d{5}",
			[6],
			[[
				"(\\d{2})(\\d{2})(\\d{2})",
				"$1 $2 $3",
				["[2-9]"]
			]],
			0,
			0,
			"(10(?:01|[12]0|88))"
		],
		FR: [
			"33",
			"00",
			"[1-9]\\d{8}",
			[9],
			[[
				"(\\d{3})(\\d{2})(\\d{2})(\\d{2})",
				"$1 $2 $3 $4",
				["8"],
				"0 $1"
			], [
				"(\\d)(\\d{2})(\\d{2})(\\d{2})(\\d{2})",
				"$1 $2 $3 $4 $5",
				["[1-79]"],
				"0$1"
			]],
			"0"
		],
		GA: [
			"241",
			"00",
			"(?:[067]\\d|11)\\d{6}|[2-7]\\d{6}",
			[7, 8],
			[
				[
					"(\\d)(\\d{2})(\\d{2})(\\d{2})",
					"$1 $2 $3 $4",
					["[2-7]"],
					"0$1"
				],
				[
					"(\\d{2})(\\d{2})(\\d{2})(\\d{2})",
					"$1 $2 $3 $4",
					["0"]
				],
				[
					"(\\d{2})(\\d{2})(\\d{2})(\\d{2})",
					"$1 $2 $3 $4",
					["11|[67]"],
					"0$1"
				]
			],
			0,
			0,
			"0(11\\d{6}|60\\d{6}|61\\d{6}|6[256]\\d{6}|7[467]\\d{6})",
			"$1"
		],
		GB: [
			"44",
			"00",
			"[1-357-9]\\d{9}|[18]\\d{8}|8\\d{6}",
			[
				7,
				9,
				10
			],
			[
				[
					"(\\d{3})(\\d{4})",
					"$1 $2",
					[
						"800",
						"8001",
						"80011",
						"800111",
						"8001111"
					],
					"0$1"
				],
				[
					"(\\d{3})(\\d{2})(\\d{2})",
					"$1 $2 $3",
					[
						"845",
						"8454",
						"84546",
						"845464"
					],
					"0$1"
				],
				[
					"(\\d{3})(\\d{6})",
					"$1 $2",
					["800"],
					"0$1"
				],
				[
					"(\\d{5})(\\d{4,5})",
					"$1 $2",
					[
						"1(?:38|5[23]|69|76|94)",
						"1(?:(?:38|69)7|5(?:24|39)|768|946)",
						"1(?:3873|5(?:242|39[4-6])|(?:697|768)[347]|9467)"
					],
					"0$1"
				],
				[
					"(\\d{4})(\\d{5,6})",
					"$1 $2",
					["1(?:[2-69][02-9]|[78])"],
					"0$1"
				],
				[
					"(\\d{2})(\\d{4})(\\d{4})",
					"$1 $2 $3",
					["[25]|7(?:0|6[02-9])", "[25]|7(?:0|6(?:[03-9]|2[356]))"],
					"0$1"
				],
				[
					"(\\d{4})(\\d{6})",
					"$1 $2",
					["7"],
					"0$1"
				],
				[
					"(\\d{3})(\\d{3})(\\d{4})",
					"$1 $2 $3",
					["[1389]"],
					"0$1"
				]
			],
			"0",
			0,
			"0|180020",
			0,
			0,
			0,
			[
				["(?:1(?:1(?:3(?:[0-58]\\d\\d|73[0-5])|4(?:(?:[0-5]\\d|70)\\d|69[7-9])|(?:(?:5[0-26-9]|[78][0-49])\\d|6(?:[0-4]\\d|5[01]))\\d)|(?:2(?:(?:0[024-9]|2[3-9]|3[3-79]|4[1-689]|[58][02-9]|6[0-47-9]|7[013-9]|9\\d)\\d|1(?:[0-7]\\d|8[0-3]))|(?:3(?:0\\d|1[0-8]|[25][02-9]|3[02-579]|[468][0-46-9]|7[1-35-79]|9[2-578])|4(?:0[03-9]|[137]\\d|[28][02-57-9]|4[02-69]|5[0-8]|[69][0-79])|5(?:0[1-35-9]|[16]\\d|2[024-9]|3[015689]|4[02-9]|5[03-9]|7[0-35-9]|8[0-468]|9[0-57-9])|6(?:0[034689]|1\\d|2[0-35689]|[38][013-9]|4[1-467]|5[0-69]|6[13-9]|7[0-8]|9[0-24578])|7(?:0[0246-9]|2\\d|3[0236-8]|4[03-9]|5[0-46-9]|6[013-9]|7[0-35-9]|8[024-9]|9[02-9])|8(?:0[35-9]|2[1-57-9]|3[02-578]|4[0-578]|5[124-9]|6[2-69]|7\\d|8[02-9]|9[02569])|9(?:0[02-589]|[18]\\d|2[02-689]|3[1-57-9]|4[2-9]|5[0-579]|6[2-47-9]|7[0-24578]|9[2-57]))\\d)\\d)|2(?:0[013478]|3[0189]|4[017]|8[0-46-9]|9[0-2])\\d{3})\\d{4}|1(?:2(?:0(?:46[1-4]|87[2-9])|545[1-79]|76(?:2\\d|3[1-8]|6[1-6])|9(?:7(?:2[0-4]|3[2-5])|8(?:2[2-8]|7[0-47-9]|8[3-5])))|3(?:6(?:38[2-5]|47[23])|8(?:47[04-9]|64[0157-9]))|4(?:044[1-7]|20(?:2[23]|8\\d)|6(?:0(?:30|5[2-57]|6[1-8]|7[2-8])|140)|8(?:052|87[1-3]))|5(?:2(?:4(?:3[2-79]|6\\d)|76\\d)|6(?:26[06-9]|686))|6(?:06(?:4\\d|7[4-79])|295[5-7]|35[34]\\d|47(?:24|61)|59(?:5[08]|6[67]|74)|9(?:55[0-4]|77[23]))|7(?:26(?:6[13-9]|7[0-7])|(?:442|688)\\d|50(?:2[0-3]|[3-68]2|76))|8(?:27[56]\\d|37(?:5[2-5]|8[239])|843[2-58])|9(?:0(?:0(?:6[1-8]|85)|52\\d)|3583|4(?:66[1-8]|9(?:2[01]|81))|63(?:23|3[1-4])|9561))\\d{3}", [9, 10]],
				["7(?:457[0-57-9]|700[01]|911[028])\\d{5}|7(?:[1-3]\\d\\d|4(?:[0-46-9]\\d|5[0-689])|5(?:0[0-8]|[13-9]\\d|2[0-35-9])|7(?:0[1-9]|[1-7]\\d|8[02-9]|9[0-689])|8(?:[014-9]\\d|[23][0-8])|9(?:[024-9]\\d|1[02-9]|3[0-689]))\\d{6}", [10]],
				["80[08]\\d{7}|800\\d{6}|8001111"],
				["(?:8(?:4[2-5]|7[0-3])|9(?:[01]\\d|8[2-49]))\\d{7}|845464\\d", [7, 10]],
				["70\\d{8}", [10]],
				0,
				["(?:3[0347]|55)\\d{8}", [10]],
				["76(?:464|652)\\d{5}|76(?:0[0-28]|2[356]|34|4[01347]|5[49]|6[0-369]|77|8[14]|9[139])\\d{6}", [10]],
				["56\\d{8}", [10]]
			],
			0,
			" x"
		],
		GD: [
			"1",
			"011",
			"(?:473|[58]\\d\\d|900)\\d{7}",
			[10],
			0,
			"1",
			0,
			"([2-9]\\d{6})$|1",
			"473$1",
			0,
			"473"
		],
		GE: [
			"995",
			"00",
			"(?:[3-57]\\d\\d|800)\\d{6}",
			[9],
			[
				[
					"(\\d{3})(\\d{3})(\\d{3})",
					"$1 $2 $3",
					["70"],
					"0$1"
				],
				[
					"(\\d{2})(\\d{3})(\\d{2})(\\d{2})",
					"$1 $2 $3 $4",
					["32"],
					"0$1"
				],
				[
					"(\\d{3})(\\d{2})(\\d{2})(\\d{2})",
					"$1 $2 $3 $4",
					["[57]"]
				],
				[
					"(\\d{3})(\\d{2})(\\d{2})(\\d{2})",
					"$1 $2 $3 $4",
					["[348]"],
					"0$1"
				]
			],
			"0"
		],
		GF: [
			"594",
			"00",
			"(?:694\\d|7093)\\d{5}|(?:59|[89]\\d)\\d{7}",
			[9],
			[[
				"(\\d{3})(\\d{2})(\\d{2})(\\d{2})",
				"$1 $2 $3 $4",
				["[5-7]|80[6-9]|9[47]"],
				"0$1"
			], [
				"(\\d{3})(\\d{2})(\\d{2})(\\d{2})",
				"$1 $2 $3 $4",
				["[89]"],
				"0$1"
			]],
			"0"
		],
		GG: [
			"44",
			"00",
			"(?:1481|[357-9]\\d{3})\\d{6}|8\\d{6}(?:\\d{2})?",
			[
				7,
				9,
				10
			],
			0,
			"0",
			0,
			"([25-9]\\d{5})$|0|180020",
			"1481$1",
			0,
			0,
			[
				["1481[25-9]\\d{5}", [10]],
				["7(?:(?:781|839)\\d|911[17])\\d{5}", [10]],
				["80[08]\\d{7}|800\\d{6}|8001111"],
				["(?:8(?:4[2-5]|7[0-3])|9(?:[01]\\d|8[0-3]))\\d{7}|845464\\d", [7, 10]],
				["70\\d{8}", [10]],
				0,
				["(?:3[0347]|55)\\d{8}", [10]],
				["76(?:464|652)\\d{5}|76(?:0[0-28]|2[356]|34|4[01347]|5[49]|6[0-369]|77|8[14]|9[139])\\d{6}", [10]],
				["56\\d{8}", [10]]
			]
		],
		GH: [
			"233",
			"00",
			"[235]\\d{8}|800\\d{5,6}",
			[8, 9],
			[[
				"(\\d{3})(\\d{5})",
				"$1 $2",
				["8"],
				"0$1"
			], [
				"(\\d{2})(\\d{3})(\\d{4})",
				"$1 $2 $3",
				["[2358]"],
				"0$1"
			]],
			"0"
		],
		GI: [
			"350",
			"00",
			"(?:[25]\\d|60)\\d{6}",
			[8],
			[[
				"(\\d{3})(\\d{5})",
				"$1 $2",
				["2"]
			]]
		],
		GL: [
			"299",
			"00",
			"(?:19|[2-689]\\d|70)\\d{4}",
			[6],
			[[
				"(\\d{2})(\\d{2})(\\d{2})",
				"$1 $2 $3",
				["19|[2-9]"]
			]]
		],
		GM: [
			"220",
			"00",
			"[48]\\d{8}|[2-9]\\d{6}",
			[7, 9],
			[[
				"(\\d{3})(\\d{4})",
				"$1 $2",
				["[235-9]|4(?:[0-35]|4[16-9])"]
			], [
				"(\\d{2})(\\d{3})(\\d{4})",
				"$1 $2 $3",
				["[48]"]
			]]
		],
		GN: [
			"224",
			"00",
			"722\\d{6}|(?:3|6\\d)\\d{7}",
			[8, 9],
			[[
				"(\\d{2})(\\d{2})(\\d{2})(\\d{2})",
				"$1 $2 $3 $4",
				["3"]
			], [
				"(\\d{3})(\\d{2})(\\d{2})(\\d{2})",
				"$1 $2 $3 $4",
				["[67]"]
			]]
		],
		GP: [
			"590",
			"00",
			"7090\\d{5}|(?:[56]9|[89]\\d)\\d{7}",
			[9],
			[[
				"(\\d{3})(\\d{2})(\\d{2})(\\d{2})",
				"$1 $2 $3 $4",
				["[5-79]|80[6-9]"],
				"0$1"
			], [
				"(\\d{3})(\\d{2})(\\d{2})(\\d{2})",
				"$1 $2 $3 $4",
				["8"],
				"0$1"
			]],
			"0",
			0,
			0,
			0,
			0,
			0,
			[
				["(?:59(?:0(?:0[1-68]|[14][0-24-9]|2[0-68]|3[1-9]|5[3-579]|[68][0-689]|7[08]|9\\d)|87\\d)|80[6-9]\\d\\d)\\d{4}"],
				["(?:69(?:0\\d\\d|1(?:2[2-9]|3[0-5]))|7090[0-4])\\d{4}"],
				["80[0-5]\\d{6}"],
				["8[129]\\d{7}"],
				0,
				0,
				0,
				0,
				["9(?:(?:39[5-7]|76[018])\\d|475[0-6])\\d{4}"]
			]
		],
		GQ: [
			"240",
			"00",
			"222\\d{6}|(?:3\\d|55|[89]0)\\d{7}",
			[9],
			[[
				"(\\d{3})(\\d{3})(\\d{3})",
				"$1 $2 $3",
				["[235]"]
			], [
				"(\\d{3})(\\d{6})",
				"$1 $2",
				["[89]"]
			]]
		],
		GR: [
			"30",
			"00",
			"5005000\\d{3}|8\\d{9,11}|(?:[269]\\d|70)\\d{8}",
			[
				10,
				11,
				12
			],
			[
				[
					"(\\d{2})(\\d{4})(\\d{4})",
					"$1 $2 $3",
					["21|7"]
				],
				[
					"(\\d{4})(\\d{6})",
					"$1 $2",
					["2(?:2|3[2-57-9]|4[2-469]|5[2-59]|6[2-9]|7[2-69]|8[2-49])|5"]
				],
				[
					"(\\d{3})(\\d{3})(\\d{4})",
					"$1 $2 $3",
					["[2689]"]
				],
				[
					"(\\d{3})(\\d{3,4})(\\d{5})",
					"$1 $2 $3",
					["8"]
				]
			]
		],
		GT: [
			"502",
			"00",
			"80\\d{6}|(?:1\\d{3}|[2-7])\\d{7}",
			[8, 11],
			[[
				"(\\d{4})(\\d{4})",
				"$1 $2",
				["[2-8]"]
			], [
				"(\\d{4})(\\d{3})(\\d{4})",
				"$1 $2 $3",
				["1"]
			]]
		],
		GU: [
			"1",
			"011",
			"(?:[58]\\d\\d|671|900)\\d{7}",
			[10],
			0,
			"1",
			0,
			"([2-9]\\d{6})$|1",
			"671$1",
			0,
			"671"
		],
		GW: [
			"245",
			"00",
			"[49]\\d{8}|4\\d{6}",
			[7, 9],
			[[
				"(\\d{3})(\\d{4})",
				"$1 $2",
				["40"]
			], [
				"(\\d{3})(\\d{3})(\\d{3})",
				"$1 $2 $3",
				["[49]"]
			]]
		],
		GY: [
			"592",
			"001",
			"(?:[2-8]\\d{3}|9008)\\d{3}",
			[7],
			[[
				"(\\d{3})(\\d{4})",
				"$1 $2",
				["[2-9]"]
			]]
		],
		HK: [
			"852",
			"00(?:30|5[09]|[126-9]?)",
			"8[0-46-9]\\d{6,7}|9\\d{4,7}|(?:[2-7]|9\\d{3})\\d{7}",
			[
				5,
				6,
				7,
				8,
				9,
				11
			],
			[
				[
					"(\\d{3})(\\d{2,5})",
					"$1 $2",
					["900", "9003"]
				],
				[
					"(\\d{4})(\\d{4})",
					"$1 $2",
					["[2-7]|8[1-4]|9(?:0[1-9]|[1-8])"]
				],
				[
					"(\\d{3})(\\d{3})(\\d{3})",
					"$1 $2 $3",
					["8"]
				],
				[
					"(\\d{3})(\\d{2})(\\d{3})(\\d{3})",
					"$1 $2 $3 $4",
					["9"]
				]
			],
			0,
			0,
			0,
			0,
			0,
			0,
			0,
			"00"
		],
		HN: [
			"504",
			"00",
			"8\\d{10}|[237-9]\\d{7}",
			[8, 11],
			[[
				"(\\d{4})(\\d{4})",
				"$1-$2",
				["[237-9]"]
			]]
		],
		HR: [
			"385",
			"00",
			"[2-69]\\d{8}|80\\d{5,7}|[1-79]\\d{7}|6\\d{6}",
			[
				7,
				8,
				9
			],
			[
				[
					"(\\d{2})(\\d{2})(\\d{3})",
					"$1 $2 $3",
					["6[01]"],
					"0$1"
				],
				[
					"(\\d{3})(\\d{2})(\\d{2,3})",
					"$1 $2 $3",
					["8"],
					"0$1"
				],
				[
					"(\\d)(\\d{4})(\\d{3})",
					"$1 $2 $3",
					["1"],
					"0$1"
				],
				[
					"(\\d{2})(\\d{3})(\\d{3,4})",
					"$1 $2 $3",
					["6|7[245]"],
					"0$1"
				],
				[
					"(\\d{2})(\\d{3})(\\d{3,4})",
					"$1 $2 $3",
					["9"],
					"0$1"
				],
				[
					"(\\d{2})(\\d{3})(\\d{3,4})",
					"$1 $2 $3",
					["[2-57]"],
					"0$1"
				],
				[
					"(\\d{3})(\\d{3})(\\d{3})",
					"$1 $2 $3",
					["8"],
					"0$1"
				]
			],
			"0"
		],
		HT: [
			"509",
			"00",
			"[2-589]\\d{7}",
			[8],
			[[
				"(\\d{2})(\\d{2})(\\d{4})",
				"$1 $2 $3",
				["[2-589]"]
			]]
		],
		HU: [
			"36",
			"00",
			"[235-7]\\d{8}|[1-9]\\d{7}",
			[8, 9],
			[
				[
					"(\\d)(\\d{3})(\\d{4})",
					"$1 $2 $3",
					["1"],
					"(06 $1)"
				],
				[
					"(\\d{2})(\\d{3})(\\d{3})",
					"$1 $2 $3",
					["[27][2-9]|3[2-7]|4[24-9]|5[2-79]|6|8[2-57-9]|9[2-69]"],
					"(06 $1)"
				],
				[
					"(\\d{2})(\\d{3})(\\d{3,4})",
					"$1 $2 $3",
					["[2-9]"],
					"06 $1"
				]
			],
			"06"
		],
		ID: [
			"62",
			"00[89]",
			"00[1-9]\\d{9,14}|(?:[1-36]|8\\d{5})\\d{6}|00\\d{9}|[1-9]\\d{8,10}|[2-9]\\d{7}",
			[
				7,
				8,
				9,
				10,
				11,
				12,
				13,
				14,
				15,
				16,
				17
			],
			[
				[
					"(\\d)(\\d{3})(\\d{3})",
					"$1 $2 $3",
					["15"]
				],
				[
					"(\\d{2})(\\d{5,9})",
					"$1 $2",
					["2[124]|[36]1"],
					"(0$1)"
				],
				[
					"(\\d{3})(\\d{5,7})",
					"$1 $2",
					["800"],
					"0$1"
				],
				[
					"(\\d{3})(\\d{5,8})",
					"$1 $2",
					["[2-79]"],
					"(0$1)"
				],
				[
					"(\\d{3})(\\d{3,4})(\\d{3})",
					"$1-$2-$3",
					["8[1-35-9]"],
					"0$1"
				],
				[
					"(\\d{3})(\\d{6,8})",
					"$1 $2",
					["1"],
					"0$1"
				],
				[
					"(\\d{3})(\\d{3})(\\d{4})",
					"$1 $2 $3",
					["804"],
					"0$1"
				],
				[
					"(\\d{3})(\\d)(\\d{3})(\\d{3})",
					"$1 $2 $3 $4",
					["80"],
					"0$1"
				],
				[
					"(\\d{3})(\\d{4})(\\d{4,5})",
					"$1-$2-$3",
					["8"],
					"0$1"
				]
			],
			"0"
		],
		IE: [
			"353",
			"00",
			"(?:1\\d|[2569])\\d{6,8}|4\\d{6,9}|7\\d{8}|8\\d{8,9}",
			[
				7,
				8,
				9,
				10
			],
			[
				[
					"(\\d{2})(\\d{5})",
					"$1 $2",
					["2[24-9]|47|58|6[237-9]|9[35-9]"],
					"(0$1)"
				],
				[
					"(\\d{3})(\\d{5})",
					"$1 $2",
					["[45]0"],
					"(0$1)"
				],
				[
					"(\\d)(\\d{3,4})(\\d{4})",
					"$1 $2 $3",
					["1"],
					"(0$1)"
				],
				[
					"(\\d{2})(\\d{3})(\\d{3,4})",
					"$1 $2 $3",
					["[2569]|4[1-69]|7[14]"],
					"(0$1)"
				],
				[
					"(\\d{3})(\\d{3})(\\d{3})",
					"$1 $2 $3",
					["70"],
					"0$1"
				],
				[
					"(\\d{3})(\\d{3})(\\d{3})",
					"$1 $2 $3",
					["81"],
					"(0$1)"
				],
				[
					"(\\d{2})(\\d{3})(\\d{4})",
					"$1 $2 $3",
					["[78]"],
					"0$1"
				],
				[
					"(\\d{4})(\\d{3})(\\d{3})",
					"$1 $2 $3",
					["1"]
				],
				[
					"(\\d{2})(\\d{4})(\\d{4})",
					"$1 $2 $3",
					["4"],
					"(0$1)"
				],
				[
					"(\\d{2})(\\d)(\\d{3})(\\d{4})",
					"$1 $2 $3 $4",
					["8"],
					"0$1"
				]
			],
			"0"
		],
		IL: [
			"972",
			"0(?:0|1(?:05|[2-9]))",
			"1\\d{6}(?:\\d{3,5})?|[57]\\d{8}|[1-489]\\d{7}",
			[
				7,
				8,
				9,
				10,
				11,
				12
			],
			[
				[
					"(\\d{4})(\\d{3})",
					"$1-$2",
					["125"]
				],
				[
					"(\\d{4})(\\d{2})(\\d{2})",
					"$1-$2-$3",
					["121"]
				],
				[
					"(\\d)(\\d{3})(\\d{4})",
					"$1-$2-$3",
					["[2-489]"],
					"0$1"
				],
				[
					"(\\d{2})(\\d{3})(\\d{4})",
					"$1-$2-$3",
					["[57]"],
					"0$1"
				],
				[
					"(\\d{4})(\\d{3})(\\d{3})",
					"$1-$2-$3",
					["12"]
				],
				[
					"(\\d{4})(\\d{6})",
					"$1-$2",
					["159"]
				],
				[
					"(\\d)(\\d{3})(\\d{3})(\\d{3})",
					"$1-$2-$3-$4",
					["1[7-9]"]
				],
				[
					"(\\d{3})(\\d{1,2})(\\d{3})(\\d{4})",
					"$1-$2 $3-$4",
					["15"]
				]
			],
			"0"
		],
		IM: [
			"44",
			"00",
			"1624\\d{6}|(?:[3578]\\d|90)\\d{8}",
			[10],
			0,
			"0",
			0,
			"([25-8]\\d{5})$|0|180020",
			"1624$1",
			0,
			"74576|(?:16|7[56])24"
		],
		IN: [
			"91",
			"00",
			"(?:000800|[2-9]\\d\\d)\\d{7}|1\\d{7,12}",
			[
				8,
				9,
				10,
				11,
				12,
				13
			],
			[
				[
					"(\\d{8})",
					"$1",
					[
						"5(?:0|2[23]|3[03]|[67]1|88)",
						"5(?:0|2(?:21|3)|3(?:0|3[23])|616|717|888)",
						"5(?:0|2(?:21|3)|3(?:0|3[23])|616|717|8888)"
					],
					0,
					1
				],
				[
					"(\\d{4})(\\d{4,5})",
					"$1 $2",
					["180", "1800"],
					0,
					1
				],
				[
					"(\\d{3})(\\d{3})(\\d{4})",
					"$1 $2 $3",
					["140"],
					0,
					1
				],
				[
					"(\\d{2})(\\d{4})(\\d{4})",
					"$1 $2 $3",
					[
						"11|2[02]|33|4[04]|79[1-6]|80[2-46]",
						"11|2[02]|33|4[04]|79[1-6]|80(?:[2-4]|6[0-589])",
						"11|2[02]|33|4[04]|79(?:[124-6]|3(?:[02-9]|1[0-24-9]))|80(?:[2-4]|6[0-589])"
					],
					"0$1",
					1
				],
				[
					"(\\d{3})(\\d{3})(\\d{4})",
					"$1 $2 $3",
					[
						"1(?:2[0-249]|3[0-25]|4[145]|[68]|7[1257])|2(?:1[257]|3[013]|4[01]|5[0137]|6[0158]|78|8[1568])|3(?:26|4[1-3]|5[34]|6[01489]|7[02-46]|8[159])|4(?:1[36]|2[1-47]|5[12]|6[0-26-9]|7[0-24-9]|8[013-57]|9[014-7])|5(?:1[025]|22|[36][25]|4[28]|5[12]|[78]1)|6(?:12|[2-4]1|5[17]|6[13]|80)|7(?:12|3[134]|61|88)|8(?:16|2[014]|3[126]|6[136]|7[078]|8[34]|91)|(?:43|59|75)[15]|(?:1[59]|29|67)[14]",
						"1(?:2[0-24]|3[0-25]|4[145]|[59][14]|6[1-9]|7[1257]|8[1-57-9])|2(?:1[257]|3[013]|4[01]|5[0137]|6[058]|78|8[1568]|9[14])|3(?:26|4[1-3]|5[34]|6[01489]|7[02-46]|8[159])|4(?:1[36]|2[1-47]|3[15]|5[12]|6[0-26-9]|7[0-24-9]|8[013-57]|9[014-7])|5(?:1[025]|22|[36][25]|4[28]|[578]1|9[15])|674|7(?:(?:3[34]|5[15])[2-6]|61[346]|88[0-8])|8(?:70[2-6]|84[235-7]|91[3-7])|(?:1(?:29|60|8[06])|261|552|6(?:12|[2-47]1|5[17]|6[13]|80)|7(?:12|31)|8(?:16|2[014]|3[126]|6[136]|7[78]|83))[2-7]",
						"1(?:2[0-24]|3[0-25]|4[145]|[59][14]|6[1-9]|7[1257]|8[1-57-9])|2(?:1[257]|3[013]|4[01]|5[0137]|6[058]|78|8[1568]|9[14])|3(?:26|4[1-3]|5[34]|6[01489]|7[02-46]|8[159])|4(?:1[36]|2[1-47]|3[15]|5[12]|6[0-26-9]|7[0-24-9]|8[013-57]|9[014-7])|5(?:1[025]|22|[36][25]|4[28]|[578]1|9[15])|6(?:12(?:[2-6]|7[0-8])|74[2-7])|7(?:3171|5[15][2-6]|61[346]|88(?:[2-7]|82))|8(?:70[2-6]|84(?:[2356]|7[19])|91(?:[3-6]|7[19]))|73[134][2-6]|8(?:16|2[014]|3[126]|6[136]|7[78]|83)(?:[2-6]|7[19])|(?:1(?:29|60|8[06])|261|552|6(?:[2-4]1|5[17]|6[13]|7(?:1|4[0189])|80)|7(?:12|88[01]))[2-7]"
					],
					"0$1",
					1
				],
				[
					"(\\d{4})(\\d{3})(\\d{3})",
					"$1 $2 $3",
					[
						"1(?:[2-479]|5[0235-9])|[2-5]|6(?:1[1358]|2[2457-9]|3[2-5]|4[235-7]|5[2-689]|6[24578]|7[235689]|8[1-6])|7(?:1[013-9]|3[129]|5[29]|6[02-5]|70)|807",
						"1(?:[2-479]|5[0235-9])|[2-5]|6(?:1[1358]|2(?:[2457]|84|95)|3(?:[2-4]|55)|4[235-7]|5[2-689]|6[24578]|7(?:[23569]|8[0-57-9])|8[1-6])|7(?:1(?:[013-8]|9[6-9])|3(?:17|2[0-49]|9[2-57])|5(?:2[1-3]|9[0-6])|6(?:0[5689]|2[5-9]|3[02-8]|4|5[0-367])|70[13-7])|807[19]",
						"1(?:[2-479]|5(?:[0236-9]|5[013-9]))|[2-5]|6(?:2(?:84|95)|355|8(?:28[235-7]|3))|73179|807(?:1|9[1-3])|(?:1552|6(?:(?:1[1358]|2[2457]|3[2-4]|4[235-7]|5[2-689]|6[24578])\\d|7(?:[23569]\\d|8[0-57-9])|8(?:[14-6]\\d|2[0-79]))|7(?:1(?:[013-8]\\d|9[6-9])|3(?:2[0-49]|9[2-57])|5(?:2[1-3]|9[0-6])|6(?:0[5689]|2[5-9]|3[02-8]|4\\d|5[0-367])|70[13-7]))[2-7]"
					],
					"0$1",
					1
				],
				[
					"(\\d{5})(\\d{5})",
					"$1 $2",
					["16|[6-9]"],
					"0$1",
					1
				],
				[
					"(\\d{4})(\\d{2,4})(\\d{4})",
					"$1 $2 $3",
					["18[06]", "18[06]0"],
					0,
					1
				],
				[
					"(\\d{4})(\\d{3})(\\d{3})(\\d{3})",
					"$1 $2 $3 $4",
					["18"],
					0,
					1
				]
			],
			"0"
		],
		IO: [
			"246",
			"00",
			"3\\d{6}",
			[7],
			[[
				"(\\d{3})(\\d{4})",
				"$1 $2",
				["3"]
			]]
		],
		IQ: [
			"964",
			"00",
			"(?:1|7\\d\\d)\\d{7}|[2-6]\\d{7,8}",
			[
				8,
				9,
				10
			],
			[
				[
					"(\\d)(\\d{3})(\\d{4})",
					"$1 $2 $3",
					["1"],
					"0$1"
				],
				[
					"(\\d{2})(\\d{3})(\\d{3,4})",
					"$1 $2 $3",
					["[2-6]"],
					"0$1"
				],
				[
					"(\\d{3})(\\d{3})(\\d{4})",
					"$1 $2 $3",
					["7"],
					"0$1"
				]
			],
			"0"
		],
		IR: [
			"98",
			"00",
			"[1-9]\\d{9}|(?:[1-8]\\d\\d|9)\\d{3,4}",
			[
				4,
				5,
				6,
				7,
				10
			],
			[
				[
					"(\\d{4,5})",
					"$1",
					["96"],
					"0$1"
				],
				[
					"(\\d{2})(\\d{4,5})",
					"$1 $2",
					["(?:1[137]|2[13-68]|3[1458]|4[145]|5[1468]|6[16]|7[1467]|8[13467])[12689]"],
					"0$1"
				],
				[
					"(\\d{3})(\\d{3})(\\d{3,4})",
					"$1 $2 $3",
					["9"],
					"0$1"
				],
				[
					"(\\d{2})(\\d{4})(\\d{4})",
					"$1 $2 $3",
					["[1-8]"],
					"0$1"
				]
			],
			"0"
		],
		IS: [
			"354",
			"00|1(?:0(?:01|[12]0)|100)",
			"(?:38\\d|[4-9])\\d{6}",
			[7, 9],
			[[
				"(\\d{3})(\\d{4})",
				"$1 $2",
				["[4-9]"]
			], [
				"(\\d{3})(\\d{3})(\\d{3})",
				"$1 $2 $3",
				["3"]
			]],
			0,
			0,
			0,
			0,
			0,
			0,
			0,
			"00"
		],
		IT: [
			"39",
			"00",
			"0\\d{5,11}|1\\d{8,10}|3(?:[0-8]\\d{7,10}|9\\d{7,8})|(?:43|55|70)\\d{8}|8\\d{5}(?:\\d{2,4})?",
			[
				6,
				7,
				8,
				9,
				10,
				11,
				12
			],
			[
				[
					"(\\d{2})(\\d{4,6})",
					"$1 $2",
					["0[26]"]
				],
				[
					"(\\d{3})(\\d{3,6})",
					"$1 $2",
					["0[13-57-9][0159]|8(?:03|4[17]|9[2-5])", "0[13-57-9][0159]|8(?:03|4[17]|9(?:2|3[04]|[45][0-4]))"]
				],
				[
					"(\\d{4})(\\d{2,6})",
					"$1 $2",
					["0(?:[13-579][2-46-8]|8[236-8])"]
				],
				[
					"(\\d{4})(\\d{4})",
					"$1 $2",
					["894"]
				],
				[
					"(\\d{2})(\\d{3,4})(\\d{4})",
					"$1 $2 $3",
					["0[26]|5"]
				],
				[
					"(\\d{3})(\\d{3})(\\d{3,4})",
					"$1 $2 $3",
					["1(?:44|[679])|[378]|43"]
				],
				[
					"(\\d{3})(\\d{3,4})(\\d{4})",
					"$1 $2 $3",
					["0[13-57-9][0159]|14"]
				],
				[
					"(\\d{2})(\\d{4})(\\d{5})",
					"$1 $2 $3",
					["0[26]"]
				],
				[
					"(\\d{4})(\\d{3})(\\d{4})",
					"$1 $2 $3",
					["0"]
				],
				[
					"(\\d{3})(\\d{4})(\\d{4,5})",
					"$1 $2 $3",
					["[03]"]
				]
			],
			0,
			0,
			0,
			0,
			0,
			0,
			[
				["0(?:669[0-79]\\d{1,6}|831\\d{2,8})|0(?:1(?:[0159]\\d|[27][1-5]|31|4[1-4]|6[1356]|8[2-57])|2\\d\\d|3(?:[0159]\\d|2[1-4]|3[12]|[48][1-6]|6[2-59]|7[1-7])|4(?:[0159]\\d|[23][1-9]|4[245]|6[1-5]|7[1-4]|81)|5(?:[0159]\\d|2[1-5]|3[2-6]|4[1-79]|6[4-6]|7[1-578]|8[3-8])|6(?:[0-57-9]\\d|6[0-8])|7(?:[0159]\\d|2[12]|3[1-7]|4[2-46]|6[13569]|7[13-6]|8[1-59])|8(?:[0159]\\d|2[3-578]|3[2356]|[6-8][1-5])|9(?:[0159]\\d|[238][1-5]|4[12]|6[1-8]|7[1-6]))\\d{2,7}"],
				["3[2-9]\\d{7,8}|(?:31|43)\\d{8}", [9, 10]],
				["80(?:0\\d{3}|3)\\d{3}", [6, 9]],
				["(?:0878\\d{3}|89(?:2\\d|3[04]|4(?:[0-4]|[5-9]\\d\\d)|5[0-4]))\\d\\d|(?:1(?:44|6[346])|89(?:38|5[5-9]|9))\\d{6}", [
					6,
					8,
					9,
					10
				]],
				["1(?:78\\d|99)\\d{6}", [9, 10]],
				["3[2-8]\\d{9,10}", [11, 12]],
				0,
				0,
				["55\\d{8}", [10]],
				["84(?:[08]\\d{3}|[17])\\d{3}", [6, 9]]
			]
		],
		JE: [
			"44",
			"00",
			"1534\\d{6}|(?:[3578]\\d|90)\\d{8}",
			[10],
			0,
			"0",
			0,
			"([0-24-8]\\d{5})$|0|180020",
			"1534$1",
			0,
			0,
			[
				["1534[0-24-8]\\d{5}"],
				["7(?:(?:(?:50|82)9|937)\\d|7(?:00[378]|97\\d))\\d{5}"],
				["80(?:07(?:35|81)|8901)\\d{4}"],
				["(?:8(?:4(?:4(?:4(?:05|42|69)|703)|5(?:041|800))|7(?:0002|1206))|90(?:066[59]|1810|71(?:07|55)))\\d{4}"],
				["701511\\d{4}"],
				0,
				["(?:3(?:0(?:07(?:35|81)|8901)|3\\d{4}|4(?:4(?:4(?:05|42|69)|703)|5(?:041|800))|7(?:0002|1206))|55\\d{4})\\d{4}"],
				["76(?:464|652)\\d{5}|76(?:0[0-28]|2[356]|34|4[01347]|5[49]|6[0-369]|77|8[14]|9[139])\\d{6}"],
				["56\\d{8}"]
			]
		],
		JM: [
			"1",
			"011",
			"(?:[58]\\d\\d|658|900)\\d{7}",
			[10],
			0,
			"1",
			0,
			0,
			0,
			0,
			"658|876"
		],
		JO: [
			"962",
			"00",
			"(?:(?:[2689]|7\\d)\\d|32|427|53)\\d{6}",
			[8, 9],
			[
				[
					"(\\d)(\\d{3})(\\d{4})",
					"$1 $2 $3",
					["[2356]|87"],
					"(0$1)"
				],
				[
					"(\\d{3})(\\d{5,6})",
					"$1 $2",
					["[89]"],
					"0$1"
				],
				[
					"(\\d{2})(\\d{7})",
					"$1 $2",
					["70"],
					"0$1"
				],
				[
					"(\\d)(\\d{4})(\\d{4})",
					"$1 $2 $3",
					["[47]"],
					"0$1"
				]
			],
			"0"
		],
		JP: [
			"81",
			"010",
			"00[1-9]\\d{6,14}|[25-9]\\d{9}|(?:00|[1-9]\\d\\d)\\d{6}",
			[
				8,
				9,
				10,
				11,
				12,
				13,
				14,
				15,
				16,
				17
			],
			[
				[
					"(\\d{3})(\\d{3})(\\d{3})",
					"$1-$2-$3",
					["(?:12|57|99)0"],
					"0$1"
				],
				[
					"(\\d{4})(\\d)(\\d{4})",
					"$1-$2-$3",
					[
						"1(?:26|3[79]|4[56]|5[4-68]|6[3-5])|499|5(?:76|97)|746|8(?:3[89]|47|51)|9(?:80|9[16])",
						"1(?:267|3(?:7[247]|9[278])|466|5(?:47|58|64)|6(?:3[245]|48|5[4-68]))|499[2468]|5(?:76|97)9|7468|8(?:3(?:8[7-9]|96)|477|51[2-9])|9(?:802|9(?:1[23]|69))|1(?:45|58)[67]",
						"1(?:267|3(?:7[247]|9[278])|466|5(?:47|58|64)|6(?:3[245]|48|5[4-68]))|499[2468]|5(?:769|979[2-69])|7468|8(?:3(?:8[7-9]|96[2457-9])|477|51[2-9])|9(?:802|9(?:1[23]|69))|1(?:45|58)[67]"
					],
					"0$1"
				],
				[
					"(\\d{2})(\\d{3})(\\d{4})",
					"$1-$2-$3",
					["60"],
					"0$1"
				],
				[
					"(\\d)(\\d{4})(\\d{4})",
					"$1-$2-$3",
					["3|4(?:2[09]|7[01])|6[1-9]", "3|4(?:2(?:0|9[02-69])|7(?:0[019]|1))|6[1-9]"],
					"0$1"
				],
				[
					"(\\d{2})(\\d{3})(\\d{4})",
					"$1-$2-$3",
					[
						"1(?:1|5[45]|77|88|9[69])|2(?:2[1-37]|3[0-269]|4[59]|5|6[24]|7[1-358]|8[1369]|9[0-38])|4(?:[28][1-9]|3[0-57]|[45]|6[248]|7[2-579]|9[29])|5(?:2|3[0459]|4[0-369]|5[29]|8[02389]|9[0-389])|7(?:2[02-46-9]|34|[58]|6[0249]|7[57]|9[2-6])|8(?:2[124589]|3[26-9]|49|51|6|7[0-468]|8[68]|9[019])|9(?:[23][1-9]|4[15]|5[138]|6[1-3]|7[156]|8[189]|9[1-489])",
						"1(?:1|5(?:4[018]|5[017])|77|88|9[69])|2(?:2(?:[127]|3[014-9])|3[0-269]|4[59]|5(?:[1-3]|5[0-69]|9[19])|62|7(?:[1-35]|8[0189])|8(?:[16]|3[0134]|9[0-5])|9(?:[028]|17))|4(?:2(?:[13-79]|8[014-6])|3[0-57]|[45]|6[248]|7[2-47]|8[1-9]|9[29])|5(?:2|3(?:[045]|9[0-8])|4[0-369]|5[29]|8[02389]|9[0-3])|7(?:2[02-46-9]|34|[58]|6[0249]|7[57]|9(?:[23]|4[0-59]|5[01569]|6[0167]))|8(?:2(?:[1258]|4[0-39]|9[0-2469])|3(?:[29]|60)|49|51|6(?:[0-24]|36|5[0-3589]|7[23]|9[01459])|7[0-468]|8[68])|9(?:[23][1-9]|4[15]|5[138]|6[1-3]|7[156]|8[189]|9(?:[1289]|3[34]|4[0178]))|(?:264|837)[016-9]|2(?:57|93)[015-9]|(?:25[0468]|422|838)[01]|(?:47[59]|59[89]|8(?:6[68]|9))[019]",
						"1(?:1|5(?:4[018]|5[017])|77|88|9[69])|2(?:2[127]|3[0-269]|4[59]|5(?:[1-3]|5[0-69]|9(?:17|99))|6(?:2|4[016-9])|7(?:[1-35]|8[0189])|8(?:[16]|3[0134]|9[0-5])|9(?:[028]|17))|4(?:2(?:[13-79]|8[014-6])|3[0-57]|[45]|6[248]|7[2-47]|9[29])|5(?:2|3(?:[045]|9(?:[0-58]|6[4-9]|7[0-35689]))|4[0-369]|5[29]|8[02389]|9[0-3])|7(?:2[02-46-9]|34|[58]|6[0249]|7[57]|9(?:[23]|4[0-59]|5[01569]|6[0167]))|8(?:2(?:[1258]|4[0-39]|9[0169])|3(?:[29]|60|7(?:[017-9]|6[6-8]))|49|51|6(?:[0-24]|36[2-57-9]|5(?:[0-389]|5[23])|6(?:[01]|9[178])|7(?:2[2-468]|3[78])|9[0145])|7[0-468]|8[68])|9(?:4[15]|5[138]|7[156]|8[189]|9(?:[1289]|3(?:31|4[357])|4[0178]))|(?:8294|96)[1-3]|2(?:57|93)[015-9]|(?:223|8699)[014-9]|(?:25[0468]|422|838)[01]|(?:48|8292|9[23])[1-9]|(?:47[59]|59[89]|8(?:68|9))[019]"
					],
					"0$1"
				],
				[
					"(\\d{3})(\\d{2})(\\d{4})",
					"$1-$2-$3",
					["[14]|[289][2-9]|5[3-9]|7[2-4679]"],
					"0$1"
				],
				[
					"(\\d{3})(\\d{3})(\\d{4})",
					"$1-$2-$3",
					["800"],
					"0$1"
				],
				[
					"(\\d{2})(\\d{4})(\\d{4})",
					"$1-$2-$3",
					["[25-9]"],
					"0$1"
				]
			],
			"0",
			0,
			"(000[2569]\\d{4,6})$|(?:(?:003768)0?)|0",
			"$1"
		],
		KE: [
			"254",
			"000",
			"(?:[17]\\d\\d|900)\\d{6}|(?:2|80)0\\d{6,7}|[4-6]\\d{6,8}",
			[
				7,
				8,
				9,
				10
			],
			[
				[
					"(\\d{2})(\\d{5,7})",
					"$1 $2",
					["[24-6]"],
					"0$1"
				],
				[
					"(\\d{3})(\\d{6})",
					"$1 $2",
					["[17]"],
					"0$1"
				],
				[
					"(\\d{3})(\\d{3})(\\d{3,4})",
					"$1 $2 $3",
					["[89]"],
					"0$1"
				]
			],
			"0"
		],
		KG: [
			"996",
			"00",
			"8\\d{9}|[235-9]\\d{8}",
			[9, 10],
			[
				[
					"(\\d{4})(\\d{5})",
					"$1 $2",
					["3(?:1[346]|[24-79])"],
					"0$1"
				],
				[
					"(\\d{3})(\\d{3})(\\d{3})",
					"$1 $2 $3",
					["[235-79]|88"],
					"0$1"
				],
				[
					"(\\d{3})(\\d{3})(\\d)(\\d{2,3})",
					"$1 $2 $3 $4",
					["8"],
					"0$1"
				]
			],
			"0"
		],
		KH: [
			"855",
			"00[14-9]",
			"1\\d{9}|[1-9]\\d{7,8}",
			[
				8,
				9,
				10
			],
			[[
				"(\\d{2})(\\d{3})(\\d{3,4})",
				"$1 $2 $3",
				["[1-9]"],
				"0$1"
			], [
				"(\\d{4})(\\d{3})(\\d{3})",
				"$1 $2 $3",
				["1"]
			]],
			"0"
		],
		KI: [
			"686",
			"00",
			"(?:[37]\\d|6[0-79])\\d{6}|(?:[2-48]\\d|50)\\d{3}",
			[5, 8],
			0,
			"0"
		],
		KM: [
			"269",
			"00",
			"[3478]\\d{6}",
			[7],
			[[
				"(\\d{3})(\\d{2})(\\d{2})",
				"$1 $2 $3",
				["[3478]"]
			]]
		],
		KN: [
			"1",
			"011",
			"(?:[58]\\d\\d|900)\\d{7}",
			[10],
			0,
			"1",
			0,
			"([2-7]\\d{6})$|1",
			"869$1",
			0,
			"869"
		],
		KP: [
			"850",
			"00|99",
			"85\\d{6}|(?:19\\d|[2-7])\\d{7}",
			[8, 10],
			[
				[
					"(\\d{2})(\\d{3})(\\d{3})",
					"$1 $2 $3",
					["8"],
					"0$1"
				],
				[
					"(\\d)(\\d{3})(\\d{4})",
					"$1 $2 $3",
					["[2-7]"],
					"0$1"
				],
				[
					"(\\d{3})(\\d{3})(\\d{4})",
					"$1 $2 $3",
					["1"],
					"0$1"
				]
			],
			"0"
		],
		KR: [
			"82",
			"00(?:[125689]|3(?:[46]5|91)|7(?:00|27|3|55|6[126]))",
			"00[1-9]\\d{8,11}|(?:[12]|5\\d{3})\\d{7}|[13-6]\\d{9}|(?:[1-6]\\d|80)\\d{7}|[3-6]\\d{4,5}|(?:00|7)0\\d{8}",
			[
				5,
				6,
				8,
				9,
				10,
				11,
				12,
				13,
				14
			],
			[
				[
					"(\\d{2})(\\d{3,4})",
					"$1-$2",
					["(?:3[1-3]|[46][1-4]|5[1-5])1"],
					"0$1"
				],
				[
					"(\\d{4})(\\d{4})",
					"$1-$2",
					["1"]
				],
				[
					"(\\d)(\\d{3,4})(\\d{4})",
					"$1-$2-$3",
					["2"],
					"0$1"
				],
				[
					"(\\d{2})(\\d{3})(\\d{4})",
					"$1-$2-$3",
					["[36]0|8"],
					"0$1"
				],
				[
					"(\\d{2})(\\d{3,4})(\\d{4})",
					"$1-$2-$3",
					["[1346]|5[1-5]"],
					"0$1"
				],
				[
					"(\\d{2})(\\d{4})(\\d{4})",
					"$1-$2-$3",
					["[57]"],
					"0$1"
				],
				[
					"(\\d{2})(\\d{5})(\\d{4})",
					"$1-$2-$3",
					["5"],
					"0$1"
				]
			],
			"0",
			0,
			"0(8(?:[1-46-8]|5\\d\\d))?"
		],
		KW: [
			"965",
			"00",
			"18\\d{5}|(?:[2569]\\d|41)\\d{6}",
			[7, 8],
			[[
				"(\\d{4})(\\d{3,4})",
				"$1 $2",
				["[169]|2(?:[235]|4[1-35-9])|52"]
			], [
				"(\\d{3})(\\d{5})",
				"$1 $2",
				["[245]"]
			]]
		],
		KY: [
			"1",
			"011",
			"(?:345|[58]\\d\\d|900)\\d{7}",
			[10],
			0,
			"1",
			0,
			"([2-9]\\d{6})$|1",
			"345$1",
			0,
			"345"
		],
		KZ: [
			"7",
			"810",
			"8\\d{13}|[78]\\d{9}",
			[10, 14],
			0,
			"8",
			0,
			0,
			0,
			0,
			"7",
			0,
			"8~10"
		],
		LA: [
			"856",
			"00",
			"[23]\\d{9}|3\\d{8}|(?:[235-8]\\d|41)\\d{6}",
			[
				8,
				9,
				10
			],
			[
				[
					"(\\d{2})(\\d{3})(\\d{3})",
					"$1 $2 $3",
					["2[13]|3[14]|[4-8]"],
					"0$1"
				],
				[
					"(\\d{2})(\\d{2})(\\d{2})(\\d{3})",
					"$1 $2 $3 $4",
					["3"],
					"0$1"
				],
				[
					"(\\d{2})(\\d{2})(\\d{3})(\\d{3})",
					"$1 $2 $3 $4",
					["[23]"],
					"0$1"
				]
			],
			"0"
		],
		LB: [
			"961",
			"00",
			"[27-9]\\d{7}|[13-9]\\d{6}",
			[7, 8],
			[[
				"(\\d)(\\d{3})(\\d{3})",
				"$1 $2 $3",
				["[13-69]|7(?:[2-57]|62|8[0-6]|9[04-9])|8[02-9]"],
				"0$1"
			], [
				"(\\d{2})(\\d{3})(\\d{3})",
				"$1 $2 $3",
				["[27-9]"]
			]],
			"0"
		],
		LC: [
			"1",
			"011",
			"(?:[58]\\d\\d|758|900)\\d{7}",
			[10],
			0,
			"1",
			0,
			"([2-8]\\d{6})$|1",
			"758$1",
			0,
			"758"
		],
		LI: [
			"423",
			"00",
			"[68]\\d{8}|(?:[2378]\\d|90)\\d{5}",
			[7, 9],
			[
				[
					"(\\d{3})(\\d{2})(\\d{2})",
					"$1 $2 $3",
					["[2379]|8(?:0[09]|7)", "[2379]|8(?:0(?:02|9)|7)"]
				],
				[
					"(\\d{3})(\\d{3})(\\d{3})",
					"$1 $2 $3",
					["8"]
				],
				[
					"(\\d{2})(\\d{3})(\\d{4})",
					"$1 $2 $3",
					["69"]
				],
				[
					"(\\d{3})(\\d{3})(\\d{3})",
					"$1 $2 $3",
					["6"]
				]
			],
			"0",
			0,
			"(1001)|0"
		],
		LK: [
			"94",
			"00",
			"[1-9]\\d{8}",
			[9],
			[[
				"(\\d{2})(\\d{3})(\\d{4})",
				"$1 $2 $3",
				["7"],
				"0$1"
			], [
				"(\\d{3})(\\d{3})(\\d{3})",
				"$1 $2 $3",
				["[1-689]"],
				"0$1"
			]],
			"0"
		],
		LR: [
			"231",
			"00",
			"(?:[2457]\\d|33|88)\\d{7}|(?:2\\d|[4-6])\\d{6}",
			[
				7,
				8,
				9
			],
			[
				[
					"(\\d)(\\d{3})(\\d{3})",
					"$1 $2 $3",
					["4[67]|[56]"],
					"0$1"
				],
				[
					"(\\d{2})(\\d{3})(\\d{3})",
					"$1 $2 $3",
					["2"],
					"0$1"
				],
				[
					"(\\d{2})(\\d{3})(\\d{4})",
					"$1 $2 $3",
					["[2-578]"],
					"0$1"
				]
			],
			"0"
		],
		LS: [
			"266",
			"00",
			"(?:[256]\\d\\d|800)\\d{5}",
			[8],
			[[
				"(\\d{4})(\\d{4})",
				"$1 $2",
				["[2568]"]
			]]
		],
		LT: [
			"370",
			"00",
			"(?:[3469]\\d|52|[78]0)\\d{6}",
			[8],
			[
				[
					"(\\d)(\\d{3})(\\d{4})",
					"$1 $2 $3",
					["52[0-7]"],
					"(0-$1)",
					1
				],
				[
					"(\\d{3})(\\d{2})(\\d{3})",
					"$1 $2 $3",
					["[7-9]"],
					"0 $1",
					1
				],
				[
					"(\\d{2})(\\d{6})",
					"$1 $2",
					["37|4(?:[15]|6[1-8])"],
					"(0-$1)",
					1
				],
				[
					"(\\d{3})(\\d{5})",
					"$1 $2",
					["[3-6]"],
					"(0-$1)",
					1
				]
			],
			"0",
			0,
			"[08]"
		],
		LU: [
			"352",
			"00",
			"35[013-9]\\d{4,8}|6\\d{8}|35\\d{2,4}|(?:[2457-9]\\d|3[0-46-9])\\d{2,9}",
			[
				4,
				5,
				6,
				7,
				8,
				9,
				10,
				11
			],
			[
				[
					"(\\d{2})(\\d{3})",
					"$1 $2",
					["2(?:0[2-689]|[2-9])|[3-57]|8(?:0[2-9]|[13-9])|9(?:0[89]|[2-579])"]
				],
				[
					"(\\d{2})(\\d{2})(\\d{2})",
					"$1 $2 $3",
					["2(?:0[2-689]|[2-9])|[3-57]|8(?:0[2-9]|[13-9])|9(?:0[89]|[2-579])"]
				],
				[
					"(\\d{2})(\\d{2})(\\d{3})",
					"$1 $2 $3",
					["20[2-689]"]
				],
				[
					"(\\d{2})(\\d{2})(\\d{2})(\\d{1,2})",
					"$1 $2 $3 $4",
					["20"]
				],
				[
					"(\\d{2})(\\d{2})(\\d{2})(\\d{1,5})",
					"$1 $2 $3 $4",
					["[3-57]|8[13-9]|9(?:0[89]|[2-579])|(?:2|80)[2-9]"]
				],
				[
					"(\\d{3})(\\d{2})(\\d{3})",
					"$1 $2 $3",
					["80[01]|90[015]"]
				],
				[
					"(\\d{2})(\\d{2})(\\d{2})(\\d{3})",
					"$1 $2 $3 $4",
					["20"]
				],
				[
					"(\\d{3})(\\d{3})(\\d{3})",
					"$1 $2 $3",
					["6"]
				],
				[
					"(\\d{2})(\\d{2})(\\d{2})(\\d{2})(\\d{1,2})",
					"$1 $2 $3 $4 $5",
					["20"]
				]
			],
			0,
			0,
			"(15(?:0[06]|1[12]|[35]5|4[04]|6[26]|77|88|99)\\d)"
		],
		LV: [
			"371",
			"00",
			"(?:[268]\\d|78|90)\\d{6}",
			[8],
			[[
				"(\\d{2})(\\d{3})(\\d{3})",
				"$1 $2 $3",
				["[2679]|8[01]"]
			]]
		],
		LY: [
			"218",
			"00",
			"[2-9]\\d{8}",
			[9],
			[[
				"(\\d{2})(\\d{7})",
				"$1-$2",
				["[2-9]"],
				"0$1"
			]],
			"0"
		],
		MA: [
			"212",
			"00",
			"[5-8]\\d{8}",
			[9],
			[
				[
					"(\\d{4})(\\d{5})",
					"$1-$2",
					["892"],
					"0$1"
				],
				[
					"(\\d{2})(\\d{7})",
					"$1-$2",
					["8(?:0[0-7]|9)"],
					"0$1"
				],
				[
					"(\\d)(\\d{2})(\\d{2})(\\d{2})(\\d{2})",
					"$1 $2 $3 $4 $5",
					["[5-8]"],
					"0$1"
				]
			],
			"0",
			0,
			0,
			0,
			0,
			"[5-8]"
		],
		MC: [
			"377",
			"00",
			"(?:[3489]|[67]\\d)\\d{7}",
			[8, 9],
			[
				[
					"(\\d{2})(\\d{3})(\\d{3})",
					"$1 $2 $3",
					["4"],
					"0$1"
				],
				[
					"(\\d{2})(\\d{2})(\\d{2})(\\d{2})",
					"$1 $2 $3 $4",
					["[389]"]
				],
				[
					"(\\d)(\\d{2})(\\d{2})(\\d{2})(\\d{2})",
					"$1 $2 $3 $4 $5",
					["[67]"],
					"0$1"
				]
			],
			"0"
		],
		MD: [
			"373",
			"00",
			"(?:[235-7]\\d|[89]0)\\d{6}",
			[8],
			[
				[
					"(\\d{3})(\\d{5})",
					"$1 $2",
					["[89]"],
					"0$1"
				],
				[
					"(\\d{2})(\\d{3})(\\d{3})",
					"$1 $2 $3",
					["22|3"],
					"0$1"
				],
				[
					"(\\d{3})(\\d{2})(\\d{3})",
					"$1 $2 $3",
					["[25-7]"],
					"0$1"
				]
			],
			"0"
		],
		ME: [
			"382",
			"00",
			"(?:20|[3-79]\\d)\\d{6}|80\\d{6,7}",
			[8, 9],
			[[
				"(\\d{2})(\\d{3})(\\d{3,4})",
				"$1 $2 $3",
				["[2-9]"],
				"0$1"
			]],
			"0"
		],
		MF: [
			"590",
			"00",
			"7090\\d{5}|(?:[56]9|[89]\\d)\\d{7}",
			[9],
			0,
			"0",
			0,
			0,
			0,
			0,
			0,
			[
				["(?:59(?:0(?:0[079]|[14]3|[27][79]|3[03-7]|5[0-268]|87)|87\\d)|80[6-9]\\d\\d)\\d{4}"],
				["(?:69(?:0\\d\\d|1(?:2[2-9]|3[0-5]))|7090[0-4])\\d{4}"],
				["80[0-5]\\d{6}"],
				["8[129]\\d{7}"],
				0,
				0,
				0,
				0,
				["9(?:(?:39[5-7]|76[018])\\d|475[0-6])\\d{4}"]
			]
		],
		MG: [
			"261",
			"00",
			"[23]\\d{8}",
			[9],
			[[
				"(\\d{2})(\\d{2})(\\d{3})(\\d{2})",
				"$1 $2 $3 $4",
				["[23]"],
				"0$1"
			]],
			"0",
			0,
			"([24-9]\\d{6})$|0",
			"20$1"
		],
		MH: [
			"692",
			"011",
			"329\\d{4}|(?:[256]\\d|45)\\d{5}",
			[7],
			[[
				"(\\d{3})(\\d{4})",
				"$1-$2",
				["[2-6]"]
			]],
			"1"
		],
		MK: [
			"389",
			"00",
			"[2-578]\\d{7}",
			[8],
			[
				[
					"(\\d)(\\d{3})(\\d{4})",
					"$1 $2 $3",
					["2|34[47]|4(?:[37]7|5[47]|64)"],
					"0$1"
				],
				[
					"(\\d{2})(\\d{3})(\\d{3})",
					"$1 $2 $3",
					["[347]"],
					"0$1"
				],
				[
					"(\\d{3})(\\d)(\\d{2})(\\d{2})",
					"$1 $2 $3 $4",
					["[58]"],
					"0$1"
				]
			],
			"0"
		],
		ML: [
			"223",
			"00",
			"[24-9]\\d{7}",
			[8],
			[[
				"(\\d{2})(\\d{2})(\\d{2})(\\d{2})",
				"$1 $2 $3 $4",
				["[24-9]"]
			]]
		],
		MM: [
			"95",
			"00",
			"1\\d{5,7}|95\\d{6}|(?:[4-7]|9[0-46-9])\\d{6,8}|(?:2|8\\d)\\d{5,8}",
			[
				6,
				7,
				8,
				9,
				10
			],
			[
				[
					"(\\d)(\\d{2})(\\d{3})",
					"$1 $2 $3",
					["16|2"],
					"0$1"
				],
				[
					"(\\d{2})(\\d{2})(\\d{3})",
					"$1 $2 $3",
					["4(?:[2-46]|5[3-5])|5|6(?:[1-689]|7[235-7])|7(?:[0-4]|5[2-7])|8[1-5]|(?:60|86)[23]"],
					"0$1"
				],
				[
					"(\\d)(\\d{3})(\\d{3,4})",
					"$1 $2 $3",
					["[12]|452|678|86", "[12]|452|6788|86"],
					"0$1"
				],
				[
					"(\\d{2})(\\d{3})(\\d{3,4})",
					"$1 $2 $3",
					["[4-7]|8[1-35]"],
					"0$1"
				],
				[
					"(\\d)(\\d{3})(\\d{4,6})",
					"$1 $2 $3",
					["9(?:2[0-4]|[35-9]|4[137-9])"],
					"0$1"
				],
				[
					"(\\d)(\\d{4})(\\d{4})",
					"$1 $2 $3",
					["2"],
					"0$1"
				],
				[
					"(\\d{3})(\\d{3})(\\d{4})",
					"$1 $2 $3",
					["8"],
					"0$1"
				],
				[
					"(\\d)(\\d{3})(\\d{3})(\\d{3})",
					"$1 $2 $3 $4",
					["92"],
					"0$1"
				],
				[
					"(\\d)(\\d{5})(\\d{4})",
					"$1 $2 $3",
					["9"],
					"0$1"
				]
			],
			"0"
		],
		MN: [
			"976",
			"001",
			"[12]\\d{7,9}|[5-9]\\d{7}",
			[
				8,
				9,
				10
			],
			[
				[
					"(\\d{2})(\\d{2})(\\d{4})",
					"$1 $2 $3",
					["11|2[16]"],
					"0$1"
				],
				[
					"(\\d{4})(\\d{4})",
					"$1 $2",
					["[5-9]"]
				],
				[
					"(\\d{3})(\\d{5,6})",
					"$1 $2",
					["[12]2[1-3]"],
					"0$1"
				],
				[
					"(\\d{4})(\\d{5,6})",
					"$1 $2",
					["[12](?:27|3[2-8]|4[2-68]|5[1-4689])", "[12](?:27|3[2-8]|4[2-68]|5[1-4689])[0-3]"],
					"0$1"
				],
				[
					"(\\d{5})(\\d{4,5})",
					"$1 $2",
					["[12]"],
					"0$1"
				]
			],
			"0"
		],
		MO: [
			"853",
			"00",
			"0800\\d{3}|(?:28|[68]\\d)\\d{6}",
			[7, 8],
			[[
				"(\\d{4})(\\d{3})",
				"$1 $2",
				["0"]
			], [
				"(\\d{4})(\\d{4})",
				"$1 $2",
				["[268]"]
			]]
		],
		MP: [
			"1",
			"011",
			"[58]\\d{9}|(?:67|90)0\\d{7}",
			[10],
			0,
			"1",
			0,
			"([2-9]\\d{6})$|1",
			"670$1",
			0,
			"670"
		],
		MQ: [
			"596",
			"00",
			"7091\\d{5}|(?:[56]9|[89]\\d)\\d{7}",
			[9],
			[[
				"(\\d{3})(\\d{2})(\\d{2})(\\d{2})",
				"$1 $2 $3 $4",
				["[5-79]|8(?:0[6-9]|[36])"],
				"0$1"
			], [
				"(\\d{3})(\\d{2})(\\d{2})(\\d{2})",
				"$1 $2 $3 $4",
				["8"],
				"0$1"
			]],
			"0"
		],
		MR: [
			"222",
			"00",
			"(?:[2-4]\\d\\d|800)\\d{5}",
			[8],
			[[
				"(\\d{2})(\\d{2})(\\d{2})(\\d{2})",
				"$1 $2 $3 $4",
				["[2-48]"]
			]]
		],
		MS: [
			"1",
			"011",
			"(?:[58]\\d\\d|664|900)\\d{7}",
			[10],
			0,
			"1",
			0,
			"([34]\\d{6})$|1",
			"664$1",
			0,
			"664"
		],
		MT: [
			"356",
			"00",
			"3550\\d{4}|(?:[2579]\\d\\d|800)\\d{5}",
			[8],
			[[
				"(\\d{4})(\\d{4})",
				"$1 $2",
				["[2357-9]"]
			]]
		],
		MU: [
			"230",
			"0(?:0|[24-7]0|3[03])",
			"(?:[57]|8\\d\\d)\\d{7}|[2-468]\\d{6}",
			[
				7,
				8,
				10
			],
			[
				[
					"(\\d{3})(\\d{4})",
					"$1 $2",
					["[2-46]|8[013]"]
				],
				[
					"(\\d{4})(\\d{4})",
					"$1 $2",
					["[57]"]
				],
				[
					"(\\d{5})(\\d{5})",
					"$1 $2",
					["8"]
				]
			],
			0,
			0,
			0,
			0,
			0,
			0,
			0,
			"020"
		],
		MV: [
			"960",
			"0(?:0|19)",
			"(?:800|9[0-57-9]\\d)\\d{7}|[34679]\\d{6}",
			[7, 10],
			[[
				"(\\d{3})(\\d{4})",
				"$1-$2",
				["[34679]"]
			], [
				"(\\d{3})(\\d{3})(\\d{4})",
				"$1 $2 $3",
				["[89]"]
			]],
			0,
			0,
			0,
			0,
			0,
			0,
			0,
			"00"
		],
		MW: [
			"265",
			"00",
			"(?:[1289]\\d|31|77)\\d{7}|1\\d{6}",
			[7, 9],
			[[
				"(\\d)(\\d{3})(\\d{3})",
				"$1 $2 $3",
				["1[2-9]"],
				"0$1"
			], [
				"(\\d{3})(\\d{2})(\\d{2})(\\d{2})",
				"$1 $2 $3 $4",
				["[1-37-9]"],
				"0$1"
			]],
			"0"
		],
		MX: [
			"52",
			"0[09]",
			"[2-9]\\d{9}",
			[10],
			[[
				"(\\d{2})(\\d{4})(\\d{4})",
				"$1 $2 $3",
				["33|5[56]|81"]
			], [
				"(\\d{3})(\\d{3})(\\d{4})",
				"$1 $2 $3",
				["[2-9]"]
			]],
			0,
			0,
			0,
			0,
			0,
			0,
			0,
			"00"
		],
		MY: [
			"60",
			"00",
			"1\\d{8,9}|(?:3\\d|[4-9])\\d{7}",
			[
				8,
				9,
				10
			],
			[
				[
					"(\\d)(\\d{3})(\\d{4})",
					"$1-$2 $3",
					["[4-79]"],
					"0$1"
				],
				[
					"(\\d{2})(\\d{3})(\\d{3,4})",
					"$1-$2 $3",
					["1(?:[02469]|[378][1-9]|53)|8", "1(?:[02469]|[37][1-9]|53|8(?:[1-46-9]|5[7-9]))|8"],
					"0$1"
				],
				[
					"(\\d)(\\d{4})(\\d{4})",
					"$1-$2 $3",
					["3"],
					"0$1"
				],
				[
					"(\\d)(\\d{3})(\\d{2})(\\d{4})",
					"$1-$2-$3-$4",
					["1(?:[367]|80)"]
				],
				[
					"(\\d{3})(\\d{3})(\\d{4})",
					"$1-$2 $3",
					["15"],
					"0$1"
				],
				[
					"(\\d{2})(\\d{4})(\\d{4})",
					"$1-$2 $3",
					["1"],
					"0$1"
				]
			],
			"0"
		],
		MZ: [
			"258",
			"00",
			"(?:2|8\\d)\\d{7}",
			[8, 9],
			[[
				"(\\d{2})(\\d{3})(\\d{3,4})",
				"$1 $2 $3",
				["2|8[2-9]"]
			], [
				"(\\d{3})(\\d{3})(\\d{3})",
				"$1 $2 $3",
				["8"]
			]]
		],
		NA: [
			"264",
			"00",
			"[68]\\d{7,8}",
			[8, 9],
			[
				[
					"(\\d{2})(\\d{3})(\\d{3})",
					"$1 $2 $3",
					["88"],
					"0$1"
				],
				[
					"(\\d{2})(\\d{3})(\\d{3,4})",
					"$1 $2 $3",
					["6"],
					"0$1"
				],
				[
					"(\\d{3})(\\d{3})(\\d{3})",
					"$1 $2 $3",
					["87"],
					"0$1"
				],
				[
					"(\\d{2})(\\d{3})(\\d{4})",
					"$1 $2 $3",
					["8"],
					"0$1"
				]
			],
			"0"
		],
		NC: [
			"687",
			"00",
			"(?:050|[2-57-9]\\d\\d)\\d{3}",
			[6],
			[[
				"(\\d{2})(\\d{2})(\\d{2})",
				"$1.$2.$3",
				["[02-57-9]"]
			]]
		],
		NE: [
			"227",
			"00",
			"[027-9]\\d{7}",
			[8],
			[[
				"(\\d{2})(\\d{3})(\\d{3})",
				"$1 $2 $3",
				["08"]
			], [
				"(\\d{2})(\\d{2})(\\d{2})(\\d{2})",
				"$1 $2 $3 $4",
				["[089]|2[013]|7[0467]"]
			]]
		],
		NF: [
			"672",
			"00",
			"[13]\\d{5}",
			[6],
			[[
				"(\\d{2})(\\d{4})",
				"$1 $2",
				["1[0-3]"]
			], [
				"(\\d)(\\d{5})",
				"$1 $2",
				["[13]"]
			]],
			0,
			0,
			"([0-258]\\d{4})$",
			"3$1"
		],
		NG: [
			"234",
			"009",
			"(?:20|9\\d)\\d{8}|[78]\\d{9,13}",
			[
				10,
				11,
				12,
				13,
				14
			],
			[
				[
					"(\\d{3})(\\d{3})(\\d{3,4})",
					"$1 $2 $3",
					["[7-9]"],
					"0$1"
				],
				[
					"(\\d{3})(\\d{3})(\\d{4})",
					"$1 $2 $3",
					["20[129]"],
					"0$1"
				],
				[
					"(\\d{4})(\\d{2})(\\d{4})",
					"$1 $2 $3",
					["2"],
					"0$1"
				],
				[
					"(\\d{3})(\\d{4})(\\d{4,5})",
					"$1 $2 $3",
					["[78]"],
					"0$1"
				],
				[
					"(\\d{3})(\\d{5})(\\d{5,6})",
					"$1 $2 $3",
					["[78]"],
					"0$1"
				]
			],
			"0"
		],
		NI: [
			"505",
			"00",
			"(?:1800|[25-8]\\d{3})\\d{4}",
			[8],
			[[
				"(\\d{4})(\\d{4})",
				"$1 $2",
				["[125-8]"]
			]]
		],
		NL: [
			"31",
			"00",
			"(?:[124-7]\\d\\d|3(?:[02-9]\\d|1[0-8]))\\d{6}|8\\d{6,9}|9\\d{6,10}|1\\d{4,5}",
			[
				5,
				6,
				7,
				8,
				9,
				10,
				11
			],
			[
				[
					"(\\d{3})(\\d{4,7})",
					"$1 $2",
					["[89]0"],
					"0$1"
				],
				[
					"(\\d{2})(\\d{7})",
					"$1 $2",
					["66"],
					"0$1"
				],
				[
					"(\\d)(\\d{8})",
					"$1 $2",
					["6"],
					"0$1"
				],
				[
					"(\\d{3})(\\d{3})(\\d{3})",
					"$1 $2 $3",
					["1[16-8]|2[259]|3[124]|4[17-9]|5[124679]"],
					"0$1"
				],
				[
					"(\\d{2})(\\d{3})(\\d{4})",
					"$1 $2 $3",
					["[1-578]|91"],
					"0$1"
				],
				[
					"(\\d{3})(\\d{3})(\\d{5})",
					"$1 $2 $3",
					["9"],
					"0$1"
				]
			],
			"0"
		],
		NO: [
			"47",
			"00",
			"(?:0|[2-9]\\d{3})\\d{4}",
			[5, 8],
			[[
				"(\\d{3})(\\d{2})(\\d{3})",
				"$1 $2 $3",
				["8"]
			], [
				"(\\d{2})(\\d{2})(\\d{2})(\\d{2})",
				"$1 $2 $3 $4",
				["[2-79]"]
			]],
			0,
			0,
			0,
			0,
			0,
			"[02-689]|7[0-8]"
		],
		NP: [
			"977",
			"00",
			"(?:1\\d|9)\\d{9}|[1-9]\\d{7}",
			[
				8,
				10,
				11
			],
			[
				[
					"(\\d)(\\d{7})",
					"$1-$2",
					["1[2-6]"],
					"0$1"
				],
				[
					"(\\d{2})(\\d{6})",
					"$1-$2",
					["1[01]|[2-8]|9(?:[1-59]|[67][2-6])"],
					"0$1"
				],
				[
					"(\\d{3})(\\d{7})",
					"$1-$2",
					["9"]
				]
			],
			"0"
		],
		NR: [
			"674",
			"00",
			"(?:222|444|(?:55|8\\d)\\d|666|777|999)\\d{4}",
			[7],
			[[
				"(\\d{3})(\\d{4})",
				"$1 $2",
				["[24-9]"]
			]]
		],
		NU: [
			"683",
			"00",
			"(?:[4-7]|888\\d)\\d{3}",
			[4, 7],
			[[
				"(\\d{3})(\\d{4})",
				"$1 $2",
				["8"]
			]]
		],
		NZ: [
			"64",
			"0(?:0|161)",
			"[1289]\\d{9}|50\\d{5}(?:\\d{2,3})?|[27-9]\\d{7,8}|(?:[34]\\d|6[0-35-9])\\d{6}|8\\d{4,6}",
			[
				5,
				6,
				7,
				8,
				9,
				10
			],
			[
				[
					"(\\d{2})(\\d{3,8})",
					"$1 $2",
					["8[1-79]"],
					"0$1"
				],
				[
					"(\\d{3})(\\d{2})(\\d{2,3})",
					"$1 $2 $3",
					["50[036-8]|8|90", "50(?:[0367]|88)|8|90"],
					"0$1"
				],
				[
					"(\\d)(\\d{3})(\\d{4})",
					"$1 $2 $3",
					["24|[346]|7[2-57-9]|9[2-9]"],
					"0$1"
				],
				[
					"(\\d{3})(\\d{3})(\\d{3,4})",
					"$1 $2 $3",
					["2(?:10|74)|[589]"],
					"0$1"
				],
				[
					"(\\d{2})(\\d{3,4})(\\d{4})",
					"$1 $2 $3",
					["1|2[028]"],
					"0$1"
				],
				[
					"(\\d{2})(\\d{3})(\\d{3,5})",
					"$1 $2 $3",
					["2(?:[169]|7[0-35-9])|7"],
					"0$1"
				]
			],
			"0",
			0,
			0,
			0,
			0,
			0,
			0,
			"00"
		],
		OM: [
			"968",
			"00",
			"(?:1505|[279]\\d{3}|500)\\d{4}|800\\d{5,6}",
			[
				7,
				8,
				9
			],
			[
				[
					"(\\d{3})(\\d{4,6})",
					"$1 $2",
					["[58]"]
				],
				[
					"(\\d{2})(\\d{6})",
					"$1 $2",
					["2"]
				],
				[
					"(\\d{4})(\\d{4})",
					"$1 $2",
					["[179]"]
				]
			]
		],
		PA: [
			"507",
			"00",
			"(?:00800|8\\d{3})\\d{6}|[68]\\d{7}|[1-57-9]\\d{6}",
			[
				7,
				8,
				10,
				11
			],
			[
				[
					"(\\d{3})(\\d{4})",
					"$1-$2",
					["[1-57-9]"]
				],
				[
					"(\\d{4})(\\d{4})",
					"$1-$2",
					["[68]"]
				],
				[
					"(\\d{3})(\\d{3})(\\d{4})",
					"$1 $2 $3",
					["8"]
				]
			]
		],
		PE: [
			"51",
			"00|19(?:1[124]|77|90)00",
			"(?:[14-8]|9\\d)\\d{7}",
			[8, 9],
			[
				[
					"(\\d{3})(\\d{5})",
					"$1 $2",
					["80"],
					"(0$1)"
				],
				[
					"(\\d)(\\d{7})",
					"$1 $2",
					["1"],
					"(0$1)"
				],
				[
					"(\\d{2})(\\d{6})",
					"$1 $2",
					["[4-8]"],
					"(0$1)"
				],
				[
					"(\\d{3})(\\d{3})(\\d{3})",
					"$1 $2 $3",
					["9"]
				]
			],
			"0",
			0,
			0,
			0,
			0,
			0,
			0,
			"00",
			" Anexo "
		],
		PF: [
			"689",
			"00",
			"4\\d{5}(?:\\d{2})?|8\\d{7,8}",
			[
				6,
				8,
				9
			],
			[
				[
					"(\\d{2})(\\d{2})(\\d{2})",
					"$1 $2 $3",
					["44"]
				],
				[
					"(\\d{2})(\\d{2})(\\d{2})(\\d{2})",
					"$1 $2 $3 $4",
					["4|8[7-9]"]
				],
				[
					"(\\d{3})(\\d{2})(\\d{2})(\\d{2})",
					"$1 $2 $3 $4",
					["8"]
				]
			]
		],
		PG: [
			"675",
			"00|140[1-3]",
			"(?:180|[78]\\d{3})\\d{4}|(?:[2-589]\\d|64)\\d{5}",
			[7, 8],
			[[
				"(\\d{3})(\\d{4})",
				"$1 $2",
				["18|[2-69]|85[02-46-9]"]
			], [
				"(\\d{4})(\\d{4})",
				"$1 $2",
				["[78]"]
			]],
			0,
			0,
			0,
			0,
			0,
			0,
			0,
			"00"
		],
		PH: [
			"63",
			"00",
			"(?:[2-7]|9\\d)\\d{8}|2\\d{5}|(?:1800|8)\\d{7,9}",
			[
				6,
				8,
				9,
				10,
				11,
				12,
				13
			],
			[
				[
					"(\\d)(\\d{5})",
					"$1 $2",
					["2"],
					"(0$1)"
				],
				[
					"(\\d{4})(\\d{4,6})",
					"$1 $2",
					["3(?:23|39|46)|4(?:2[3-6]|[35]9|4[26]|76)|544|88[245]|(?:52|64|86)2", "3(?:230|397|461)|4(?:2(?:35|[46]4|51)|396|4(?:22|63)|59[347]|76[15])|5(?:221|446)|642[23]|8(?:622|8(?:[24]2|5[13]))"],
					"(0$1)"
				],
				[
					"(\\d{5})(\\d{4})",
					"$1 $2",
					["346|4(?:27|9[35])|883", "3469|4(?:279|9(?:30|56))|8834"],
					"(0$1)"
				],
				[
					"(\\d)(\\d{4})(\\d{4})",
					"$1 $2 $3",
					["2"],
					"(0$1)"
				],
				[
					"(\\d{2})(\\d{3})(\\d{4})",
					"$1 $2 $3",
					["[3-7]|8[2-8]"],
					"(0$1)"
				],
				[
					"(\\d{3})(\\d{3})(\\d{4})",
					"$1 $2 $3",
					["[89]"],
					"0$1"
				],
				[
					"(\\d{4})(\\d{3})(\\d{4})",
					"$1 $2 $3",
					["1"]
				],
				[
					"(\\d{4})(\\d{1,2})(\\d{3})(\\d{4})",
					"$1 $2 $3 $4",
					["1"]
				]
			],
			"0"
		],
		PK: [
			"92",
			"00",
			"122\\d{6}|[24-8]\\d{10,11}|9(?:[013-9]\\d{8,10}|2(?:[01]\\d\\d|2(?:[06-8]\\d|1[01]))\\d{7})|(?:[2-8]\\d{3}|92(?:[0-7]\\d|8[1-9]))\\d{6}|[24-9]\\d{8}|[89]\\d{7}",
			[
				8,
				9,
				10,
				11,
				12
			],
			[
				[
					"(\\d{3})(\\d{3})(\\d{2,7})",
					"$1 $2 $3",
					["[89]0"],
					"0$1"
				],
				[
					"(\\d{4})(\\d{5})",
					"$1 $2",
					["1"]
				],
				[
					"(\\d{3})(\\d{6,7})",
					"$1 $2",
					["2(?:3[2358]|4[2-4]|9[2-8])|45[3479]|54[2-467]|60[468]|72[236]|8(?:2[2-689]|3[23578]|4[3478]|5[2356])|9(?:2[2-8]|3[27-9]|4[2-6]|6[3569]|9[25-8])", "9(?:2[3-8]|98)|(?:2(?:3[2358]|4[2-4]|9[2-8])|45[3479]|54[2-467]|60[468]|72[236]|8(?:2[2-689]|3[23578]|4[3478]|5[2356])|9(?:22|3[27-9]|4[2-6]|6[3569]|9[25-7]))[2-9]"],
					"(0$1)"
				],
				[
					"(\\d{2})(\\d{7,8})",
					"$1 $2",
					["(?:2[125]|4[0-246-9]|5[1-35-7]|6[1-8]|7[14]|8[16]|91)[2-9]"],
					"(0$1)"
				],
				[
					"(\\d{5})(\\d{5})",
					"$1 $2",
					["58"],
					"(0$1)"
				],
				[
					"(\\d{3})(\\d{7})",
					"$1 $2",
					["3"],
					"0$1"
				],
				[
					"(\\d{2})(\\d{3})(\\d{3})(\\d{3})",
					"$1 $2 $3 $4",
					["2[125]|4[0-246-9]|5[1-35-7]|6[1-8]|7[14]|8[16]|91"],
					"(0$1)"
				],
				[
					"(\\d{3})(\\d{3})(\\d{3})(\\d{3})",
					"$1 $2 $3 $4",
					["[24-9]"],
					"(0$1)"
				]
			],
			"0"
		],
		PL: [
			"48",
			"00",
			"(?:6|8\\d\\d)\\d{7}|[1-9]\\d{6}(?:\\d{2})?|[26]\\d{5}",
			[
				6,
				7,
				8,
				9,
				10
			],
			[
				[
					"(\\d{5})",
					"$1",
					["19"]
				],
				[
					"(\\d{3})(\\d{3})",
					"$1 $2",
					["11|20|64"]
				],
				[
					"(\\d{2})(\\d{2})(\\d{3})",
					"$1 $2 $3",
					["30|(?:1[2-8]|2[2-69]|3[2-4]|4[1-468]|5[24-689]|6[1-3578]|7[14-7]|8[1-79]|9[145])1", "30|(?:1[2-8]|2[2-69]|3[2-4]|4[1-468]|5[24-689]|6[1-3578]|7[14-7]|8[1-79]|9[145])19"]
				],
				[
					"(\\d{3})(\\d{2})(\\d{2,3})",
					"$1 $2 $3",
					["64"]
				],
				[
					"(\\d{3})(\\d{3})(\\d{3})",
					"$1 $2 $3",
					["21|39|45|5[0137]|6[0469]|7[02389]|8(?:0[14]|8)"]
				],
				[
					"(\\d{2})(\\d{3})(\\d{2})(\\d{2})",
					"$1 $2 $3 $4",
					["1[2-8]|[2-7]|8[1-79]|9[145]"]
				],
				[
					"(\\d{3})(\\d{3})(\\d{3,4})",
					"$1 $2 $3",
					["8"]
				]
			]
		],
		PM: [
			"508",
			"00",
			"[78]\\d{8}|[2-9]\\d{5}",
			[6, 9],
			[
				[
					"(\\d{2})(\\d{2})(\\d{2})",
					"$1 $2 $3",
					["[2-9]"],
					"0$1"
				],
				[
					"(\\d{3})(\\d{3})(\\d{3})",
					"$1 $2 $3",
					["7"]
				],
				[
					"(\\d{3})(\\d{2})(\\d{2})(\\d{2})",
					"$1 $2 $3 $4",
					["8"],
					"0$1"
				]
			],
			"0"
		],
		PR: [
			"1",
			"011",
			"(?:[589]\\d\\d|787)\\d{7}",
			[10],
			0,
			"1",
			0,
			0,
			0,
			0,
			"787|939"
		],
		PS: [
			"970",
			"00",
			"[2489]2\\d{6}|(?:1\\d|5)\\d{8}",
			[
				8,
				9,
				10
			],
			[
				[
					"(\\d)(\\d{3})(\\d{4})",
					"$1 $2 $3",
					["[2489]"],
					"0$1"
				],
				[
					"(\\d{3})(\\d{3})(\\d{3})",
					"$1 $2 $3",
					["5"],
					"0$1"
				],
				[
					"(\\d{4})(\\d{3})(\\d{3})",
					"$1 $2 $3",
					["1"]
				]
			],
			"0"
		],
		PT: [
			"351",
			"00",
			"1693\\d{5}|(?:[26-9]\\d|30)\\d{7}",
			[9],
			[[
				"(\\d{2})(\\d{3})(\\d{4})",
				"$1 $2 $3",
				["2[12]"]
			], [
				"(\\d{3})(\\d{3})(\\d{3})",
				"$1 $2 $3",
				["16|[236-9]"]
			]]
		],
		PW: [
			"680",
			"01[12]",
			"(?:[24-8]\\d\\d|345|900)\\d{4}",
			[7],
			[[
				"(\\d{3})(\\d{4})",
				"$1 $2",
				["[2-9]"]
			]]
		],
		PY: [
			"595",
			"00",
			"[36-8]\\d{5,8}|4\\d{6,8}|59\\d{6}|9\\d{5,10}|(?:2\\d|5[0-8])\\d{6,7}",
			[
				6,
				7,
				8,
				9,
				10,
				11
			],
			[
				[
					"(\\d{3})(\\d{3,6})",
					"$1 $2",
					["[2-9]0"],
					"0$1"
				],
				[
					"(\\d{2})(\\d{5})",
					"$1 $2",
					["3[289]|4[246-8]|61|7[1-3]|8[1-36]"],
					"(0$1)"
				],
				[
					"(\\d{3})(\\d{4,5})",
					"$1 $2",
					["2[279]|3[13-5]|4[359]|5|6(?:[34]|7[1-46-8])|7[46-8]|85"],
					"(0$1)"
				],
				[
					"(\\d{2})(\\d{3})(\\d{3,4})",
					"$1 $2 $3",
					["2[14-68]|3[26-9]|4[1246-8]|6(?:1|75)|7[1-35]|8[1-36]"],
					"(0$1)"
				],
				[
					"(\\d{2})(\\d{3})(\\d{4})",
					"$1 $2 $3",
					["87"]
				],
				[
					"(\\d{3})(\\d{6})",
					"$1 $2",
					["9(?:[5-79]|8[1-7])"],
					"0$1"
				],
				[
					"(\\d{3})(\\d{3})(\\d{3})",
					"$1 $2 $3",
					["[2-8]"],
					"0$1"
				],
				[
					"(\\d{4})(\\d{3})(\\d{4})",
					"$1 $2 $3",
					["9"]
				]
			],
			"0"
		],
		QA: [
			"974",
			"00",
			"800\\d{4}|(?:2|800)\\d{6}|(?:0080|[3-7])\\d{7}",
			[
				7,
				8,
				9,
				11
			],
			[[
				"(\\d{3})(\\d{4})",
				"$1 $2",
				["2[136]|8"]
			], [
				"(\\d{4})(\\d{4})",
				"$1 $2",
				["[3-7]"]
			]]
		],
		RE: [
			"262",
			"00",
			"709\\d{6}|(?:26|[689]\\d)\\d{7}",
			[9],
			[[
				"(\\d{3})(\\d{2})(\\d{2})(\\d{2})",
				"$1 $2 $3 $4",
				["[26-9]"],
				"0$1"
			]],
			"0",
			0,
			0,
			0,
			0,
			0,
			[
				["2631[0-6]\\d{4}|26(?:2\\d|30|88)\\d{5}"],
				["(?:69(?:2\\d\\d|3(?:[06][0-6]|1[0-3]|2[0-2]|3[0-39]|4\\d|5[0-5]|7[0-37]|8[0-8]|9[0-479]))|7092[0-3])\\d{4}"],
				["80\\d{7}"],
				["89[1-37-9]\\d{6}"],
				0,
				0,
				0,
				0,
				["9(?:399[0-3]|479[0-6]|76(?:2[278]|3[0-37]))\\d{4}"],
				["8(?:1[019]|2[0156]|84|90)\\d{6}"]
			]
		],
		RO: [
			"40",
			"00",
			"(?:[236-8]\\d|90)\\d{7}|[23]\\d{5}",
			[6, 9],
			[
				[
					"(\\d{3})(\\d{3})",
					"$1 $2",
					["2[3-6]", "2[3-6]\\d9"],
					"0$1"
				],
				[
					"(\\d{2})(\\d{4})",
					"$1 $2",
					["219|31"],
					"0$1"
				],
				[
					"(\\d{2})(\\d{3})(\\d{4})",
					"$1 $2 $3",
					["[23]1"],
					"0$1"
				],
				[
					"(\\d{3})(\\d{3})(\\d{3})",
					"$1 $2 $3",
					["[236-9]"],
					"0$1"
				]
			],
			"0",
			0,
			0,
			0,
			0,
			0,
			0,
			0,
			" int "
		],
		RS: [
			"381",
			"00",
			"38[02-9]\\d{6,9}|6\\d{7,9}|90\\d{4,8}|38\\d{5,6}|(?:7\\d\\d|800)\\d{3,9}|(?:[12]\\d|3[0-79])\\d{5,10}",
			[
				6,
				7,
				8,
				9,
				10,
				11,
				12
			],
			[[
				"(\\d{3})(\\d{3,9})",
				"$1 $2",
				["(?:2[389]|39)0|[7-9]"],
				"0$1"
			], [
				"(\\d{2})(\\d{5,10})",
				"$1 $2",
				["[1-36]"],
				"0$1"
			]],
			"0"
		],
		RU: [
			"7",
			"810",
			"8\\d{13}|[347-9]\\d{9}",
			[10, 14],
			[
				[
					"(\\d{4})(\\d{2})(\\d{2})(\\d{2})",
					"$1 $2 $3 $4",
					[
						"7(?:1[0-8]|2[1-9])",
						"7(?:1(?:[0-356]2|4[29]|7|8[27])|2(?:1[23]|[2-9]2))",
						"7(?:1(?:[0-356]2|4[29]|7|8[27])|2(?:13[03-69]|62[013-9]))|72[1-57-9]2"
					],
					"8 ($1)",
					1
				],
				[
					"(\\d{5})(\\d)(\\d{2})(\\d{2})",
					"$1 $2 $3 $4",
					[
						"7(?:1[0-68]|2[1-9])",
						"7(?:1(?:[06][3-6]|[18]|2[35]|[3-5][3-5])|2(?:[13][3-5]|[24-689]|7[457]))",
						"7(?:1(?:0(?:[356]|4[023])|[18]|2(?:3[013-9]|5)|3[45]|43[013-79]|5(?:3[1-8]|4[1-7]|5)|6(?:3[0-35-9]|[4-6]))|2(?:1(?:3[178]|[45])|[24-689]|3[35]|7[457]))|7(?:14|23)4[0-8]|71(?:33|45)[1-79]"
					],
					"8 ($1)",
					1
				],
				[
					"(\\d{3})(\\d{3})(\\d{4})",
					"$1 $2 $3",
					["7"],
					"8 ($1)",
					1
				],
				[
					"(\\d{3})(\\d{3})(\\d{2})(\\d{2})",
					"$1 $2-$3-$4",
					["[349]|8(?:[02-7]|1[1-8])"],
					"8 ($1)",
					1
				],
				[
					"(\\d{4})(\\d{4})(\\d{3})(\\d{3})",
					"$1 $2 $3 $4",
					["8"],
					"8 ($1)"
				]
			],
			"8",
			0,
			0,
			0,
			0,
			"[3489]",
			0,
			"8~10"
		],
		RW: [
			"250",
			"00",
			"(?:06|[27]\\d\\d|[89]00)\\d{6}",
			[8, 9],
			[
				[
					"(\\d{2})(\\d{2})(\\d{2})(\\d{2})",
					"$1 $2 $3 $4",
					["0"]
				],
				[
					"(\\d{3})(\\d{3})(\\d{3})",
					"$1 $2 $3",
					["2"]
				],
				[
					"(\\d{3})(\\d{3})(\\d{3})",
					"$1 $2 $3",
					["[7-9]"],
					"0$1"
				]
			],
			"0"
		],
		SA: [
			"966",
			"00",
			"(?:[15]\\d|800|92)\\d{7}",
			[9, 10],
			[
				[
					"(\\d{4})(\\d{5})",
					"$1 $2",
					["9"]
				],
				[
					"(\\d{2})(\\d{3})(\\d{4})",
					"$1 $2 $3",
					["1"],
					"0$1"
				],
				[
					"(\\d{2})(\\d{3})(\\d{4})",
					"$1 $2 $3",
					["5"],
					"0$1"
				],
				[
					"(\\d{3})(\\d{3})(\\d{4})",
					"$1 $2 $3",
					["8"]
				]
			],
			"0"
		],
		SB: [
			"677",
			"0[01]",
			"[6-9]\\d{6}|[1-6]\\d{4}",
			[5, 7],
			[[
				"(\\d{2})(\\d{5})",
				"$1 $2",
				["6[89]|7|8[4-9]|9(?:[0-8]|9[0-8])"]
			]]
		],
		SC: [
			"248",
			"010|0[0-2]",
			"(?:[2489]\\d|64)\\d{5}",
			[7],
			[[
				"(\\d)(\\d{3})(\\d{3})",
				"$1 $2 $3",
				["[246]|9[57]"]
			]],
			0,
			0,
			0,
			0,
			0,
			0,
			0,
			"00"
		],
		SD: [
			"249",
			"00",
			"[19]\\d{8}",
			[9],
			[[
				"(\\d{2})(\\d{3})(\\d{4})",
				"$1 $2 $3",
				["[19]"],
				"0$1"
			]],
			"0"
		],
		SE: [
			"46",
			"00",
			"(?:[26]\\d\\d|9)\\d{9}|[1-9]\\d{8}|[1-689]\\d{7}|[1-4689]\\d{6}|2\\d{5}",
			[
				6,
				7,
				8,
				9,
				10,
				12
			],
			[
				[
					"(\\d{2})(\\d{2,3})(\\d{2})",
					"$1-$2 $3",
					["20"],
					"0$1",
					0,
					"$1 $2 $3"
				],
				[
					"(\\d{3})(\\d{4})",
					"$1-$2",
					["9(?:00|39|44|9)"],
					"0$1",
					0,
					"$1 $2"
				],
				[
					"(\\d{2})(\\d{3})(\\d{2})",
					"$1-$2 $3",
					["[12][136]|3[356]|4[0246]|6[03]|90[1-9]"],
					"0$1",
					0,
					"$1 $2 $3"
				],
				[
					"(\\d)(\\d{2,3})(\\d{2})(\\d{2})",
					"$1-$2 $3 $4",
					["8"],
					"0$1",
					0,
					"$1 $2 $3 $4"
				],
				[
					"(\\d{3})(\\d{2,3})(\\d{2})",
					"$1-$2 $3",
					["1[2457]|2(?:[247-9]|5[0138])|3[0247-9]|4[1357-9]|5[0-35-9]|6(?:[125689]|4[02-57]|7[0-2])|9(?:[125-8]|3[02-5]|4[0-3])"],
					"0$1",
					0,
					"$1 $2 $3"
				],
				[
					"(\\d{3})(\\d{2,3})(\\d{3})",
					"$1-$2 $3",
					["9(?:00|39|44)"],
					"0$1",
					0,
					"$1 $2 $3"
				],
				[
					"(\\d{2})(\\d{2,3})(\\d{2})(\\d{2})",
					"$1-$2 $3 $4",
					["1[13689]|2[0136]|3[1356]|4[0246]|54|6[03]|90[1-9]"],
					"0$1",
					0,
					"$1 $2 $3 $4"
				],
				[
					"(\\d{2})(\\d{3})(\\d{2})(\\d{2})",
					"$1-$2 $3 $4",
					["10|7"],
					"0$1",
					0,
					"$1 $2 $3 $4"
				],
				[
					"(\\d)(\\d{3})(\\d{3})(\\d{2})",
					"$1-$2 $3 $4",
					["8"],
					"0$1",
					0,
					"$1 $2 $3 $4"
				],
				[
					"(\\d{3})(\\d{2})(\\d{2})(\\d{2})",
					"$1-$2 $3 $4",
					["[13-5]|2(?:[247-9]|5[0138])|6(?:[124-689]|7[0-2])|9(?:[125-8]|3[02-5]|4[0-3])"],
					"0$1",
					0,
					"$1 $2 $3 $4"
				],
				[
					"(\\d{3})(\\d{2})(\\d{2})(\\d{3})",
					"$1-$2 $3 $4",
					["9"],
					"0$1",
					0,
					"$1 $2 $3 $4"
				],
				[
					"(\\d{3})(\\d{2})(\\d{3})(\\d{2})(\\d{2})",
					"$1-$2 $3 $4 $5",
					["[26]"],
					"0$1",
					0,
					"$1 $2 $3 $4 $5"
				]
			],
			"0"
		],
		SG: [
			"65",
			"0[0-3]\\d",
			"(?:(?:1\\d|8)\\d\\d|7000)\\d{7}|[3689]\\d{7}",
			[
				8,
				10,
				11
			],
			[
				[
					"(\\d{4})(\\d{4})",
					"$1 $2",
					["[369]|8(?:0[1-9]|[1-9])"]
				],
				[
					"(\\d{3})(\\d{3})(\\d{4})",
					"$1 $2 $3",
					["8"]
				],
				[
					"(\\d{4})(\\d{4})(\\d{3})",
					"$1 $2 $3",
					["7"]
				],
				[
					"(\\d{4})(\\d{3})(\\d{4})",
					"$1 $2 $3",
					["1"]
				]
			]
		],
		SH: [
			"290",
			"00",
			"(?:[256]\\d|8)\\d{3}",
			[4, 5],
			0,
			0,
			0,
			0,
			0,
			0,
			"[256]"
		],
		SI: [
			"386",
			"00|10(?:22|66|88|99)",
			"[1-7]\\d{7}|8\\d{4,7}|90\\d{4,6}",
			[
				5,
				6,
				7,
				8
			],
			[
				[
					"(\\d{2})(\\d{3,6})",
					"$1 $2",
					["8[09]|9"],
					"0$1"
				],
				[
					"(\\d{3})(\\d{5})",
					"$1 $2",
					["59|8"],
					"0$1"
				],
				[
					"(\\d{2})(\\d{3})(\\d{3})",
					"$1 $2 $3",
					["[37][01]|4[013]|51|6"],
					"0$1"
				],
				[
					"(\\d)(\\d{3})(\\d{2})(\\d{2})",
					"$1 $2 $3 $4",
					["[1-57]"],
					"(0$1)"
				]
			],
			"0",
			0,
			0,
			0,
			0,
			0,
			0,
			"00"
		],
		SJ: [
			"47",
			"00",
			"0\\d{4}|(?:[489]\\d|79)\\d{6}",
			[5, 8],
			0,
			0,
			0,
			0,
			0,
			0,
			"79"
		],
		SK: [
			"421",
			"00",
			"[2-689]\\d{8}|[2-59]\\d{6}|[2-5]\\d{5}",
			[
				6,
				7,
				9
			],
			[
				[
					"(\\d)(\\d{2})(\\d{3,4})",
					"$1 $2 $3",
					["21"],
					"0$1"
				],
				[
					"(\\d{2})(\\d{2})(\\d{2,3})",
					"$1 $2 $3",
					["[3-5][1-8]1", "[3-5][1-8]1[67]"],
					"0$1"
				],
				[
					"(\\d)(\\d{3})(\\d{3})(\\d{2})",
					"$1 $2 $3 $4",
					["2"],
					"0$1"
				],
				[
					"(\\d{3})(\\d{3})(\\d{3})",
					"$1 $2 $3",
					["[689]"],
					"0$1"
				],
				[
					"(\\d{2})(\\d{3})(\\d{2})(\\d{2})",
					"$1 $2 $3 $4",
					["[3-5]"],
					"0$1"
				]
			],
			"0"
		],
		SL: [
			"232",
			"00",
			"(?:[237-9]\\d|66)\\d{6}",
			[8],
			[[
				"(\\d{2})(\\d{6})",
				"$1 $2",
				["[236-9]"],
				"(0$1)"
			]],
			"0"
		],
		SM: [
			"378",
			"00",
			"(?:0549|[5-7]\\d)\\d{6}",
			[8, 10],
			[[
				"(\\d{2})(\\d{2})(\\d{2})(\\d{2})",
				"$1 $2 $3 $4",
				["[5-7]"]
			], [
				"(\\d{4})(\\d{6})",
				"$1 $2",
				["0"]
			]],
			0,
			0,
			"([89]\\d{5})$",
			"0549$1"
		],
		SN: [
			"221",
			"00",
			"(?:[378]\\d|93)\\d{7}",
			[9],
			[[
				"(\\d{3})(\\d{2})(\\d{2})(\\d{2})",
				"$1 $2 $3 $4",
				["8"]
			], [
				"(\\d{2})(\\d{3})(\\d{2})(\\d{2})",
				"$1 $2 $3 $4",
				["[379]"]
			]]
		],
		SO: [
			"252",
			"00",
			"[346-9]\\d{8}|[12679]\\d{7}|[1-5]\\d{6}|[1348]\\d{5}",
			[
				6,
				7,
				8,
				9
			],
			[
				[
					"(\\d{2})(\\d{4})",
					"$1 $2",
					["8[125]"]
				],
				[
					"(\\d{6})",
					"$1",
					["[134]"]
				],
				[
					"(\\d)(\\d{6})",
					"$1 $2",
					["[15]|2[0-79]|3[0-46-8]|4[0-7]"]
				],
				[
					"(\\d{2})(\\d{5,7})",
					"$1 $2",
					["1|28|9[2-9]"]
				],
				[
					"(\\d)(\\d{7})",
					"$1 $2",
					["[267]|904"]
				],
				[
					"(\\d{2})(\\d{3})(\\d{4})",
					"$1 $2 $3",
					["[346-9]"]
				]
			],
			"0"
		],
		SR: [
			"597",
			"00",
			"(?:[2-5]|[6-9]\\d)\\d{5}",
			[6, 7],
			[
				[
					"(\\d{2})(\\d{2})(\\d{2})",
					"$1-$2-$3",
					["56"]
				],
				[
					"(\\d{3})(\\d{3})",
					"$1-$2",
					["[2-5]"]
				],
				[
					"(\\d{3})(\\d{4})",
					"$1-$2",
					["[6-9]"]
				]
			]
		],
		SS: [
			"211",
			"00",
			"[19]\\d{8}",
			[9],
			[[
				"(\\d{3})(\\d{3})(\\d{3})",
				"$1 $2 $3",
				["[19]"],
				"0$1"
			]],
			"0"
		],
		ST: [
			"239",
			"00",
			"(?:22|9\\d)\\d{5}",
			[7],
			[[
				"(\\d{3})(\\d{4})",
				"$1 $2",
				["[29]"]
			]]
		],
		SV: [
			"503",
			"00",
			"[25-7]\\d{7}|(?:80\\d|900)\\d{4}(?:\\d{4})?",
			[
				7,
				8,
				11
			],
			[
				[
					"(\\d{3})(\\d{4})",
					"$1 $2",
					["[89]"]
				],
				[
					"(\\d{4})(\\d{4})",
					"$1 $2",
					["[25-7]"]
				],
				[
					"(\\d{3})(\\d{4})(\\d{4})",
					"$1 $2 $3",
					["[89]"]
				]
			]
		],
		SX: [
			"1",
			"011",
			"7215\\d{6}|(?:[58]\\d\\d|900)\\d{7}",
			[10],
			0,
			"1",
			0,
			"(5\\d{6})$|1",
			"721$1",
			0,
			"721"
		],
		SY: [
			"963",
			"00",
			"[1-359]\\d{8}|[1-5]\\d{7}",
			[8, 9],
			[[
				"(\\d{2})(\\d{3})(\\d{3,4})",
				"$1 $2 $3",
				["[1-4]|5[1-3]"],
				"0$1",
				1
			], [
				"(\\d{3})(\\d{3})(\\d{3})",
				"$1 $2 $3",
				["[59]"],
				"0$1",
				1
			]],
			"0"
		],
		SZ: [
			"268",
			"00",
			"0800\\d{4}|(?:[237]\\d|900)\\d{6}",
			[8, 9],
			[[
				"(\\d{4})(\\d{4})",
				"$1 $2",
				["[0237]"]
			], [
				"(\\d{5})(\\d{4})",
				"$1 $2",
				["9"]
			]]
		],
		TA: [
			"290",
			"00",
			"8\\d{3}",
			[4],
			0,
			0,
			0,
			0,
			0,
			0,
			"8"
		],
		TC: [
			"1",
			"011",
			"(?:[58]\\d\\d|649|900)\\d{7}",
			[10],
			0,
			"1",
			0,
			"([2-479]\\d{6})$|1",
			"649$1",
			0,
			"649"
		],
		TD: [
			"235",
			"00|16",
			"(?:22|[3689]\\d|77)\\d{6}",
			[8],
			[[
				"(\\d{2})(\\d{2})(\\d{2})(\\d{2})",
				"$1 $2 $3 $4",
				["[236-9]"]
			]],
			0,
			0,
			0,
			0,
			0,
			0,
			0,
			"00"
		],
		TG: [
			"228",
			"00",
			"[279]\\d{7}",
			[8],
			[[
				"(\\d{2})(\\d{2})(\\d{2})(\\d{2})",
				"$1 $2 $3 $4",
				["[279]"]
			]]
		],
		TH: [
			"66",
			"00[1-9]",
			"(?:001800|[2-57]|[689]\\d)\\d{7}|1\\d{7,9}",
			[
				8,
				9,
				10,
				13
			],
			[
				[
					"(\\d)(\\d{3})(\\d{4})",
					"$1 $2 $3",
					["2"],
					"0$1"
				],
				[
					"(\\d{2})(\\d{3})(\\d{3,4})",
					"$1 $2 $3",
					["[13-9]"],
					"0$1"
				],
				[
					"(\\d{4})(\\d{3})(\\d{3})",
					"$1 $2 $3",
					["1"]
				]
			],
			"0"
		],
		TJ: [
			"992",
			"810",
			"(?:[0-57-9]\\d|66)\\d{7}",
			[9],
			[
				[
					"(\\d{6})(\\d)(\\d{2})",
					"$1 $2 $3",
					["331", "3317"]
				],
				[
					"(\\d{3})(\\d{2})(\\d{4})",
					"$1 $2 $3",
					["44[02-479]|[34]7"]
				],
				[
					"(\\d{4})(\\d)(\\d{4})",
					"$1 $2 $3",
					["3(?:[1245]|3[12])"]
				],
				[
					"(\\d{2})(\\d{3})(\\d{4})",
					"$1 $2 $3",
					["\\d"]
				]
			],
			0,
			0,
			0,
			0,
			0,
			0,
			0,
			"8~10"
		],
		TK: [
			"690",
			"00",
			"[2-47]\\d{3,6}",
			[
				4,
				5,
				6,
				7
			]
		],
		TL: [
			"670",
			"00",
			"7\\d{7}|(?:[2-47]\\d|[89]0)\\d{5}",
			[7, 8],
			[[
				"(\\d{3})(\\d{4})",
				"$1 $2",
				["[2-489]|70"]
			], [
				"(\\d{4})(\\d{4})",
				"$1 $2",
				["7"]
			]]
		],
		TM: [
			"993",
			"810",
			"[1-7]\\d{7}",
			[8],
			[
				[
					"(\\d{2})(\\d{2})(\\d{2})(\\d{2})",
					"$1 $2-$3-$4",
					["12"],
					"(8 $1)"
				],
				[
					"(\\d{3})(\\d)(\\d{2})(\\d{2})",
					"$1 $2-$3-$4",
					["[1-5]"],
					"(8 $1)"
				],
				[
					"(\\d{2})(\\d{6})",
					"$1 $2",
					["[67]"],
					"8 $1"
				]
			],
			"8",
			0,
			0,
			0,
			0,
			0,
			0,
			"8~10"
		],
		TN: [
			"216",
			"00",
			"[2-57-9]\\d{7}",
			[8],
			[[
				"(\\d{2})(\\d{3})(\\d{3})",
				"$1 $2 $3",
				["[2-57-9]"]
			]]
		],
		TO: [
			"676",
			"00",
			"(?:0800|(?:[5-8]\\d\\d|999)\\d)\\d{3}|[2-8]\\d{4}",
			[5, 7],
			[
				[
					"(\\d{2})(\\d{3})",
					"$1-$2",
					["[2-4]|50|6[09]|7[0-24-69]|8[05]"]
				],
				[
					"(\\d{4})(\\d{3})",
					"$1 $2",
					["0"]
				],
				[
					"(\\d{3})(\\d{4})",
					"$1 $2",
					["[5-9]"]
				]
			]
		],
		TR: [
			"90",
			"00",
			"4\\d{6}|8\\d{11,12}|(?:[2-58]\\d\\d|900)\\d{7}",
			[
				7,
				10,
				12,
				13
			],
			[
				[
					"(\\d{3})(\\d{3})(\\d{4})",
					"$1 $2 $3",
					["512|8[01589]|90"],
					"0$1",
					1
				],
				[
					"(\\d{3})(\\d{3})(\\d{2})(\\d{2})",
					"$1 $2 $3 $4",
					["5"],
					"0$1",
					1
				],
				[
					"(\\d{3})(\\d{3})(\\d{2})(\\d{2})",
					"$1 $2 $3 $4",
					["[24][1-8]|3[1-9]"],
					"(0$1)",
					1
				],
				[
					"(\\d{3})(\\d{3})(\\d{6,7})",
					"$1 $2 $3",
					["80"],
					"0$1",
					1
				]
			],
			"0"
		],
		TT: [
			"1",
			"011",
			"(?:[58]\\d\\d|900)\\d{7}",
			[10],
			0,
			"1",
			0,
			"([2-46-8]\\d{6})$|1",
			"868$1",
			0,
			"868"
		],
		TV: [
			"688",
			"00",
			"(?:2|7\\d\\d|90)\\d{4}",
			[
				5,
				6,
				7
			],
			[
				[
					"(\\d{2})(\\d{3})",
					"$1 $2",
					["2"]
				],
				[
					"(\\d{2})(\\d{4})",
					"$1 $2",
					["90"]
				],
				[
					"(\\d{2})(\\d{5})",
					"$1 $2",
					["7"]
				]
			]
		],
		TW: [
			"886",
			"0(?:0[25-79]|19)",
			"[2-689]\\d{8}|7\\d{9,10}|[2-8]\\d{7}|2\\d{6}",
			[
				7,
				8,
				9,
				10,
				11
			],
			[
				[
					"(\\d{2})(\\d)(\\d{4})",
					"$1 $2 $3",
					["202"],
					"0$1"
				],
				[
					"(\\d{3})(\\d{5})",
					"$1 $2",
					["826"],
					"0$1"
				],
				[
					"(\\d{3})(\\d{2})(\\d{3})",
					"$1 $2 $3",
					["83"],
					"0$1"
				],
				[
					"(\\d{2})(\\d{2})(\\d{4})",
					"$1 $2 $3",
					["82"],
					"0$1"
				],
				[
					"(\\d{2})(\\d{3})(\\d{3,4})",
					"$1 $2 $3",
					["[25]0|37|49|8[09]"],
					"0$1"
				],
				[
					"(\\d)(\\d{3,4})(\\d{4})",
					"$1 $2 $3",
					["[23568]|4(?:0[02-48]|[1-478])|7[1-9]", "[23568]|4(?:0[2-48]|[1-478])|(?:400|7)[1-9]"],
					"0$1"
				],
				[
					"(\\d{3})(\\d{3})(\\d{3})",
					"$1 $2 $3",
					["[49]"],
					"0$1"
				],
				[
					"(\\d{2})(\\d{4})(\\d{4,5})",
					"$1 $2 $3",
					["7"],
					"0$1"
				]
			],
			"0",
			0,
			0,
			0,
			0,
			0,
			0,
			0,
			"#"
		],
		TZ: [
			"255",
			"00[056]",
			"(?:[25-8]\\d|41|90)\\d{7}",
			[9],
			[
				[
					"(\\d{3})(\\d{2})(\\d{4})",
					"$1 $2 $3",
					["[89]"],
					"0$1"
				],
				[
					"(\\d{2})(\\d{3})(\\d{4})",
					"$1 $2 $3",
					["[24]"],
					"0$1"
				],
				[
					"(\\d{2})(\\d{7})",
					"$1 $2",
					["5"]
				],
				[
					"(\\d{3})(\\d{3})(\\d{3})",
					"$1 $2 $3",
					["[67]"],
					"0$1"
				]
			],
			"0"
		],
		UA: [
			"380",
			"00",
			"[89]\\d{9}|[3-9]\\d{8}",
			[9, 10],
			[
				[
					"(\\d{3})(\\d{3})(\\d{3})",
					"$1 $2 $3",
					["6[12][29]|(?:3[1-8]|4[136-8]|5[12457]|6[49])2|(?:56|65)[24]", "6[12][29]|(?:35|4[1378]|5[12457]|6[49])2|(?:56|65)[24]|(?:3[1-46-8]|46)2[013-9]"],
					"0$1"
				],
				[
					"(\\d{4})(\\d{5})",
					"$1 $2",
					["3[1-8]|4(?:[1367]|[45][6-9]|8[4-6])|5(?:[1-5]|6[0135689]|7[4-6])|6(?:[12][3-7]|[459])", "3[1-8]|4(?:[1367]|[45][6-9]|8[4-6])|5(?:[1-5]|6(?:[015689]|3[02389])|7[4-6])|6(?:[12][3-7]|[459])"],
					"0$1"
				],
				[
					"(\\d{2})(\\d{3})(\\d{4})",
					"$1 $2 $3",
					["[3-7]|89|9[1-9]"],
					"0$1"
				],
				[
					"(\\d{3})(\\d{3})(\\d{3,4})",
					"$1 $2 $3",
					["[89]"],
					"0$1"
				]
			],
			"0",
			0,
			0,
			0,
			0,
			0,
			0,
			"0~0"
		],
		UG: [
			"256",
			"00[057]",
			"800\\d{6}|(?:[29]0|[347]\\d)\\d{7}",
			[9],
			[
				[
					"(\\d{4})(\\d{5})",
					"$1 $2",
					[
						"202",
						"2024",
						"20240"
					],
					"0$1"
				],
				[
					"(\\d{3})(\\d{6})",
					"$1 $2",
					["20[0-35-7]|4(?:6[45]|[7-9])|[7-9]", "20(?:[0135-7]|2[5-9])|4(?:6[45]|[7-9])|[7-9]"],
					"0$1"
				],
				[
					"(\\d{2})(\\d{7})",
					"$1 $2",
					["[2-4]"],
					"0$1"
				]
			],
			"0"
		],
		US: [
			"1",
			"011",
			"[2-9]\\d{9}|3\\d{6}",
			[10],
			[[
				"(\\d{3})(\\d{4})",
				"$1-$2",
				["310"],
				0,
				1
			], [
				"(\\d{3})(\\d{3})(\\d{4})",
				"($1) $2-$3",
				["[2-9]"],
				0,
				1,
				"$1-$2-$3"
			]],
			"1",
			0,
			0,
			0,
			0,
			0,
			[
				["983[2-57-9]\\d{6}|(?:2(?:0[1-35-9]|1[02-9]|2[03-57-9]|3[1459]|4[08]|5[1-46]|6[0279]|7[02469]|8[13])|3(?:0[1-57-9]|1[02-9]|2[013-79]|3[0-24679]|4[167]|5[0-3]|6[01349]|8[056])|4(?:0[124-9]|1[02-579]|2[3-5]|3[0245]|4[023578]|58|6[349]|7[02589]|8[04])|5(?:0[1-57-9]|1[0235-8]|20|3[0149]|4[01]|5[179]|6[1-47]|7[0-5]|8[0256])|6(?:0[1-35-9]|1[024-9]|2[03689]|3[016]|4[0156]|5[01679]|6[0-279]|78|8[0-269])|7(?:0[1-46-8]|1[2-9]|2[04-8]|3[0-2478]|4[0378]|5[47]|6[02359]|7[0-59]|8[156])|8(?:0[1-68]|1[02-8]|2[0168]|3[0-2589]|4[03578]|5[046-9]|6[02-5]|7[028])|9(?:0[1346-9]|1[02-9]|2[0589]|3[0146-8]|4[01357-9]|5[12469]|7[0-3589]|8[04-69]))[2-9]\\d{6}"],
				[""],
				["8(?:00|33|44|55|66|77|88)[2-9]\\d{6}"],
				["900[2-9]\\d{6}"],
				["52(?:3(?:[2-46-9][02-9]\\d|5(?:[02-46-9]\\d|5[0-46-9]))|4(?:[2-478][02-9]\\d|5(?:[034]\\d|2[024-9]|5[0-46-9])|6(?:0[1-9]|[2-9]\\d)|9(?:[05-9]\\d|2[0-5]|49)))\\d{4}|52[34][2-9]1[02-9]\\d{4}|5(?:00|2[125-9]|3[23]|44|66|77|88)[2-9]\\d{6}"]
			]
		],
		UY: [
			"598",
			"0(?:0|1[3-9]\\d)",
			"0004\\d{2,9}|[1249]\\d{7}|2\\d{3,4}|(?:[49]\\d|80)\\d{5}",
			[
				4,
				5,
				6,
				7,
				8,
				9,
				10,
				11,
				12,
				13
			],
			[
				[
					"(\\d{4,5})",
					"$1",
					["21"]
				],
				[
					"(\\d{3})(\\d{3,4})",
					"$1 $2",
					["0"]
				],
				[
					"(\\d{3})(\\d{4})",
					"$1 $2",
					["[49]0|8"],
					"0$1"
				],
				[
					"(\\d{2})(\\d{3})(\\d{3})",
					"$1 $2 $3",
					["9"],
					"0$1"
				],
				[
					"(\\d{4})(\\d{4})",
					"$1 $2",
					["[124]"]
				],
				[
					"(\\d{3})(\\d{3})(\\d{2,4})",
					"$1 $2 $3",
					["0"]
				],
				[
					"(\\d{3})(\\d{3})(\\d{3})(\\d{2,4})",
					"$1 $2 $3 $4",
					["0"]
				]
			],
			"0",
			0,
			0,
			0,
			0,
			0,
			0,
			"00",
			" int. "
		],
		UZ: [
			"998",
			"00",
			"(?:20|33|[5-9]\\d)\\d{7}",
			[9],
			[[
				"(\\d{2})(\\d{3})(\\d{2})(\\d{2})",
				"$1 $2 $3 $4",
				["[235-9]"]
			]]
		],
		VA: [
			"39",
			"00",
			"0\\d{5,10}|3[0-8]\\d{7,10}|55\\d{8}|8\\d{5}(?:\\d{2,4})?|(?:1\\d|39)\\d{7,8}",
			[
				6,
				7,
				8,
				9,
				10,
				11,
				12
			],
			0,
			0,
			0,
			0,
			0,
			0,
			"06698"
		],
		VC: [
			"1",
			"011",
			"(?:[58]\\d\\d|784|900)\\d{7}",
			[10],
			0,
			"1",
			0,
			"([2-7]\\d{6})$|1",
			"784$1",
			0,
			"784"
		],
		VE: [
			"58",
			"00",
			"[68]00\\d{7}|(?:[24]\\d|[59]0)\\d{8}",
			[10],
			[[
				"(\\d{3})(\\d{7})",
				"$1-$2",
				["[24-689]"],
				"0$1"
			]],
			"0"
		],
		VG: [
			"1",
			"011",
			"(?:284|[58]\\d\\d|900)\\d{7}",
			[10],
			0,
			"1",
			0,
			"([2-578]\\d{6})$|1",
			"284$1",
			0,
			"284"
		],
		VI: [
			"1",
			"011",
			"[58]\\d{9}|(?:34|90)0\\d{7}",
			[10],
			0,
			"1",
			0,
			"([2-9]\\d{6})$|1",
			"340$1",
			0,
			"340"
		],
		VN: [
			"84",
			"00",
			"[12]\\d{9}|[135-9]\\d{8}|[16]\\d{6,7}|7\\d{6}",
			[
				7,
				8,
				9,
				10
			],
			[
				[
					"(\\d{4})(\\d{4,6})",
					"$1 $2",
					["1(?:2[02]|[89])"],
					0,
					1
				],
				[
					"(\\d{2})(\\d{3})(\\d{2})(\\d{2})",
					"$1 $2 $3 $4",
					["1[26]|6"],
					"0$1",
					1
				],
				[
					"(\\d{3})(\\d{3})(\\d{3})",
					"$1 $2 $3",
					["[1357-9]"],
					"0$1",
					1
				],
				[
					"(\\d{2})(\\d{4})(\\d{4})",
					"$1 $2 $3",
					["2[48]"],
					"0$1",
					1
				],
				[
					"(\\d{3})(\\d{4})(\\d{3})",
					"$1 $2 $3",
					["2"],
					"0$1",
					1
				]
			],
			"0"
		],
		VU: [
			"678",
			"00",
			"[57-9]\\d{6}|(?:[238]\\d|48)\\d{3}",
			[5, 7],
			[[
				"(\\d{3})(\\d{4})",
				"$1 $2",
				["[57-9]"]
			]]
		],
		WF: [
			"681",
			"00",
			"(?:40|72|8\\d{4})\\d{4}|[89]\\d{5}",
			[6, 9],
			[[
				"(\\d{2})(\\d{2})(\\d{2})",
				"$1 $2 $3",
				["[47-9]"]
			], [
				"(\\d{3})(\\d{2})(\\d{2})(\\d{2})",
				"$1 $2 $3 $4",
				["8"]
			]]
		],
		WS: [
			"685",
			"0",
			"(?:[2-6]|8\\d{5})\\d{4}|[78]\\d{6}|[68]\\d{5}",
			[
				5,
				6,
				7,
				10
			],
			[
				[
					"(\\d{5})",
					"$1",
					["[2-5]|6[1-9]"]
				],
				[
					"(\\d{3})(\\d{3,7})",
					"$1 $2",
					["[68]"]
				],
				[
					"(\\d{2})(\\d{5})",
					"$1 $2",
					["7"]
				]
			]
		],
		XK: [
			"383",
			"00",
			"2\\d{7,8}|3\\d{7,11}|(?:4\\d\\d|[89]00)\\d{5}",
			[
				8,
				9,
				10,
				11,
				12
			],
			[
				[
					"(\\d{3})(\\d{5})",
					"$1 $2",
					["[89]"],
					"0$1"
				],
				[
					"(\\d{2})(\\d{3})(\\d{3})",
					"$1 $2 $3",
					["[2-4]"],
					"0$1"
				],
				[
					"(\\d{3})(\\d{3})(\\d{3})",
					"$1 $2 $3",
					["2|39"],
					"0$1"
				],
				[
					"(\\d{2})(\\d{7,10})",
					"$1 $2",
					["3"],
					"0$1"
				]
			],
			"0"
		],
		YE: [
			"967",
			"00",
			"(?:1|7\\d)\\d{7}|[1-7]\\d{6}",
			[
				7,
				8,
				9
			],
			[[
				"(\\d)(\\d{3})(\\d{3,4})",
				"$1 $2 $3",
				["[1-6]|7(?:[24-6]|8[0-7])"],
				"0$1"
			], [
				"(\\d{3})(\\d{3})(\\d{3})",
				"$1 $2 $3",
				["7"],
				"0$1"
			]],
			"0"
		],
		YT: [
			"262",
			"00",
			"(?:639\\d|7093)\\d{5}|(?:26|80|9\\d)\\d{7}",
			[9],
			0,
			"0",
			0,
			0,
			0,
			0,
			0,
			[
				["26(?:89\\d|9(?:0[0-467]|15|5[0-4]|6\\d|[78]0))\\d{4}"],
				["(?:639(?:0[0-79]|1[019]|[267]\\d|3[09]|40|5[05-9]|9[04-79])|7093[5-7])\\d{4}"],
				["80\\d{7}"],
				0,
				0,
				0,
				0,
				0,
				["9(?:(?:39|47)8[01]|769\\d)\\d{4}"]
			]
		],
		ZA: [
			"27",
			"00",
			"[1-79]\\d{8}|8\\d{4,9}",
			[
				5,
				6,
				7,
				8,
				9,
				10
			],
			[
				[
					"(\\d{2})(\\d{3,4})",
					"$1 $2",
					["8[1-4]"],
					"0$1"
				],
				[
					"(\\d{2})(\\d{3})(\\d{2,3})",
					"$1 $2 $3",
					["8[1-4]"],
					"0$1"
				],
				[
					"(\\d{3})(\\d{3})(\\d{3})",
					"$1 $2 $3",
					["860"],
					"0$1"
				],
				[
					"(\\d{2})(\\d{3})(\\d{4})",
					"$1 $2 $3",
					["[1-9]"],
					"0$1"
				],
				[
					"(\\d{3})(\\d{3})(\\d{4})",
					"$1 $2 $3",
					["8"],
					"0$1"
				]
			],
			"0"
		],
		ZM: [
			"260",
			"00",
			"800\\d{6}|(?:21|[579]\\d|63)\\d{7}",
			[9],
			[[
				"(\\d{3})(\\d{3})(\\d{3})",
				"$1 $2 $3",
				["[28]"],
				"0$1"
			], [
				"(\\d{2})(\\d{7})",
				"$1 $2",
				["[579]"],
				"0$1"
			]],
			"0"
		],
		ZW: [
			"263",
			"00",
			"(?:13|8\\d{4})\\d{5}|[235-8]\\d{8}|[23568]\\d{6}",
			[
				7,
				9,
				10
			],
			[
				[
					"(\\d{2})(\\d{3,5})",
					"$1 $2",
					["1|2(?:0[0-36-9]|29|58)|67[0-46-9]|(?:55|68)[0-69]"],
					"0$1"
				],
				[
					"(\\d{3})(\\d{3,5})",
					"$1 $2",
					["2(?:0[45]|[27]|48)|37|675|(?:55|68)[78]"],
					"0$1"
				],
				[
					"(\\d{3})(\\d{4})",
					"$1 $2",
					["80"],
					"0$1"
				],
				[
					"(\\d{4})(\\d{3,5})",
					"$1 $2",
					["548"],
					"0$1"
				],
				[
					"(\\d{2})(\\d{3})(\\d{3,4})",
					"$1 $2 $3",
					["29[013-9]"],
					"0$1"
				],
				[
					"(\\d{2})(\\d{7})",
					"$1 $2",
					["[256]|39|8[13-59]"],
					"(0$1)"
				],
				[
					"(\\d{2})(\\d{3})(\\d{4})",
					"$1 $2 $3",
					["7"],
					"0$1"
				],
				[
					"(\\d{3})(\\d{3})(\\d{3,4})",
					"$1 $2 $3",
					["3"],
					"0$1"
				],
				[
					"(\\d{4})(\\d{6})",
					"$1 $2",
					["8"],
					"0$1"
				]
			],
			"0"
		]
	},
	nonGeographic: {
		800: [
			"800",
			0,
			"(?:00|[1-9]\\d)\\d{6}",
			[8],
			[[
				"(\\d{4})(\\d{4})",
				"$1 $2",
				["\\d"]
			]],
			0,
			0,
			0,
			0,
			0,
			0,
			[
				0,
				0,
				["(?:00|[1-9]\\d)\\d{6}"]
			]
		],
		808: [
			"808",
			0,
			"[1-9]\\d{7}",
			[8],
			[[
				"(\\d{4})(\\d{4})",
				"$1 $2",
				["[1-9]"]
			]],
			0,
			0,
			0,
			0,
			0,
			0,
			[
				0,
				0,
				0,
				0,
				0,
				0,
				0,
				0,
				0,
				["[1-9]\\d{7}"]
			]
		],
		870: [
			"870",
			0,
			"7\\d{11}|[235-7]\\d{8}",
			[9, 12],
			[[
				"(\\d{3})(\\d{3})(\\d{3})",
				"$1 $2 $3",
				["[235-7]"]
			]],
			0,
			0,
			0,
			0,
			0,
			0,
			[
				0,
				["(?:[356]|774[45])\\d{8}|7[6-8]\\d{7}"],
				0,
				0,
				0,
				0,
				0,
				0,
				["2\\d{8}", [9]]
			]
		],
		878: [
			"878",
			0,
			"10\\d{10}",
			[12],
			[[
				"(\\d{2})(\\d{5})(\\d{5})",
				"$1 $2 $3",
				["1"]
			]],
			0,
			0,
			0,
			0,
			0,
			0,
			[
				0,
				0,
				0,
				0,
				0,
				0,
				0,
				0,
				["10\\d{10}"]
			]
		],
		881: [
			"881",
			0,
			"6\\d{9}|[0-36-9]\\d{8}",
			[9, 10],
			[[
				"(\\d)(\\d{3})(\\d{5})",
				"$1 $2 $3",
				["[0-37-9]"]
			], [
				"(\\d)(\\d{3})(\\d{5,6})",
				"$1 $2 $3",
				["6"]
			]],
			0,
			0,
			0,
			0,
			0,
			0,
			[0, ["6\\d{9}|[0-36-9]\\d{8}"]]
		],
		882: [
			"882",
			0,
			"[13]\\d{6}(?:\\d{2,5})?|[19]\\d{7}|(?:[25]\\d\\d|4)\\d{7}(?:\\d{2})?",
			[
				7,
				8,
				9,
				10,
				11,
				12
			],
			[
				[
					"(\\d{2})(\\d{5})",
					"$1 $2",
					["16|342"]
				],
				[
					"(\\d{2})(\\d{6})",
					"$1 $2",
					["49"]
				],
				[
					"(\\d{2})(\\d{2})(\\d{4})",
					"$1 $2 $3",
					["1[36]|9"]
				],
				[
					"(\\d{2})(\\d{4})(\\d{3})",
					"$1 $2 $3",
					["3[23]"]
				],
				[
					"(\\d{2})(\\d{3,4})(\\d{4})",
					"$1 $2 $3",
					["16"]
				],
				[
					"(\\d{2})(\\d{4})(\\d{4})",
					"$1 $2 $3",
					["10|23|3(?:[15]|4[57])|4|5[12]"]
				],
				[
					"(\\d{3})(\\d{4})(\\d{4})",
					"$1 $2 $3",
					["34"]
				],
				[
					"(\\d{2})(\\d{4,5})(\\d{5})",
					"$1 $2 $3",
					["[1-35]"]
				]
			],
			0,
			0,
			0,
			0,
			0,
			0,
			[
				0,
				["342\\d{4}|(?:337|49)\\d{6}|(?:3(?:2|47|7\\d{3})|5(?:0\\d{3}|2[0-2]))\\d{7}", [
					7,
					8,
					9,
					10,
					12
				]],
				0,
				0,
				0,
				["348[57]\\d{7}", [11]],
				0,
				0,
				["1(?:3(?:0[0347]|[13][0139]|2[035]|4[013568]|6[0459]|7[06]|8[15-8]|9[0689])\\d{4}|6\\d{5,10})|(?:345\\d|9[89])\\d{6}|(?:10|2(?:3|85\\d)|3(?:[15]|[69]\\d\\d)|4[15-8]|51)\\d{8}"]
			]
		],
		883: [
			"883",
			0,
			"(?:[1-4]\\d|51)\\d{6,10}",
			[
				8,
				9,
				10,
				11,
				12
			],
			[
				[
					"(\\d{3})(\\d{3})(\\d{2,8})",
					"$1 $2 $3",
					["[14]|2[24-689]|3[02-689]|51[24-9]"]
				],
				[
					"(\\d{3})(\\d{3})(\\d{3})",
					"$1 $2 $3",
					["510"]
				],
				[
					"(\\d{3})(\\d{3})(\\d{4})",
					"$1 $2 $3",
					["21"]
				],
				[
					"(\\d{4})(\\d{4})(\\d{4})",
					"$1 $2 $3",
					["51[13]"]
				],
				[
					"(\\d{3})(\\d{3})(\\d{3})(\\d{3})",
					"$1 $2 $3 $4",
					["[235]"]
				]
			],
			0,
			0,
			0,
			0,
			0,
			0,
			[
				0,
				0,
				0,
				0,
				0,
				0,
				0,
				0,
				["(?:2(?:00\\d\\d|10)|(?:370[1-9]|51\\d0)\\d)\\d{7}|51(?:00\\d{5}|[24-9]0\\d{4,7})|(?:1[0-79]|2[24-689]|3[02-689]|4[0-4])0\\d{5,9}"]
			]
		],
		888: [
			"888",
			0,
			"\\d{11}",
			[11],
			[["(\\d{3})(\\d{3})(\\d{5})", "$1 $2 $3"]],
			0,
			0,
			0,
			0,
			0,
			0,
			[
				0,
				0,
				0,
				0,
				0,
				0,
				["\\d{11}"]
			]
		],
		979: [
			"979",
			0,
			"[1359]\\d{8}",
			[9],
			[[
				"(\\d)(\\d{4})(\\d{4})",
				"$1 $2 $3",
				["[1359]"]
			]],
			0,
			0,
			0,
			0,
			0,
			0,
			[
				0,
				0,
				0,
				["[1359]\\d{8}"]
			]
		]
	}
};
//#endregion
//#region ../../../node_modules/.pnpm/libphonenumber-js@1.13.15/node_modules/libphonenumber-js/min/exports/withMetadataArgument.js
function withMetadataArgument(e, t) {
	var n = Array.prototype.slice.call(t);
	return n.push(je), e.apply(this, n);
}
//#endregion
//#region ../../../node_modules/.pnpm/libphonenumber-js@1.13.15/node_modules/libphonenumber-js/es6/tools/semver-compare.js
function semver_compare_default(e, t) {
	e = e.split("-"), t = t.split("-");
	for (var n = e[0].split("."), r = t[0].split("."), i = 0; i < 3; i++) {
		var a = Number(n[i]), o = Number(r[i]);
		if (a > o) return 1;
		if (o > a) return -1;
		if (!isNaN(a) && isNaN(o)) return 1;
		if (isNaN(a) && !isNaN(o)) return -1;
	}
	return e[1] && t[1] ? e[1] > t[1] ? 1 : e[1] < t[1] ? -1 : 0 : !e[1] && t[1] ? 1 : e[1] && !t[1] ? -1 : 0;
}
__name(semver_compare_default, "default");
//#endregion
//#region ../../../node_modules/.pnpm/libphonenumber-js@1.13.15/node_modules/libphonenumber-js/es6/helpers/isObject.js
var Me = {}.constructor;
function isObject(e) {
	return e != null && e.constructor === Me;
}
//#endregion
//#region ../../../node_modules/.pnpm/libphonenumber-js@1.13.15/node_modules/libphonenumber-js/es6/helpers/isCallingCode.js
var Ne = /^\d+$/;
function isCallingCode(e) {
	return Ne.test(e);
}
//#endregion
//#region ../../../node_modules/.pnpm/libphonenumber-js@1.13.15/node_modules/libphonenumber-js/es6/metadata.js
function _typeof$4(e) {
	"@babel/helpers - typeof";
	return _typeof$4 = typeof Symbol == "function" && typeof Symbol.iterator == "symbol" ? function(e) {
		return typeof e;
	} : function(e) {
		return e && typeof Symbol == "function" && e.constructor === Symbol && e !== Symbol.prototype ? "symbol" : typeof e;
	}, _typeof$4(e);
}
__name(_typeof$4, "_typeof");
function _classCallCheck$2(e, t) {
	if (!(e instanceof t)) throw TypeError("Cannot call a class as a function");
}
__name(_classCallCheck$2, "_classCallCheck");
function _defineProperties$2(e, t) {
	for (var n = 0; n < t.length; n++) {
		var r = t[n];
		r.enumerable = r.enumerable || !1, r.configurable = !0, "value" in r && (r.writable = !0), Object.defineProperty(e, _toPropertyKey$4(r.key), r);
	}
}
__name(_defineProperties$2, "_defineProperties");
function _createClass$2(e, t, n) {
	return t && _defineProperties$2(e.prototype, t), n && _defineProperties$2(e, n), Object.defineProperty(e, "prototype", { writable: !1 }), e;
}
__name(_createClass$2, "_createClass");
function _toPropertyKey$4(e) {
	var t = _toPrimitive$4(e, "string");
	return _typeof$4(t) == "symbol" ? t : t + "";
}
__name(_toPropertyKey$4, "_toPropertyKey");
function _toPrimitive$4(e, t) {
	if (_typeof$4(e) != "object" || !e) return e;
	var n = e[Symbol.toPrimitive];
	if (n !== void 0) {
		var r = n.call(e, t || "default");
		if (_typeof$4(r) != "object") return r;
		throw TypeError("@@toPrimitive must return a primitive value.");
	}
	return (t === "string" ? String : Number)(e);
}
__name(_toPrimitive$4, "_toPrimitive");
var Pe = "1.2.0", Fe = "1.7.35", Ie = " ext. ", M = /*#__PURE__*/ function() {
	function Metadata(e) {
		_classCallCheck$2(this, Metadata), validateMetadata(e), this.metadata = e, setVersion.call(this, e);
	}
	return _createClass$2(Metadata, [
		{
			key: "getCountries",
			value: function getCountries() {
				return Object.keys(this.metadata.countries).filter(function(e) {
					return e !== "001";
				});
			}
		},
		{
			key: "getCountryMetadata",
			value: function getCountryMetadata(e) {
				return this.metadata.countries[e];
			}
		},
		{
			key: "nonGeographic",
			value: function nonGeographic() {
				if (!(this.v1 || this.v2 || this.v3)) return this.metadata.nonGeographic || this.metadata.nonGeographical;
			}
		},
		{
			key: "hasCountry",
			value: function hasCountry(e) {
				return this.getCountryMetadata(e) !== void 0;
			}
		},
		{
			key: "hasCallingCode",
			value: function hasCallingCode(e) {
				if (this.getCountryCodesForCallingCode(e)) return !0;
				if (this.nonGeographic()) {
					if (this.nonGeographic()[e]) return !0;
				} else {
					var t = this.countryCallingCodes()[e];
					if (t && t.length === 1 && t[0] === "001") return !0;
				}
			}
		},
		{
			key: "isNonGeographicCallingCode",
			value: function isNonGeographicCallingCode(e) {
				return this.nonGeographic() ? !!this.nonGeographic()[e] : !this.getCountryCodesForCallingCode(e);
			}
		},
		{
			key: "country",
			value: function country(e) {
				return this.selectNumberingPlan(e);
			}
		},
		{
			key: "selectNumberingPlan",
			value: function selectNumberingPlan(e, t) {
				var n, r;
				if (e && (isCallingCode(e) ? r = e : n = e), t && (r = t), n && n !== "001") {
					var i = this.getCountryMetadata(n);
					if (!i) throw Error(`Unknown country: ${n}`);
					this.numberingPlan = new Le(i, this);
				} else if (r) {
					if (!this.hasCallingCode(r)) throw Error(`Unknown calling code: ${r}`);
					this.numberingPlan = new Le(this.getNumberingPlanMetadata(r), this);
				} else this.numberingPlan = void 0;
				return this;
			}
		},
		{
			key: "getCountryCodesForCallingCode",
			value: function getCountryCodesForCallingCode(e) {
				var t = this.countryCallingCodes()[e];
				if (t) return t.length === 1 && t[0].length === 3 ? void 0 : t;
			}
		},
		{
			key: "getCountryCodeForCallingCode",
			value: function getCountryCodeForCallingCode(e) {
				var t = this.getCountryCodesForCallingCode(e);
				if (t) return t[0];
			}
		},
		{
			key: "getNumberingPlanMetadata",
			value: function getNumberingPlanMetadata(e) {
				var t = this.getCountryCodeForCallingCode(e);
				if (t) return this.getCountryMetadata(t);
				if (this.nonGeographic()) {
					var n = this.nonGeographic()[e];
					if (n) return n;
				} else {
					var r = this.countryCallingCodes()[e];
					if (r && r.length === 1 && r[0] === "001") return this.metadata.countries["001"];
				}
			}
		},
		{
			key: "countryCallingCode",
			value: function countryCallingCode() {
				return this.numberingPlan.callingCode();
			}
		},
		{
			key: "IDDPrefix",
			value: function IDDPrefix() {
				return this.numberingPlan.IDDPrefix();
			}
		},
		{
			key: "defaultIDDPrefix",
			value: function defaultIDDPrefix() {
				return this.numberingPlan.defaultIDDPrefix();
			}
		},
		{
			key: "nationalNumberPattern",
			value: function nationalNumberPattern() {
				return this.numberingPlan.nationalNumberPattern();
			}
		},
		{
			key: "possibleLengths",
			value: function possibleLengths() {
				return this.numberingPlan.possibleLengths();
			}
		},
		{
			key: "formats",
			value: function formats() {
				return this.numberingPlan.formats();
			}
		},
		{
			key: "nationalPrefixForParsing",
			value: function nationalPrefixForParsing() {
				return this.numberingPlan.nationalPrefixForParsing();
			}
		},
		{
			key: "nationalPrefixTransformRule",
			value: function nationalPrefixTransformRule() {
				return this.numberingPlan.nationalPrefixTransformRule();
			}
		},
		{
			key: "leadingDigits",
			value: function leadingDigits() {
				return this.numberingPlan.leadingDigits();
			}
		},
		{
			key: "hasTypes",
			value: function hasTypes() {
				return this.numberingPlan.hasTypes();
			}
		},
		{
			key: "type",
			value: function type(e) {
				return this.numberingPlan.type(e);
			}
		},
		{
			key: "ext",
			value: function ext() {
				return this.numberingPlan.ext();
			}
		},
		{
			key: "countryCallingCodes",
			value: function countryCallingCodes() {
				return this.v1 ? this.metadata.country_phone_code_to_countries : this.metadata.country_calling_codes;
			}
		},
		{
			key: "chooseCountryByCountryCallingCode",
			value: function chooseCountryByCountryCallingCode(e) {
				return this.selectNumberingPlan(e);
			}
		},
		{
			key: "hasSelectedNumberingPlan",
			value: function hasSelectedNumberingPlan() {
				return this.numberingPlan !== void 0;
			}
		}
	]);
}(), Le = /*#__PURE__*/ function() {
	function NumberingPlan(e, t) {
		_classCallCheck$2(this, NumberingPlan), this.globalMetadataObject = t, this.metadata = e, setVersion.call(this, t.metadata);
	}
	return _createClass$2(NumberingPlan, [
		{
			key: "callingCode",
			value: function callingCode() {
				return this.metadata[0];
			}
		},
		{
			key: "_getDefaultCountryMetadataForThisCallingCode",
			value: function _getDefaultCountryMetadataForThisCallingCode() {
				return this.globalMetadataObject.getNumberingPlanMetadata(this.callingCode());
			}
		},
		{
			key: "getDefaultCountryMetadataForRegion",
			value: function getDefaultCountryMetadataForRegion() {
				return this._getDefaultCountryMetadataForThisCallingCode();
			}
		},
		{
			key: "IDDPrefix",
			value: function IDDPrefix() {
				if (!(this.v1 || this.v2)) return this.metadata[1];
			}
		},
		{
			key: "defaultIDDPrefix",
			value: function defaultIDDPrefix() {
				if (!(this.v1 || this.v2)) return this.metadata[12];
			}
		},
		{
			key: "nationalNumberPattern",
			value: function nationalNumberPattern() {
				return this.v1 || this.v2 ? this.metadata[1] : this.metadata[2];
			}
		},
		{
			key: "possibleLengths",
			value: function possibleLengths() {
				if (!this.v1) return this.metadata[this.v2 ? 2 : 3];
			}
		},
		{
			key: "_getFormats",
			value: function _getFormats(e) {
				return e[this.v1 ? 2 : this.v2 ? 3 : 4];
			}
		},
		{
			key: "formats",
			value: function formats() {
				var e = this;
				return (this._getFormats(this.metadata) || this._getFormats(this._getDefaultCountryMetadataForThisCallingCode()) || []).map(function(t) {
					return new Re(t, e);
				});
			}
		},
		{
			key: "nationalPrefix",
			value: function nationalPrefix() {
				return this.metadata[this.v1 ? 3 : this.v2 ? 4 : 5];
			}
		},
		{
			key: "_getNationalPrefixFormattingRule",
			value: function _getNationalPrefixFormattingRule(e) {
				return e[this.v1 ? 4 : this.v2 ? 5 : 6];
			}
		},
		{
			key: "nationalPrefixFormattingRule",
			value: function nationalPrefixFormattingRule() {
				return this._getNationalPrefixFormattingRule(this.metadata) || this._getNationalPrefixFormattingRule(this._getDefaultCountryMetadataForThisCallingCode());
			}
		},
		{
			key: "_nationalPrefixForParsing",
			value: function _nationalPrefixForParsing() {
				return this.metadata[this.v1 ? 5 : this.v2 ? 6 : 7];
			}
		},
		{
			key: "nationalPrefixForParsing",
			value: function nationalPrefixForParsing() {
				return this._nationalPrefixForParsing() || this.nationalPrefix();
			}
		},
		{
			key: "nationalPrefixTransformRule",
			value: function nationalPrefixTransformRule() {
				return this.metadata[this.v1 ? 6 : this.v2 ? 7 : 8];
			}
		},
		{
			key: "_getNationalPrefixIsOptionalWhenFormatting",
			value: function _getNationalPrefixIsOptionalWhenFormatting() {
				return !!this.metadata[this.v1 ? 7 : this.v2 ? 8 : 9];
			}
		},
		{
			key: "nationalPrefixIsOptionalWhenFormattingInNationalFormat",
			value: function nationalPrefixIsOptionalWhenFormattingInNationalFormat() {
				return this._getNationalPrefixIsOptionalWhenFormatting(this.metadata) || this._getNationalPrefixIsOptionalWhenFormatting(this._getDefaultCountryMetadataForThisCallingCode());
			}
		},
		{
			key: "leadingDigits",
			value: function leadingDigits() {
				return this.metadata[this.v1 ? 8 : this.v2 ? 9 : 10];
			}
		},
		{
			key: "types",
			value: function types() {
				return this.metadata[this.v1 ? 9 : this.v2 ? 10 : 11];
			}
		},
		{
			key: "hasTypes",
			value: function hasTypes() {
				return this.types() && this.types().length === 0 ? !1 : !!this.types();
			}
		},
		{
			key: "type",
			value: function type(e) {
				if (this.hasTypes() && getType(this.types(), e)) return new Be(getType(this.types(), e), this);
			}
		},
		{
			key: "ext",
			value: function ext() {
				return this.v1 || this.v2 ? Ie : this.metadata[13] || Ie;
			}
		}
	]);
}(), Re = /*#__PURE__*/ function() {
	function Format(e, t) {
		_classCallCheck$2(this, Format), this._format = e, this.metadata = t;
	}
	return _createClass$2(Format, [
		{
			key: "pattern",
			value: function pattern() {
				return this._format[0];
			}
		},
		{
			key: "format",
			value: function format() {
				return this._format[1];
			}
		},
		{
			key: "leadingDigitsPatterns",
			value: function leadingDigitsPatterns() {
				return this._format[2] || [];
			}
		},
		{
			key: "nationalPrefixFormattingRule",
			value: function nationalPrefixFormattingRule() {
				return this._format[3] || this.metadata.nationalPrefixFormattingRule();
			}
		},
		{
			key: "nationalPrefixIsOptionalWhenFormattingInNationalFormat",
			value: function nationalPrefixIsOptionalWhenFormattingInNationalFormat() {
				return !!this._format[4] || this.metadata.nationalPrefixIsOptionalWhenFormattingInNationalFormat();
			}
		},
		{
			key: "nationalPrefixIsMandatoryWhenFormattingInNationalFormat",
			value: function nationalPrefixIsMandatoryWhenFormattingInNationalFormat() {
				return this.usesNationalPrefix() && !this.nationalPrefixIsOptionalWhenFormattingInNationalFormat();
			}
		},
		{
			key: "usesNationalPrefix",
			value: function usesNationalPrefix() {
				return !(!this.nationalPrefixFormattingRule() || ze.test(this.nationalPrefixFormattingRule()));
			}
		},
		{
			key: "internationalFormat",
			value: function internationalFormat() {
				return this._format[5] || this.format();
			}
		}
	]);
}(), ze = /^\(?\$1\)?$/, Be = /*#__PURE__*/ function() {
	function Type(e, t) {
		_classCallCheck$2(this, Type), this.type = e, this.metadata = t;
	}
	return _createClass$2(Type, [{
		key: "pattern",
		value: function pattern() {
			return this.metadata.v1 ? this.type : this.type[0];
		}
	}, {
		key: "possibleLengths",
		value: function possibleLengths() {
			if (!this.metadata.v1) return this.type[1] || this.metadata.possibleLengths();
		}
	}]);
}();
function getType(e, t) {
	switch (t) {
		case "FIXED_LINE": return e[0];
		case "MOBILE": return e[1];
		case "TOLL_FREE": return e[2];
		case "PREMIUM_RATE": return e[3];
		case "PERSONAL_NUMBER": return e[4];
		case "VOICEMAIL": return e[5];
		case "UAN": return e[6];
		case "PAGER": return e[7];
		case "VOIP": return e[8];
		case "SHARED_COST": return e[9];
	}
}
function validateMetadata(e) {
	if (!e) throw Error("[libphonenumber-js] `metadata` argument not passed. Check your arguments.");
	if (!isObject(e) || !isObject(e.countries)) throw Error(`[libphonenumber-js] \`metadata\` argument was passed but it's not a valid metadata. Must be an object having \`.countries\` child object property. Got ${isObject(e) ? "an object of shape: { " + Object.keys(e).join(", ") + " }" : "a " + Ve(e) + ": " + e}.`);
}
/* istanbul ignore next */
var Ve = function typeOf(e) {
	return _typeof$4(e);
};
function getCountryCallingCode$1(e, t) {
	var n = new M(t);
	if (n.hasCountry(e)) return n.selectNumberingPlan(e).countryCallingCode();
	throw Error(`Unknown country: ${e}`);
}
__name(getCountryCallingCode$1, "getCountryCallingCode");
function setVersion(e) {
	var t = e.version;
	typeof t == "number" ? (this.v1 = t === 1, this.v2 = t === 2, this.v3 = t === 3, this.v4 = t === 4) : t ? semver_compare_default(t, Pe) === -1 ? this.v2 = !0 : semver_compare_default(t, Fe) === -1 ? this.v3 = !0 : this.v4 = !0 : this.v1 = !0;
}
//#endregion
//#region ../../../node_modules/.pnpm/libphonenumber-js@1.13.15/node_modules/libphonenumber-js/es6/helpers/mergeArrays.js
function _createForOfIteratorHelperLoose$3(e, t) {
	var n = typeof Symbol < "u" && e[Symbol.iterator] || e["@@iterator"];
	if (n) return (n = n.call(e)).next.bind(n);
	if (Array.isArray(e) || (n = _unsupportedIterableToArray$4(e)) || t && e && typeof e.length == "number") {
		n && (e = n);
		var r = 0;
		return function() {
			return r >= e.length ? { done: !0 } : {
				done: !1,
				value: e[r++]
			};
		};
	}
	throw TypeError("Invalid attempt to iterate non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}
__name(_createForOfIteratorHelperLoose$3, "_createForOfIteratorHelperLoose");
function _unsupportedIterableToArray$4(e, t) {
	if (e) {
		if (typeof e == "string") return _arrayLikeToArray$4(e, t);
		var n = {}.toString.call(e).slice(8, -1);
		return n === "Object" && e.constructor && (n = e.constructor.name), n === "Map" || n === "Set" ? Array.from(e) : n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n) ? _arrayLikeToArray$4(e, t) : void 0;
	}
}
__name(_unsupportedIterableToArray$4, "_unsupportedIterableToArray");
function _arrayLikeToArray$4(e, t) {
	(t == null || t > e.length) && (t = e.length);
	for (var n = 0, r = Array(t); n < t; n++) r[n] = e[n];
	return r;
}
__name(_arrayLikeToArray$4, "_arrayLikeToArray");
function mergeArrays(e, t) {
	for (var n = e.slice(), r = _createForOfIteratorHelperLoose$3(t), i; !(i = r()).done;) {
		var a = i.value;
		e.indexOf(a) < 0 && n.push(a);
	}
	return n.sort(function(e, t) {
		return e - t;
	});
}
//#endregion
//#region ../../../node_modules/.pnpm/libphonenumber-js@1.13.15/node_modules/libphonenumber-js/es6/helpers/checkNumberLength.js
function checkNumberLength(e, t, n) {
	return checkNumberLengthForType(e, void 0, t, n);
}
function checkNumberLengthForType(e, t, n, r) {
	n && (r = new M(r.metadata), r.selectNumberingPlan(n));
	var i = r.type(t), a = i && i.possibleLengths() || r.possibleLengths();
	if (!a) return "IS_POSSIBLE";
	if (t === "FIXED_LINE_OR_MOBILE") {
		/* istanbul ignore next */
		if (!r.type("FIXED_LINE")) return checkNumberLengthForType(e, "MOBILE", n, r);
		var o = r.type("MOBILE");
		o && (a = mergeArrays(a, o.possibleLengths()));
	} else if (t && !i) return "INVALID_LENGTH";
	var s = e.length, c = a[0];
	return c === s ? "IS_POSSIBLE" : c > s ? "TOO_SHORT" : a[a.length - 1] < s ? "TOO_LONG" : a.indexOf(s, 1) >= 0 ? "IS_POSSIBLE" : "INVALID_LENGTH";
}
//#endregion
//#region ../../../node_modules/.pnpm/libphonenumber-js@1.13.15/node_modules/libphonenumber-js/es6/isPossible.js
function isPossiblePhoneNumber(e, t, n) {
	/* istanbul ignore if */
	t === void 0 && (t = {});
	var r = new M(n);
	if (t.v2) {
		if (!e.countryCallingCode) throw Error("Invalid phone number object passed");
		r.selectNumberingPlan(e.country || e.countryCallingCode);
	} else {
		if (!e.phone) return !1;
		if (e.country) {
			if (!r.hasCountry(e.country)) throw Error(`Unknown country: ${e.country}`);
			r.selectNumberingPlan(e.country);
		} else {
			if (!e.countryCallingCode) throw Error("Invalid phone number object passed");
			r.selectNumberingPlan(e.countryCallingCode);
		}
	}
	if (r.possibleLengths()) return isPossibleNumber(e.phone || e.nationalNumber, r);
	if (e.countryCallingCode && r.isNonGeographicCallingCode(e.countryCallingCode)) return !0;
	throw Error("Missing \"possibleLengths\" in metadata. Perhaps the metadata has been generated before v1.0.18.");
}
function isPossibleNumber(e, t) {
	switch (checkNumberLength(e, void 0, t)) {
		case "IS_POSSIBLE": return !0;
		default: return !1;
	}
}
//#endregion
//#region ../../../node_modules/.pnpm/libphonenumber-js@1.13.15/node_modules/libphonenumber-js/es6/helpers/matchesEntirely.js
function matchesEntirely(e, t) {
	return e ||= "", RegExp("^(?:" + t + ")$").test(e);
}
//#endregion
//#region ../../../node_modules/.pnpm/libphonenumber-js@1.13.15/node_modules/libphonenumber-js/es6/helpers/getNumberType.js
function _createForOfIteratorHelperLoose$2(e, t) {
	var n = typeof Symbol < "u" && e[Symbol.iterator] || e["@@iterator"];
	if (n) return (n = n.call(e)).next.bind(n);
	if (Array.isArray(e) || (n = _unsupportedIterableToArray$3(e)) || t && e && typeof e.length == "number") {
		n && (e = n);
		var r = 0;
		return function() {
			return r >= e.length ? { done: !0 } : {
				done: !1,
				value: e[r++]
			};
		};
	}
	throw TypeError("Invalid attempt to iterate non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}
__name(_createForOfIteratorHelperLoose$2, "_createForOfIteratorHelperLoose");
function _unsupportedIterableToArray$3(e, t) {
	if (e) {
		if (typeof e == "string") return _arrayLikeToArray$3(e, t);
		var n = {}.toString.call(e).slice(8, -1);
		return n === "Object" && e.constructor && (n = e.constructor.name), n === "Map" || n === "Set" ? Array.from(e) : n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n) ? _arrayLikeToArray$3(e, t) : void 0;
	}
}
__name(_unsupportedIterableToArray$3, "_unsupportedIterableToArray");
function _arrayLikeToArray$3(e, t) {
	(t == null || t > e.length) && (t = e.length);
	for (var n = 0, r = Array(t); n < t; n++) r[n] = e[n];
	return r;
}
__name(_arrayLikeToArray$3, "_arrayLikeToArray");
var He = [
	"MOBILE",
	"PREMIUM_RATE",
	"TOLL_FREE",
	"SHARED_COST",
	"VOIP",
	"PERSONAL_NUMBER",
	"PAGER",
	"UAN",
	"VOICEMAIL"
];
function getNumberType(e, t, n) {
	if (t ||= {}, e.country || e.countryCallingCode) {
		var r = new M(n);
		r.selectNumberingPlan(e.country || e.countryCallingCode);
		var i = t.v2 ? e.nationalNumber : e.phone;
		if (matchesEntirely(i, r.nationalNumberPattern())) {
			if (isNumberTypeEqualTo(i, "FIXED_LINE", r)) return r.type("MOBILE") && r.type("MOBILE").pattern() === "" || !r.type("MOBILE") || isNumberTypeEqualTo(i, "MOBILE", r) ? "FIXED_LINE_OR_MOBILE" : "FIXED_LINE";
			for (var a = _createForOfIteratorHelperLoose$2(He), o; !(o = a()).done;) {
				var s = o.value;
				if (isNumberTypeEqualTo(i, s, r)) return s;
			}
		}
	}
}
function isNumberTypeEqualTo(e, t, n) {
	var r = n.type(t);
	return !r || !r.pattern() || r.possibleLengths() && r.possibleLengths().indexOf(e.length) < 0 ? !1 : matchesEntirely(e, r.pattern());
}
//#endregion
//#region ../../../node_modules/.pnpm/libphonenumber-js@1.13.15/node_modules/libphonenumber-js/es6/isValid.js
function isValidNumber(e, t, n) {
	t ||= {};
	var r = new M(n);
	return r.selectNumberingPlan(e.country || e.countryCallingCode), r.hasTypes() ? getNumberType(e, t, r.metadata) !== void 0 : matchesEntirely(t.v2 ? e.nationalNumber : e.phone, r.nationalNumberPattern());
}
//#endregion
//#region ../../../node_modules/.pnpm/libphonenumber-js@1.13.15/node_modules/libphonenumber-js/es6/helpers/isCountryCode.js
var Ue = /^[A-Z]{2}$/;
function isCountryCode(e) {
	return Ue.test(e);
}
function getCountryAndCallingCodeFromOneOfThem(e, t) {
	var n, r, i = new M(t);
	return isCountryCode(e) ? (n = e, i.selectNumberingPlan(n), r = i.countryCallingCode()) : r = e, {
		country: n,
		callingCode: r
	};
}
//#endregion
//#region ../../../node_modules/.pnpm/libphonenumber-js@1.13.15/node_modules/libphonenumber-js/es6/helpers/getPossibleCountriesForNumber.js
function getPossibleCountriesForNumber(e, t, n) {
	var r = new M(n).getCountryCodesForCallingCode(e);
	return r ? r.filter(function(e) {
		return couldNationalNumberBelongToCountry(t, e, n);
	}) : [];
}
function couldNationalNumberBelongToCountry(e, t, n) {
	var r = new M(n);
	return r.selectNumberingPlan(t), r.numberingPlan.possibleLengths().indexOf(e.length) >= 0;
}
//#endregion
//#region ../../../node_modules/.pnpm/libphonenumber-js@1.13.15/node_modules/libphonenumber-js/es6/constants.js
var N = "0-9０-９٠-٩۰-۹", We = "-‐-―−ー－／/．. \xA0­​⁠　()（）［］\\[\\]~⁓∼～", Ge = "+＋", Ke = RegExp("([" + N + "])");
function stripIddPrefix(e, t, n, r) {
	if (t) {
		var i = new M(r);
		i.selectNumberingPlan(t || n);
		var a = new RegExp(i.IDDPrefix());
		if (e.search(a) === 0) {
			e = e.slice(e.match(a)[0].length);
			var o = e.match(Ke);
			if (!(o && o[1] != null && o[1].length > 0 && o[1] === "0")) return e;
		}
	}
}
//#endregion
//#region ../../../node_modules/.pnpm/libphonenumber-js@1.13.15/node_modules/libphonenumber-js/es6/helpers/extractNationalNumberFromPossiblyIncompleteNumber.js
function extractNationalNumberFromPossiblyIncompleteNumber(e, t) {
	if (e && t.numberingPlan.nationalPrefixForParsing()) {
		var n = RegExp("^(?:" + t.numberingPlan.nationalPrefixForParsing() + ")"), r = n.exec(e);
		if (r) {
			var i, a, o = r.length - 1, s = o > 0 && r[o];
			if (t.nationalPrefixTransformRule() && s) i = e.replace(n, t.nationalPrefixTransformRule()), o > 1 && (a = r[1]);
			else {
				var c = r[0];
				i = e.slice(c.length), s && (a = r[1]);
			}
			var l;
			if (s) {
				var u = e.indexOf(r[1]);
				e.slice(0, u) === t.numberingPlan.nationalPrefix() && (l = t.numberingPlan.nationalPrefix());
			} else l = r[0];
			return {
				nationalNumber: i,
				nationalPrefix: l,
				carrierCode: a
			};
		}
	}
	return { nationalNumber: e };
}
//#endregion
//#region ../../../node_modules/.pnpm/libphonenumber-js@1.13.15/node_modules/libphonenumber-js/es6/helpers/getCountryByNationalNumber.js
function _createForOfIteratorHelperLoose$1(e, t) {
	var n = typeof Symbol < "u" && e[Symbol.iterator] || e["@@iterator"];
	if (n) return (n = n.call(e)).next.bind(n);
	if (Array.isArray(e) || (n = _unsupportedIterableToArray$2(e)) || t && e && typeof e.length == "number") {
		n && (e = n);
		var r = 0;
		return function() {
			return r >= e.length ? { done: !0 } : {
				done: !1,
				value: e[r++]
			};
		};
	}
	throw TypeError("Invalid attempt to iterate non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}
__name(_createForOfIteratorHelperLoose$1, "_createForOfIteratorHelperLoose");
function _unsupportedIterableToArray$2(e, t) {
	if (e) {
		if (typeof e == "string") return _arrayLikeToArray$2(e, t);
		var n = {}.toString.call(e).slice(8, -1);
		return n === "Object" && e.constructor && (n = e.constructor.name), n === "Map" || n === "Set" ? Array.from(e) : n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n) ? _arrayLikeToArray$2(e, t) : void 0;
	}
}
__name(_unsupportedIterableToArray$2, "_unsupportedIterableToArray");
function _arrayLikeToArray$2(e, t) {
	(t == null || t > e.length) && (t = e.length);
	for (var n = 0, r = Array(t); n < t; n++) r[n] = e[n];
	return r;
}
__name(_arrayLikeToArray$2, "_arrayLikeToArray");
function getCountryByNationalNumber(e, t, n) {
	for (var r = new M(n), i = _createForOfIteratorHelperLoose$1(t), a; !(a = i()).done;) {
		var o = a.value;
		if (r.selectNumberingPlan(o), r.leadingDigits()) {
			if (e && e.search(r.leadingDigits()) === 0) return o;
		} else if (getNumberType({
			phone: e,
			country: o
		}, void 0, r.metadata)) return o;
	}
}
function getCountryByCallingCode(e, t) {
	var n = t.nationalNumber, r = t.metadata, i = r.getCountryCodesForCallingCode(e);
	if (i) return i.length === 1 ? i[0] : getCountryByNationalNumber(n, i, r.metadata);
}
//#endregion
//#region ../../../node_modules/.pnpm/libphonenumber-js@1.13.15/node_modules/libphonenumber-js/es6/helpers/extractNationalNumber.js
function extractNationalNumber(e, t, n) {
	var r = extractNationalNumberFromPossiblyIncompleteNumber(e, n), i = r.carrierCode, a = r.nationalNumber;
	return a !== e && (!shouldHaveExtractedNationalPrefix(e, a, n) || n.numberingPlan.possibleLengths() && (t ||= getCountryByCallingCode(n.numberingPlan.callingCode(), {
		nationalNumber: a,
		metadata: n
	}), !isPossibleIncompleteNationalNumber(a, t, n))) ? { nationalNumber: e } : {
		nationalNumber: a,
		carrierCode: i
	};
}
function shouldHaveExtractedNationalPrefix(e, t, n) {
	return !(matchesEntirely(e, n.nationalNumberPattern()) && !matchesEntirely(t, n.nationalNumberPattern()));
}
function isPossibleIncompleteNationalNumber(e, t, n) {
	switch (checkNumberLength(e, t, n)) {
		case "TOO_SHORT":
		case "INVALID_LENGTH": return !1;
		default: return !0;
	}
}
//#endregion
//#region ../../../node_modules/.pnpm/libphonenumber-js@1.13.15/node_modules/libphonenumber-js/es6/helpers/extractCountryCallingCodeFromInternationalNumberWithoutPlusSign.js
function extractCountryCallingCodeFromInternationalNumberWithoutPlusSign(e, t, n, r, i) {
	if (!(t || n || r)) return { number: e };
	var a = t || n ? getCountryCallingCode$1(t || n, i) : r;
	if (e.indexOf(a) === 0) {
		var o = new M(i);
		o.selectNumberingPlan(t || n || r);
		var s = e.slice(a.length), c = extractNationalNumber(s, void 0, o).nationalNumber, l = extractNationalNumber(e, void 0, o).nationalNumber;
		if (!matchesEntirely(l, o.nationalNumberPattern()) && matchesEntirely(c, o.nationalNumberPattern()) || checkNumberLength(l, void 0, o) === "TOO_LONG") return {
			countryCallingCode: a,
			number: s
		};
	}
	return { number: e };
}
//#endregion
//#region ../../../node_modules/.pnpm/libphonenumber-js@1.13.15/node_modules/libphonenumber-js/es6/helpers/extractCountryCallingCode.js
function extractCountryCallingCode(e, t, n, r, i) {
	if (!e) return {};
	var a;
	if (e[0] !== "+") {
		var o = stripIddPrefix(e, t || n, r, i);
		if (o && o !== e) a = !0, e = "+" + o;
		else {
			if (t || n || r) {
				var s = extractCountryCallingCodeFromInternationalNumberWithoutPlusSign(e, t, n, r, i), c = s.countryCallingCode, l = s.number;
				if (c) return {
					countryCallingCodeSource: "FROM_NUMBER_WITHOUT_PLUS_SIGN",
					countryCallingCode: c,
					number: l
				};
			}
			return { number: e };
		}
	}
	if (e[1] === "0") return {};
	for (var u = new M(i), d = 2; d - 1 <= 3 && d <= e.length;) {
		var f = e.slice(1, d);
		if (u.hasCallingCode(f)) return u.selectNumberingPlan(f), {
			countryCallingCodeSource: a ? "FROM_NUMBER_WITH_IDD" : "FROM_NUMBER_WITH_PLUS_SIGN",
			countryCallingCode: f,
			number: e.slice(d)
		};
		d++;
	}
	return {};
}
//#endregion
//#region ../../../node_modules/.pnpm/libphonenumber-js@1.13.15/node_modules/libphonenumber-js/es6/helpers/applyInternationalSeparatorStyle.js
function applyInternationalSeparatorStyle(e) {
	return e.replace(RegExp(`[${We}]+`, "g"), " ").trim();
}
//#endregion
//#region ../../../node_modules/.pnpm/libphonenumber-js@1.13.15/node_modules/libphonenumber-js/es6/helpers/formatNationalNumberUsingFormat.js
var qe = /(\$\d)/;
function formatNationalNumberUsingFormat(e, t, n) {
	var r = n.useInternationalFormat, i = n.withNationalPrefix;
	n.carrierCode, n.metadata;
	var a = e.replace(new RegExp(t.pattern()), r ? t.internationalFormat() : i && t.nationalPrefixFormattingRule() ? t.format().replace(qe, t.nationalPrefixFormattingRule()) : t.format());
	return r ? applyInternationalSeparatorStyle(a) : a;
}
//#endregion
//#region ../../../node_modules/.pnpm/libphonenumber-js@1.13.15/node_modules/libphonenumber-js/es6/helpers/getIddPrefix.js
var Je = /^[\d]+(?:[~\u2053\u223C\uFF5E][\d]+)?$/;
function getIddPrefix(e, t, n) {
	var r = new M(n);
	if (r.selectNumberingPlan(e || t), r.defaultIDDPrefix()) return r.defaultIDDPrefix();
	if (Je.test(r.IDDPrefix())) return r.IDDPrefix();
}
//#endregion
//#region ../../../node_modules/.pnpm/libphonenumber-js@1.13.15/node_modules/libphonenumber-js/es6/helpers/extension/createExtensionPattern.js
var Ye = ";ext=", P = function getExtensionDigitsPattern(e) {
	return `([${N}]{1,${e}})`;
};
function createExtensionPattern(e) {
	var t = "20", n = "15", r = "9", i = "6", a = "[ \xA0\\t,]*", o = "[:\\.．]?[ \xA0\\t,-]*", s = "#?", c = "(?:e?xt(?:ensi(?:ó?|ó))?n?|ｅ?ｘｔｎ?|доб|anexo)", l = "(?:[xｘ#＃~～]|int|ｉｎｔ)", u = "[- ]+", d = "[ \xA0\\t]*", f = "(?:,{2}|;)", p = Ye + P(t), m = a + c + o + P(t) + s, h = a + l + o + P(r) + s, ee = u + P(i) + "#", g = d + f + o + P(n) + s, te = d + "(?:,)+" + o + P(r) + s;
	return p + "|" + m + "|" + h + "|" + ee + "|" + g + "|" + te;
}
//#endregion
//#region ../../../node_modules/.pnpm/libphonenumber-js@1.13.15/node_modules/libphonenumber-js/es6/helpers/isViablePhoneNumber.js
var Xe = "[" + N + "]{2}", Ze = "[" + Ge + "]{0,1}(?:[" + We + "]*[" + N + "]){3,}[" + We + N + "]*", Qe = RegExp("^[" + Ge + "]{0,1}(?:[" + We + "]*[" + N + "]){1,2}$", "i"), $e = Ze + "(?:" + createExtensionPattern() + ")?", et = RegExp("^" + Xe + "$|^" + $e + "$", "i");
function isViablePhoneNumber(e) {
	return e.length >= 2 && et.test(e);
}
function isViablePhoneNumberStart(e) {
	return Qe.test(e);
}
//#endregion
//#region ../../../node_modules/.pnpm/libphonenumber-js@1.13.15/node_modules/libphonenumber-js/es6/helpers/RFC3966.js
function formatRFC3966(e) {
	var t = e.number, n = e.ext;
	if (!t) return "";
	if (t[0] !== "+") throw Error("\"formatRFC3966()\" expects \"number\" to be in E.164 format.");
	return `tel:${t}${n ? ";ext=" + n : ""}`;
}
//#endregion
//#region ../../../node_modules/.pnpm/libphonenumber-js@1.13.15/node_modules/libphonenumber-js/es6/format.js
var tt = { formatExtension: function formatExtension(e, t, n) {
	return `${e}${n.ext()}${t}`;
} };
function formatNumber(e, t, n, r) {
	n = n ? merge({}, tt, n) : tt;
	var i = new M(r);
	if (e.country && e.country !== "001") {
		if (!i.hasCountry(e.country)) throw Error(`Unknown country: ${e.country}`);
		i.selectNumberingPlan(e.country);
	} else if (e.countryCallingCode) i.selectNumberingPlan(e.countryCallingCode);
	else return e.phone || "";
	var a = i.countryCallingCode(), o = n.v2 ? e.nationalNumber : e.phone, s;
	switch (t) {
		case "NATIONAL": return o ? (s = formatNationalNumber(o, e.carrierCode, "NATIONAL", i, n), addExtension(s, e.ext, i, n.formatExtension)) : "";
		case "INTERNATIONAL": return o ? (s = formatNationalNumber(o, null, "INTERNATIONAL", i, n), s = `+${a} ${s}`, addExtension(s, e.ext, i, n.formatExtension)) : `+${a}`;
		case "E.164": return `+${a}${o}`;
		case "RFC3966": return formatRFC3966({
			number: `+${a}${o}`,
			ext: e.ext
		});
		case "IDD":
			if (!n.fromCountry) return;
			var c = formatIDD(o, e.carrierCode, a, n.fromCountry, i);
			return c ? addExtension(c, e.ext, i, n.formatExtension) : void 0;
		default: throw Error(`Unknown "format" argument passed to "formatNumber()": "${t}"`);
	}
}
function formatNationalNumber(e, t, n, r, i) {
	var a = chooseFormatForNumber(r.formats(), e);
	return a ? formatNationalNumberUsingFormat(e, a, {
		useInternationalFormat: n === "INTERNATIONAL",
		withNationalPrefix: !(a.nationalPrefixIsOptionalWhenFormattingInNationalFormat() && i && i.nationalPrefix === !1),
		carrierCode: t,
		metadata: r
	}) : e;
}
function chooseFormatForNumber(e, t) {
	return pickFirstMatchingElement(e, function(e) {
		if (e.leadingDigitsPatterns().length > 0) {
			var n = e.leadingDigitsPatterns()[e.leadingDigitsPatterns().length - 1];
			if (t.search(n) !== 0) return !1;
		}
		return matchesEntirely(t, e.pattern());
	});
}
function addExtension(e, t, n, r) {
	return t ? r(e, t, n) : e;
}
function formatIDD(e, t, n, r, i) {
	if (getCountryCallingCode$1(r, i.metadata) === n) {
		var a = formatNationalNumber(e, t, "NATIONAL", i);
		return n === "1" ? n + " " + a : a;
	}
	var o = getIddPrefix(r, void 0, i.metadata);
	if (o) return `${o} ${n} ${formatNationalNumber(e, null, "INTERNATIONAL", i)}`;
}
function merge() {
	for (var e = 1, t = [...arguments]; e < t.length;) {
		if (t[e]) for (var n in t[e]) t[0][n] = t[e][n];
		e++;
	}
	return t[0];
}
function pickFirstMatchingElement(e, t) {
	for (var n = 0; n < e.length;) {
		if (t(e[n])) return e[n];
		n++;
	}
}
//#endregion
//#region ../../../node_modules/.pnpm/libphonenumber-js@1.13.15/node_modules/libphonenumber-js/es6/PhoneNumber.js
function _typeof$3(e) {
	"@babel/helpers - typeof";
	return _typeof$3 = typeof Symbol == "function" && typeof Symbol.iterator == "symbol" ? function(e) {
		return typeof e;
	} : function(e) {
		return e && typeof Symbol == "function" && e.constructor === Symbol && e !== Symbol.prototype ? "symbol" : typeof e;
	}, _typeof$3(e);
}
__name(_typeof$3, "_typeof");
function ownKeys$2(e, t) {
	var n = Object.keys(e);
	if (Object.getOwnPropertySymbols) {
		var r = Object.getOwnPropertySymbols(e);
		t && (r = r.filter(function(t) {
			return Object.getOwnPropertyDescriptor(e, t).enumerable;
		})), n.push.apply(n, r);
	}
	return n;
}
__name(ownKeys$2, "ownKeys");
function _objectSpread$2(e) {
	for (var t = 1; t < arguments.length; t++) {
		var n = arguments[t] == null ? {} : arguments[t];
		t % 2 ? ownKeys$2(Object(n), !0).forEach(function(t) {
			_defineProperty$2(e, t, n[t]);
		}) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(n)) : ownKeys$2(Object(n)).forEach(function(t) {
			Object.defineProperty(e, t, Object.getOwnPropertyDescriptor(n, t));
		});
	}
	return e;
}
__name(_objectSpread$2, "_objectSpread");
function _defineProperty$2(e, t, n) {
	return (t = _toPropertyKey$3(t)) in e ? Object.defineProperty(e, t, {
		value: n,
		enumerable: !0,
		configurable: !0,
		writable: !0
	}) : e[t] = n, e;
}
__name(_defineProperty$2, "_defineProperty");
function _classCallCheck$1(e, t) {
	if (!(e instanceof t)) throw TypeError("Cannot call a class as a function");
}
__name(_classCallCheck$1, "_classCallCheck");
function _defineProperties$1(e, t) {
	for (var n = 0; n < t.length; n++) {
		var r = t[n];
		r.enumerable = r.enumerable || !1, r.configurable = !0, "value" in r && (r.writable = !0), Object.defineProperty(e, _toPropertyKey$3(r.key), r);
	}
}
__name(_defineProperties$1, "_defineProperties");
function _createClass$1(e, t, n) {
	return t && _defineProperties$1(e.prototype, t), n && _defineProperties$1(e, n), Object.defineProperty(e, "prototype", { writable: !1 }), e;
}
__name(_createClass$1, "_createClass");
function _toPropertyKey$3(e) {
	var t = _toPrimitive$3(e, "string");
	return _typeof$3(t) == "symbol" ? t : t + "";
}
__name(_toPropertyKey$3, "_toPropertyKey");
function _toPrimitive$3(e, t) {
	if (_typeof$3(e) != "object" || !e) return e;
	var n = e[Symbol.toPrimitive];
	if (n !== void 0) {
		var r = n.call(e, t || "default");
		if (_typeof$3(r) != "object") return r;
		throw TypeError("@@toPrimitive must return a primitive value.");
	}
	return (t === "string" ? String : Number)(e);
}
__name(_toPrimitive$3, "_toPrimitive");
var nt = /*#__PURE__*/ function() {
	function PhoneNumber(e, t, n) {
		if (_classCallCheck$1(this, PhoneNumber), !e) throw TypeError("First argument is required");
		if (typeof e != "string") throw TypeError("First argument must be a string");
		if (e[0] === "+" && !t) throw TypeError("`metadata` argument not passed");
		if (isObject(t) && isObject(t.countries)) {
			n = t;
			var r = e;
			if (!rt.test(r)) throw Error("Invalid `number` argument passed: must consist of a \"+\" followed by digits");
			var i = extractCountryCallingCode(r, void 0, void 0, void 0, n), a = i.countryCallingCode;
			if (t = i.number, e = a, !t) throw Error("Invalid `number` argument passed: too short");
		}
		if (!t) throw TypeError("`nationalNumber` argument is required");
		if (typeof t != "string") throw TypeError("`nationalNumber` argument must be a string");
		validateMetadata(n);
		var o = getCountryAndCallingCodeFromOneOfThem(e, n), s = o.country, c = o.callingCode;
		this.country = s, this.countryCallingCode = c, this.nationalNumber = t, this.number = "+" + this.countryCallingCode + this.nationalNumber, this.getMetadata = function() {
			return n;
		};
	}
	return _createClass$1(PhoneNumber, [
		{
			key: "setExt",
			value: function setExt(e) {
				this.ext = e;
			}
		},
		{
			key: "getPossibleCountries",
			value: function getPossibleCountries() {
				return this.country ? [this.country] : getPossibleCountriesForNumber(this.countryCallingCode, this.nationalNumber, this.getMetadata());
			}
		},
		{
			key: "isPossible",
			value: function isPossible() {
				return isPossiblePhoneNumber(this, { v2: !0 }, this.getMetadata());
			}
		},
		{
			key: "isValid",
			value: function isValid() {
				return isValidNumber(this, { v2: !0 }, this.getMetadata());
			}
		},
		{
			key: "isNonGeographic",
			value: function isNonGeographic() {
				return new M(this.getMetadata()).isNonGeographicCallingCode(this.countryCallingCode);
			}
		},
		{
			key: "isEqual",
			value: function isEqual(e) {
				return this.number === e.number && this.ext === e.ext;
			}
		},
		{
			key: "getType",
			value: function getType() {
				return getNumberType(this, { v2: !0 }, this.getMetadata());
			}
		},
		{
			key: "format",
			value: function format(e, t) {
				return formatNumber(this, e, t ? _objectSpread$2(_objectSpread$2({}, t), {}, { v2: !0 }) : { v2: !0 }, this.getMetadata());
			}
		},
		{
			key: "formatNational",
			value: function formatNational(e) {
				return this.format("NATIONAL", e);
			}
		},
		{
			key: "formatInternational",
			value: function formatInternational(e) {
				return this.format("INTERNATIONAL", e);
			}
		},
		{
			key: "getURI",
			value: function getURI(e) {
				return this.format("RFC3966", e);
			}
		}
	]);
}(), rt = /^\+\d+$/;
//#endregion
//#region ../../../node_modules/.pnpm/libphonenumber-js@1.13.15/node_modules/libphonenumber-js/es6/ParseError.js
function _typeof$2(e) {
	"@babel/helpers - typeof";
	return _typeof$2 = typeof Symbol == "function" && typeof Symbol.iterator == "symbol" ? function(e) {
		return typeof e;
	} : function(e) {
		return e && typeof Symbol == "function" && e.constructor === Symbol && e !== Symbol.prototype ? "symbol" : typeof e;
	}, _typeof$2(e);
}
__name(_typeof$2, "_typeof");
function _defineProperties(e, t) {
	for (var n = 0; n < t.length; n++) {
		var r = t[n];
		r.enumerable = r.enumerable || !1, r.configurable = !0, "value" in r && (r.writable = !0), Object.defineProperty(e, _toPropertyKey$2(r.key), r);
	}
}
function _createClass(e, t, n) {
	return t && _defineProperties(e.prototype, t), n && _defineProperties(e, n), Object.defineProperty(e, "prototype", { writable: !1 }), e;
}
function _toPropertyKey$2(e) {
	var t = _toPrimitive$2(e, "string");
	return _typeof$2(t) == "symbol" ? t : t + "";
}
__name(_toPropertyKey$2, "_toPropertyKey");
function _toPrimitive$2(e, t) {
	if (_typeof$2(e) != "object" || !e) return e;
	var n = e[Symbol.toPrimitive];
	if (n !== void 0) {
		var r = n.call(e, t || "default");
		if (_typeof$2(r) != "object") return r;
		throw TypeError("@@toPrimitive must return a primitive value.");
	}
	return (t === "string" ? String : Number)(e);
}
__name(_toPrimitive$2, "_toPrimitive");
function _classCallCheck(e, t) {
	if (!(e instanceof t)) throw TypeError("Cannot call a class as a function");
}
function _callSuper(e, t, n) {
	return t = _getPrototypeOf(t), _possibleConstructorReturn(e, _isNativeReflectConstruct() ? Reflect.construct(t, n || [], _getPrototypeOf(e).constructor) : t.apply(e, n));
}
function _possibleConstructorReturn(e, t) {
	if (t && (_typeof$2(t) == "object" || typeof t == "function")) return t;
	if (t !== void 0) throw TypeError("Derived constructors may only return object or undefined");
	return _assertThisInitialized(e);
}
function _assertThisInitialized(e) {
	if (e === void 0) throw ReferenceError("this hasn't been initialised - super() hasn't been called");
	return e;
}
function _inherits(e, t) {
	if (typeof t != "function" && t !== null) throw TypeError("Super expression must either be null or a function");
	e.prototype = Object.create(t && t.prototype, { constructor: {
		value: e,
		writable: !0,
		configurable: !0
	} }), Object.defineProperty(e, "prototype", { writable: !1 }), t && _setPrototypeOf(e, t);
}
function _wrapNativeSuper(e) {
	var t = typeof Map == "function" ? /* @__PURE__ */ new Map() : void 0;
	return _wrapNativeSuper = function _wrapNativeSuper(e) {
		if (e === null || !_isNativeFunction(e)) return e;
		if (typeof e != "function") throw TypeError("Super expression must either be null or a function");
		if (t !== void 0) {
			if (t.has(e)) return t.get(e);
			t.set(e, Wrapper);
		}
		function Wrapper() {
			return _construct(e, arguments, _getPrototypeOf(this).constructor);
		}
		return Wrapper.prototype = Object.create(e.prototype, { constructor: {
			value: Wrapper,
			enumerable: !1,
			writable: !0,
			configurable: !0
		} }), _setPrototypeOf(Wrapper, e);
	}, _wrapNativeSuper(e);
}
function _construct(e, t, n) {
	if (_isNativeReflectConstruct()) return Reflect.construct.apply(null, arguments);
	var r = [null];
	r.push.apply(r, t);
	var i = new (e.bind.apply(e, r))();
	return n && _setPrototypeOf(i, n.prototype), i;
}
function _isNativeReflectConstruct() {
	try {
		var e = !Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function() {}));
	} catch {}
	return (_isNativeReflectConstruct = function _isNativeReflectConstruct() {
		return !!e;
	})();
}
function _isNativeFunction(e) {
	try {
		return Function.toString.call(e).indexOf("[native code]") !== -1;
	} catch {
		return typeof e == "function";
	}
}
function _setPrototypeOf(e, t) {
	return _setPrototypeOf = Object.setPrototypeOf ? Object.setPrototypeOf.bind() : function(e, t) {
		return e.__proto__ = t, e;
	}, _setPrototypeOf(e, t);
}
function _getPrototypeOf(e) {
	return _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf.bind() : function(e) {
		return e.__proto__ || Object.getPrototypeOf(e);
	}, _getPrototypeOf(e);
}
var F = /*#__PURE__*/ function(e) {
	function ParseError(e) {
		var t;
		return _classCallCheck(this, ParseError), t = _callSuper(this, ParseError, [e]), Object.setPrototypeOf(t, ParseError.prototype), t.name = t.constructor.name, t;
	}
	return _inherits(ParseError, e), _createClass(ParseError);
}(/*#__PURE__*/ _wrapNativeSuper(Error)), it = RegExp("(?:" + createExtensionPattern() + ")$", "i");
function extractExtension(e) {
	var t = e.search(it);
	if (t < 0) return {};
	for (var n = e.slice(0, t), r = e.match(it), i = 1; i < r.length;) {
		if (r[i]) return {
			number: n,
			ext: r[i]
		};
		i++;
	}
}
//#endregion
//#region ../../../node_modules/.pnpm/libphonenumber-js@1.13.15/node_modules/libphonenumber-js/es6/helpers/parseDigits.js
var at = {
	0: "0",
	1: "1",
	2: "2",
	3: "3",
	4: "4",
	5: "5",
	6: "6",
	7: "7",
	8: "8",
	9: "9",
	"０": "0",
	"１": "1",
	"２": "2",
	"３": "3",
	"４": "4",
	"５": "5",
	"６": "6",
	"７": "7",
	"８": "8",
	"９": "9",
	"٠": "0",
	"١": "1",
	"٢": "2",
	"٣": "3",
	"٤": "4",
	"٥": "5",
	"٦": "6",
	"٧": "7",
	"٨": "8",
	"٩": "9",
	"۰": "0",
	"۱": "1",
	"۲": "2",
	"۳": "3",
	"۴": "4",
	"۵": "5",
	"۶": "6",
	"۷": "7",
	"۸": "8",
	"۹": "9"
};
function parseDigit(e) {
	return at[e];
}
//#endregion
//#region ../../../node_modules/.pnpm/libphonenumber-js@1.13.15/node_modules/libphonenumber-js/es6/parseIncompletePhoneNumber.js
function _createForOfIteratorHelperLoose(e, t) {
	var n = typeof Symbol < "u" && e[Symbol.iterator] || e["@@iterator"];
	if (n) return (n = n.call(e)).next.bind(n);
	if (Array.isArray(e) || (n = _unsupportedIterableToArray$1(e)) || t && e && typeof e.length == "number") {
		n && (e = n);
		var r = 0;
		return function() {
			return r >= e.length ? { done: !0 } : {
				done: !1,
				value: e[r++]
			};
		};
	}
	throw TypeError("Invalid attempt to iterate non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}
function _unsupportedIterableToArray$1(e, t) {
	if (e) {
		if (typeof e == "string") return _arrayLikeToArray$1(e, t);
		var n = {}.toString.call(e).slice(8, -1);
		return n === "Object" && e.constructor && (n = e.constructor.name), n === "Map" || n === "Set" ? Array.from(e) : n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n) ? _arrayLikeToArray$1(e, t) : void 0;
	}
}
__name(_unsupportedIterableToArray$1, "_unsupportedIterableToArray");
function _arrayLikeToArray$1(e, t) {
	(t == null || t > e.length) && (t = e.length);
	for (var n = 0, r = Array(t); n < t; n++) r[n] = e[n];
	return r;
}
__name(_arrayLikeToArray$1, "_arrayLikeToArray");
function parseIncompletePhoneNumber(e) {
	for (var t = "", n = _createForOfIteratorHelperLoose(e.split("")), r; !(r = n()).done;) {
		var i = r.value;
		t += parsePhoneNumberCharacter(i, t) || "";
	}
	return t;
}
function parsePhoneNumberCharacter(e, t, n) {
	if (e === "+") {
		if (t) {
			typeof n == "function" && n("end");
			return;
		}
		return "+";
	}
	return parseDigit(e);
}
var ot = "([" + N + "]|[\\-\\.\\(\\)]?)", st = "^\\+" + ot + "*[" + N + "]" + ot + "*$", ct = new RegExp(st, "g"), lt = N, ut = "[" + lt + "]+((\\-)*[" + lt + "])*", dt = "[a-zA-Z]+((\\-)*[" + lt + "])*", ft = "^(" + ut + "\\.)*" + dt + "\\.?$", pt = new RegExp(ft, "g"), mt = "tel:", ht = ";phone-context=", gt = ";isub=";
function extractPhoneContext(e) {
	var t = e.indexOf(ht);
	if (t < 0) return null;
	var n = t + ht.length;
	if (n >= e.length) return "";
	var r = e.indexOf(";", n);
	return r >= 0 ? e.substring(n, r) : e.substring(n);
}
function isPhoneContextValid(e) {
	return e === null ? !0 : e.length === 0 ? !1 : ct.test(e) || pt.test(e);
}
//#endregion
//#region ../../../node_modules/.pnpm/libphonenumber-js@1.13.15/node_modules/libphonenumber-js/es6/helpers/extractFormattedPhoneNumberFromPossibleRfc3966NumberUri.js
function extractFormattedPhoneNumberFromPossibleRfc3966NumberUri(e, t) {
	var n = t.extractFormattedPhoneNumber, r = extractPhoneContext(e);
	if (!isPhoneContextValid(r)) throw new F("NOT_A_NUMBER");
	var i;
	if (r === null) i = n(e) || "";
	else {
		i = "", r.charAt(0) === "+" && (i += r);
		var a = e.indexOf(mt), o = a >= 0 ? a + mt.length : 0, s = e.indexOf(ht);
		i += e.substring(o, s);
	}
	var c = i.indexOf(gt);
	if (c > 0 && (i = i.substring(0, c)), i !== "") return i;
}
//#endregion
//#region ../../../node_modules/.pnpm/libphonenumber-js@1.13.15/node_modules/libphonenumber-js/es6/parse.js
var _t = 250, vt = RegExp("[" + Ge + N + "]"), yt = RegExp("[^" + N + "#]+$");
function parse(e, t, n) {
	t ||= {};
	var r = new M(n);
	if (t.defaultCountry && !r.hasCountry(t.defaultCountry)) throw t.v2 ? new F("INVALID_COUNTRY") : Error(`Unknown country: ${t.defaultCountry}`);
	var i = parseInput(e, t.v2, t.extract), a = i.number, o = i.ext, s = i.error;
	if (!a) {
		if (t.v2) throw s === "TOO_SHORT" ? new F("TOO_SHORT") : new F("NOT_A_NUMBER");
		return {};
	}
	var c = parsePhoneNumber(a, t.defaultCountry, t.defaultCallingCode, r), l = c.country, u = c.nationalNumber, d = c.countryCallingCode, f = c.countryCallingCodeSource, p = c.carrierCode;
	if (!r.hasSelectedNumberingPlan()) {
		if (t.v2) throw new F("INVALID_COUNTRY");
		return {};
	}
	if (!u || u.length < 2) {
		/* istanbul ignore if */
		if (t.v2) throw new F("TOO_SHORT");
		return {};
	}
	if (u.length > 17) {
		if (t.v2) throw new F("TOO_LONG");
		return {};
	}
	if (t.v2) {
		var m = new nt(d, u, r.metadata);
		return l && (m.country = l), p && (m.carrierCode = p), o && (m.ext = o), m.__countryCallingCodeSource = f, m;
	}
	var h = (t.extended ? r.hasSelectedNumberingPlan() : l) ? matchesEntirely(u, r.nationalNumberPattern()) : !1;
	return t.extended ? {
		country: l,
		countryCallingCode: d,
		carrierCode: p,
		valid: h,
		possible: h ? !0 : !!(t.extended === !0 && r.possibleLengths() && isPossibleNumber(u, r)),
		phone: u,
		ext: o
	} : h ? result(l, u, o) : {};
}
function _extractFormattedPhoneNumber(e, t, n) {
	if (e) {
		if (e.length > _t) {
			if (n) throw new F("TOO_LONG");
			return;
		}
		if (t === !1) return e;
		var r = e.search(vt);
		if (!(r < 0)) return e.slice(r).replace(yt, "");
	}
}
function parseInput(e, t, n) {
	var r = extractFormattedPhoneNumberFromPossibleRfc3966NumberUri(e, { extractFormattedPhoneNumber: function extractFormattedPhoneNumber(e) {
		return _extractFormattedPhoneNumber(e, n, t);
	} });
	if (!r) return {};
	if (!isViablePhoneNumber(r)) return isViablePhoneNumberStart(r) ? { error: "TOO_SHORT" } : {};
	var i = extractExtension(r);
	return i.ext ? i : { number: r };
}
function result(e, t, n) {
	var r = {
		country: e,
		phone: t
	};
	return n && (r.ext = n), r;
}
function parsePhoneNumber(e, t, n, r) {
	var i = extractCountryCallingCode(parseIncompletePhoneNumber(e), void 0, t, n, r.metadata), a = i.countryCallingCodeSource, o = i.countryCallingCode, s = i.number, c;
	if (o) r.selectNumberingPlan(o);
	else if (s && (t || n)) t ? (c = t, r.selectNumberingPlan(t), o = r.numberingPlan.callingCode()) : (r.selectNumberingPlan(n), o = n);
	else return {};
	if (!s) return {
		countryCallingCodeSource: a,
		countryCallingCode: o
	};
	var l = extractNationalNumber(parseIncompletePhoneNumber(s), void 0, r), u = l.nationalNumber, d = l.carrierCode, f = getCountryByCallingCode(o, {
		nationalNumber: u,
		metadata: r
	});
	return f && (c = f, f === "001" || r.selectNumberingPlan(c)), {
		country: c,
		countryCallingCode: o,
		countryCallingCodeSource: a,
		nationalNumber: u,
		carrierCode: d
	};
}
//#endregion
//#region ../../../node_modules/.pnpm/libphonenumber-js@1.13.15/node_modules/libphonenumber-js/es6/parsePhoneNumberWithError_.js
function _typeof$1(e) {
	"@babel/helpers - typeof";
	return _typeof$1 = typeof Symbol == "function" && typeof Symbol.iterator == "symbol" ? function(e) {
		return typeof e;
	} : function(e) {
		return e && typeof Symbol == "function" && e.constructor === Symbol && e !== Symbol.prototype ? "symbol" : typeof e;
	}, _typeof$1(e);
}
__name(_typeof$1, "_typeof");
function ownKeys$1(e, t) {
	var n = Object.keys(e);
	if (Object.getOwnPropertySymbols) {
		var r = Object.getOwnPropertySymbols(e);
		t && (r = r.filter(function(t) {
			return Object.getOwnPropertyDescriptor(e, t).enumerable;
		})), n.push.apply(n, r);
	}
	return n;
}
__name(ownKeys$1, "ownKeys");
function _objectSpread$1(e) {
	for (var t = 1; t < arguments.length; t++) {
		var n = arguments[t] == null ? {} : arguments[t];
		t % 2 ? ownKeys$1(Object(n), !0).forEach(function(t) {
			_defineProperty$1(e, t, n[t]);
		}) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(n)) : ownKeys$1(Object(n)).forEach(function(t) {
			Object.defineProperty(e, t, Object.getOwnPropertyDescriptor(n, t));
		});
	}
	return e;
}
__name(_objectSpread$1, "_objectSpread");
function _defineProperty$1(e, t, n) {
	return (t = _toPropertyKey$1(t)) in e ? Object.defineProperty(e, t, {
		value: n,
		enumerable: !0,
		configurable: !0,
		writable: !0
	}) : e[t] = n, e;
}
__name(_defineProperty$1, "_defineProperty");
function _toPropertyKey$1(e) {
	var t = _toPrimitive$1(e, "string");
	return _typeof$1(t) == "symbol" ? t : t + "";
}
__name(_toPropertyKey$1, "_toPropertyKey");
function _toPrimitive$1(e, t) {
	if (_typeof$1(e) != "object" || !e) return e;
	var n = e[Symbol.toPrimitive];
	if (n !== void 0) {
		var r = n.call(e, t || "default");
		if (_typeof$1(r) != "object") return r;
		throw TypeError("@@toPrimitive must return a primitive value.");
	}
	return (t === "string" ? String : Number)(e);
}
__name(_toPrimitive$1, "_toPrimitive");
function parsePhoneNumberWithError$2(e, t, n) {
	return parse(e, _objectSpread$1(_objectSpread$1({}, t), {}, { v2: !0 }), n);
}
__name(parsePhoneNumberWithError$2, "parsePhoneNumberWithError");
//#endregion
//#region ../../../node_modules/.pnpm/libphonenumber-js@1.13.15/node_modules/libphonenumber-js/es6/normalizeArguments.js
function _typeof(e) {
	"@babel/helpers - typeof";
	return _typeof = typeof Symbol == "function" && typeof Symbol.iterator == "symbol" ? function(e) {
		return typeof e;
	} : function(e) {
		return e && typeof Symbol == "function" && e.constructor === Symbol && e !== Symbol.prototype ? "symbol" : typeof e;
	}, _typeof(e);
}
function ownKeys(e, t) {
	var n = Object.keys(e);
	if (Object.getOwnPropertySymbols) {
		var r = Object.getOwnPropertySymbols(e);
		t && (r = r.filter(function(t) {
			return Object.getOwnPropertyDescriptor(e, t).enumerable;
		})), n.push.apply(n, r);
	}
	return n;
}
function _objectSpread(e) {
	for (var t = 1; t < arguments.length; t++) {
		var n = arguments[t] == null ? {} : arguments[t];
		t % 2 ? ownKeys(Object(n), !0).forEach(function(t) {
			_defineProperty(e, t, n[t]);
		}) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(n)) : ownKeys(Object(n)).forEach(function(t) {
			Object.defineProperty(e, t, Object.getOwnPropertyDescriptor(n, t));
		});
	}
	return e;
}
function _defineProperty(e, t, n) {
	return (t = _toPropertyKey(t)) in e ? Object.defineProperty(e, t, {
		value: n,
		enumerable: !0,
		configurable: !0,
		writable: !0
	}) : e[t] = n, e;
}
function _toPropertyKey(e) {
	var t = _toPrimitive(e, "string");
	return _typeof(t) == "symbol" ? t : t + "";
}
function _toPrimitive(e, t) {
	if (_typeof(e) != "object" || !e) return e;
	var n = e[Symbol.toPrimitive];
	if (n !== void 0) {
		var r = n.call(e, t || "default");
		if (_typeof(r) != "object") return r;
		throw TypeError("@@toPrimitive must return a primitive value.");
	}
	return (t === "string" ? String : Number)(e);
}
function _slicedToArray(e, t) {
	return _arrayWithHoles(e) || _iterableToArrayLimit(e, t) || _unsupportedIterableToArray(e, t) || _nonIterableRest();
}
function _nonIterableRest() {
	throw TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}
function _unsupportedIterableToArray(e, t) {
	if (e) {
		if (typeof e == "string") return _arrayLikeToArray(e, t);
		var n = {}.toString.call(e).slice(8, -1);
		return n === "Object" && e.constructor && (n = e.constructor.name), n === "Map" || n === "Set" ? Array.from(e) : n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n) ? _arrayLikeToArray(e, t) : void 0;
	}
}
function _arrayLikeToArray(e, t) {
	(t == null || t > e.length) && (t = e.length);
	for (var n = 0, r = Array(t); n < t; n++) r[n] = e[n];
	return r;
}
function _iterableToArrayLimit(e, t) {
	var n = e == null ? null : typeof Symbol < "u" && e[Symbol.iterator] || e["@@iterator"];
	if (n != null) {
		var r, i, a, o, s = [], c = !0, l = !1;
		try {
			if (a = (n = n.call(e)).next, t === 0) {
				if (Object(n) !== n) return;
				c = !1;
			} else for (; !(c = (r = a.call(n)).done) && (s.push(r.value), s.length !== t); c = !0);
		} catch (e) {
			l = !0, i = e;
		} finally {
			try {
				if (!c && n.return != null && (o = n.return(), Object(o) !== o)) return;
			} finally {
				if (l) throw i;
			}
		}
		return s;
	}
}
function _arrayWithHoles(e) {
	if (Array.isArray(e)) return e;
}
function normalizeArguments(e) {
	var t = _slicedToArray(Array.prototype.slice.call(e), 4), n = t[0], r = t[1], i = t[2], a = t[3], o, s, c;
	if (typeof n == "string") o = n;
	else throw TypeError("A text for parsing must be a string.");
	if (!r || typeof r == "string") a ? (s = i, c = a) : (s = void 0, c = i), r && (s = _objectSpread({ defaultCountry: r }, s));
	else if (isObject(r)) i ? (s = r, c = i) : c = r;
	else throw Error(`Invalid second argument: ${r}`);
	return {
		text: o,
		options: s,
		metadata: c
	};
}
//#endregion
//#region ../../../node_modules/.pnpm/libphonenumber-js@1.13.15/node_modules/libphonenumber-js/es6/parsePhoneNumberWithError.js
function parsePhoneNumberWithError$1() {
	var e = normalizeArguments(arguments), t = e.text, n = e.options, r = e.metadata;
	return parsePhoneNumberWithError$2(t, n, r);
}
__name(parsePhoneNumberWithError$1, "parsePhoneNumberWithError");
//#endregion
//#region ../../../node_modules/.pnpm/libphonenumber-js@1.13.15/node_modules/libphonenumber-js/min/exports/parsePhoneNumberWithError.js
function parsePhoneNumberWithError() {
	return withMetadataArgument(parsePhoneNumberWithError$1, arguments);
}
//#endregion
//#region ../../../node_modules/.pnpm/libphonenumber-js@1.13.15/node_modules/libphonenumber-js/min/exports/getCountryCallingCode.js
function getCountryCallingCode() {
	return withMetadataArgument(getCountryCallingCode$1, arguments);
}
//#endregion
//#region lib/core/TelNumber.ts
var bt = /^\d{2,5}-\d{1,4}-\d{3,5}$/, parseErrorMessage = (e) => {
	if (!(e instanceof F)) return "不正な電話番号です";
	switch (e.message) {
		case "NOT_A_NUMBER": return "不正な文字が含まれています";
		case "TOO_SHORT": return "桁数が短すぎます";
		case "TOO_LONG": return "桁数が長すぎます";
		default: return "不正な電話番号です";
	}
}, validate = (e, t) => {
	let n = !0;
	e.length < 1 && (t.addIssue({
		code: l.custom,
		message: "入力は必須です"
	}), n = !1);
	try {
		!parsePhoneNumberWithError(e, "JP").isValid() && !bt.test(e) && (t.addIssue({
			code: l.custom,
			message: "電話番号の形式が正しくありません 例）03-xxxx-xxxx"
		}), n = !1);
	} catch (e) {
		t.addIssue({
			code: l.custom,
			message: parseErrorMessage(e)
		}), n = !1;
	}
	return n;
}, xt = C().transform((e, t) => {
	if (!validate(e, t)) return e;
	let n = parsePhoneNumberWithError(e, "JP");
	return n.isValid() ? getCountryCallingCode("JP") === n.countryCallingCode ? n.formatNational() : n.formatInternational() : e;
}).describe("電話番号"), St = C().trim().length(7, { message: "7ケタで入力してください" }).regex(/^[0-9]*$/, { message: "数値のみ入力できます" }).describe("郵便番号"), Ct = D({
	yubinNumber: C().trim().describe("郵便番号"),
	jushoText: C().trim().describe("住所テキスト"),
	nokoriJusho: C().trim().describe("残り住所テキスト").nullable(),
	gaikuGoto: C().trim().describe("街区号棟テキスト").nullable(),
	jushoCode: C().describe("国土地理院コード"),
	isDirectInput: T().describe("直接入力しているか")
}).describe("住所"), wt = 120, Tt = 120, Et = 120, Dt = D({
	yubinNumber: St,
	jushoText: C().trim().min(1, { message: "入力は必須です" }).max(wt, { message: `${wt}文字以内で入力してください` }).describe("住所テキスト"),
	nokoriJusho: C().max(Tt, { message: `${Tt}文字以内で入力してください` }).trim().describe("残り住所テキスト").nullable(),
	gaikuGoto: C().trim().max(Et, { message: `${Et}文字以内で入力してください` }).describe("街区号棟テキスト").nullable(),
	jushoCode: C().trim().describe("国土地理院コード"),
	isDirectInput: T().describe("直接入力しているか")
}).describe("住所"), getJushoFulltext = (e) => [
	e.jushoText,
	e.nokoriJusho,
	e.gaikuGoto
].join(""), Ot = /* @__PURE__ */ __commonJSMin(((e, t) => {
	Object.defineProperty(e, "__esModule", { value: !0 }), e.default = assertString;
	function assertString(e) {
		if (e == null) throw TypeError(`Expected a string but received a ${e}`);
		if (e.constructor.name !== "String") throw TypeError(`Expected a string but received a ${e.constructor.name}`);
	}
	t.exports = e.default, t.exports.default = e.default;
})), kt = /* @__PURE__ */ __commonJSMin(((e, t) => {
	Object.defineProperty(e, "__esModule", { value: !0 }), e.default = checkHost;
	function isRegExp(e) {
		return Object.prototype.toString.call(e) === "[object RegExp]";
	}
	function checkHost(e, t) {
		for (var n = 0; n < t.length; n++) {
			var r = t[n];
			if (e === r || isRegExp(r) && r.test(e)) return !0;
		}
		return !1;
	}
	t.exports = e.default, t.exports.default = e.default;
})), At = /* @__PURE__ */ __commonJSMin(((e, t) => {
	Object.defineProperty(e, "__esModule", { value: !0 }), e.default = isByteLength;
	var n = _interopRequireDefault(Ot());
	function _interopRequireDefault(e) {
		return e && e.__esModule ? e : { default: e };
	}
	function _typeof(e) {
		"@babel/helpers - typeof";
		return _typeof = typeof Symbol == "function" && typeof Symbol.iterator == "symbol" ? function(e) {
			return typeof e;
		} : function(e) {
			return e && typeof Symbol == "function" && e.constructor === Symbol && e !== Symbol.prototype ? "symbol" : typeof e;
		}, _typeof(e);
	}
	function isByteLength(e, t) {
		(0, n.default)(e);
		var r, i;
		_typeof(t) === "object" ? (r = t.min || 0, i = t.max) : (r = arguments[1], i = arguments[2]);
		var a = encodeURI(e).split(/%..|./).length - 1;
		return a >= r && (i === void 0 || a <= i);
	}
	t.exports = e.default, t.exports.default = e.default;
})), jt = /* @__PURE__ */ __commonJSMin(((e, t) => {
	Object.defineProperty(e, "__esModule", { value: !0 }), e.default = merge;
	function _typeof(e) {
		"@babel/helpers - typeof";
		return _typeof = typeof Symbol == "function" && typeof Symbol.iterator == "symbol" ? function(e) {
			return typeof e;
		} : function(e) {
			return e && typeof Symbol == "function" && e.constructor === Symbol && e !== Symbol.prototype ? "symbol" : typeof e;
		}, _typeof(e);
	}
	function merge() {
		var e = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : {}, t = arguments.length > 1 ? arguments[1] : void 0;
		for (var n in (_typeof(e) !== "object" || e === null) && (e = {}), t) e[n] === void 0 && (e[n] = t[n]);
		return e;
	}
	t.exports = e.default, t.exports.default = e.default;
})), Mt = /* @__PURE__ */ __commonJSMin(((e, t) => {
	Object.defineProperty(e, "__esModule", { value: !0 }), e.default = isFQDN;
	var n = _interopRequireDefault(Ot()), r = _interopRequireDefault(jt());
	function _interopRequireDefault(e) {
		return e && e.__esModule ? e : { default: e };
	}
	var i = {
		require_tld: !0,
		allow_underscores: !1,
		allow_trailing_dot: !1,
		allow_numeric_tld: !1,
		allow_wildcard: !1,
		ignore_max_length: !1
	};
	function isFQDN(e, t) {
		(0, n.default)(e), t = (0, r.default)(t, i), t.allow_trailing_dot && e[e.length - 1] === "." && (e = e.substring(0, e.length - 1)), t.allow_wildcard === !0 && e.indexOf("*.") === 0 && (e = e.substring(2));
		var a = e.split("."), o = a[a.length - 1];
		return t.require_tld && (a.length < 2 || !t.allow_numeric_tld && !/^([a-z\u00A1-\u00A8\u00AA-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF]{2,}|xn[a-z0-9-]{2,})$/i.test(o) || /\s/.test(o)) || !t.allow_numeric_tld && /^\d+$/.test(o) ? !1 : a.every(function(e) {
			return !(e.length > 63 && !t.ignore_max_length || !/^[a-z_\u00a1-\uffff0-9-]+$/i.test(e) || /[\uff01-\uff5e]/.test(e) || /^-|-$/.test(e) || !t.allow_underscores && /_/.test(e));
		});
	}
	t.exports = e.default, t.exports.default = e.default;
})), Nt = /* @__PURE__ */ __commonJSMin(((e, t) => {
	Object.defineProperty(e, "__esModule", { value: !0 }), e.default = isIP;
	var n = _interopRequireDefault(Ot());
	function _interopRequireDefault(e) {
		return e && e.__esModule ? e : { default: e };
	}
	function _typeof(e) {
		"@babel/helpers - typeof";
		return _typeof = typeof Symbol == "function" && typeof Symbol.iterator == "symbol" ? function(e) {
			return typeof e;
		} : function(e) {
			return e && typeof Symbol == "function" && e.constructor === Symbol && e !== Symbol.prototype ? "symbol" : typeof e;
		}, _typeof(e);
	}
	var r = "(?:[0-9]|[1-9][0-9]|1[0-9][0-9]|2[0-4][0-9]|25[0-5])", i = `(${r}[.]){3}${r}`, a = RegExp(`^${i}\$`), o = "(?:[0-9a-fA-F]{1,4})", s = RegExp(`^((?:${o}:){7}(?:${o}|:)|(?:${o}:){6}(?:${i}|:${o}|:)|(?:${o}:){5}(?::${i}|(:${o}){1,2}|:)|(?:${o}:){4}(?:(:${o}){0,1}:${i}|(:${o}){1,3}|:)|(?:${o}:){3}(?:(:${o}){0,2}:${i}|(:${o}){1,4}|:)|(?:${o}:){2}(?:(:${o}){0,3}:${i}|(:${o}){1,5}|:)|(?:${o}:){1}(?:(:${o}){0,4}:${i}|(:${o}){1,6}|:)|(?::((?::${o}){0,5}:${i}|(?::${o}){1,7}|:)))(%[0-9a-zA-Z.]{1,})?\$`);
	function isIP(e) {
		var t = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : {};
		(0, n.default)(e);
		var r = (_typeof(t) === "object" ? t.version : arguments[1]) || "";
		return r ? r.toString() === "4" ? a.test(e) : r.toString() === "6" && s.test(e) : isIP(e, { version: 4 }) || isIP(e, { version: 6 });
	}
	t.exports = e.default, t.exports.default = e.default;
})), Pt = /* @__PURE__ */ __toESM((/* @__PURE__ */ __commonJSMin(((e, t) => {
	Object.defineProperty(e, "__esModule", { value: !0 }), e.default = isEmail;
	var n = _interopRequireDefault(Ot()), r = _interopRequireDefault(kt()), i = _interopRequireDefault(At()), a = _interopRequireDefault(Mt()), o = _interopRequireDefault(Nt()), s = _interopRequireDefault(jt());
	function _interopRequireDefault(e) {
		return e && e.__esModule ? e : { default: e };
	}
	var c = {
		allow_display_name: !1,
		allow_underscores: !1,
		require_display_name: !1,
		allow_utf8_local_part: !0,
		require_tld: !0,
		blacklisted_chars: "",
		ignore_max_length: !1,
		host_blacklist: [],
		host_whitelist: []
	}, l = /^([^\x00-\x1F\x7F-\x9F\cX]+)</i, u = /^[a-z\d!#\$%&'\*\+\-\/=\?\^_`{\|}~]+$/i, d = /^[a-z\d]+$/, f = /^([\s\x01-\x08\x0b\x0c\x0e-\x1f\x7f\x21\x23-\x5b\x5d-\x7e]|(\\[\x01-\x09\x0b\x0c\x0d-\x7f]))*$/i, p = /^[a-z\d!#\$%&'\*\+\-\/=\?\^_`{\|}~\u00A1-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF]+$/i, m = /^([\s\x01-\x08\x0b\x0c\x0e-\x1f\x7f\x21\x23-\x5b\x5d-\x7e\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF]|(\\[\x01-\x09\x0b\x0c\x0d-\x7f\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF]))*$/i, h = 254;
	function validateDisplayName(e) {
		var t = e.replace(/^"(.+)"$/, "$1");
		return !(!t.trim() || /[\.";<>]/.test(t) && (t === e || t.split("\"").length !== t.split("\\\"").length));
	}
	function isEmail(e, t) {
		if ((0, n.default)(e), t = (0, s.default)(t, c), t.require_display_name || t.allow_display_name) {
			var ee = e.match(l);
			if (ee) {
				var g = ee[1];
				if (e = e.replace(g, "").replace(/(^<|>$)/g, ""), g.endsWith(" ") && (g = g.slice(0, -1)), !validateDisplayName(g)) return !1;
			} else if (t.require_display_name) return !1;
		}
		if (!t.ignore_max_length && e.length > h) return !1;
		var te = e.split("@"), _ = te.pop(), ne = _.toLowerCase();
		if (t.host_blacklist.length > 0 && (0, r.default)(ne, t.host_blacklist) || t.host_whitelist.length > 0 && !(0, r.default)(ne, t.host_whitelist)) return !1;
		var v = te.join("@");
		if (t.domain_specific_validation && (ne === "gmail.com" || ne === "googlemail.com")) {
			v = v.toLowerCase();
			var re = v.split("+")[0];
			if (!(0, i.default)(re.replace(/\./g, ""), {
				min: 6,
				max: 30
			})) return !1;
			for (var ie = re.split("."), ae = 0; ae < ie.length; ae++) if (!d.test(ie[ae])) return !1;
		}
		if (t.ignore_max_length === !1 && (!(0, i.default)(v, { max: 64 }) || !(0, i.default)(_, { max: 254 }))) return !1;
		if (!(0, a.default)(_, {
			require_tld: t.require_tld,
			ignore_max_length: t.ignore_max_length,
			allow_underscores: t.allow_underscores
		})) {
			if (!t.allow_ip_domain) return !1;
			if (!(0, o.default)(_)) {
				if (!_.startsWith("[") || !_.endsWith("]")) return !1;
				var oe = _.slice(1, -1);
				if (oe.length === 0 || !(0, o.default)(oe)) return !1;
			}
		}
		if (t.blacklisted_chars && v.search(RegExp(`[${t.blacklisted_chars}]+`, "g")) !== -1) return !1;
		if (v[0] === "\"" && v[v.length - 1] === "\"") return v = v.slice(1, v.length - 1), t.allow_utf8_local_part ? m.test(v) : f.test(v);
		for (var se = t.allow_utf8_local_part ? p : u, ce = v.split("."), le = 0; le < ce.length; le++) if (!se.test(ce[le])) return !1;
		return !0;
	}
	t.exports = e.default, t.exports.default = e.default;
})))()), Ft = C().min(1, { message: "入力は必須です" }).regex(/^[^A-Z]*$/, { message: "メールアドレス内の大文字を小文字に変えて入力してください" }).refine((e) => (0, Pt.default)(e, { allow_utf8_local_part: !1 }), { message: "メールアドレスに利用できない文字が含まれています" }).describe("メールアドレス"), I = /* @__PURE__ */ __commonJSMin(((e) => {
	Object.defineProperty(e, "__esModule", { value: !0 }), e.matchingBitCount = e.intLog2 = e.cidrPrefixToMaskBinaryString = e.leftPadWithZeroBit = e.dottedDecimalNotationToBinaryString = e.parseBinaryStringToBigInt = e.decimalNumberToOctetString = e.numberToBinaryString = void 0;
	var numberToBinaryString = (e) => e.toString(2);
	e.numberToBinaryString = numberToBinaryString;
	var decimalNumberToOctetString = (t) => {
		let n = (0, e.numberToBinaryString)(t);
		if (n.length > 8) throw Error("Given decimal in binary contains digits greater than an octet");
		return (0, e.leftPadWithZeroBit)(n, 8);
	};
	e.decimalNumberToOctetString = decimalNumberToOctetString;
	var parseBinaryStringToBigInt = (e) => BigInt(`0b${e}`);
	e.parseBinaryStringToBigInt = parseBinaryStringToBigInt;
	var dottedDecimalNotationToBinaryString = (t) => t.split(".").reduce((t, n) => t.concat((0, e.decimalNumberToOctetString)(parseInt(n))), "");
	e.dottedDecimalNotationToBinaryString = dottedDecimalNotationToBinaryString;
	var leftPadWithZeroBit = (e, t) => {
		if (e.length > t) throw Error(`Given string is already longer than given final length after padding: ${t}`);
		return "0".repeat(t - e.length).concat(e);
	};
	e.leftPadWithZeroBit = leftPadWithZeroBit;
	var cidrPrefixToMaskBinaryString = (e, t) => {
		let n;
		if (n = t == "IPv4" ? 32 : 128, e > n) throw Error(`Value is greater than ${n}`);
		return `${"1".repeat(e)}${"0".repeat(n - e)}`;
	};
	e.cidrPrefixToMaskBinaryString = cidrPrefixToMaskBinaryString;
	var intLog2 = (e) => {
		let t = 0;
		if (e <= 0n) throw Error(`The value of log2 for ${e.toString()} is not an integer`);
		if (e === 1n) return 0;
		for (; e % 2n == 0n;) {
			if (e === 2n) {
				t++;
				break;
			}
			if (e >>= 1n, e % 2n != 0n) {
				t = 0;
				break;
			}
			t++;
		}
		if (t == 0) throw Error(`The value of log2 for ${e.toString()} is not an integer`);
		return t;
	};
	e.intLog2 = intLog2;
	var matchingBitCount = (e, t) => {
		let n, r;
		e.length >= t.length ? (n = e, r = t) : (n = t, r = e);
		let i = 0;
		for (; i < n.length && n.charAt(i) === r.charAt(i); i++);
		return i;
	};
	e.matchingBitCount = matchingBitCount;
})), It = /* @__PURE__ */ __commonJSMin(((e) => {
	Object.defineProperty(e, "__esModule", { value: !0 }), e.collapseIPv6Number = e.expandIPv6Number = void 0;
	var t = I(), n = R(), extractPrefix = (e) => e.includes("/") ? `/${e.split("/")[1]}` : "", expandIPv6Number = (e) => {
		let expandWithZero = (e) => {
			let n = [];
			return e.forEach((e) => {
				if (e.includes(".")) {
					let [r, i] = (0, t.dottedDecimalNotationToBinaryString)(e).match(/.{1,16}/g).map((e) => (0, t.parseBinaryStringToBigInt)(e).toString(16));
					n.push((0, t.leftPadWithZeroBit)(r, 4)), n.push((0, t.leftPadWithZeroBit)(i, 4));
				} else n.push((0, t.leftPadWithZeroBit)(e, 4));
			}), n.join(":");
		}, expandDoubleColon = (e) => {
			let t = [];
			for (let n = 0; n < e; n++) t.push("0000");
			return t.join(":");
		};
		if (/(:){3,}/.test(e)) throw "given IPv6 contains consecutive : more than two";
		let r = extractPrefix(e);
		if (e.includes("/") && (e = e.split("/")[0]), !n.Validator.IPV6_PATTERN.test(e)) throw Error(n.Validator.invalidIPv6PatternMessage);
		if (e.includes("::")) {
			let t = e.split("::"), n = t[0], i = t[1], a = n.split(":").filter((e) => e !== ""), o = i.split(":").filter((e) => e !== ""), s = a.concat(o).filter((e) => e.includes(".")).length, c = expandDoubleColon(8 - (a.length + o.length + s)), l = expandWithZero(a);
			l !== "" && (l += ":");
			let u = expandWithZero(o);
			return u !== "" && (u = ":" + u), `${l}${c}${u}${r}`;
		}
		return `${expandWithZero(e.split(":"))}${r}`;
	};
	e.expandIPv6Number = expandIPv6Number;
	var shortenHexadecatet = (e) => {
		let t = e.replace(/^0+/, "");
		return t === "" ? "0" : t;
	}, collapseIPv6Number = (t) => {
		let n = extractPrefix(t), r = t.includes("/") ? t.split("/")[0] : t, i = "";
		try {
			let t = (0, e.expandIPv6Number)(r);
			i = t.includes("/") ? t.split("/")[0] : t;
		} catch (e) {
			throw e;
		}
		let a = i.split(":");
		if (a.length !== 8) throw Error(`Invalid IPv6 structure after expansion: ${i}. Expected 8 segments.`);
		let o = [], s = -1, c = 0;
		for (let e = 0; e < 8; e++) a[e] === "0000" ? (s === -1 && (s = e), c++) : (c > 0 && o.push({
			start: s,
			length: c
		}), s = -1, c = 0);
		if (c > 0 && o.push({
			start: s,
			length: c
		}), o.length === 0) return a.map(shortenHexadecatet).join(":") + n;
		o.sort((e, t) => t.length === e.length ? e.start - t.start : t.length - e.length);
		let l = o[0];
		if (l.length === 8) return "::" + n;
		if (l.length < 2) return a.map(shortenHexadecatet).join(":") + n;
		let u = a.slice(0, l.start), d = a.slice(l.start + l.length), f = u.map(shortenHexadecatet).join(":"), p = d.map(shortenHexadecatet).join(":"), m = "";
		return m = l.start === 0 ? "::" + p : l.start + l.length === 8 ? f + "::" : f + "::" + p, m + n;
	};
	e.collapseIPv6Number = collapseIPv6Number;
})), L = /* @__PURE__ */ __commonJSMin(((e) => {
	Object.defineProperty(e, "__esModule", { value: !0 }), e.hexadectetNotationToBinaryString = e.binaryStringToHexadecimalString = e.colonHexadecimalNotationToBinaryString = e.hexadecimalStringToHexadecatetString = e.hexadecimalStringToBinaryString = e.bigIntToHexadecimalString = void 0;
	var t = It(), n = I(), bigIntToHexadecimalString = (e) => e.toString(16);
	e.bigIntToHexadecimalString = bigIntToHexadecimalString;
	var hexadecimalStringToBinaryString = (e) => BigInt(`0x${e}`).toString(2);
	e.hexadecimalStringToBinaryString = hexadecimalStringToBinaryString;
	var hexadecimalStringToHexadecatetString = (t) => {
		let r = (0, e.hexadecimalStringToBinaryString)(t);
		if (r.length > 16) throw Error("Given decimal in binary contains digits greater than an Hexadecatet");
		return (0, n.leftPadWithZeroBit)(r, 16);
	};
	e.hexadecimalStringToHexadecatetString = hexadecimalStringToHexadecatetString;
	var colonHexadecimalNotationToBinaryString = (n) => (0, t.expandIPv6Number)(n).split(":").reduce((t, n) => t.concat((0, e.hexadecimalStringToHexadecatetString)(n)), "");
	e.colonHexadecimalNotationToBinaryString = colonHexadecimalNotationToBinaryString;
	var binaryStringToHexadecimalString = (e) => BigInt(`0b${e}`).toString(16);
	e.binaryStringToHexadecimalString = binaryStringToHexadecimalString;
	var hexadectetNotationToBinaryString = (r) => (0, t.expandIPv6Number)(r).split(":").reduce((t, r) => t.concat((0, n.leftPadWithZeroBit)((0, e.hexadecimalStringToBinaryString)(r), 16)), "");
	e.hexadectetNotationToBinaryString = hexadectetNotationToBinaryString;
})), R = /* @__PURE__ */ __commonJSMin(((e) => {
	Object.defineProperty(e, "__esModule", { value: !0 }), e.Validator = void 0;
	var t = I(), n = I(), r = It(), i = L(), a = L(), o = class Validator {
		static isWithinRange(e, t, n) {
			return e >= t && e <= n;
		}
		static isValidAsnNumber(e) {
			let t = this.isWithinRange(e, 0n, this.THIRTY_TWO_BIT_SIZE);
			return [t, t ? [] : [Validator.invalidAsnRangeMessage]];
		}
		static isValid16BitAsnNumber(e) {
			let t = Validator.isWithinRange(e, 0n, Validator.SIXTEEN_BIT_SIZE);
			return [t, t ? [] : [Validator.invalid16BitAsnRangeMessage]];
		}
		static isValidIPv4Number(e) {
			e = typeof e == "bigint" ? e : BigInt(e);
			let t = this.isWithinRange(e, 0n, this.THIRTY_TWO_BIT_SIZE);
			return t ? [t, []] : [t, [Validator.invalidIPv4NumberMessage]];
		}
		static isValidIPv6Number(e) {
			let t = this.isWithinRange(e, 0n, this.ONE_HUNDRED_AND_TWENTY_EIGHT_BIT_SIZE);
			return t ? [t, []] : [t, [Validator.invalidIPv6NumberMessage]];
		}
		static isValidIPv4Octet(e) {
			let t = this.isWithinRange(e, 0n, this.EIGHT_BIT_SIZE);
			return [t, t ? [] : [Validator.invalidOctetRangeMessage]];
		}
		static isValidIPv6Hexadecatet(e) {
			let t = this.isWithinRange(e, 0n, this.SIXTEEN_BIT_SIZE);
			return t ? [t, []] : [t, [Validator.invalidHexadecatetMessage]];
		}
		static isValidIPv4String(e) {
			let t = e.split(".");
			if (t.length != 4 || t.includes("")) return [!1, [Validator.invalidOctetCountMessage]];
			let n = t.every((e) => e.length > 1 && e.startsWith("0") ? !1 : Validator.isNumeric(e) ? Validator.isValidIPv4Octet(BigInt(e))[0] : !1);
			return n ? (n = Validator.IPV4_PATTERN.test(e), [n, n ? [] : [Validator.invalidIPv4PatternMessage]]) : [!1, [Validator.invalidOctetRangeMessage]];
		}
		static isValidIPv6String(e) {
			let [t, n, ...i] = e.split("%");
			if (i.length > 0 || n && !Validator.ZONE_INDEX_PATTERN.test(n) || e.includes("%") && !n) return [!1, [Validator.invalidIPv6PatternMessage]];
			try {
				let e = (0, r.expandIPv6Number)(t).split(":");
				if (e.length != 8) return [!1, [Validator.invalidHexadecatetCountMessage]];
				let n = e.every((e) => Validator.isHexadecatet(e) ? Validator.isValidIPv6Hexadecatet(BigInt(`0x${e}`))[0] : !1);
				return n ? (n = Validator.IPV6_PATTERN.test(t), n ? [n, []] : [!1, [Validator.invalidIPv6PatternMessage]]) : [!1, [Validator.invalidHexadecatetMessage]];
			} catch (e) {
				return [!1, [String(e)]];
			}
		}
		static isValidPrefixValue(e, t) {
			if (t === "IPv4") {
				let t = Validator.isWithinRange(BigInt(e), 0n, 32n);
				return [t, t ? [] : [Validator.invalidPrefixValueMessage]];
			}
			if (t === "IPv6") {
				let t = Validator.isWithinRange(BigInt(e), 0n, 128n);
				return [t, t ? [] : [Validator.invalidPrefixValueMessage]];
			}
			return [!1, [Validator.invalidInetNumType]];
		}
		static isValidIPv4Mask(e) {
			let [n, r] = Validator.isValidIPv4String(e);
			if (!n) return [!1, r];
			let i = (0, t.dottedDecimalNotationToBinaryString)(e), a = Validator.IPV4_CONTIGUOUS_MASK_BIT_PATTERN.test(i);
			return a ? [a, []] : [a, [Validator.invalidMaskMessage]];
		}
		static isValidIPv6Mask(e) {
			try {
				let t = (0, a.hexadectetNotationToBinaryString)(e), n = Validator.IPV6_CONTIGUOUS_MASK_BIT_PATTERN.test(t);
				return n ? [n, []] : [n, [Validator.invalidMaskMessage]];
			} catch (e) {
				return [!1, [String(e)]];
			}
		}
		static isValidIPv4CidrNotation(e) {
			let t = e.split("/");
			if (t.length !== 2 || t[0].length === 0 || t[1].length === 0) return [!1, [Validator.invalidIPv4CidrNotationMessage]];
			let n = t[0], r = t[1];
			if (!/^\d+$/.test(r) || isNaN(Number(r))) return [!1, [Validator.invalidIPv4CidrNotationMessage]];
			let [i, a] = Validator.isValidIPv4String(n), [o, s] = Validator.isValidPrefixValue(BigInt(r), "IPv4"), c = i && o, l = a.concat(s);
			return c ? [c, []] : [c, l];
		}
		static isValidIPv4CidrRange(e) {
			return Validator.isValidCidrRange(e, Validator.isValidIPv4CidrNotation, t.dottedDecimalNotationToBinaryString, (e) => (0, n.cidrPrefixToMaskBinaryString)(e, "IPv4"));
		}
		static isValidIPv6CidrRange(e) {
			return Validator.isValidCidrRange(e, Validator.isValidIPv6CidrNotation, i.colonHexadecimalNotationToBinaryString, (e) => (0, n.cidrPrefixToMaskBinaryString)(e, "IPv6"));
		}
		static isValidCidrRange(e, t, n, r) {
			let i = t(e);
			if (!i[0]) return i;
			let a = e.split("/"), o = a[0], s = a[1], c = BigInt(`0b${n(o)}`), l = (c & BigInt(`0b${r(parseInt(s))}`)) === c;
			return l ? [l, []] : [l, [Validator.InvalidIPCidrRangeMessage]];
		}
		static isValidIPv4RangeString(e) {
			let firstLastValidator = (e, n) => BigInt(`0b${(0, t.dottedDecimalNotationToBinaryString)(e)}`) >= BigInt(`0b${(0, t.dottedDecimalNotationToBinaryString)(n)}`);
			return this.isValidRange(e, Validator.isValidIPv4String, firstLastValidator);
		}
		static isValidIPv6RangeString(e) {
			let firstLastValidator = (e, t) => BigInt(`0b${(0, a.hexadectetNotationToBinaryString)(e)}`) >= BigInt(`0b${(0, a.hexadectetNotationToBinaryString)(t)}`);
			return this.isValidRange(e, Validator.isValidIPv6String, firstLastValidator);
		}
		static isValidRange(e, t, n) {
			let r = e.split("-").map((e) => e.trim());
			if (r.length !== 2 || r[0].length === 0 || r[1].length === 0) return [!1, [Validator.invalidRangeNotationMessage]];
			let i = r[0], a = r[1], [o, s] = t(i), [c, l] = t(a), u = o && c;
			if (u && n(i, a)) return [!1, [Validator.invalidRangeFirstNotGreaterThanLastMessage]];
			let d = s.concat(l);
			return u ? [u, []] : [u, d];
		}
		static isValidIPv6CidrNotation(e) {
			let t = e.split("/");
			if (t.length !== 2 || t[0].length === 0 || t[1].length === 0) return [!1, [Validator.invalidIPv6CidrNotationString]];
			let n = Validator.IPV6_RANGE_PATTERN.test(e);
			return n ? [n, []] : [n, [Validator.invalidIPv6CidrNotationString]];
		}
		static isValidBinaryString(e) {
			return /^([10])+$/.test(e) ? [!0, []] : [!1, [Validator.invalidBinaryStringErrorMessage]];
		}
		static isNumeric(e) {
			return /^(\d+)$/.test(e);
		}
		static isHexadecatet(e) {
			return /^[0-9A-Fa-f]{4}$/.test(e);
		}
	};
	e.Validator = o, o.IPV4_PATTERN = /* @__PURE__ */ new RegExp(/^(25[0-5]|2[0-4][0-9]|1[0-9][0-9]|[1-9]?[0-9])\.(25[0-5]|2[0-4][0-9]|1[0-9][0-9]|[1-9]?[0-9])\.(25[0-5]|2[0-4][0-9]|1[0-9][0-9]|[1-9]?[0-9])\.(25[0-5]|2[0-4][0-9]|1[0-9][0-9]|[1-9]?[0-9])$/), o.IPV6_PATTERN = /* @__PURE__ */ new RegExp(/^(((?:[0-9A-Fa-f]{1,4}:){7}(?:[0-9A-Fa-f]{1,4}|:))|((?:[0-9A-Fa-f]{1,4}:){6}(?::[0-9A-Fa-f]{1,4}|(?:(?:25[0-5]|2[0-4]\d|1\d\d|[1-9]?\d)(?:\.(?:25[0-5]|2[0-4]\d|1\d\d|[1-9]?\d)){3})|:))|((?:[0-9A-Fa-f]{1,4}:){5}(?:(?:(?::[0-9A-Fa-f]{1,4}){1,2})|:(?:(?:25[0-5]|2[0-4]\d|1\d\d|[1-9]?\d)(?:\.(?:25[0-5]|2[0-4]\d|1\d\d|[1-9]?\d)){3})|:))|((?:[0-9A-Fa-f]{1,4}:){4}(?:(?:(?::[0-9A-Fa-f]{1,4}){1,3})|(?:(?::[0-9A-Fa-f]{1,4})?:(?:(?:25[0-5]|2[0-4]\d|1\d\d|[1-9]?\d)(?:\.(?:25[0-5]|2[0-4]\d|1\d\d|[1-9]?\d)){3}))|:))|((?:[0-9A-Fa-f]{1,4}:){3}(?:(?:(?::[0-9A-Fa-f]{1,4}){1,4})|(?:(?::[0-9A-Fa-f]{1,4}){0,2}:(?:(?:25[0-5]|2[0-4]\d|1\d\d|[1-9]?\d)(?:\.(?:25[0-5]|2[0-4]\d|1\d\d|[1-9]?\d)){3}))|:))|((?:[0-9A-Fa-f]{1,4}:){2}(?:(?:(?::[0-9A-Fa-f]{1,4}){1,5})|(?:(?::[0-9A-Fa-f]{1,4}){0,3}:(?:(?:25[0-5]|2[0-4]\d|1\d\d|[1-9]?\d)(?:\.(?:25[0-5]|2[0-4]\d|1\d\d|[1-9]?\d)){3}))|:))|((?:[0-9A-Fa-f]{1,4}:){1}(?:(?:(?::[0-9A-Fa-f]{1,4}){1,6})|(?:(?::[0-9A-Fa-f]{1,4}){0,4}:(?:(?:25[0-5]|2[0-4]\d|1\d\d|[1-9]?\d)(?:\.(?:25[0-5]|2[0-4]\d|1\d\d|[1-9]?\d)){3}))|:))|(?::(?:(?:(?::[0-9A-Fa-f]{1,4}){1,7})|(?:(?::[0-9A-Fa-f]{1,4}){0,5}:(?:(?:25[0-5]|2[0-4]\d|1\d\d|[1-9]?\d)(?:\.(?:25[0-5]|2[0-4]\d|1\d\d|[1-9]?\d)){3}))|:)))(?:%.+)?$/), o.ZONE_INDEX_PATTERN = /* @__PURE__ */ new RegExp(/^[a-zA-Z0-9]*$/), o.IPV4_RANGE_PATTERN = /* @__PURE__ */ new RegExp(/^(25[0-5]|2[0-4][0-9]|1[0-9][0-9]|[1-9]?[0-9])\.(25[0-5]|2[0-4][0-9]|1[0-9][0-9]|[1-9]?[0-9])\.(25[0-5]|2[0-4][0-9]|1[0-9][0-9]|[1-9]?[0-9])\.(25[0-5]|2[0-4][0-9]|1[0-9][0-9]|[1-9]?[0-9])(\/)([1-9]|[1-2][0-9]|3[0-2])$/), o.IPV6_RANGE_PATTERN = /* @__PURE__ */ new RegExp(/^((([0-9A-Fa-f]{1,4}:){7}([0-9A-Fa-f]{1,4}|:))|(([0-9A-Fa-f]{1,4}:){6}(:[0-9A-Fa-f]{1,4}|((25[0-5]|2[0-4]d|1dd|[1-9]?d)(.(25[0-5]|2[0-4]d|1dd|[1-9]?d)){3})|:))|(([0-9A-Fa-f]{1,4}:){5}(((:[0-9A-Fa-f]{1,4}){1,2})|:((25[0-5]|2[0-4]d|1dd|[1-9]?d)(.(25[0-5]|2[0-4]d|1dd|[1-9]?d)){3})|:))|(([0-9A-Fa-f]{1,4}:){4}(((:[0-9A-Fa-f]{1,4}){1,3})|((:[0-9A-Fa-f]{1,4})?:((25[0-5]|2[0-4]d|1dd|[1-9]?d)(.(25[0-5]|2[0-4]d|1dd|[1-9]?d)){3}))|:))|(([0-9A-Fa-f]{1,4}:){3}(((:[0-9A-Fa-f]{1,4}){1,4})|((:[0-9A-Fa-f]{1,4}){0,2}:((25[0-5]|2[0-4]d|1dd|[1-9]?d)(.(25[0-5]|2[0-4]d|1dd|[1-9]?d)){3}))|:))|(([0-9A-Fa-f]{1,4}:){2}(((:[0-9A-Fa-f]{1,4}){1,5})|((:[0-9A-Fa-f]{1,4}){0,3}:((25[0-5]|2[0-4]d|1dd|[1-9]?d)(.(25[0-5]|2[0-4]d|1dd|[1-9]?d)){3}))|:))|(([0-9A-Fa-f]{1,4}:){1}(((:[0-9A-Fa-f]{1,4}){1,6})|((:[0-9A-Fa-f]{1,4}){0,4}:((25[0-5]|2[0-4]d|1dd|[1-9]?d)(.(25[0-5]|2[0-4]d|1dd|[1-9]?d)){3}))|:))|(:(((:[0-9A-Fa-f]{1,4}){1,7})|((:[0-9A-Fa-f]{1,4}){0,5}:((25[0-5]|2[0-4]d|1dd|[1-9]?d)(.(25[0-5]|2[0-4]d|1dd|[1-9]?d)){3}))|:)))(%.+)?(\/([0-9]|[1-9][0-9]|1[0-1][0-9]|12[0-8]))?$/), o.IPV4_CONTIGUOUS_MASK_BIT_PATTERN = /* @__PURE__ */ new RegExp(/^(1){0,32}(0){0,32}$/), o.IPV6_CONTIGUOUS_MASK_BIT_PATTERN = /* @__PURE__ */ new RegExp(/^(1){0,128}(0){0,128}$/), o.EIGHT_BIT_SIZE = BigInt(`0b${"1".repeat(8)}`), o.SIXTEEN_BIT_SIZE = BigInt(`0b${"1".repeat(16)}`), o.THIRTY_TWO_BIT_SIZE = BigInt(`0b${"1".repeat(32)}`), o.ONE_HUNDRED_AND_TWENTY_EIGHT_BIT_SIZE = BigInt(`0b${"1".repeat(128)}`), o.IPV4_SIZE = BigInt("4294967296"), o.IPV6_SIZE = BigInt("340282366920938463463374607431768211456"), o.invalidAsnRangeMessage = "ASN number given less than zero or is greater than 32bit", o.invalid16BitAsnRangeMessage = "ASN number given less than zero or is greater than 16bit", o.invalidIPv4NumberMessage = "IPv4 number given less than zero or is greater than 32bit", o.invalidIPv6NumberMessage = "IPv6 number given less than zero or is greater than 128bit", o.invalidOctetRangeMessage = "Value given contains an invalid Octet; Value is less than zero or is greater than 8bit", o.invalidHexadecatetMessage = "The value given is less than zero or is greater than 16bit", o.invalidOctetCountMessage = "An IP4 number cannot have less or greater than 4 octets", o.invalidHexadecatetCountMessage = "An IP6 number must have exactly 8 hexadecatet", o.invalidMaskMessage = "The Mask is invalid", o.invalidPrefixValueMessage = "A Prefix value cannot be less than 0 or greater than 32", o.invalidIPv4CidrNotationMessage = "Cidr notation should be in the form [ip number]/[range]", o.InvalidIPCidrRangeMessage = "Given IP number portion must is not the start of the range", o.invalidRangeNotationMessage = "Range notation should be in the form [first ip]-[last ip]", o.invalidRangeFirstNotGreaterThanLastMessage = "First IP in [first ip]-[last ip] must be less than Last IP", o.invalidIPv6CidrNotationString = "A Cidr notation string should contain an IPv6 number and prefix", o.takeOutOfRangeSizeMessage = "$count is greater than $size, the size of the range", o.cannotSplitSingleRangeErrorMessage = "Cannot split an IP range with a single IP number", o.invalidInetNumType = "Given ipNumType must be either InetNumType.IPv4 or InetNumType.IPv6", o.invalidBinaryStringErrorMessage = "Binary string should contain only contiguous 1s and 0s", o.invalidIPRangeSizeMessage = "Given size is zero or greater than maximum size of $iptype", o.invalidIPRangeSizeForCidrMessage = "Given size can't be created via cidr prefix", o.invalidIPv4PatternMessage = "Given IPv4 is not confirm to a valid IPv6 address", o.invalidIPv6PatternMessage = "Given IPv6 is not confirm to a valid IPv6 address";
})), Lt = /* @__PURE__ */ __commonJSMin(((e) => {
	Object.defineProperty(e, "__esModule", { value: !0 }), e.Hexadecatet = void 0;
	var t = R();
	e.Hexadecatet = class Hexadecatet {
		static fromString(e) {
			return new Hexadecatet(e);
		}
		static fromNumber(e) {
			return new Hexadecatet(e);
		}
		constructor(e) {
			let n;
			n = parseInt(typeof e == "string" ? e : String(e), 16);
			let [r, i] = t.Validator.isValidIPv6Hexadecatet(BigInt(n));
			if (!r) throw Error(i.filter((e) => e !== "").toString());
			this.value = n;
		}
		getValue() {
			return this.value;
		}
		toString() {
			return this.value.toString(16);
		}
	};
})), Rt = /* @__PURE__ */ __commonJSMin(((e) => {
	Object.defineProperty(e, "__esModule", { value: !0 }), e.Octet = void 0;
	var t = R();
	e.Octet = class Octet {
		static fromString(e) {
			return new Octet(e);
		}
		static fromNumber(e) {
			return new Octet(e);
		}
		constructor(e) {
			let n;
			n = typeof e == "string" ? parseInt(e) : e;
			let [r, i] = t.Validator.isValidIPv4Octet(BigInt(n));
			if (!r) throw Error(i.filter((e) => e !== "").toString());
			this.value = n;
		}
		getValue() {
			return this.value;
		}
		toString() {
			return this.value.toString(10);
		}
	};
})), zt = /* @__PURE__ */ __commonJSMin(((e) => {
	Object.defineProperty(e, "__esModule", { value: !0 }), e.IPv6Prefix = e.IPv4Prefix = void 0, e.isIPv4Prefix = isIPv4Prefix;
	var t = R(), n = Vt(), r = I(), i = L(), a = Lt();
	e.IPv4Prefix = class IPv4Prefix {
		static fromNumber(e) {
			return new IPv4Prefix(e);
		}
		static fromRangeSize(e) {
			let n = e === 1n ? 32 : 32 - rangeSizeToPrefix(e, t.Validator.IPV4_SIZE);
			return IPv4Prefix.fromNumber(BigInt(n));
		}
		constructor(e) {
			this.type = "IPv4", this.bitValue = 32n;
			let n, r;
			if ([n, r] = t.Validator.isValidPrefixValue(e, "IPv4"), !n) throw Error(r.filter((e) => e !== "").toString());
			this.value = e;
		}
		getValue() {
			return this.value;
		}
		toString() {
			return this.value.toString();
		}
		toMask() {
			let e = "1".repeat(Number(this.value)), t = "0".repeat(Number(32n - this.value));
			return n.IPv4Mask.fromDecimalDottedString(this.toDecimalNotation(`${e}${t}`));
		}
		toRangeSize() {
			return 1n << this.bitValue - this.getValue();
		}
		merge() {
			return new IPv4Prefix(this.value - 1n);
		}
		split() {
			return new IPv4Prefix(this.value + 1n);
		}
		toDecimalNotation(e) {
			return `${(0, r.parseBinaryStringToBigInt)(e.substr(0, 8))}.${(0, r.parseBinaryStringToBigInt)(e.substr(8, 8))}.${(0, r.parseBinaryStringToBigInt)(e.substr(16, 8))}.${(0, r.parseBinaryStringToBigInt)(e.substr(24, 8))}`;
		}
	}, e.IPv6Prefix = class IPv6Prefix {
		static fromNumber(e) {
			return new IPv6Prefix(e);
		}
		static fromRangeSize(e) {
			let n = e === 1n ? 128 : 128 - rangeSizeToPrefix(e, t.Validator.IPV6_SIZE);
			return IPv6Prefix.fromNumber(BigInt(n));
		}
		constructor(e) {
			this.type = "IPv6", this.bitValue = 128n;
			let n, r;
			if ([n, r] = t.Validator.isValidPrefixValue(e, "IPv6"), !n) throw Error(r.filter((e) => e !== "").toString());
			this.value = e;
		}
		getValue() {
			return this.value;
		}
		toString() {
			return this.value.toString();
		}
		toMask() {
			let e = "1".repeat(Number(this.value)), t = "0".repeat(128 - Number(this.value));
			return n.IPv6Mask.fromHexadecatet(this.toHexadecatetNotation(`${e}${t}`));
		}
		toRangeSize() {
			return 1n << this.bitValue - this.getValue();
		}
		merge() {
			return new IPv6Prefix(this.value - 1n);
		}
		split() {
			return new IPv6Prefix(this.value + 1n);
		}
		toHexadecatetNotation(e) {
			return e.match(/.{1,16}/g).map((e) => a.Hexadecatet.fromString((0, i.binaryStringToHexadecimalString)(e))).map((e) => e.toString()).join(":");
		}
	};
	function rangeSizeToPrefix(e, n) {
		let i = n > t.Validator.IPV4_SIZE ? "IPv6" : "IPv4";
		if (e > n || e === 0n) throw Error(t.Validator.invalidIPRangeSizeMessage.replace("$iptype", i));
		try {
			return (0, r.intLog2)(e);
		} catch {
			throw Error(t.Validator.invalidIPRangeSizeForCidrMessage);
		}
	}
	function isIPv4Prefix(e) {
		return e.type === "IPv4";
	}
})), Bt = /* @__PURE__ */ __commonJSMin(((e) => {
	Object.defineProperty(e, "__esModule", { value: !0 }), e.IPv6CidrRange = e.IPv4CidrRange = e.AbstractIPRange = e.RangedSet = void 0, e.isIPv4CidrRange = isIPv4CidrRange;
	var t = Vt(), n = zt(), r = I(), i = R(), a = class RangedSet {
		static fromSingleIP(e) {
			return new RangedSet(e, e);
		}
		static fromCidrRange(e) {
			return new RangedSet(e.getFirst(), e.getLast());
		}
		static fromRangeString(e) {
			let n = e.split("-").map((e) => e.trim());
			if (n.length !== 2) throw Error("Argument should be in the format firstip-lastip");
			let [r, a] = n, [o] = i.Validator.isValidIPv4String(r), [s] = i.Validator.isValidIPv4String(a), [c] = i.Validator.isValidIPv6String(r), [l] = i.Validator.isValidIPv6String(a);
			if (o && s) return new RangedSet(t.IPv4.fromDecimalDottedString(r), t.IPv4.fromDecimalDottedString(a));
			if (c && l) return new RangedSet(t.IPv6.fromHexadecatet(r), t.IPv6.fromHexadecatet(a));
			throw Error("First IP and Last IP should be valid and same type");
		}
		constructor(e, t) {
			if (this.first = e, this.last = t, e.isGreaterThan(t)) throw Error(`${e.toString()} should be lower than ${t.toString()}`);
			this.currentValue = e, this.bitValue = BigInt(e.bitSize);
		}
		getFirst() {
			return this.first;
		}
		getLast() {
			return this.last;
		}
		getSize() {
			return this.last.getValue() - this.first.getValue() + 1n;
		}
		toRangeString() {
			return `${this.getFirst()}-${this.getLast()}`;
		}
		inside(e) {
			return e.contains(this);
		}
		contains(e) {
			let t = this.getFirst(), n = this.getLast(), r = e.getFirst(), i = e.getLast();
			return t.isLessThanOrEquals(r) && n.isGreaterThanOrEquals(i);
		}
		isEquals(e) {
			return this.getFirst().isEquals(e.getFirst()) && this.getLast().isEquals(e.getLast());
		}
		isLessThan(e) {
			return this.isEquals(e) ? !1 : this.getFirst().isEquals(e.getFirst()) ? this.getSize() < e.getSize() : this.getFirst().isLessThan(e.getFirst());
		}
		isGreaterThan(e) {
			return this.isEquals(e) ? !1 : this.getFirst().isEquals(e.getFirst()) ? this.getSize() > e.getSize() : this.getFirst().isGreaterThan(e.getFirst());
		}
		isOverlapping(e) {
			let t = this.getFirst(), n = this.getLast(), r = e.getFirst(), i = e.getLast();
			return n.isGreaterThan(r) && n.isLessThanOrEquals(i) && t.isLessThan(r) || i.isGreaterThan(t) && i.isLessThanOrEquals(n) && r.isLessThan(t) || this.contains(e) || e.contains(this);
		}
		isCidrAble() {
			if (this.getSize() === 1n) return !0;
			try {
				let e = Number(this.bitValue) - (0, r.intLog2)(this.getSize()), n = (0, r.parseBinaryStringToBigInt)((0, r.cidrPrefixToMaskBinaryString)(e, (0, t.isIPv4)(this.currentValue) ? "IPv4" : "IPv6"));
				return this.first.getValue() === (n & this.first.getValue());
			} catch {
				return !1;
			}
		}
		toCidrRange() {
			return (0, t.isIPv4)(this.currentValue) ? this.toIPv4CidrRange() : this.toIPv6CidrRange();
		}
		isConsecutive(e) {
			let t = this.getFirst(), n = this.getLast(), r = e.getFirst(), i = e.getLast();
			return n.hasNext() && n.nextIPNumber().isEquals(r) || i.hasNext() && i.nextIPNumber().isEquals(t);
		}
		union(e) {
			if (this.isEquals(e)) return new RangedSet(e.getFirst(), e.getLast());
			if (this.contains(e)) return new RangedSet(this.getFirst(), this.getLast());
			if (e.contains(this)) return new RangedSet(e.getFirst(), e.getLast());
			if (this.isOverlapping(e)) return this.getFirst().isLessThan(e.getFirst()) ? new RangedSet(this.getFirst(), e.getLast()) : new RangedSet(e.getFirst(), this.getLast());
			throw Error("Ranges do not overlap nor are equal");
		}
		prepend(e) {
			if (e.getLast().nextIPNumber().isEquals(this.getFirst())) return new RangedSet(e.getFirst(), this.getLast());
			throw Error("Range to prepend must be adjacent");
		}
		append(e) {
			if (this.getLast().nextIPNumber().isEquals(e.getFirst())) return new RangedSet(this.getFirst(), e.getLast());
			throw Error("Range to append must be adjacent");
		}
		subtract(e) {
			if (!this.isOverlapping(e)) throw Error("Cannot subtract ranges that are not overlapping");
			if (!this.isLessThan(e)) throw Error("Cannot subtract a larger range from this range");
			return new RangedSet(this.getFirst(), e.getLast());
		}
		takeSubRange(e, n) {
			if (e + n > this.getSize()) throw RangeError("Requested range is greater than what can be taken");
			if (n === 0n) throw Error("Sub range cannot be zero");
			let r = this.getFirst().value + e, i = (0, t.isIPv4)(this.getFirst()) ? t.IPv4.fromNumber(r) : t.IPv6.fromBigInt(r), a = i.value + (n - 1n), o = (0, t.isIPv4)(i) ? t.IPv4.fromNumber(a) : t.IPv6.fromBigInt(a);
			return new RangedSet(i, o);
		}
		difference(e) {
			if (e.getSize() > this.getSize()) throw Error("Range is greater than range to be subtracted from");
			if (!this.contains(e)) throw Error("Range to subtract is not contained in this range");
			let t = [];
			try {
				t.push(new RangedSet(this.getFirst(), e.getFirst().previousIPNumber()));
			} catch {}
			try {
				t.push(new RangedSet(e.getLast().nextIPNumber(), this.getLast()));
			} catch {}
			return t;
		}
		*take(e) {
			let t = this.getFirst(), n = e === void 0 ? this.getSize().valueOf() : e;
			for (; n > 0;) n--, yield t, t = t.nextIPNumber();
		}
		*[Symbol.iterator]() {
			yield* this.take();
		}
		toIPv4CidrRange() {
			let e = new o(t.IPv4.fromNumber(this.getFirst().getValue()), n.IPv4Prefix.fromRangeSize(this.getSize()));
			if (e.getFirst().isEquals(this.getFirst())) return e;
			throw Error("Range cannot be converted to CIDR");
		}
		toIPv6CidrRange() {
			let e = new s(t.IPv6.fromBigInt(this.getFirst().getValue()), n.IPv6Prefix.fromRangeSize(this.getSize()));
			if (e.getFirst().isEquals(this.getFirst())) return e;
			throw Error("Range cannot be converted to CIDR");
		}
	};
	e.RangedSet = a;
	var AbstractIPRange = class {
		hasNextRange() {
			let e = this.getSize();
			return 2n ** this.bitValue - e >= this.getFirst().getValue() + e;
		}
		hasPreviousRange() {
			return this.getSize() <= this.getFirst().getValue();
		}
		toRangeSet() {
			return new a(this.getFirst(), this.getLast());
		}
		inside(e) {
			return this.toRangeSet().inside(e.toRangeSet());
		}
		contains(e) {
			if (e instanceof t.AbstractIPNum) {
				let t = this.getFirst().getValue(), n = this.getLast().getValue(), r = e.getValue();
				return r >= t && r <= n;
			}
			return this.toRangeSet().contains(e.toRangeSet());
		}
		toRangeString() {
			return this.toRangeSet().toRangeString();
		}
		isOverlapping(e) {
			return this.toRangeSet().isOverlapping(e.toRangeSet());
		}
		isConsecutive(e) {
			return this.toRangeSet().isConsecutive(e.toRangeSet());
		}
		isCidrMergeable(e) {
			let t = BigInt((0, r.matchingBitCount)(this.getFirst().toBinaryString(), e.getFirst().toBinaryString()));
			return this.getPrefix().value - t === 1n && this.isConsecutive(e) && this.getSize() === e.getSize();
		}
		isMergeable(e) {
			return this.isCidrMergeable(e) || this.contains(e) || this.inside(e);
		}
		isEquals(e) {
			return this.toRangeSet().isEquals(e.toRangeSet());
		}
		merge(e) {
			if (!this.isCidrMergeable(e)) throw Error(`Cannot merge. Ranges (${this.toRangeString()},${e.toRangeString()}) are not consecutive and/or of same size`);
			return this.newInstance(this.getFirst(), this.getPrefix().merge());
		}
		*takeStream(e) {
			return this.toRangeSet().take(e);
		}
		*[Symbol.iterator]() {
			yield* this.toRangeSet();
		}
	};
	e.AbstractIPRange = AbstractIPRange;
	var o = class IPv4CidrRange extends AbstractIPRange {
		static fromCidr(e) {
			let [r, a] = i.Validator.isValidIPv4CidrNotation(e);
			if (!r) {
				let e = a.filter((e) => e !== "");
				throw Error(e.join(" and "));
			}
			let o = e.split("/"), s = o[0], c = BigInt(parseInt(o[1]));
			return new IPv4CidrRange(t.IPv4.fromDecimalDottedString(s), n.IPv4Prefix.fromNumber(c));
		}
		constructor(e, t) {
			super(), this.ipv4 = e, this.cidrPrefix = t, this.bitValue = 32n;
		}
		getSize() {
			return this.cidrPrefix.toRangeSize();
		}
		toCidrString() {
			return `${this.ipv4.toString().toString()}/${this.cidrPrefix.toString()}`;
		}
		toRangeString() {
			return super.toRangeString();
		}
		getFirst() {
			return t.IPv4.fromNumber(this.ipv4.getValue() & this.cidrPrefix.toMask().getValue());
		}
		getLast() {
			return last(this, this.ipv4);
		}
		newInstance(e, t) {
			return new IPv4CidrRange(e, t);
		}
		getPrefix() {
			return this.cidrPrefix;
		}
		isConsecutive(e) {
			return super.isConsecutive(e);
		}
		contains(e) {
			return super.contains(e);
		}
		inside(e) {
			return super.inside(e);
		}
		isOverlapping(e) {
			return super.isOverlapping(e);
		}
		take(e) {
			let t = [this.getFirst()], n = this.getFirst();
			if (e > this.getSize()) {
				let t = i.Validator.takeOutOfRangeSizeMessage.replace("$count", e.toString()).replace("$size", this.getSize().toString());
				throw Error(t);
			}
			for (let r = 0; r < e - 1n; r++) t.push(n.nextIPNumber()), n = n.nextIPNumber();
			return t;
		}
		split() {
			let e = this.cidrPrefix.getValue();
			if (e === 32n) throw Error("Cannot split an IP range with a single IP number");
			let t = n.IPv4Prefix.fromNumber(e + 1n), r = this.getFirst(), i = new IPv4CidrRange(r, t), a = i.getLast().nextIPNumber();
			return [i, new IPv4CidrRange(a, t)];
		}
		splitInto(e) {
			let t = e.getValue() - this.cidrPrefix.getValue();
			if (t < 0) throw Error("Prefix to split into is larger than source prefix");
			if (t === 0n) return [new IPv4CidrRange(this.getFirst(), e)];
			if (t === 1n) return this.split();
			{
				let e = this.split();
				for (; t > 1;) e = e.flatMap((e) => e.split()), t -= 1n;
				return e;
			}
		}
		hasNextRange() {
			return super.hasNextRange();
		}
		hasPreviousRange() {
			return super.hasPreviousRange();
		}
		nextRange() {
			if (this.hasNextRange()) {
				let e = this.getSize(), n = this.getFirst().getValue() + e;
				return new IPv4CidrRange(new t.IPv4(n), this.cidrPrefix);
			}
		}
		previousRange() {
			if (this.hasPreviousRange()) {
				let e = this.getSize(), n = this.getFirst().getValue() - e;
				return new IPv4CidrRange(new t.IPv4(n), this.cidrPrefix);
			}
		}
	};
	e.IPv4CidrRange = o;
	var s = class IPv6CidrRange extends AbstractIPRange {
		static fromCidr(e) {
			let [r, a] = i.Validator.isValidIPv6CidrNotation(e);
			if (!r) throw Error(a.filter((e) => e !== "").toString());
			let o = e.split("/"), s = o[0], c = BigInt(parseInt(o[1]));
			return new IPv6CidrRange(t.IPv6.fromHexadecatet(s), n.IPv6Prefix.fromNumber(c));
		}
		constructor(e, t) {
			super(), this.ipv6 = e, this.cidrPrefix = t, this.bitValue = 128n;
		}
		getSize() {
			return this.cidrPrefix.toRangeSize();
		}
		toCidrString() {
			return `${this.ipv6.toString().toString()}/${this.cidrPrefix.toString()}`;
		}
		toRangeString() {
			return super.toRangeString();
		}
		getFirst() {
			return t.IPv6.fromBigInt(this.ipv6.getValue() & this.cidrPrefix.toMask().getValue());
		}
		getLast() {
			return last(this, this.ipv6);
		}
		newInstance(e, t) {
			return new IPv6CidrRange(e, t);
		}
		getPrefix() {
			return this.cidrPrefix;
		}
		isConsecutive(e) {
			return super.isConsecutive(e);
		}
		contains(e) {
			return super.contains(e);
		}
		inside(e) {
			return super.inside(e);
		}
		isOverlapping(e) {
			return super.isOverlapping(e);
		}
		take(e) {
			let t = [this.getFirst()], n = this.getFirst();
			if (e > this.getSize()) throw Error(`${e.toString()} is greater than ${this.getSize().toString()}, the size of the range`);
			for (var r = 0; r < e - 1n; r++) t.push(n.nextIPNumber()), n = n.nextIPNumber();
			return t;
		}
		split() {
			let e = this.cidrPrefix.getValue();
			if (e === 128n) throw Error("Cannot split an IP range with a single IP number");
			let t = n.IPv6Prefix.fromNumber(e + 1n), r = this.getFirst(), i = new IPv6CidrRange(r, t), a = i.getLast().nextIPNumber();
			return [i, new IPv6CidrRange(a, t)];
		}
		splitInto(e) {
			let t = e.getValue() - this.cidrPrefix.getValue();
			if (t < 0) throw Error("Prefix to split into is larger than source prefix");
			if (t === 0n) return [new IPv6CidrRange(this.getFirst(), e)];
			if (t === 1n) return this.split();
			{
				let e = this.split();
				for (; t > 1;) e = e.flatMap((e) => e.split()), t -= 1n;
				return e;
			}
		}
		hasNextRange() {
			return super.hasNextRange();
		}
		hasPreviousRange() {
			return super.hasPreviousRange();
		}
		nextRange() {
			if (this.hasNextRange()) {
				let e = this.getSize(), n = this.getFirst().getValue() + e;
				return new IPv6CidrRange(new t.IPv6(n, this.ipv6.zoneId), this.cidrPrefix);
			}
		}
		previousRange() {
			if (this.hasPreviousRange()) {
				let e = this.getSize(), n = this.getFirst().getValue() - e;
				return new IPv6CidrRange(new t.IPv6(n, this.ipv6.zoneId), this.cidrPrefix);
			}
		}
	};
	e.IPv6CidrRange = s;
	var last = (e, n) => {
		let i = Number(e.bitValue.valueOf()), a = BigInt(`0b${"1".repeat(i)}`), o = e.cidrPrefix.toMask().getValue(), s = (0, r.leftPadWithZeroBit)((o ^ a).toString(2), i);
		return isIPv4CidrRange(e) ? t.IPv4.fromNumber(n.getValue() | (0, r.parseBinaryStringToBigInt)(s)) : t.IPv6.fromBigInt(n.getValue() | (0, r.parseBinaryStringToBigInt)(s));
	};
	function isIPv4CidrRange(e) {
		return e.bitValue.valueOf() === 32n;
	}
})), Vt = /* @__PURE__ */ __commonJSMin(((e) => {
	Object.defineProperty(e, "__esModule", { value: !0 }), e.IPv6Mask = e.IPv4Mask = e.IPv6 = e.Asn = e.IPv4 = e.AbstractIPNum = void 0, e.isIPv4 = isIPv4;
	var t = Rt(), n = R(), r = I(), i = I(), a = I(), o = I(), s = Lt(), c = L(), l = It(), u = L(), d = Bt(), f = Bt(), AbstractIPNum = class {
		getValue() {
			return this.value;
		}
		toBinaryString() {
			return (0, a.leftPadWithZeroBit)(this.value.toString(2), this.bitSize);
		}
		hasNext() {
			return this.value < this.maximumBitSize;
		}
		hasPrevious() {
			return this.value > 0n;
		}
		isEquals(e) {
			return this.value === e.value;
		}
		isLessThan(e) {
			return this.value < e.value;
		}
		isGreaterThan(e) {
			return this.value > e.value;
		}
		isLessThanOrEquals(e) {
			return this.value <= e.value;
		}
		isGreaterThanOrEquals(e) {
			return this.value >= e.value;
		}
	};
	e.AbstractIPNum = AbstractIPNum;
	var p = class IPv4 extends AbstractIPNum {
		static fromNumber(e) {
			return new IPv4(e);
		}
		static fromDecimalDottedString(e) {
			return new IPv4(e);
		}
		static fromString(e) {
			return IPv4.fromDecimalDottedString(e);
		}
		static fromBinaryString(e) {
			let t = n.Validator.isValidBinaryString(e);
			if (t[0]) return new IPv4((0, i.parseBinaryStringToBigInt)(e));
			throw Error(t[1].join(","));
		}
		constructor(e) {
			if (super(), this.bitSize = 32, this.maximumBitSize = n.Validator.THIRTY_TWO_BIT_SIZE, this.type = "IPv4", this.octets = [], this.separator = ".", typeof e == "string") {
				let [t, n] = this.constructFromDecimalDottedString(e);
				this.value = t, this.octets = n;
			} else {
				let [t, n] = this.constructFromBigIntValue(e);
				this.value = t, this.octets = n;
			}
		}
		toString() {
			return this.octets.map((e) => e.toString()).join(this.separator);
		}
		getOctets() {
			return this.octets;
		}
		nextIPNumber() {
			return IPv4.fromNumber(this.getValue() + 1n);
		}
		previousIPNumber() {
			return IPv4.fromNumber(this.getValue() - 1n);
		}
		isPrivate() {
			return IPv4.PRIVATE_RANGES.some((e) => e.contains(this));
		}
		isDocumentation() {
			return IPv4.DOCUMENTATION_RANGES.some((e) => e.contains(this));
		}
		isMulticast() {
			return IPv4.MULTICAST_RANGE.contains(this);
		}
		isBroadcast(e) {
			return e ? this.isEquals(e.getLast()) : this.isEquals(IPv4.LIMITED_BROADCAST);
		}
		isLoopback() {
			return IPv4.LOOPBACK_RANGE.contains(this);
		}
		isUnspecified() {
			return this.value === 0n;
		}
		isLinkLocal() {
			return IPv4.LINK_LOCAL_RANGE.contains(this);
		}
		isGlobalUnicast() {
			return !this.isUnspecified() && !this.isLoopback() && !this.isPrivate() && !this.isLinkLocal() && !this.isDocumentation() && !this.isMulticast() && !this.isReserved() && !this.isBroadcast();
		}
		isReserved() {
			let e = IPv4.fromDecimalDottedString("240.0.0.0").value, t = IPv4.fromDecimalDottedString("255.255.255.254").value;
			return this.value >= e && this.value <= t;
		}
		toIPv4MappedIPv6() {
			let e = "1".repeat(16) + this.toBinaryString();
			return h.fromBinaryString(e);
		}
		constructFromDecimalDottedString(e) {
			let i, a, [o, s] = n.Validator.isValidIPv4String(e);
			if (!o) throw Error(s.filter((e) => e !== "").toString());
			return i = e.split(".").map((e) => t.Octet.fromString(e)), a = BigInt(`0b${(0, r.dottedDecimalNotationToBinaryString)(e)}`), [a, i];
		}
		constructFromBigIntValue(e) {
			let [t, r] = n.Validator.isValidIPv4Number(e);
			if (!t) throw Error(r.filter((e) => e !== "").toString());
			let i = (0, o.numberToBinaryString)(e);
			return e = typeof e == "bigint" ? e : BigInt(e), [e, this.binaryStringToDecimalOctets(i)];
		}
		binaryStringToDecimalOctets(e) {
			return e.length < 32 && (e = (0, a.leftPadWithZeroBit)(e, 32)), e.match(/.{1,8}/g).map((e) => t.Octet.fromString((0, i.parseBinaryStringToBigInt)(e).toString()));
		}
	};
	e.IPv4 = p, p.PRIVATE_RANGES = [
		d.IPv4CidrRange.fromCidr("10.0.0.0/8"),
		d.IPv4CidrRange.fromCidr("172.16.0.0/12"),
		d.IPv4CidrRange.fromCidr("192.168.0.0/16")
	], p.DOCUMENTATION_RANGES = [
		d.IPv4CidrRange.fromCidr("192.0.2.0/24"),
		d.IPv4CidrRange.fromCidr("198.51.100.0/24"),
		d.IPv4CidrRange.fromCidr("203.0.113.0/24")
	], p.MULTICAST_RANGE = d.IPv4CidrRange.fromCidr("224.0.0.0/4"), p.LOOPBACK_RANGE = d.IPv4CidrRange.fromCidr("127.0.0.0/8"), p.LINK_LOCAL_RANGE = d.IPv4CidrRange.fromCidr("169.254.0.0/16"), p.LIMITED_BROADCAST = p.fromDecimalDottedString("255.255.255.255");
	var m = class Asn extends AbstractIPNum {
		static fromString(e) {
			return new Asn(e);
		}
		static fromNumber(e) {
			return new Asn(e);
		}
		static fromBinaryString(e) {
			let t = n.Validator.isValidBinaryString(e);
			if (t[0]) return new Asn(parseInt(e, 2));
			throw Error(t[1].join(","));
		}
		constructor(e) {
			if (super(), this.bitSize = 32, this.maximumBitSize = n.Validator.THIRTY_TWO_BIT_SIZE, this.type = "ASN", typeof e == "string") this.value = Asn.startWithASPrefix(e) ? BigInt(parseInt(e.substring(2))) : e.indexOf(".") == -1 ? BigInt(parseInt(e)) : BigInt(this.parseFromDotNotation(e));
			else {
				let t = BigInt(e), [r, i] = n.Validator.isValidAsnNumber(t);
				if (!r) throw Error(i.filter((e) => e !== "").toString());
				this.value = t;
			}
		}
		toString() {
			let e = this.value.toString();
			return `${Asn.AS_PREFIX}${e}`;
		}
		toASPlain() {
			return this.value.toString();
		}
		toASDot() {
			return this.value.valueOf() >= 65536n ? this.toASDotPlus() : this.toASPlain();
		}
		toASDotPlus() {
			return `${this.value.valueOf() / 65536n}.${this.value.valueOf() % 65536n}`;
		}
		toBinaryString() {
			return (0, o.numberToBinaryString)(this.value);
		}
		is16Bit() {
			let [e] = n.Validator.isValid16BitAsnNumber(this.value);
			return e;
		}
		is32Bit() {
			return !this.is16Bit();
		}
		nextIPNumber() {
			return new Asn(this.value.valueOf() + 1n);
		}
		previousIPNumber() {
			return new Asn(this.value.valueOf() - 1n);
		}
		isMulticast() {
			return !1;
		}
		isPrivate() {
			return !1;
		}
		static startWithASPrefix(e) {
			return e.indexOf(Asn.AS_PREFIX) === 0;
		}
		parseFromDotNotation(e) {
			let t = e.split("."), n = parseInt(t[0]), r = parseInt(t[1]);
			return n * 65535 + (r + n);
		}
	};
	e.Asn = m, m.AS_PREFIX = "AS";
	var h = class IPv6 extends AbstractIPNum {
		static fromBigInt(e) {
			return new IPv6(e);
		}
		static fromHexadecatet(e) {
			return new IPv6(e);
		}
		static fromString(e) {
			return IPv6.fromHexadecatet(e);
		}
		static fromBinaryString(e) {
			let t = n.Validator.isValidBinaryString(e);
			if (t[0]) {
				let t = (0, a.leftPadWithZeroBit)(e, 128);
				return new IPv6((0, i.parseBinaryStringToBigInt)(t));
			}
			throw Error(t[1].join(","));
		}
		static fromIPv4(e) {
			return e.toIPv4MappedIPv6();
		}
		static fromIPv4DotDecimalString(e) {
			return new p(e).toIPv4MappedIPv6();
		}
		constructor(e, t) {
			if (super(), this.bitSize = 128, this.maximumBitSize = n.Validator.ONE_HUNDRED_AND_TWENTY_EIGHT_BIT_SIZE, this.type = "IPv6", this.hexadecatet = [], this.separator = ":", typeof e == "string") {
				let [r, i] = n.Validator.isValidIPv6String(e);
				if (!r) throw Error(i.filter((e) => e !== "").toString());
				let [a, o] = e.split("%");
				this.zoneId = o || t;
				let s = (0, l.expandIPv6Number)(a), [c, u] = this.constructFromHexadecimalDottedString(s);
				this.value = c, this.hexadecatet = u;
			} else {
				let [n, r] = this.constructFromBigIntValue(e);
				this.value = n, this.hexadecatet = r, this.zoneId = t;
			}
		}
		toString() {
			let e = this.hexadecatet.map((e) => e.toString()).join(":");
			return this.hexadecatet.length < 8 && (e = `::${e}`), this.zoneId && (e = `${(0, l.collapseIPv6Number)(e)}%${this.zoneId}`), e;
		}
		getHexadecatet() {
			return this.hexadecatet;
		}
		nextIPNumber() {
			return IPv6.fromBigInt(this.getValue() + 1n);
		}
		previousIPNumber() {
			return IPv6.fromBigInt(this.getValue() - 1n);
		}
		isPrivate() {
			return IPv6.PRIVATE_RANGE.contains(this);
		}
		isDocumentation() {
			return IPv6.DOCUMENTATION_RANGES.some((e) => e.contains(this));
		}
		isMulticast() {
			return IPv6.MULTICAST_RANGE.contains(this);
		}
		hasEmbeddedRP() {
			if (!this.isMulticast()) throw Error("Embedded RP can only be checked for multicast addresses");
			return (Number(this.value >> 112n & 255n) & 112) == 112;
		}
		isUnspecified() {
			return this.value === 0n;
		}
		isLoopback() {
			return this.value === 1n;
		}
		isLinkLocal() {
			return IPv6.LINK_LOCAL_RANGE.contains(this);
		}
		isGlobalUnicast() {
			return !this.isUnspecified() && !this.isLoopback() && !this.isMulticast() && !this.isLinkLocal() && !this.isIPv4Mapped() && !this.isDiscardOnly() && !this.isDocumentation() && !this.isPrivate();
		}
		isIPv4Mapped() {
			return this.value >> 32n == 65535n;
		}
		isDiscardOnly() {
			return IPv6.DISCARD_ONLY_RANGE.contains(this);
		}
		getKind() {
			return this.isUnspecified() ? "Unspecified" : this.isLoopback() ? "Loopback" : this.isMulticast() ? "Multicast" : this.isDocumentation() ? "Documentation" : this.isIPv4Mapped() ? "IPv4-Mapped IPv6" : this.isDiscardOnly() ? "Discard-Only" : this.isLinkLocal() ? "Link-Local" : this.isPrivate() ? "Unique Local Address" : this.isGlobalUnicast() ? "Global Unicast" : "Unknown";
		}
		constructFromBigIntValue(e) {
			let [t, r] = n.Validator.isValidIPv6Number(e);
			if (!t) throw Error(r.filter((e) => e !== "").toString());
			let i = (0, o.numberToBinaryString)(e);
			return [e, this.binaryStringToHexadecatets(i)];
		}
		constructFromHexadecimalDottedString(e) {
			let [t, r] = n.Validator.isValidIPv6String(e);
			if (!t) throw Error(r.filter((e) => e !== "").toString());
			let i = e.split(":").map((e) => s.Hexadecatet.fromString(e));
			return [BigInt(`0b${(0, u.hexadectetNotationToBinaryString)(e)}`), i];
		}
		binaryStringToHexadecatets(e) {
			let t = (0, c.binaryStringToHexadecimalString)(e);
			for (; t.length % 4 != 0;) t = "0" + t;
			return t.match(/.{1,4}/g).map((e) => s.Hexadecatet.fromString(e));
		}
	};
	e.IPv6 = h, h.PRIVATE_RANGE = f.IPv6CidrRange.fromCidr("fc00::/7"), h.DOCUMENTATION_RANGES = [f.IPv6CidrRange.fromCidr("2001:db8::/32"), f.IPv6CidrRange.fromCidr("3fff::/20")], h.MULTICAST_RANGE = f.IPv6CidrRange.fromCidr("ff00::/8"), h.UNSPECIFIED_RANGE = f.IPv6CidrRange.fromCidr("::/128"), h.LOOPBACK_RANGE = f.IPv6CidrRange.fromCidr("::1/128"), h.LINK_LOCAL_RANGE = f.IPv6CidrRange.fromCidr("fe80::/10"), h.DISCARD_ONLY_RANGE = f.IPv6CidrRange.fromCidr("100::/64"), e.IPv4Mask = class IPv4Mask extends p {
		static fromDecimalDottedString(e) {
			return new IPv4Mask(e);
		}
		constructor(e) {
			super(e), this.octets = [];
			let i, a;
			if ([i, a] = n.Validator.isValidIPv4Mask(e), !i) throw Error(a.filter((e) => e !== "").toString());
			let o = e.split(".");
			this.octets = o.map((e) => t.Octet.fromString(e));
			let s = (0, r.dottedDecimalNotationToBinaryString)(e);
			this.prefix = (s.match(/1/g) || []).length, this.value = BigInt(`0b${s}`);
		}
	}, e.IPv6Mask = class IPv6Mask extends h {
		static fromHexadecatet(e) {
			return new IPv6Mask(e);
		}
		constructor(e) {
			super(e), this.hexadecatet = [];
			let t, r, i = (0, l.expandIPv6Number)(e);
			if ([t, r] = n.Validator.isValidIPv6Mask(i), !t) throw Error(r.filter((e) => e !== "").toString());
			let a = i.split(":");
			this.hexadecatet = a.map((e) => s.Hexadecatet.fromString(e));
			let o = (0, u.hexadectetNotationToBinaryString)(i);
			this.prefix = (o.match(/1/g) || []).length, this.value = BigInt(`0b${o}`), this.value = BigInt(`0b${(0, u.hexadectetNotationToBinaryString)(i)}`);
		}
	};
	function isIPv4(e) {
		return e.bitSize === 32;
	}
})), Ht = /* @__PURE__ */ __commonJSMin(((e) => {
	Object.defineProperty(e, "__esModule", { value: !0 });
})), Ut = /* @__PURE__ */ __commonJSMin(((e) => {
	Object.defineProperty(e, "__esModule", { value: !0 }), e.Pool = void 0;
	var t = Bt(), n = zt();
	e.Pool = class Pool {
		static fromIP(e) {
			let n = e.map((e) => t.RangedSet.fromSingleIP(e));
			return new Pool(n);
		}
		static fromRangeSet(e) {
			return new Pool(e);
		}
		static fromCidrRanges(e) {
			let t = e.map((e) => e.toRangeSet());
			return new Pool(t);
		}
		constructor(e) {
			this.backingSet = new r(), e.forEach((e) => {
				this.backingSet.add(e);
			});
		}
		getRanges() {
			return this.backingSet.asArray();
		}
		aggregate() {
			let e = this.backingSet.asArray().reduce((e, t, n, r) => {
				if (e.length == 0) return e.push(t), e;
				{
					let n = e.pop(), r = n.toCidrRange(), i = t.toCidrRange();
					if (r.isCidrMergeable(i)) {
						let t = r.merge(i);
						return e.push(t.toRangeSet()), e;
					}
					return n.contains(t) ? e.push(n) : (e.push(n), e.push(t)), e;
				}
			}, []), t = Pool.fromRangeSet(e);
			return t.getRanges().length === this.getRanges().length ? t : t.aggregate();
		}
		getCidrRange(e) {
			if (e.toRangeSize() > this.getSize()) throw Error(`Not enough IP number in the pool for requested prefix: ${e}`);
			let t, n;
			loop: for (let r of this.getRanges()) for (let i = 0n; i + e.toRangeSize() <= r.getSize(); i += 1n) try {
				let n = r.takeSubRange(i, e.toRangeSize());
				t = n.toCidrRange();
				let a = r.difference(n);
				this.removeExact(r), this.add(a);
				break loop;
			} catch (e) {
				if (e instanceof RangeError) continue loop;
				n = e instanceof Error ? e : Error(String(e));
			}
			if (t) return t;
			throw n === void 0 ? /* @__PURE__ */ Error(`No range big enough in the pool for requested prefix: ${e}`) : n;
		}
		getCidrRanges(e) {
			if (e.toRangeSize() > this.getSize()) throw Error("Prefix greater than pool");
			let go = (e, t, r) => {
				try {
					let n = this.getCidrRange(t);
					r.push(n);
					let i = r.reduce((e, t) => e + t.getSize(), 0n);
					return e.toRangeSize() === i ? r : go(e, t, r);
				} catch {
					let i = (0, n.isIPv4Prefix)(t) ? n.IPv4Prefix.fromNumber(t.getValue() + 1n) : n.IPv6Prefix.fromNumber(t.getValue() + 1n);
					return go(e, i, r);
				}
			};
			return go(e, e, []);
		}
		getSize() {
			return this.aggregate().getRanges().reduce((e, t) => e + t.getSize(), 0n);
		}
		resetWith(e) {
			this.backingSet.clear(), this.backingSet = this.backingSet.add(e);
		}
		removeExact(e) {
			let t = this.backingSet.removeExact(e), n = !this.backingSet.isEquals(t);
			return this.backingSet = t, n;
		}
		removeOverlapping(e) {
			let t = this.backingSet.removeOverlapping(e), n = !this.backingSet.isEquals(t);
			return this.backingSet = t, n;
		}
		add(e) {
			this.backingSet = this.backingSet.add(e);
		}
		clear() {
			this.backingSet.clear();
		}
	};
	var r = class SortedSet {
		sortArray(e) {
			return e.sort((e, t) => e.isLessThan(t) ? -1 : +!!e.isGreaterThan(t)), e;
		}
		constructor(e) {
			this.backingArray = e ? this.sortArray(e) : [];
		}
		asArray() {
			return this.backingArray;
		}
		isEquals(e) {
			return this.backingArray.length === e.asArray().length && this.backingArray.every((t, n) => t.getSize() === e.asArray()[n].getSize());
		}
		add(e) {
			let t = this.backingArray;
			return "push" in e ? t = t.concat(e) : t.push(e), new SortedSet(this.sortArray(t));
		}
		removeExact(e) {
			let t = this.backingArray.filter((t) => "push" in e ? e.find((e) => e.isEquals(t)) !== void 0 : !e.isEquals(t));
			return new SortedSet(this.sortArray(t));
		}
		removeOverlapping(e) {
			let t = this.backingArray.flatMap((t) => {
				if ("push" in e) return e.flatMap((e) => t.contains(e) ? t.difference(e) : t.inside(e) ? [] : t.isOverlapping(e) ? [t.subtract(e)] : [e]);
				try {
					return t.difference(e);
				} catch {
					return t;
				}
			});
			return new SortedSet(this.sortArray(t));
		}
		clear() {
			this.backingArray = [];
		}
	};
})), Wt = /* @__PURE__ */ __commonJSMin(((e) => {
	Object.defineProperty(e, "__esModule", { value: !0 });
})), z = (/* @__PURE__ */ __commonJSMin(((e) => {
	var t = e && e.__createBinding || (Object.create ? (function(e, t, n, r) {
		r === void 0 && (r = n);
		var i = Object.getOwnPropertyDescriptor(t, n);
		(!i || ("get" in i ? !t.__esModule : i.writable || i.configurable)) && (i = {
			enumerable: !0,
			get: function() {
				return t[n];
			}
		}), Object.defineProperty(e, r, i);
	}) : (function(e, t, n, r) {
		r === void 0 && (r = n), e[r] = t[n];
	})), n = e && e.__exportStar || function(e, n) {
		for (var r in e) r !== "default" && !Object.prototype.hasOwnProperty.call(n, r) && t(n, e, r);
	};
	Object.defineProperty(e, "__esModule", { value: !0 }), n(I(), e), n(Lt(), e), n(L(), e), n(Vt(), e), n(Ht(), e), n(Ut(), e), n(Bt(), e), n(Wt(), e), n(It(), e), n(Rt(), e), n(zt(), e), n(R(), e);
})))(), toCidr = (e) => e.includes("/") ? e : `${e}/32`, Gt = C().trim().superRefine((e, t) => {
	let n = toCidr(e);
	try {
		let e = n.split("/")[0];
		z.IPv4CidrRange.fromCidr(n).getFirst().toString() !== e && t.addIssue({
			code: l.custom,
			message: "IPアドレスがネットワークの最初のアドレスになっていません"
		});
	} catch {
		t.addIssue({
			code: l.custom,
			message: "IPアドレス範囲の形式が正しくありません"
		});
	}
}).describe("CIDR"), isIpRestricted = (e, t) => {
	let n = e.map((e) => Gt.safeParse(e)).filter((e) => e.success).map((e) => z.IPv4CidrRange.fromCidr(toCidr(e.data)));
	if (n.length === 0) return !1;
	let r = z.IPv4CidrRange.fromCidr(toCidr(t));
	return !n.some((e) => r.inside(e));
}, isLocalIp = (e) => {
	let t = [
		z.IPv4CidrRange.fromCidr("10.0.0.0/8"),
		z.IPv4CidrRange.fromCidr("172.16.0.0/12"),
		z.IPv4CidrRange.fromCidr("192.168.0.0/16")
	];
	try {
		let n = z.IPv4CidrRange.fromCidr(toCidr(e));
		return t.some((e) => n.inside(e));
	} catch {
		return !1;
	}
}, B = Oe((e) => {
	if (typeof e == "string" || e instanceof Date) return new Date(e);
}, Te()), Kt = /* @__PURE__ */ __toESM(Mt()), qt = C().refine(Kt.default, { message: "不正なメールアドレスのドメインです" }), Jt = E(qt).max(5, { message: "自動承認するメールアドレスのドメインは5個を超えて登録できません" }).describe("会社所属リクエストの自動承認メールドメイン"), Yt = D({
	enabled: T().describe("会社所属リクエスト自動承認が有効か"),
	emailDomains: C().array(),
	modifiedAt: B.optional().describe("会社所属リクエストの自動承認設定の変更日時")
}).superRefine((e, t) => {
	if (e.enabled) {
		let n = Jt.safeParse(e.emailDomains);
		n.success || t.addIssue({
			message: n.error.errors[0]?.message,
			path: ["emailDomains"],
			code: l.custom
		}), e.emailDomains.length < 1 && t.addIssue({
			message: "会社所属リクエストの自動承認設定を行う場合はドメインを指定して下さい",
			path: ["emailDomains"],
			code: l.custom
		});
	}
}).transform((e) => {
	let t = e.emailDomains.filter((e) => qt.safeParse(e).success).slice(0, 5);
	return {
		...e,
		emailDomains: t
	};
}).describe("会社所属リクエスト自動承認設定"), Xt = D({
	enabled: T().describe("会社所属リクエスト自動承認が有効か"),
	emailDomains: C().array().describe("会社所属リクエストの自動承認メールドメイン"),
	modifiedAt: B.optional().describe("会社所属リクエストの自動承認設定の変更日時")
}), Zt = [
	"電話",
	"FAX",
	"携帯",
	"スマートフォン"
], Qt = D({
	denwaNumberShubetsu: C().trim().describe("電話番号種別"),
	denwaNumber: C().trim().describe("電話番号")
}).describe("電話番号"), $t = D({
	denwaNumberShubetsu: j(Zt).describe("電話番号種別"),
	denwaNumber: xt
}).describe("電話番号"), toDenwa = (e) => {
	let t = $t.shape.denwaNumberShubetsu.safeParse(e.denwaNumberShubetsu);
	return {
		denwaNumberShubetsu: t.success ? t.data : "電話",
		denwaNumber: e.denwaNumber
	};
}, toEditableDenwaList = (e) => e.length > 0 ? e.map(toDenwa) : [{
	denwaNumberShubetsu: "電話",
	denwaNumber: ""
}], en = j([
	"disabled",
	"enabled",
	"enforced"
]), tn = D({
	enableMfa: T().describe("MFAを利用中か"),
	enforcedMfa: T().describe("MFAが必須か"),
	enablePasskey: T().describe("パスキーを利用するか"),
	enableTotp: T().describe("ワンタイムパスワードを利用するか")
}), nn = D({
	mfaState: en.describe("MFA状態の詳細"),
	enablePasskey: T().optional().describe("パスキーを利用するか"),
	enableTotp: T().optional().describe("ワンタイムパスワードを利用するか")
}), rn = D({
	domainGuid: C().describe("One側の法人識別子"),
	customerId: w().int().nullable().describe("法人カスタマーID"),
	synced: T()
}).describe("One側の法人情報"), an = D({
	domain_guid: C().describe("One API法人識別子"),
	rent_bukken_limit: w().nullable().describe("賃貸物件上限数"),
	rent_bukken_usage: w().nullable().describe("賃貸物件利用数"),
	sale_bukken_limit: w().nullable().describe("売買物件上限数"),
	sale_bukken_usage: w().nullable().describe("売買物件利用数"),
	bukken_limit: w().nullable().describe("物件上限数"),
	bukken_usage: w().nullable().describe("物件利用数"),
	keiyaku_rent_bukken_limit: w().nullable().describe("管理委託契約上限数"),
	keiyaku_rent_bukken_usage: w().nullable().describe("管理委託契約利用数"),
	yachin_kanri_bukken_limit: w().nullable().describe("家賃管理タイプ上限数"),
	yachin_kanri_bukken_usage: w().nullable().describe("家賃管理タイプ利用数"),
	sennin_kanri_bukken_limit: w().nullable().describe("専任管理タイプ上限数"),
	sennin_kanri_bukken_usage: w().nullable().describe("専任管理タイプ利用数"),
	rent_tsuikyaku_limit: w().nullable().describe("賃貸追客上限数"),
	rent_tsuikyaku_usage: w().nullable().describe("賃貸追客利用数"),
	sale_tsuikyaku_limit: w().nullable().describe("売買追客上限数"),
	sale_tsuikyaku_usage: w().nullable().describe("売買追客利用数"),
	all_tsuikyaku_limit: w().nullable().describe("追客上限数"),
	all_tsuikyaku_usage: w().nullable().describe("追客利用数"),
	file_limit: w().nullable().describe("ファイル登録上限数"),
	file_usage: w().nullable().describe("ファイル登録利用数"),
	jirei_limit: w().nullable().describe("取引事例登録上限数"),
	jirei_usage: w().nullable().describe("取引事例登録利用数")
}), on = k(C(), E(C())).describe("法人で使える機能。名前空間ごとの名前の一覧"), isEsaFeatureGranted = (e, t) => (e.esa ?? []).includes(t);
//#endregion
//#region lib/models/ModelBase.ts
setErrorMap(customErrorMap);
var V = D({
	createdAt: B.describe("作成日時"),
	modifiedAt: B.describe("更新日時")
}), sn = D({
	enabled: T().describe("電話番号在籍確認が有効か"),
	modifiedAt: B.optional().describe("電話番号在籍確認設定の変更日時")
}).describe("電話番号在籍確認設定"), cn = C().min(1, { message: "1~6桁で入力してください" }).max(6, { message: "1~6桁で入力してください" }).regex(/^\d*$/, { message: "数値のみ入力できます" }).regex(/^0*([1-9]+0*)+$/, { message: "1~9の数値を含めて入力してください" }).transform((e) => e.padStart(6, "0")).describe("宅建免許番号"), ln = C().min(1, { message: "1~2桁で入力してください" }).max(2, { message: "1~2桁で入力してください" }).regex(/^\d*$/, { message: "数値のみ入力できます" }).regex(/^0*([1-9]+0*)+$/, { message: "1~9の数値を含めて入力してください" }).transform((e) => e.padStart(2, "0")).describe("宅建免許更新回数"), un = /* @__PURE__ */ "国土交通大臣.青森県知事.岩手県知事.宮城県知事.秋田県知事.山形県知事.福島県知事.茨城県知事.栃木県知事.群馬県知事.埼玉県知事.千葉県知事.東京都知事.神奈川県知事.新潟県知事.富山県知事.石川県知事.福井県知事.山梨県知事.長野県知事.岐阜県知事.静岡県知事.愛知県知事.三重県知事.滋賀県知事.京都府知事.大阪府知事.兵庫県知事.奈良県知事.和歌山県知事.鳥取県知事.島根県知事.岡山県知事.広島県知事.山口県知事.徳島県知事.香川県知事.愛媛県知事.高知県知事.福岡県知事.佐賀県知事.長崎県知事.熊本県知事.大分県知事.宮崎県知事.鹿児島県知事.沖縄県知事.北海道（石狩）知事.北海道（渡島）知事.北海道（檜山）知事.北海道（後志）知事.北海道（空知）知事.北海道（上川）知事.北海道（留萌）知事.北海道（宗谷）知事.北海道（オホ）知事.北海道（胆振）知事.北海道（日高）知事.北海道（十勝）知事.北海道（釧路）知事.北海道（根室）知事.信託会社等".split("."), isTakkenLicensor = (e) => un.includes(e), dn = C().refine(isTakkenLicensor, { message: "不正な宅建免許認可者名です" }).describe("宅建免許認可者名"), fn = D({
	licensor: dn,
	updateCount: ln,
	number: cn
}).describe("宅建免許情報"), pn = D({
	licensor: C().describe("宅建免許認可者名"),
	updateCount: C().describe("宅建免許更新回数"),
	number: C().describe("宅建免許番号")
}).describe("宅建免許情報"), mn = D({
	name: C().describe("商号又は名称"),
	representativeName: C().nullable().describe("代表者の氏名"),
	address: C().describe("主たる事務所の所在地")
}).describe("国土交通省の宅建業者情報"), hn = j([
	"unchecked",
	"exists",
	"missing",
	"invalid"
]), gn = j([
	"unchecked",
	"phone_verified",
	"admin_verified",
	"admin_denied"
]), _n = D({
	state: hn.describe("国交省の名簿での免許の確認状態"),
	modifiedAt: B.optional().describe("確認状態の変更日時")
}).describe("宅建免許の存在確認"), vn = D({
	state: gn.describe("免許保有の確認状態"),
	modifiedAt: B.optional().describe("確認状態の変更日時")
}).describe("宅建免許の保有確認"), yn = pn.extend({
	existence: _n.optional(),
	verification: vn.optional()
}).describe("確認状態付きの宅建免許情報"), bn = yn.extend({ latestUpdateCount: ln.nullable().describe("国土交通省が持つ最新の更新回数") }).describe("国土交通省の最新の更新回数付きの宅建免許情報"), xn = D({
	takkenLicense: bn.nullable(),
	latestUpdateCount: ln.nullable().describe("takkenLicense.latestUpdateCount と同じ値。互換のために残している"),
	takkenTrader: mn.nullable()
}).describe("法人宅建免許情報"), Sn = D({
	fileUid: C(),
	url: C().url({ message: "不正な画像URLです" }).optional()
}), Cn = Sn.nullable().describe("宅建免許画像"), wn = Sn.nullable().describe("ロゴ画像ファイル"), Tn = 255, En = D({
	domainUid: C().describe("法人識別子"),
	name: C().min(1, { message: "入力は必須です" }).max(Tn, { message: `${Tn}文字以内で入力してください` }).describe("法人名"),
	isPhoneVerified: T().describe("電話発信による法人確認済かどうか"),
	takkenLicense: fn.nullable().describe("法人の宅建免許情報"),
	takkenLicenseImage: Cn,
	logoImage: wn,
	denwaList: E($t).refine((e) => e.some((e) => e.denwaNumberShubetsu === "電話" && e.denwaNumber != null && e.denwaNumber.length > 0), () => ({ message: "種別「電話」の電話番号を1つ以上指定する必要があります。" })).describe("電話番号リスト"),
	autoApproval: Yt,
	phoneVerification: sn,
	nativeAppIpRestrictionEnforced: T().describe("デスクトップアプリのIPアドレス制限を強制するか"),
	webAppIpRestrictionEnforced: T().describe("ウェブアプリのIPアドレス制限を強制するか"),
	ebone: rn.nullable().describe("One側の法人情報")
}), H = D({
	domainUid: C().describe("法人識別子"),
	name: C().describe("法人名"),
	isPhoneVerified: T().describe("電話発信による法人確認済かどうか"),
	takkenLicense: pn.nullable().describe("法人の宅建免許情報"),
	takkenLicenseImage: Cn,
	logoImage: wn,
	denwaList: E(Qt).describe("電話番号リスト"),
	autoApproval: Xt,
	phoneVerification: sn,
	nativeAppIpRestrictionEnforced: T().describe("デスクトップアプリのIPアドレス制限を強制するか"),
	webAppIpRestrictionEnforced: T().describe("ウェブアプリのIPアドレス制限を強制するか"),
	mfaState: en.describe("MFA状態の詳細"),
	enablePasskey: T().describe("パスキーを利用するか"),
	enableTotp: T().describe("ワンタイムパスワードを利用するか"),
	ebone: rn.nullable().describe("One側の法人情報"),
	corporateNumber: C().nullable().describe("法人番号"),
	enableIntegrationFeature: T().describe("データ統合を利用可能か"),
	enableEntryFeature: T().describe("ログイン可能か"),
	grantedFeatures: on
}).merge(V).describe("法人情報"), Dn = En.omit({
	domainUid: !0,
	ebone: !0
}).partial().extend({ domainUid: C().describe("法人識別子") }), convertDomainReadToUpdate = (e) => ({
	domainUid: e.domainUid,
	name: e.name,
	isPhoneVerified: e.isPhoneVerified,
	takkenLicense: e.takkenLicense ? {
		licensor: e.takkenLicense.licensor,
		updateCount: e.takkenLicense.updateCount,
		number: e.takkenLicense.number
	} : null,
	takkenLicenseImage: e.takkenLicenseImage,
	logoImage: e.logoImage,
	denwaList: e.denwaList.map(toDenwa),
	autoApproval: e.autoApproval,
	phoneVerification: e.phoneVerification,
	nativeAppIpRestrictionEnforced: e.nativeAppIpRestrictionEnforced,
	webAppIpRestrictionEnforced: e.webAppIpRestrictionEnforced
}), U = D({
	startIndex: w(),
	itemsPerPage: w()
}), On = C().min(1, { message: "入力は必須です" }), kn = C().nullable().transform((e) => e === "" ? null : e), An = 255, jn = 255, Mn = 300;
setErrorMap(customErrorMap);
var Nn = D({
	domainUid: C().describe("法人の識別子"),
	organizationUid: C().describe("組織の識別子"),
	name: On.max(An, { message: `${An}文字以内で入力してください` }).describe("組織名"),
	businessName: C().max(jn, { message: `${jn}文字以内で入力してください` }).nullable().transform((e) => e === "" ? null : e).describe("屋号"),
	jusho: Dt.nullable(),
	denwaList: E($t).refine((e) => e.some((e) => e.denwaNumberShubetsu === "電話" && e.denwaNumber != null && e.denwaNumber.length > 0), () => ({ message: "種別「電話」の電話番号を1つ以上指定する必要があります。" })).describe("電話番号リスト"),
	kameiDantaiList: E(D({ name: C().max(300, { message: "300文字以内で入力してください" }).nullable() })).describe("加盟団体リスト"),
	partnerAutoApproval: D({ enabled: T() }).nullable().describe("取引先の自動承認設定"),
	ebone: D({
		domainGuid: C().uuid(),
		organizationGuid: C().uuid(),
		customerId: w().int().nullable().describe("法人カスタマーID")
	}).nullable().describe("One店舗情報"),
	isPublic: T().describe("組織情報公開状態")
}), Pn = D({
	domainUid: C().describe("法人の識別子"),
	organizationUid: C().describe("組織の識別子"),
	name: On.describe("組織名"),
	businessName: kn.describe("屋号"),
	jusho: Ct.nullable(),
	denwaList: E(Qt).describe("電話番号リスト"),
	kameiDantaiList: E(D({ name: C().nullable() })).describe("加盟団体リスト"),
	partnerAutoApproval: D({ enabled: T() }).nullable().describe("取引先の自動承認設定"),
	ebone: D({
		domainGuid: C().uuid(),
		organizationGuid: C().uuid(),
		customerId: w().int().nullable().describe("法人カスタマーID")
	}).nullable().describe("One店舗情報"),
	isPublic: T().describe("組織情報公開状態")
}).merge(V), Fn = U.extend({ items: Pn.array() }), In = Nn.merge(V), Ln = Nn.omit({
	organizationUid: !0,
	ebone: !0
}).partial(), Rn = Nn.omit({ organizationUid: !0 });
//#endregion
//#region lib/models/role/Role.ts
setErrorMap(customErrorMap);
var W = j([
	"NONE",
	"USER",
	"ORGANIZATION",
	"GROUP",
	"DOMAIN"
]), G = D({ scope: W }).describe("ロールポリシー"), zn = D({
	key: C().describe("キー名"),
	isEsa: T().describe("ESA で利用するポリシー"),
	isEsaEbone: T().describe("One と同期している ESA で利用するポリシー"),
	scopes: E(W).describe("選択可能なスコープ"),
	defaultScope: W.describe("デフォルトのスコープ")
}).describe("ポリシー"), Bn = D({
	edit_esa_domain: G.optional(),
	edit_esa_organization: G.optional(),
	edit_esa_user: G.optional(),
	add_esa_user: G.optional(),
	edit_authority: G.optional(),
	edit_kokyaku: G.optional(),
	view_chinshaku_bukken: G.optional(),
	edit_chinshaku_bukken: G.optional(),
	publish_chinshaku_bukken: G.optional(),
	view_baikyaku_bukken: G.optional(),
	edit_baikyaku_bukken: G.optional(),
	publish_baikyaku_bukken: G.optional()
}).describe("ロールに付与されたポリシー"), Vn = D({
	domainRoleGuid: C().uuid().describe("One法人ロールGUID"),
	domainGuid: C().uuid().describe("One法人GUID")
}).describe("One側の権限情報"), Hn = D({
	resource: C(),
	privilege: C(),
	scope: W
}).describe("権限記述"), Un = 255, Wn = C().min(1, { message: "入力は必須です" }).max(Un, { message: `${Un}文字以内で入力してください` }).describe("ロール名"), Gn = 255, Kn = C().max(Gn, { message: `${Gn}文字以内で入力してください` }).nullable().describe("説明"), K = D({
	domainUid: C().describe("法人Uid"),
	roleUid: C().describe("ロールUid"),
	name: C().describe("ロール名"),
	comment: C().nullable().describe("コメント"),
	description: C().nullable().describe("説明"),
	policy: Bn,
	isAdmin: T().describe("管理者フラグ"),
	readonly: T().describe("読み取り専用"),
	securityDescriptors: E(Hn),
	ebone: Vn.nullable()
}).merge(V).describe("ロール"), qn = D({
	domainUid: C().describe("法人Uid"),
	name: Wn,
	description: Kn,
	policy: Bn,
	isAdmin: T().describe("管理者フラグ"),
	readonly: T().describe("読み取り専用"),
	securityDescriptors: E(Hn),
	ebone: Vn.nullable()
}).describe("ロール"), Jn = qn.partial().describe("ロール"), scopePriority = (e) => {
	switch (e) {
		case "NONE": return 0;
		case "USER": return 1;
		case "ORGANIZATION": return 2;
		case "GROUP": return 3;
		case "DOMAIN": return 4;
		default: return 0;
	}
}, isEsaPolicy = (e, t) => t ? e.isEsaEbone : e.isEsa, compareScope = (e, t) => {
	let n = scopePriority(e), r = scopePriority(t);
	return n < r ? -1 : +(n > r);
}, Yn = 1, Xn = 1e3, Zn = ["アカウント管理者", "一般"];
setErrorMap(customErrorMap);
var Qn = T().nullable().transform((e) => e ?? !0), $n = D({
	enabled: T().describe("メール通知有効"),
	enabledMessenger: Qn.describe("Squareメッセージ受信通知"),
	modifiedAt: B.describe("メール通知設定変更日時")
}), er = D({
	userGuid: C().uuid().describe("OneユーザGUID"),
	organizationGuids: C().uuid().array().describe("One組織GUIDs"),
	domainGuid: C().uuid().describe("One法人GUID")
}), tr = 255, nr = C().min(1, { message: "入力は必須です" }).max(tr, { message: `${tr}文字以内で入力してください` }).describe("ユーザ名"), rr = 255, ir = C().nullable().transform((e) => e === "" ? null : e).pipe(C().max(rr, { message: `${rr}文字以内で入力してください` }).nullable()).describe("公開名"), ar = 5e3, or = Gt.array().refine((e) => e.reduce((e, t) => e + t.length, 0) + (e.length > 0 ? e.length - 1 : 0) <= ar, { message: `${ar}文字以内で入力してください` }).describe("IPアドレスのリスト"), sr = D({
	userUid: C().describe("アカウントUid"),
	providerUserUid: C().nullable().describe("Auh0ユーザの識別子 (user_id)"),
	domainUid: C().describe("担当法人Uid"),
	name: nr,
	publicName: ir,
	ipAddressList: or,
	email: Ft.nullable(),
	denwaList: E($t).describe("電話番号リスト"),
	lastLoginDatetime: B.nullable().describe("最終ログイン日時"),
	mfaExemptedUntil: B.nullable().optional().transform((e) => e ?? null).describe("MFA 強制の一時免除期限"),
	ebone: De(er)
}).describe("ユーザ"), q = D({
	userUid: C().describe("アカウントUid"),
	providerUserUid: C().nullable().describe("provider_user_uid"),
	domainUid: C().describe("担当法人Uid"),
	roleUid: C().describe("ロールUid"),
	name: C().describe("ユーザ名"),
	publicName: kn.describe("公開名"),
	ipAddressList: C().array().describe("IPアドレスのリスト"),
	email: C().nullable().describe("メールアドレス"),
	role: K,
	denwaList: E(Qt).describe("電話番号リスト"),
	lastLoginDatetime: B.nullable().describe("最終ログイン日時"),
	mfaExemptedUntil: B.nullable().optional().transform((e) => e ?? null).describe("MFA 強制の一時免除期限"),
	ebone: De(er),
	emailNotify: $n,
	organizationUids: C().array().describe("所属店舗Uid"),
	defaultOrganizationUid: C().nullable().describe("デフォルト組織Uid"),
	enableEntryFeature: T().describe("ログイン可能か"),
	grantedFeatures: on
}).merge(V), cr = U.extend({ items: q.array() }), J = D({
	emailNotify: $n,
	organizationUids: C().array().describe("所属店舗Uid"),
	defaultOrganizationUid: C().nullable().describe("デフォルト組織Uid"),
	role: K,
	roleUid: C().describe("ロールUid"),
	enableEntryFeature: T().describe("ログイン可能か"),
	grantedFeatures: on
}).merge(sr).merge(V).refine((e) => e.defaultOrganizationUid === null || e.organizationUids.includes(e.defaultOrganizationUid), { message: "デフォルト組織が不正です" }).describe("ユーザ"), lr = D({
	emailNotify: $n.omit({ modifiedAt: !0 }).optional(),
	organizationUids: C().array().optional().describe("所属店舗Uid"),
	defaultOrganizationUid: C().nullish().describe("デフォルト組織Uid"),
	roleUid: C().optional().describe("ロールUid")
}).merge(sr.partial()).omit({
	domainUid: !0,
	userUid: !0,
	email: !0,
	ebone: !0,
	lastLoginDatetime: !0,
	mfaExemptedUntil: !0
}).refine((e) => e.defaultOrganizationUid == null || e.organizationUids && e.organizationUids.includes(e.defaultOrganizationUid), { message: "デフォルト組織が不正です" }), ur = D({ mfaExemptedUntil: B.nullable().describe("MFA 強制の一時免除期限") }), isMfaExempted = (e) => e != null && e.getTime() > Date.now(), convertUserReadToUpdate = (e) => ({
	denwaList: e.denwaList.map(toDenwa),
	emailNotify: {
		enabled: e.emailNotify.enabled,
		enabledMessenger: e.emailNotify.enabledMessenger
	},
	name: e.name,
	publicName: e.publicName == null ? "" : e.publicName,
	ipAddressList: e.ipAddressList,
	providerUserUid: e.providerUserUid,
	roleUid: e.roleUid,
	organizationUids: e.organizationUids,
	defaultOrganizationUid: e.defaultOrganizationUid
}), getUserRoleTitle = ({ isAdmin: e }) => e ? "アカウント管理者" : "一般";
//#endregion
//#region lib/models/invitation/Invitation.ts
setErrorMap(customErrorMap);
var dr = D({
	email: C().describe("メールアドレス"),
	invitationUid: C().describe("招待ID"),
	expires: B.describe("招待期限期日"),
	defaultOrganizationUid: C().describe("デフォルト組織Uid")
}).merge(q.pick({
	name: !0,
	organizationUids: !0,
	domainUid: !0,
	roleUid: !0
})).merge(V), fr = D({
	email: Ft,
	organizationUids: C().array().optional().describe("所属店舗Uid"),
	defaultOrganizationUid: C().optional().describe("デフォルト組織Uid"),
	roleUid: C().optional().describe("ロールUid")
}).merge(lr.innerType().pick({ name: !0 })).refine((e) => e.defaultOrganizationUid == null || e.organizationUids && e.organizationUids.includes(e.defaultOrganizationUid), { message: "デフォルト組織が不正です" }), pr = U.extend({ items: dr.array() });
//#endregion
//#region lib/models/invitation/InvitationTicket.ts
setErrorMap(customErrorMap);
var mr = D({ token: C().describe("チケットトークン") }).merge(H.pick({ domainUid: !0 })).merge(dr.pick({ invitationUid: !0 })).merge(V), hr = D({
	domainName: C().describe("法人名"),
	takkenLicense: pn.nullable().describe("法人の宅建免許情報"),
	isCollaborator: T().default(!1).describe("招待元が協力会社の法人か")
});
//#endregion
//#region lib/models/memberApplicant/MemberApplicant.ts
setErrorMap(customErrorMap);
var gr = D({
	memberApplicantUid: C().describe("会社所属リクエスト識別子"),
	comment: C().max(300, { message: "コメントは300文字以内で入力してください" }).describe("申請者コメント"),
	requestedOrganizationName: C().describe("所属希望組織名"),
	userName: J.innerType().shape.name,
	domainName: H.shape.name
}).merge(J.innerType().pick({
	email: !0,
	providerUserUid: !0
})).merge(H.pick({ domainUid: !0 })).merge(V), _r = U.extend({ items: gr.array() });
//#endregion
//#region lib/models/ProviderUser.ts
setErrorMap(customErrorMap);
var Y = D({
	providerUserUid: C().describe("Auh0ユーザの識別子 (user_id)"),
	email: C().describe("メールアドレス"),
	defaultUserUid: C().nullable().describe("デフォルトのユーザUid"),
	currentUserUid: C().nullable().describe("選択中のユーザUid"),
	users: E(q).describe("紐づくユーザのリスト"),
	isAgreeTerms: T().describe("利用規約同意済み"),
	ebone: De(er)
}).merge(V), vr = D({
	providerUserUid: Y.shape.providerUserUid,
	defaultUserUid: Y.shape.defaultUserUid.optional(),
	currentUserUid: Y.shape.currentUserUid.optional(),
	isAgreeTerms: Y.shape.isAgreeTerms.optional()
}), yr = D({
	identifier: C(),
	ip: C().nullable()
}), br = j(["blocked", "unblocked"]), xr = D({
	esaApi: br,
	auth0: br
}), Sr = D({
	clientIp: C().nullable(),
	email: C().describe("メールアドレス"),
	restrictedUserUids: E(C()).describe("IP アドレス制限でアクセスできないユーザ")
}).merge(Y.pick({
	providerUserUid: !0,
	defaultUserUid: !0,
	currentUserUid: !0,
	isAgreeTerms: !0,
	users: !0
})).describe("ユーザログインコンテキスト");
//#endregion
//#region lib/models/EmailVerify.ts
setErrorMap(customErrorMap);
var Cr = D({ providerUserUid: C().describe("provider_user_uid") }).describe("Auh0ユーザの識別子 (user_id)");
//#endregion
//#region lib/models/SignUpContext.ts
setErrorMap(customErrorMap);
var wr = D({ email: Ft }).describe("メールアドレス"), Tr = /* @__PURE__ */ __exportAll({
	ActivateActivationTicketRequest: () => kr,
	ApiGetActivationTicket: () => Or,
	ApiGetCollaborator: () => Xr,
	ApiGetCollaboratorInvitation: () => Ur,
	ApiGetCollaboratorLoginContext: () => qr,
	ApiGetCustomer: () => $r,
	ApiGetDefaultRole: () => ii,
	ApiGetDomain: () => pi,
	ApiGetDomainInvitation: () => si,
	ApiGetDomainMemo: () => xi,
	ApiGetEmailChangeTicket: () => na,
	ApiGetEsaLicense: () => oa,
	ApiGetFeatureGrant: () => la,
	ApiGetInvitation: () => ma,
	ApiGetLoginContext: () => xa,
	ApiGetMemberApplicant: () => Ta,
	ApiGetOrganization: () => Qi,
	ApiGetPartner: () => Wa,
	ApiGetPartnerApplicant: () => za,
	ApiGetPasswordInvalidationPlan: () => Ja,
	ApiGetPlan: () => Za,
	ApiGetPolicy: () => eo,
	ApiGetProviderUser: () => Mr,
	ApiGetRole: () => $i,
	ApiGetRoleSecurityDescriptor: () => wo,
	ApiGetSecurityDescriptor: () => Do,
	ApiGetSupportAccountProhibition: () => Fi,
	ApiGetSupportAccountReason: () => Bi,
	ApiGetUser: () => ea,
	ApiGetWebhook: () => Bo,
	ApiPostActivationTicket: () => Er,
	ApiPostDomain: () => fi,
	ApiPostEsaLicense: () => aa,
	ApiPostFeatureGrant: () => ca,
	ApiPostInvitation: () => pa,
	ApiPostOrganization: () => Ma,
	ApiPostPartnerApplicant: () => Ra,
	ApiPostPlan: () => Xa,
	ApiPostRole: () => So,
	ApiPostSecurityDescriptor: () => Eo,
	ApiPostUser: () => Po,
	ApiPostWebhook: () => zo,
	ApiPutDefaultRole: () => ai,
	ApiPutDomain: () => mi,
	ApiPutInvitation: () => ha,
	ApiPutOrganization: () => Na,
	ApiPutPlan: () => Qa,
	ApiPutProviderUser: () => ro,
	ApiPutRole: () => Co,
	ApiPutSecurityDescriptor: () => Oo,
	ApiPutUser: () => Fo,
	ApiPutWebhook: () => Vo,
	CheckCollaboratorInvitationResponse: () => Kr,
	CheckDomainInvitationResponse: () => ui,
	CollaboratorTeamWithCorporation: () => Fr,
	CreateActivationTicketResponse: () => Dr,
	CreateCollaboratorInvitationActivationRequest: () => Wr,
	CreateCollaboratorInvitationActivationResponse: () => Gr,
	CreateCollaboratorInvitationRequest: () => Hr,
	CreateCollaboratorPasswordChangeTicketRequest: () => Jr,
	CreateCollaboratorPasswordChangeTicketResponse: () => Yr,
	CreateDomainInvitationActivationRequest: () => ci,
	CreateDomainInvitationActivationResponse: () => li,
	CreateDomainInvitationRequest: () => oi,
	CreateEmailChangeTicketRequest: () => ta,
	CreateInitialDataRequest: () => da,
	CreateInitialDataResponse: () => fa,
	CreateInvitationActivationResponse: () => ga,
	CreateMemberApplicantApprovalRequest: () => Ea,
	CreateMemberApplicantApprovalResponse: () => Da,
	CreateMemberApplicantCancellationRequest: () => Oa,
	CreateMemberApplicantRequest: () => wa,
	CreateMfaEnrollmentTicketRequest: () => ka,
	CreateMfaEnrollmentTicketResponse: () => Aa,
	CreatePartnerApplicantApprovalRequest: () => Ba,
	CreatePartnerApplicantCancellationRequest: () => Va,
	CreatePartnerApplicantRejectionRequest: () => Ha,
	CreatePasswordChangeTicketRequest: () => Ga,
	CreatePasswordChangeTicketResponse: () => Ka,
	CreateProviderUserAuthenticationMethodSyncResponse: () => io,
	CreateProviderUserRequest: () => no,
	CreateSupportAccountReasonRequest: () => zi,
	CreateSupportAccountRequest: () => Hi,
	CreateSupportAccountResponse: () => Ui,
	CreateVerificationEmailJobRequest: () => ra,
	CurrentUserProfile: () => Ar,
	Customer: () => Zr,
	DeleteCollaboratorTeamMemberResponse: () => Rr,
	DeleteM2MTokenCacheRequest: () => Sa,
	DeleteProviderUserAuthenticationMethodResponse: () => so,
	DeleteProviderUserAuthenticationMethodsResponse: () => ao,
	DeleteProviderUserLockoutsResponse: () => uo,
	DomainFeatureGrantsResponse: () => gi,
	DomainLicenses: () => yi,
	ErrorResponse: () => Uo,
	GetAdminCustomerProfileResponse: () => jr,
	GetCollaboratorTeamInvitationsResponse: () => Ir,
	GetCollaboratorTeamMembersResponse: () => Lr,
	GetCustomerContractsResponse: () => Qr,
	GetCustomerProfileResponse: () => ei,
	GetCustomerSubscriptionsResponse: () => ti,
	GetDefaultRolesResponse: () => ri,
	GetDomainFeatureGrantsResponse: () => hi,
	GetDomainInvitationsResponse: () => vi,
	GetDomainMemberApplicantsResponse: () => bi,
	GetDomainMemoResponse: () => Si,
	GetDomainMfaStateResponse: () => wi,
	GetDomainOperationHistoriesListResponse: () => Ei,
	GetDomainOperationHistoryFacetsResponse: () => Di,
	GetDomainOperationHistorySettingsResponse: () => Oi,
	GetDomainOperationHistoryWeekResponse: () => Ai,
	GetDomainOperationHistoryWeeksResponse: () => ki,
	GetDomainOrganizationsResponse: () => ji,
	GetDomainPlanSummariesResponse: () => Mi,
	GetDomainPlansResponse: () => Ni,
	GetDomainRolesResponse: () => Pi,
	GetDomainSupportAccountProhibitionResponse: () => Ii,
	GetDomainSupportAccountReasonsResponse: () => Ri,
	GetDomainSupportAccountsResponse: () => Vi,
	GetDomainTakkenLicenseResponse: () => Gi,
	GetDomainUserAuthenticationMethodsResponse: () => Xi,
	GetDomainUserNotificationsResponse: () => Zi,
	GetDomainUsersResponse: () => Yi,
	GetEsaLicensesResponse: () => ia,
	GetFeatureGrantsResponse: () => sa,
	GetInvitingDomainResponse: () => _a,
	GetLegacyAccountsResponse: () => va,
	GetLegacyDomainsResponse: () => ya,
	GetLegacyOrganizationsResponse: () => ba,
	GetMemberApplicantsResponse: () => Ca,
	GetOrganizationUserNotificationsResponse: () => Ia,
	GetPhoneVerificationTicketsResponse: () => Ya,
	GetPoliciesResponse: () => $a,
	GetProviderUserAuthenticationMethodsResponse: () => oo,
	GetProviderUserEboneOrganizationsResponse: () => lo,
	GetProviderUserLockoutsResponse: () => fo,
	GetProviderUserLoginPolicyResponse: () => po,
	GetProviderUserMemberApplicantsResponse: () => ho,
	GetProviderUserMfaStateResponse: () => _o,
	GetSecurityDescriptorsResponse: () => To,
	GetSupportAccountsResponse: () => jo,
	GetWebhooksResponse: () => Ro,
	PasswordInvalidationPlansResponse: () => qa,
	ProviderUserBlockResponse: () => co,
	PutDomainFeatureGrantRequest: () => _i,
	PutDomainMemoRequest: () => Ci,
	PutSupportAccountProhibitionRequest: () => Li,
	SearchCollaboratorTeamsResponse: () => Pr,
	SearchCollaboratorsResponse: () => Vr,
	SearchDomainsResponse: () => di,
	SearchOrganizationPartnerApplicantsResponse: () => Pa,
	SearchOrganizationPartnersResponse: () => Fa,
	SearchOrganizationsResponse: () => ja,
	SearchPartnerApplicantsResponse: () => La,
	SearchPartnersResponse: () => Ua,
	SearchProviderUserPartnerOrganizationGuidsResponse: () => vo,
	SearchProviderUsersResponse: () => to,
	SearchPublicDomainsResponse: () => yo,
	SearchPublicOrganizationsResponse: () => bo,
	SearchRolesResponse: () => xo,
	SearchUserPartnersResponse: () => Lo,
	SearchUsersResponse: () => No,
	SignUpProviderUserRequest: () => ko,
	SignUpProviderUserResponse: () => Ao,
	SupportAccountPasswordReset: () => Wi,
	SyncAuth0EventRequest: () => Nr,
	SyncCustomerRequest: () => ni,
	TakkenData: () => Mo,
	TriggerWebhookRequest: () => Ho,
	UpdateCollaboratorTeamMemberRequest: () => zr,
	UpdateCollaboratorTeamMemberResponse: () => Br,
	UpdateDomainMfaStateRequest: () => Ti,
	UpdateDomainTakkenLicenseVerificationRequest: () => qi,
	UpdateDomainTakkenLicenseVerificationResponse: () => Ji,
	UpdateDomainTakkenLicensesRequest: () => Ki,
	UpdateFeatureGrantRequest: () => ua,
	UpdateLoginTimeResponse: () => mo,
	UserMfaExemptionResponse: () => Io
}), Er = D({ customerId: w().int() }).passthrough(), Dr = D({
	activationTicket: D({
		activationTicketUid: C(),
		createdAt: C().datetime({ offset: !0 }),
		customerId: w().int(),
		hashedToken: E(w().int()),
		modifiedAt: C().datetime({ offset: !0 })
	}).passthrough(),
	activationUrl: C()
}).passthrough(), Or = D({
	activationTicketUid: C(),
	createdAt: C().datetime({ offset: !0 }),
	customerId: w().int(),
	hashedToken: E(w().int()),
	modifiedAt: C().datetime({ offset: !0 })
}).passthrough(), kr = D({
	name: C(),
	providerUserUid: C(),
	token: C()
}).passthrough(), Ar = D({
	denwaList: E(D({
		denwaNumber: C(),
		denwaNumberShubetsu: C()
	}).passthrough()),
	domain: D({
		denwaList: E(D({
			denwaNumber: C(),
			denwaNumberShubetsu: C()
		}).passthrough()),
		domainUid: C(),
		grantedFeatures: k(E(C())),
		licenseNumber: C().nullish(),
		licenseUpdateCount: C().nullish(),
		licensorName: C().nullish(),
		logoImageUrl: C().nullish(),
		name: C()
	}).passthrough().nullish(),
	email: C(),
	emailModifiedAt: C().datetime({ offset: !0 }),
	emailVerified: T(),
	isAdmin: T().nullish(),
	name: C().nullish(),
	organization: D({
		businessName: C().nullish(),
		denwaList: E(D({
			denwaNumber: C(),
			denwaNumberShubetsu: C()
		}).passthrough()),
		jusho: D({
			address: C(),
			gaikuGoto: C().nullish(),
			nokoriJusho: C().nullish(),
			zipCode: C()
		}).passthrough().nullish(),
		name: C(),
		organizationUid: C()
	}).passthrough().nullish(),
	providerUserUid: C(),
	publicName: C().nullish(),
	userUid: C().nullish()
}).passthrough(), jr = D({
	address1: C().nullish(),
	address2: C().nullish(),
	billingContact: D({
		address1: C().nullish(),
		address2: C().nullish(),
		city: C().nullish(),
		email: C().nullish(),
		firstName: C().nullish(),
		id: C(),
		lastName: C().nullish(),
		prefecture: C().nullish(),
		tel: C().nullish(),
		zipCode: C().nullish()
	}).passthrough(),
	billingDestinations: E(D({
		accountName: C().nullish(),
		additionalMailAddresses: E(C()),
		contactName: C().nullish(),
		invoiceDelivery: D({
			email: T().nullable(),
			print: T().nullable()
		}).partial().passthrough(),
		invoiceMailAddress: C().nullish(),
		name: C().nullish(),
		paymentMethod: C().nullish(),
		storeName: C().nullish(),
		type: C()
	}).passthrough()),
	city: C().nullish(),
	documentDisplayName: C().nullish(),
	invoiceDelivery: D({
		additionalEmailAddresses: E(C()),
		email: T().nullish(),
		print: T().nullish()
	}).passthrough(),
	notificationMailAddress: C().nullish(),
	organizations: E(D({
		address1: C().nullable(),
		address2: C().nullable(),
		city: C().nullable(),
		documentDisplayName: C().nullable(),
		name: C().nullable(),
		notificationMailAddress: C().nullable(),
		organizationUid: C().nullable(),
		prefecture: C().nullable(),
		tel: C().nullable(),
		zipCode: C().nullable()
	}).partial().passthrough()),
	paymentMethod: C().nullish(),
	prefecture: C().nullish(),
	primaryContact: D({
		address1: C().nullish(),
		address2: C().nullish(),
		city: C().nullish(),
		email: C().nullish(),
		firstName: C().nullish(),
		id: C(),
		lastName: C().nullish(),
		prefecture: C().nullish(),
		tel: C().nullish(),
		zipCode: C().nullish()
	}).passthrough(),
	representativeName: C().nullish(),
	takkenLicense: D({
		licensor: C().nullable(),
		number: C().nullable(),
		updateCount: C().nullable()
	}).partial().passthrough(),
	tel: C().nullish(),
	zipCode: C().nullish()
}).passthrough(), Mr = D({
	createdAt: C().datetime({ offset: !0 }),
	currentUserUid: C().nullish(),
	defaultUserUid: C().nullish(),
	ebone: D({
		domainGuid: C(),
		domainRoleGuid: C(),
		enableEntryFeature: T(),
		organizationGuids: E(C()),
		userGuid: C()
	}).passthrough().nullish(),
	email: C(),
	emailModifiedAt: C().datetime({ offset: !0 }),
	emailVerified: T(),
	isAgreeTerms: T(),
	modifiedAt: C().datetime({ offset: !0 }),
	providerUserUid: C(),
	users: E(D({
		createdAt: C().datetime({ offset: !0 }),
		defaultOrganizationUid: C().nullish(),
		denwaList: E(D({
			denwaNumber: C(),
			denwaNumberShubetsu: C()
		}).passthrough()),
		domainUid: C(),
		ebone: D({
			domainGuid: C(),
			domainRoleGuid: C(),
			enableEntryFeature: T(),
			organizationGuids: E(C()),
			userGuid: C()
		}).passthrough().nullish(),
		email: C().nullish(),
		emailNotify: D({
			createdAt: C().datetime({ offset: !0 }),
			enabled: T(),
			enabledMessenger: T().nullish(),
			modifiedAt: C().datetime({ offset: !0 })
		}).passthrough(),
		emailVerified: T().nullish(),
		enableEntryFeature: T(),
		enableIntegrationFeature: T(),
		enableMfa: T(),
		grantedFeatures: k(E(C())),
		ipAddressList: E(C()),
		ipRestrictionEnforced: T(),
		lastLoginDatetime: C().datetime({ offset: !0 }).nullish(),
		mfaExemptedUntil: C().datetime({ offset: !0 }).nullish(),
		modifiedAt: C().datetime({ offset: !0 }),
		name: C(),
		organizationUids: E(C()),
		providerUserUid: C().nullish(),
		publicName: C().nullish(),
		role: D({
			comment: C().nullish(),
			createdAt: C().datetime({ offset: !0 }),
			description: C().nullish(),
			domainUid: C(),
			ebone: D({
				domainGuid: C(),
				domainRoleGuid: C()
			}).passthrough().nullish(),
			isAdmin: T(),
			modifiedAt: C().datetime({ offset: !0 }),
			name: C(),
			policy: k(D({
				key: C(),
				scope: j([
					"None",
					"User",
					"Organization",
					"OrganizationGroup",
					"Domain"
				])
			}).passthrough()),
			readonly: T(),
			roleUid: C(),
			securityDescriptors: E(D({
				audience: j([
					"*",
					"ebone",
					"esa"
				]),
				privilege: j([
					"ALL",
					"CREATE",
					"UPDATE",
					"READ",
					"DELETE",
					"APPROVE",
					"REJECT",
					"MERGE",
					"ACTIVATE"
				]),
				resource: j([
					"*",
					"domains",
					"organizations",
					"users",
					"files",
					"invitations",
					"member_applicants",
					"plans",
					"roles",
					"partner_applicants",
					"partners"
				]),
				scope: j([
					"None",
					"User",
					"Organization",
					"OrganizationGroup",
					"Domain"
				])
			}).passthrough())
		}).passthrough(),
		roleUid: C(),
		userUid: C()
	}).passthrough())
}).passthrough(), Nr = D({
	data: D({}).partial().passthrough(),
	time: C().datetime({ offset: !0 }),
	type: C()
}).passthrough(), Pr = D({
	items: E(D({
		collaboratorTeamUid: C(),
		corporateNumber: C(),
		createdAt: C().datetime({ offset: !0 }),
		memberCount: w().int(),
		modifiedAt: C().datetime({ offset: !0 }),
		name: C(),
		pendingInvitationCount: w().int()
	}).passthrough()),
	itemsPerPage: w().int(),
	startIndex: w().int(),
	totalCounts: w().int()
}).passthrough(), Fr = D({
	collaboratorTeamUid: C(),
	corporateNumber: C(),
	corporation: D({
		cityName: C(),
		closeDate: C().nullish(),
		name: C(),
		postCode: C(),
		prefectureName: C(),
		streetNumber: C()
	}).passthrough().nullish(),
	createdAt: C().datetime({ offset: !0 }),
	modifiedAt: C().datetime({ offset: !0 }),
	name: C()
}).passthrough(), Ir = D({
	items: E(D({
		collaboratorInvitationUid: C(),
		createdAt: C().datetime({ offset: !0 }),
		displayName: C(),
		email: C(),
		expires: C().datetime({ offset: !0 }),
		invitedByType: C(),
		invitingDomainName: C().nullish(),
		invitingDomainUid: C().nullish(),
		invitingOrganizationName: C().nullish(),
		status: C()
	}).passthrough()),
	itemsPerPage: w().int(),
	startIndex: w().int(),
	totalCounts: w().int()
}).passthrough(), Lr = D({
	items: E(D({
		collaboratorTeamMemberUid: C(),
		collaboratorUid: C(),
		displayName: C(),
		email: C(),
		role: C()
	}).passthrough()),
	itemsPerPage: w().int(),
	startIndex: w().int(),
	totalCounts: w().int()
}).passthrough(), Rr = D({
	collaboratorTeamMemberUid: C(),
	collaboratorUid: C(),
	displayName: C(),
	email: C(),
	role: C()
}).passthrough(), zr = D({
	displayName: C(),
	role: C().nullish()
}).passthrough(), Br = D({
	collaboratorTeamMemberUid: C(),
	collaboratorUid: C(),
	displayName: C(),
	email: C(),
	role: C()
}).passthrough(), Vr = D({
	items: E(D({
		collaboratorUid: C(),
		createdAt: C().datetime({ offset: !0 }),
		displayName: C(),
		email: C(),
		modifiedAt: C().datetime({ offset: !0 }),
		providerUserUid: C(),
		teams: E(D({
			collaboratorTeamMemberUid: C(),
			collaboratorTeamUid: C(),
			name: C(),
			role: C()
		}).passthrough()),
		termsAccepted: T(),
		termsAcceptedAt: C().datetime({ offset: !0 }).nullish()
	}).passthrough()),
	itemsPerPage: w().int(),
	startIndex: w().int(),
	totalCounts: w().int()
}).passthrough(), Hr = D({
	displayName: C(),
	email: C(),
	invitedByDomainGuid: C().nullish(),
	invitedByOrganizationGuid: C().nullish(),
	team: D({
		corporateNumber: C(),
		name: C()
	}).passthrough().nullish()
}).passthrough(), Ur = D({
	collaboratorInvitationUid: C(),
	collaboratorTeamUid: C().nullish(),
	collaboratorUid: C().nullish(),
	corporateNumber: C().nullish(),
	createdAt: C().datetime({ offset: !0 }),
	displayName: C(),
	email: C(),
	expires: C().datetime({ offset: !0 }),
	invitedByDomainUid: C().nullish(),
	invitedByOrganizationUid: C().nullish(),
	invitedByType: C(),
	modifiedAt: C().datetime({ offset: !0 }),
	status: C(),
	team: D({
		collaboratorTeamUid: C(),
		corporateNumber: C(),
		createdAt: C().datetime({ offset: !0 }),
		modifiedAt: C().datetime({ offset: !0 }),
		name: C()
	}).passthrough().nullish(),
	teamName: C().nullish()
}).passthrough(), Wr = D({
	clientId: C().nullable(),
	displayName: C().nullable()
}).partial().passthrough(), Gr = D({ callbackUrl: C() }).passthrough(), Kr = D({
	accountCreatedOnAcceptance: T().nullish(),
	displayName: C().nullish(),
	displayNameRequired: T().nullish(),
	email: C().nullish(),
	hasAccount: T().nullish(),
	invitingDomainName: C().nullish(),
	invitingOrganizationName: C().nullish(),
	passwordSetupRequired: T().nullish(),
	status: j(["pending", "accepted"]),
	team: D({ name: C() }).passthrough().nullish()
}).passthrough(), qr = D({
	collaboratorUid: C(),
	displayName: C(),
	email: C(),
	teamMembers: E(D({
		collaboratorTeamMemberUid: C(),
		collaboratorTeamUid: C(),
		name: C(),
		role: C()
	}).passthrough()),
	termsAccepted: T()
}).passthrough(), Jr = D({ clientId: C() }).passthrough(), Yr = D({ url: C() }).passthrough(), Xr = D({
	collaboratorUid: C(),
	createdAt: C().datetime({ offset: !0 }),
	displayName: C(),
	email: C(),
	modifiedAt: C().datetime({ offset: !0 }),
	providerUserUid: C(),
	termsAccepted: T(),
	termsAcceptedAt: C().datetime({ offset: !0 }).nullish()
}).passthrough(), Zr = D({
	customerId: w().int(),
	domainName: C().nullish(),
	email: C().nullish(),
	personName: C().nullish()
}).passthrough(), Qr = D({
	contracts: E(D({
		planName: C().nullish(),
		quantities: E(D({
			quantity: w(),
			unit: C()
		}).passthrough()),
		serviceName: C().nullish(),
		usageCharges: E(D({
			name: C().nullable(),
			unit: C().nullable()
		}).partial().passthrough())
	}).passthrough()),
	organizations: E(D({
		contracts: E(D({
			planName: C().nullish(),
			quantities: E(D({
				quantity: w(),
				unit: C()
			}).passthrough()),
			serviceName: C().nullish(),
			usageCharges: E(D({
				name: C().nullable(),
				unit: C().nullable()
			}).partial().passthrough())
		}).passthrough()),
		organizationUid: C().nullish()
	}).passthrough())
}).passthrough(), $r = D({
	activated: T(),
	createdAt: C().datetime({ offset: !0 }),
	customerId: w().int(),
	modifiedAt: C().datetime({ offset: !0 })
}).passthrough(), ei = D({
	address1: C().nullish(),
	address2: C().nullish(),
	billingContact: D({
		address1: C().nullish(),
		address2: C().nullish(),
		city: C().nullish(),
		email: C().nullish(),
		firstName: C().nullish(),
		id: C(),
		lastName: C().nullish(),
		prefecture: C().nullish(),
		tel: C().nullish(),
		zipCode: C().nullish()
	}).passthrough(),
	billingDestinations: E(D({
		additionalMailAddresses: E(C()).nullish(),
		contactName: C().nullish(),
		invoiceDelivery: D({
			email: T().nullable(),
			print: T().nullable()
		}).partial().passthrough().nullish(),
		invoiceMailAddress: C().nullish(),
		name: C().nullish(),
		paymentMethod: C().nullish(),
		storeName: C().nullish(),
		type: C()
	}).passthrough()),
	city: C().nullish(),
	documentDisplayName: C().nullish(),
	invoiceDelivery: D({
		additionalEmailAddresses: E(C()),
		email: T().nullish(),
		print: T().nullish()
	}).passthrough(),
	notificationMailAddress: C().nullish(),
	organizations: E(D({
		address1: C().nullable(),
		address2: C().nullable(),
		city: C().nullable(),
		documentDisplayName: C().nullable(),
		name: C().nullable(),
		notificationMailAddress: C().nullable(),
		organizationUid: C().nullable(),
		prefecture: C().nullable(),
		tel: C().nullable(),
		zipCode: C().nullable()
	}).partial().passthrough()),
	paymentMethod: C().nullish(),
	prefecture: C().nullish(),
	primaryContact: D({
		address1: C().nullish(),
		address2: C().nullish(),
		city: C().nullish(),
		email: C().nullish(),
		firstName: C().nullish(),
		id: C(),
		lastName: C().nullish(),
		prefecture: C().nullish(),
		tel: C().nullish(),
		zipCode: C().nullish()
	}).passthrough(),
	representativeName: C().nullish(),
	takkenLicense: D({
		licensor: C().nullable(),
		number: C().nullable(),
		updateCount: C().nullable()
	}).partial().passthrough(),
	tel: C().nullish(),
	zipCode: C().nullish()
}).passthrough(), ti = D({ items: E(D({
	accountName: C(),
	customerId: w().int(),
	id: C(),
	plans: E(D({
		id: C(),
		items: E(D({
			chargeModel: C(),
			chargeType: C(),
			endDate: C().nullish(),
			id: C(),
			name: C(),
			price: w().int(),
			quantity: w().int(),
			salesPrice: w().int(),
			startDate: C().nullish(),
			unitOfMeasure: C().nullish()
		}).passthrough()),
		name: C(),
		productName: C(),
		removed: T()
	}).passthrough()),
	status: C()
}).passthrough()) }).passthrough(), ni = D({
	after: D({
		customer_id: C(),
		enable: T(),
		licenses: E(D({
			end_date: C().datetime({ offset: !0 }),
			name: C(),
			start_date: C().datetime({ offset: !0 }),
			status_code: w().int()
		}).passthrough()),
		type_code: w().int()
	}).passthrough().nullish(),
	before: D({
		customer_id: C(),
		enable: T(),
		licenses: E(D({
			end_date: C().datetime({ offset: !0 }),
			name: C(),
			start_date: C().datetime({ offset: !0 }),
			status_code: w().int()
		}).passthrough()),
		type_code: w().int()
	}).passthrough().nullish(),
	event: C()
}).passthrough(), ri = D({
	items: E(D({
		comment: C().nullish(),
		createdAt: C().datetime({ offset: !0 }),
		defaultRoleUid: C(),
		description: C().nullish(),
		isAdmin: T(),
		modifiedAt: C().datetime({ offset: !0 }),
		name: C(),
		policy: k(D({
			key: C(),
			scope: j([
				"None",
				"User",
				"Organization",
				"OrganizationGroup",
				"Domain"
			])
		}).passthrough()),
		securityDescriptors: E(D({
			audience: j([
				"*",
				"ebone",
				"esa"
			]),
			privilege: j([
				"ALL",
				"CREATE",
				"UPDATE",
				"READ",
				"DELETE",
				"APPROVE",
				"REJECT",
				"MERGE",
				"ACTIVATE"
			]),
			resource: j([
				"*",
				"domains",
				"organizations",
				"users",
				"files",
				"invitations",
				"member_applicants",
				"plans",
				"roles",
				"partner_applicants",
				"partners"
			]),
			scope: j([
				"None",
				"User",
				"Organization",
				"OrganizationGroup",
				"Domain"
			])
		}).passthrough())
	}).passthrough()),
	itemsPerPage: w().int(),
	startIndex: w().int(),
	totalCounts: w().int()
}).passthrough(), ii = D({
	comment: C().nullish(),
	createdAt: C().datetime({ offset: !0 }),
	defaultRoleUid: C(),
	description: C().nullish(),
	isAdmin: T(),
	modifiedAt: C().datetime({ offset: !0 }),
	name: C(),
	policy: k(D({
		key: C(),
		scope: j([
			"None",
			"User",
			"Organization",
			"OrganizationGroup",
			"Domain"
		])
	}).passthrough()),
	securityDescriptors: E(D({
		audience: j([
			"*",
			"ebone",
			"esa"
		]),
		privilege: j([
			"ALL",
			"CREATE",
			"UPDATE",
			"READ",
			"DELETE",
			"APPROVE",
			"REJECT",
			"MERGE",
			"ACTIVATE"
		]),
		resource: j([
			"*",
			"domains",
			"organizations",
			"users",
			"files",
			"invitations",
			"member_applicants",
			"plans",
			"roles",
			"partner_applicants",
			"partners"
		]),
		scope: j([
			"None",
			"User",
			"Organization",
			"OrganizationGroup",
			"Domain"
		])
	}).passthrough())
}).passthrough(), ai = D({
	comment: C().nullable(),
	description: C().nullable(),
	isAdmin: T().nullable(),
	name: C().nullable(),
	policy: k(D({ scope: j([
		"None",
		"User",
		"Organization",
		"OrganizationGroup",
		"Domain"
	]) }).passthrough()).nullable(),
	securityDescriptors: E(D({
		audience: j([
			"*",
			"ebone",
			"esa"
		]),
		privilege: j([
			"ALL",
			"CREATE",
			"UPDATE",
			"READ",
			"DELETE",
			"APPROVE",
			"REJECT",
			"MERGE",
			"ACTIVATE"
		]),
		resource: j([
			"*",
			"domains",
			"organizations",
			"users",
			"files",
			"invitations",
			"member_applicants",
			"plans",
			"roles",
			"partner_applicants",
			"partners"
		]),
		scope: j([
			"None",
			"User",
			"Organization",
			"OrganizationGroup",
			"Domain"
		])
	}).passthrough()).nullable()
}).partial().passthrough(), oi = D({
	corporateNumber: C(),
	displayName: C(),
	domainName: C(),
	email: C(),
	invitedByDomainGuid: C().nullish(),
	invitedByOrganizationGuid: C().nullish()
}).passthrough(), si = D({
	corporateNumber: C(),
	createdAt: C().datetime({ offset: !0 }),
	displayName: C(),
	domainInvitationUid: C(),
	domainName: C(),
	domainUid: C().nullish(),
	email: C(),
	expires: C().datetime({ offset: !0 }),
	invitedByDomainUid: C().nullish(),
	invitedByOrganizationUid: C().nullish(),
	modifiedAt: C().datetime({ offset: !0 }),
	status: C(),
	userUid: C().nullish()
}).passthrough(), ci = D({
	clientId: C().nullable(),
	displayName: C().nullable()
}).partial().passthrough(), li = D({ callbackUrl: C() }).passthrough(), ui = D({
	accountCreatedOnAcceptance: T().nullish(),
	displayName: C().nullish(),
	displayNameRequired: T().nullish(),
	email: C().nullish(),
	hasAccount: T().nullish(),
	invitingDomainName: C().nullish(),
	invitingOrganizationName: C().nullish(),
	joiningDomainName: C().nullish(),
	passwordSetupRequired: T().nullish(),
	status: j(["pending", "accepted"])
}).passthrough(), di = D({
	items: E(D({
		autoApproval: D({
			createdAt: C().datetime({ offset: !0 }),
			emailDomains: E(C()),
			enabled: T(),
			modifiedAt: C().datetime({ offset: !0 })
		}).passthrough(),
		corporateNumber: C().nullish(),
		createdAt: C().datetime({ offset: !0 }),
		denwaList: E(D({
			denwaNumber: C(),
			denwaNumberShubetsu: C()
		}).passthrough()),
		domainUid: C(),
		ebone: D({
			customerId: w().int().nullish(),
			domainGuid: C(),
			enableEntryFeature: T(),
			synced: T()
		}).passthrough().nullish(),
		enableEntryFeature: T(),
		enableIntegrationFeature: T(),
		enablePasskey: T(),
		enableTotp: T(),
		grantedFeatures: k(E(C())),
		isPhoneVerified: T(),
		licenses: E(D({
			endDateTime: C().datetime({ offset: !0 }),
			name: A("Mfa"),
			startDateTime: C().datetime({ offset: !0 })
		}).passthrough()),
		logoImage: D({
			fileUid: C(),
			url: C()
		}).passthrough().nullish(),
		memo: D({
			content: C(),
			createdAt: C().datetime({ offset: !0 }),
			domainUid: C(),
			modifiedAt: C().datetime({ offset: !0 }),
			registrantEmail: C()
		}).passthrough().nullish(),
		mfaState: j([
			"disabled",
			"enabled",
			"enforced"
		]),
		modifiedAt: C().datetime({ offset: !0 }),
		name: C(),
		nativeAppIpRestrictionEnforced: T(),
		phoneVerification: D({
			createdAt: C().datetime({ offset: !0 }),
			enabled: T(),
			modifiedAt: C().datetime({ offset: !0 })
		}).passthrough(),
		takkenLicense: D({
			existence: D({
				modifiedAt: C().datetime({ offset: !0 }).nullish(),
				state: j([
					"unchecked",
					"exists",
					"missing",
					"invalid"
				])
			}).passthrough().nullish(),
			licensor: C(),
			number: C(),
			updateCount: C(),
			verification: D({
				modifiedAt: C().datetime({ offset: !0 }).nullish(),
				state: j([
					"unchecked",
					"phone_verified",
					"admin_verified",
					"admin_denied"
				])
			}).passthrough().nullish()
		}).passthrough().nullish(),
		takkenLicenseImage: D({
			createdAt: C().datetime({ offset: !0 }),
			fileUid: C(),
			modifiedAt: C().datetime({ offset: !0 }),
			url: C()
		}).passthrough().nullish(),
		webAppIpRestrictionEnforced: T()
	}).passthrough()),
	itemsPerPage: w().int(),
	startIndex: w().int(),
	totalCounts: w().int()
}).passthrough(), fi = D({
	autoApproval: D({
		emailDomains: E(C()),
		enabled: T()
	}).passthrough(),
	corporateNumber: C().nullish(),
	denwaList: E(D({
		denwaNumber: C(),
		denwaNumberShubetsu: C()
	}).passthrough()),
	ebone: D({
		customerId: w().int().nullish(),
		domainGuid: C(),
		synced: T()
	}).passthrough().nullish(),
	enableEntryFeature: T(),
	enableIntegrationFeature: T(),
	isPhoneVerified: T(),
	licenses: E(D({
		endDateTime: C().datetime({ offset: !0 }),
		name: A("Mfa"),
		startDateTime: C().datetime({ offset: !0 })
	}).passthrough()),
	logoImage: D({ fileUid: C() }).passthrough().nullish(),
	name: C(),
	nativeAppIpRestrictionEnforced: T(),
	phoneVerification: D({ enabled: T() }).passthrough(),
	takkenLicense: D({
		licensor: C(),
		number: C(),
		updateCount: C()
	}).passthrough().nullish(),
	takkenLicenseImage: D({ fileUid: C() }).passthrough().nullish(),
	webAppIpRestrictionEnforced: T()
}).passthrough(), pi = D({
	autoApproval: D({
		createdAt: C().datetime({ offset: !0 }),
		emailDomains: E(C()),
		enabled: T(),
		modifiedAt: C().datetime({ offset: !0 })
	}).passthrough(),
	corporateNumber: C().nullish(),
	createdAt: C().datetime({ offset: !0 }),
	denwaList: E(D({
		denwaNumber: C(),
		denwaNumberShubetsu: C()
	}).passthrough()),
	domainUid: C(),
	ebone: D({
		customerId: w().int().nullish(),
		domainGuid: C(),
		enableEntryFeature: T(),
		synced: T()
	}).passthrough().nullish(),
	enableEntryFeature: T(),
	enableIntegrationFeature: T(),
	enablePasskey: T(),
	enableTotp: T(),
	grantedFeatures: k(E(C())),
	isPhoneVerified: T(),
	licenses: E(D({
		endDateTime: C().datetime({ offset: !0 }),
		name: A("Mfa"),
		startDateTime: C().datetime({ offset: !0 })
	}).passthrough()),
	logoImage: D({
		fileUid: C(),
		url: C()
	}).passthrough().nullish(),
	mfaState: j([
		"disabled",
		"enabled",
		"enforced"
	]),
	modifiedAt: C().datetime({ offset: !0 }),
	name: C(),
	nativeAppIpRestrictionEnforced: T(),
	phoneVerification: D({
		createdAt: C().datetime({ offset: !0 }),
		enabled: T(),
		modifiedAt: C().datetime({ offset: !0 })
	}).passthrough(),
	takkenLicense: D({
		licensor: C(),
		number: C(),
		updateCount: C()
	}).passthrough().nullish(),
	takkenLicenseImage: D({
		createdAt: C().datetime({ offset: !0 }),
		fileUid: C(),
		modifiedAt: C().datetime({ offset: !0 }),
		url: C()
	}).passthrough().nullish(),
	webAppIpRestrictionEnforced: T()
}).passthrough(), mi = D({
	autoApproval: D({
		emailDomains: E(C()),
		enabled: T()
	}).passthrough().nullable(),
	corporateNumber: C().nullable(),
	denwaList: E(D({
		denwaNumber: C(),
		denwaNumberShubetsu: C()
	}).passthrough()).nullable(),
	ebone: D({
		customerId: w().int().nullish(),
		domainGuid: C(),
		synced: T()
	}).passthrough().nullable(),
	enableEntryFeature: T().nullable(),
	enableIntegrationFeature: T().nullable(),
	isPhoneVerified: T().nullable(),
	licenses: E(D({
		endDateTime: C().datetime({ offset: !0 }),
		name: A("Mfa"),
		startDateTime: C().datetime({ offset: !0 })
	}).passthrough()).nullable(),
	logoImage: D({ fileUid: C() }).passthrough().nullable(),
	name: C().nullable(),
	nativeAppIpRestrictionEnforced: T().nullable(),
	phoneVerification: D({ enabled: T() }).passthrough().nullable(),
	takkenLicense: D({
		licensor: C(),
		number: C(),
		updateCount: C()
	}).passthrough().nullable(),
	takkenLicenseImage: D({ fileUid: C() }).passthrough().nullable(),
	webAppIpRestrictionEnforced: T().nullable()
}).partial().passthrough(), hi = D({ items: E(D({
	assignment: j([
		"granted",
		"revoked",
		"none"
	]),
	defaultGranted: T(),
	description: C(),
	featureGrantUid: C(),
	granted: T(),
	key: C()
}).passthrough()) }).passthrough(), gi = D({ grantedFeatures: k(E(C())) }).passthrough(), _i = D({ granted: T() }).passthrough(), vi = D({
	items: E(D({
		createdAt: C().datetime({ offset: !0 }),
		defaultOrganizationUid: C(),
		domainUid: C(),
		email: C(),
		expires: C().datetime({ offset: !0 }),
		invitationUid: C(),
		modifiedAt: C().datetime({ offset: !0 }),
		name: C(),
		organizationUids: E(C()),
		roleUid: C()
	}).passthrough()),
	itemsPerPage: w().int(),
	startIndex: w().int(),
	totalCounts: w().int()
}).passthrough(), yi = D({
	company: T(),
	customerId: w().int(),
	domainName: C().nullish(),
	licenses: E(D({
		licenseAttributeMap: D({}).partial().passthrough(),
		licenseName: C()
	}).passthrough())
}).passthrough(), bi = D({
	items: E(D({
		comment: C(),
		createdAt: C().datetime({ offset: !0 }),
		domainName: C(),
		domainUid: C(),
		email: C(),
		memberApplicantUid: C(),
		modifiedAt: C().datetime({ offset: !0 }),
		providerUserUid: C(),
		requestedOrganizationName: C(),
		userName: C()
	}).passthrough()),
	itemsPerPage: w().int(),
	startIndex: w().int(),
	totalCounts: w().int()
}).passthrough(), xi = D({
	content: C(),
	createdAt: C().datetime({ offset: !0 }),
	domainUid: C(),
	modifiedAt: C().datetime({ offset: !0 }),
	registrantEmail: C()
}).passthrough(), Si = D({ memo: D({
	content: C(),
	createdAt: C().datetime({ offset: !0 }),
	domainUid: C(),
	modifiedAt: C().datetime({ offset: !0 }),
	registrantEmail: C()
}).passthrough().nullable() }).partial().passthrough(), Ci = D({ content: C() }).passthrough(), wi = D({
	enableMfa: T(),
	enablePasskey: T(),
	enableTotp: T(),
	enforcedMfa: T(),
	mfaState: j([
		"disabled",
		"enabled",
		"enforced"
	])
}).passthrough(), Ti = D({
	enablePasskey: T().nullish(),
	enableTotp: T().nullish(),
	mfaState: j([
		"disabled",
		"enabled",
		"enforced"
	])
}).passthrough(), Ei = D({
	items: E(D({
		auth0SessionId: C().nullish(),
		clientId: C().nullish(),
		clientName: C().nullish(),
		details: D({
			after: C().nullable(),
			authenticatorName: C().nullable(),
			before: C().nullable(),
			loginMethods: E(j([
				"password",
				"passkey",
				"totp",
				"email_otp"
			])).nullable(),
			prompts: E(C()).nullable(),
			role: C().nullable(),
			trigger: j(["login", "password_reset"]).nullable(),
			userAgent: C().nullable()
		}).partial().passthrough(),
		ip: C().nullish(),
		occurredAt: C().datetime({ offset: !0 }),
		operation: j([
			"login",
			"invitation_created",
			"invitation_resent",
			"invitation_accepted",
			"membership_started",
			"membership_ended",
			"email_changed",
			"password_changed",
			"passkey_registered",
			"passkey_deleted",
			"totp_registered",
			"totp_deleted",
			"login_failed",
			"login_blocked",
			"leaked_password_used"
		]),
		operationHistoryId: w().int(),
		operator: D({
			email: C().nullish(),
			name: C().nullish(),
			organizations: E(D({
				name: C(),
				uid: C()
			}).passthrough()),
			providerUserUid: C().nullish(),
			userUid: C().nullish()
		}).passthrough(),
		target: D({
			email: C().nullish(),
			name: C().nullish(),
			organizations: E(D({
				name: C(),
				uid: C()
			}).passthrough()),
			providerUserUid: C().nullish(),
			userUid: C().nullish()
		}).passthrough(),
		usages: E(D({
			auth0SessionId: C(),
			clientId: C(),
			clientName: C().nullish(),
			firstUsedAt: C().datetime({ offset: !0 }),
			ip: C(),
			lastUsedAt: C().datetime({ offset: !0 }),
			loginOperationHistoryId: w().int(),
			loginUsagePeriodId: w().int()
		}).passthrough())
	}).passthrough()),
	itemsPerPage: w().int(),
	startIndex: w().int(),
	totalCounts: w().int()
}).passthrough(), Di = D({
	ips: E(D({
		count: w().int(),
		value: C()
	}).passthrough()),
	organizations: E(D({
		name: C(),
		uid: C()
	}).passthrough()),
	people: E(D({
		email: C().nullish(),
		name: C().nullish(),
		providerUserUid: C()
	}).passthrough())
}).passthrough(), Oi = D({
	maxSearchDays: w().int(),
	recordingStartedAt: C().datetime({ offset: !0 }),
	serverSearchDays: w().int()
}).passthrough(), ki = D({ items: E(D({ week: C() }).passthrough()) }).passthrough(), Ai = D({
	archive: D({
		loginUsagePeriodsUrl: C().nullable(),
		operationHistoriesUrl: C().nullable()
	}).partial().passthrough(),
	week: C()
}).passthrough(), ji = D({
	items: E(D({
		businessName: C().nullish(),
		createdAt: C().datetime({ offset: !0 }),
		denwaList: E(D({
			denwaNumber: C(),
			denwaNumberShubetsu: C()
		}).passthrough()),
		domainUid: C(),
		ebone: D({
			customerId: w().int().nullish(),
			domainGuid: C(),
			organizationGuid: C()
		}).passthrough().nullish(),
		isPublic: T(),
		jusho: D({
			azaChoume: C().nullish(),
			cityName: C().nullish(),
			gaikuGoto: C().nullish(),
			isDirectInput: T(),
			jushoCode: C(),
			jushoText: C(),
			nokoriJusho: C().nullish(),
			ooazaTsuushou: C().nullish(),
			prefectureName: C().nullish(),
			yubinNumber: C()
		}).passthrough().nullish(),
		kameiDantaiList: E(D({ name: C().nullable() }).partial().passthrough()),
		modifiedAt: C().datetime({ offset: !0 }),
		name: C(),
		organizationExternalCode: C(),
		organizationUid: C(),
		partnerAutoApproval: D({
			createdAt: C().datetime({ offset: !0 }),
			enabled: T(),
			modifiedAt: C().datetime({ offset: !0 })
		}).passthrough(),
		partnerCount: w().int().nullish()
	}).passthrough()),
	itemsPerPage: w().int(),
	startIndex: w().int(),
	totalCounts: w().int()
}).passthrough(), Mi = D({
	items: E(D({
		createdAt: C().datetime({ offset: !0 }),
		data: D({}).partial().passthrough(),
		domainUid: C().nullish(),
		modifiedAt: C().datetime({ offset: !0 }),
		name: C(),
		operationCounts: D({
			failure: w().int(),
			progress: w().int(),
			standby: w().int(),
			success: w().int()
		}).passthrough(),
		planUid: C(),
		state: j([
			"success",
			"failure",
			"progress",
			"standby"
		])
	}).passthrough()),
	itemsPerPage: w().int(),
	startIndex: w().int(),
	totalCounts: w().int()
}).passthrough(), Ni = D({
	items: E(D({
		createdAt: C().datetime({ offset: !0 }),
		data: D({}).partial().passthrough(),
		domainUid: C().nullish(),
		modifiedAt: C().datetime({ offset: !0 }),
		name: C(),
		operations: E(D({
			createdAt: C().datetime({ offset: !0 }),
			data: D({}).partial().passthrough(),
			idx: w().int(),
			modifiedAt: C().datetime({ offset: !0 }),
			operationUid: C(),
			state: j([
				"success",
				"standby",
				"progress"
			])
		}).passthrough()),
		planUid: C(),
		state: j([
			"success",
			"failure",
			"progress",
			"standby"
		])
	}).passthrough()),
	itemsPerPage: w().int(),
	startIndex: w().int(),
	totalCounts: w().int()
}).passthrough(), Pi = D({
	items: E(D({
		comment: C().nullish(),
		createdAt: C().datetime({ offset: !0 }),
		description: C().nullish(),
		domainUid: C(),
		ebone: D({
			domainGuid: C(),
			domainRoleGuid: C()
		}).passthrough().nullish(),
		isAdmin: T(),
		modifiedAt: C().datetime({ offset: !0 }),
		name: C(),
		policy: k(D({
			key: C(),
			scope: j([
				"None",
				"User",
				"Organization",
				"OrganizationGroup",
				"Domain"
			])
		}).passthrough()),
		readonly: T(),
		roleUid: C(),
		securityDescriptors: E(D({
			audience: j([
				"*",
				"ebone",
				"esa"
			]),
			privilege: j([
				"ALL",
				"CREATE",
				"UPDATE",
				"READ",
				"DELETE",
				"APPROVE",
				"REJECT",
				"MERGE",
				"ACTIVATE"
			]),
			resource: j([
				"*",
				"domains",
				"organizations",
				"users",
				"files",
				"invitations",
				"member_applicants",
				"plans",
				"roles",
				"partner_applicants",
				"partners"
			]),
			scope: j([
				"None",
				"User",
				"Organization",
				"OrganizationGroup",
				"Domain"
			])
		}).passthrough())
	}).passthrough()),
	itemsPerPage: w().int(),
	startIndex: w().int(),
	totalCounts: w().int()
}).passthrough(), Fi = D({
	createdAt: C().datetime({ offset: !0 }),
	domainUid: C(),
	modifiedAt: C().datetime({ offset: !0 }),
	reason: C(),
	registrantEmail: C(),
	supportAccountProhibitionUid: C()
}).passthrough(), Ii = D({ supportAccountProhibition: D({
	createdAt: C().datetime({ offset: !0 }),
	domainUid: C(),
	modifiedAt: C().datetime({ offset: !0 }),
	reason: C(),
	registrantEmail: C(),
	supportAccountProhibitionUid: C()
}).passthrough().nullable() }).partial().passthrough(), Li = D({ reason: C() }).passthrough(), Ri = D({ items: E(D({
	allowedOrganizationUids: E(C()),
	allowedRoleUids: E(C()),
	approvalReason: C(),
	approvedOn: C(),
	approver: C(),
	closedAt: C().datetime({ offset: !0 }).nullish(),
	domainUid: C(),
	registrantEmail: C(),
	restrictsOrganizations: T(),
	restrictsRoles: T(),
	supportAccountReasonUid: C()
}).passthrough()) }).passthrough(), zi = D({
	allowedOrganizationUids: E(C()).nullish(),
	allowedRoleUids: E(C()).nullish(),
	approvedOn: C(),
	approver: C(),
	reason: C()
}).passthrough(), Bi = D({
	allowedOrganizationUids: E(C()),
	allowedRoleUids: E(C()),
	approvalReason: C(),
	approvedOn: C(),
	approver: C(),
	closedAt: C().datetime({ offset: !0 }).nullish(),
	domainUid: C(),
	registrantEmail: C(),
	restrictsOrganizations: T(),
	restrictsRoles: T(),
	supportAccountReasonUid: C()
}).passthrough(), Vi = D({ items: E(D({
	customerApproval: D({
		approvedOn: C(),
		approver: C(),
		reason: C()
	}).passthrough().nullish(),
	expiresAt: C().datetime({ offset: !0 }).nullish(),
	issuedByEmail: C().nullish(),
	providerUser: D({
		createdAt: C().datetime({ offset: !0 }),
		currentUserUid: C().nullish(),
		defaultUserUid: C().nullish(),
		ebone: D({
			domainGuid: C(),
			domainRoleGuid: C(),
			enableEntryFeature: T(),
			organizationGuids: E(C()),
			userGuid: C()
		}).passthrough().nullish(),
		email: C(),
		emailModifiedAt: C().datetime({ offset: !0 }),
		emailVerified: T(),
		isAgreeTerms: T(),
		modifiedAt: C().datetime({ offset: !0 }),
		providerUserUid: C(),
		users: E(D({
			createdAt: C().datetime({ offset: !0 }),
			defaultOrganizationUid: C().nullish(),
			denwaList: E(D({
				denwaNumber: C(),
				denwaNumberShubetsu: C()
			}).passthrough()),
			domainUid: C(),
			ebone: D({
				domainGuid: C(),
				domainRoleGuid: C(),
				enableEntryFeature: T(),
				organizationGuids: E(C()),
				userGuid: C()
			}).passthrough().nullish(),
			email: C().nullish(),
			emailNotify: D({
				createdAt: C().datetime({ offset: !0 }),
				enabled: T(),
				enabledMessenger: T().nullish(),
				modifiedAt: C().datetime({ offset: !0 })
			}).passthrough(),
			emailVerified: T().nullish(),
			enableEntryFeature: T(),
			enableIntegrationFeature: T(),
			enableMfa: T(),
			grantedFeatures: k(E(C())),
			ipAddressList: E(C()),
			ipRestrictionEnforced: T(),
			lastLoginDatetime: C().datetime({ offset: !0 }).nullish(),
			mfaExemptedUntil: C().datetime({ offset: !0 }).nullish(),
			modifiedAt: C().datetime({ offset: !0 }),
			name: C(),
			organizationUids: E(C()),
			providerUserUid: C().nullish(),
			publicName: C().nullish(),
			role: D({
				comment: C().nullish(),
				createdAt: C().datetime({ offset: !0 }),
				description: C().nullish(),
				domainUid: C(),
				ebone: D({
					domainGuid: C(),
					domainRoleGuid: C()
				}).passthrough().nullish(),
				isAdmin: T(),
				modifiedAt: C().datetime({ offset: !0 }),
				name: C(),
				policy: k(D({
					key: C(),
					scope: j([
						"None",
						"User",
						"Organization",
						"OrganizationGroup",
						"Domain"
					])
				}).passthrough()),
				readonly: T(),
				roleUid: C(),
				securityDescriptors: E(D({
					audience: j([
						"*",
						"ebone",
						"esa"
					]),
					privilege: j([
						"ALL",
						"CREATE",
						"UPDATE",
						"READ",
						"DELETE",
						"APPROVE",
						"REJECT",
						"MERGE",
						"ACTIVATE"
					]),
					resource: j([
						"*",
						"domains",
						"organizations",
						"users",
						"files",
						"invitations",
						"member_applicants",
						"plans",
						"roles",
						"partner_applicants",
						"partners"
					]),
					scope: j([
						"None",
						"User",
						"Organization",
						"OrganizationGroup",
						"Domain"
					])
				}).passthrough())
			}).passthrough(),
			roleUid: C(),
			userUid: C()
		}).passthrough())
	}).passthrough(),
	supportAccountReasonUid: C().nullish(),
	type: j(["temporary", "legacy"])
}).passthrough()) }).passthrough(), Hi = D({
	expiresInHours: w().int(),
	organizationUid: C(),
	roleUid: C(),
	supportAccountReasonUid: C()
}).passthrough(), Ui = D({
	expiresAt: C().datetime({ offset: !0 }),
	password: C(),
	providerUser: D({
		createdAt: C().datetime({ offset: !0 }),
		currentUserUid: C().nullish(),
		defaultUserUid: C().nullish(),
		ebone: D({
			domainGuid: C(),
			domainRoleGuid: C(),
			enableEntryFeature: T(),
			organizationGuids: E(C()),
			userGuid: C()
		}).passthrough().nullish(),
		email: C(),
		emailModifiedAt: C().datetime({ offset: !0 }),
		emailVerified: T(),
		isAgreeTerms: T(),
		modifiedAt: C().datetime({ offset: !0 }),
		providerUserUid: C(),
		users: E(D({
			createdAt: C().datetime({ offset: !0 }),
			defaultOrganizationUid: C().nullish(),
			denwaList: E(D({
				denwaNumber: C(),
				denwaNumberShubetsu: C()
			}).passthrough()),
			domainUid: C(),
			ebone: D({
				domainGuid: C(),
				domainRoleGuid: C(),
				enableEntryFeature: T(),
				organizationGuids: E(C()),
				userGuid: C()
			}).passthrough().nullish(),
			email: C().nullish(),
			emailNotify: D({
				createdAt: C().datetime({ offset: !0 }),
				enabled: T(),
				enabledMessenger: T().nullish(),
				modifiedAt: C().datetime({ offset: !0 })
			}).passthrough(),
			emailVerified: T().nullish(),
			enableEntryFeature: T(),
			enableIntegrationFeature: T(),
			enableMfa: T(),
			grantedFeatures: k(E(C())),
			ipAddressList: E(C()),
			ipRestrictionEnforced: T(),
			lastLoginDatetime: C().datetime({ offset: !0 }).nullish(),
			mfaExemptedUntil: C().datetime({ offset: !0 }).nullish(),
			modifiedAt: C().datetime({ offset: !0 }),
			name: C(),
			organizationUids: E(C()),
			providerUserUid: C().nullish(),
			publicName: C().nullish(),
			role: D({
				comment: C().nullish(),
				createdAt: C().datetime({ offset: !0 }),
				description: C().nullish(),
				domainUid: C(),
				ebone: D({
					domainGuid: C(),
					domainRoleGuid: C()
				}).passthrough().nullish(),
				isAdmin: T(),
				modifiedAt: C().datetime({ offset: !0 }),
				name: C(),
				policy: k(D({
					key: C(),
					scope: j([
						"None",
						"User",
						"Organization",
						"OrganizationGroup",
						"Domain"
					])
				}).passthrough()),
				readonly: T(),
				roleUid: C(),
				securityDescriptors: E(D({
					audience: j([
						"*",
						"ebone",
						"esa"
					]),
					privilege: j([
						"ALL",
						"CREATE",
						"UPDATE",
						"READ",
						"DELETE",
						"APPROVE",
						"REJECT",
						"MERGE",
						"ACTIVATE"
					]),
					resource: j([
						"*",
						"domains",
						"organizations",
						"users",
						"files",
						"invitations",
						"member_applicants",
						"plans",
						"roles",
						"partner_applicants",
						"partners"
					]),
					scope: j([
						"None",
						"User",
						"Organization",
						"OrganizationGroup",
						"Domain"
					])
				}).passthrough())
			}).passthrough(),
			roleUid: C(),
			userUid: C()
		}).passthrough())
	}).passthrough()
}).passthrough(), Wi = D({ password: C() }).passthrough(), Gi = D({
	latestUpdateCount: C().nullable(),
	takkenLicense: D({
		existence: D({
			modifiedAt: C().datetime({ offset: !0 }).nullish(),
			state: j([
				"unchecked",
				"exists",
				"missing",
				"invalid"
			])
		}).passthrough().nullish(),
		latestUpdateCount: C().nullish(),
		licensor: C(),
		number: C(),
		updateCount: C(),
		verification: D({
			modifiedAt: C().datetime({ offset: !0 }).nullish(),
			state: j([
				"unchecked",
				"phone_verified",
				"admin_verified",
				"admin_denied"
			])
		}).passthrough().nullish()
	}).passthrough().nullable(),
	takkenTrader: D({
		address: C(),
		name: C(),
		representativeName: C().nullish()
	}).passthrough().nullable()
}).partial().passthrough(), Ki = D({
	passcode: C().nullish(),
	takkenLicense: D({
		licensor: C(),
		number: C(),
		updateCount: C()
	}).passthrough()
}).passthrough(), qi = D({
	licensor: C(),
	number: C(),
	verification: j([
		"unchecked",
		"admin_verified",
		"admin_denied"
	])
}).passthrough(), Ji = D({ takkenLicense: D({
	existence: D({
		modifiedAt: C().datetime({ offset: !0 }).nullish(),
		state: j([
			"unchecked",
			"exists",
			"missing",
			"invalid"
		])
	}).passthrough().nullish(),
	licensor: C(),
	number: C(),
	updateCount: C(),
	verification: D({
		modifiedAt: C().datetime({ offset: !0 }).nullish(),
		state: j([
			"unchecked",
			"phone_verified",
			"admin_verified",
			"admin_denied"
		])
	}).passthrough().nullish()
}).passthrough() }).passthrough(), Yi = D({
	items: E(D({
		createdAt: C().datetime({ offset: !0 }),
		defaultOrganizationUid: C().nullish(),
		denwaList: E(D({
			denwaNumber: C(),
			denwaNumberShubetsu: C()
		}).passthrough()),
		domainUid: C(),
		ebone: D({
			domainGuid: C(),
			domainRoleGuid: C(),
			enableEntryFeature: T(),
			organizationGuids: E(C()),
			userGuid: C()
		}).passthrough().nullish(),
		email: C().nullish(),
		emailNotify: D({
			createdAt: C().datetime({ offset: !0 }),
			enabled: T(),
			enabledMessenger: T().nullish(),
			modifiedAt: C().datetime({ offset: !0 })
		}).passthrough(),
		emailVerified: T().nullish(),
		enableEntryFeature: T(),
		enableIntegrationFeature: T(),
		enableMfa: T(),
		grantedFeatures: k(E(C())),
		ipAddressList: E(C()),
		ipRestrictionEnforced: T(),
		lastLoginDatetime: C().datetime({ offset: !0 }).nullish(),
		mfaExemptedUntil: C().datetime({ offset: !0 }).nullish(),
		modifiedAt: C().datetime({ offset: !0 }),
		name: C(),
		organizationUids: E(C()),
		providerUserUid: C().nullish(),
		publicName: C().nullish(),
		role: D({
			comment: C().nullish(),
			createdAt: C().datetime({ offset: !0 }),
			description: C().nullish(),
			domainUid: C(),
			ebone: D({
				domainGuid: C(),
				domainRoleGuid: C()
			}).passthrough().nullish(),
			isAdmin: T(),
			modifiedAt: C().datetime({ offset: !0 }),
			name: C(),
			policy: k(D({
				key: C(),
				scope: j([
					"None",
					"User",
					"Organization",
					"OrganizationGroup",
					"Domain"
				])
			}).passthrough()),
			readonly: T(),
			roleUid: C(),
			securityDescriptors: E(D({
				audience: j([
					"*",
					"ebone",
					"esa"
				]),
				privilege: j([
					"ALL",
					"CREATE",
					"UPDATE",
					"READ",
					"DELETE",
					"APPROVE",
					"REJECT",
					"MERGE",
					"ACTIVATE"
				]),
				resource: j([
					"*",
					"domains",
					"organizations",
					"users",
					"files",
					"invitations",
					"member_applicants",
					"plans",
					"roles",
					"partner_applicants",
					"partners"
				]),
				scope: j([
					"None",
					"User",
					"Organization",
					"OrganizationGroup",
					"Domain"
				])
			}).passthrough())
		}).passthrough(),
		roleUid: C(),
		userUid: C()
	}).passthrough()),
	itemsPerPage: w().int(),
	startIndex: w().int(),
	totalCounts: w().int()
}).passthrough(), Xi = D({
	items: E(D({
		authenticators: E(D({
			createdAt: C().datetime({ offset: !0 }),
			type: j(["Totp", "Passkey"])
		}).passthrough()),
		userUid: C()
	}).passthrough()),
	itemsPerPage: w().int(),
	startIndex: w().int()
}).passthrough(), Zi = D({
	items: E(D({
		email: C(),
		emailNotify: D({
			createdAt: C().datetime({ offset: !0 }),
			enabled: T(),
			enabledMessenger: T().nullish(),
			modifiedAt: C().datetime({ offset: !0 })
		}).passthrough(),
		isAdmin: T(),
		userUid: C()
	}).passthrough()),
	itemsPerPage: w().int(),
	startIndex: w().int()
}).passthrough(), Qi = D({
	businessName: C().nullish(),
	createdAt: C().datetime({ offset: !0 }),
	denwaList: E(D({
		denwaNumber: C(),
		denwaNumberShubetsu: C()
	}).passthrough()),
	domainUid: C(),
	ebone: D({
		customerId: w().int().nullish(),
		domainGuid: C(),
		organizationGuid: C()
	}).passthrough().nullish(),
	isPublic: T(),
	jusho: D({
		azaChoume: C().nullish(),
		cityName: C().nullish(),
		gaikuGoto: C().nullish(),
		isDirectInput: T(),
		jushoCode: C(),
		jushoText: C(),
		nokoriJusho: C().nullish(),
		ooazaTsuushou: C().nullish(),
		prefectureName: C().nullish(),
		yubinNumber: C()
	}).passthrough().nullish(),
	kameiDantaiList: E(D({ name: C().nullable() }).partial().passthrough()),
	modifiedAt: C().datetime({ offset: !0 }),
	name: C(),
	organizationExternalCode: C(),
	organizationUid: C(),
	partnerAutoApproval: D({
		createdAt: C().datetime({ offset: !0 }),
		enabled: T(),
		modifiedAt: C().datetime({ offset: !0 })
	}).passthrough(),
	partnerCount: w().int().nullish()
}).passthrough(), $i = D({
	comment: C().nullish(),
	createdAt: C().datetime({ offset: !0 }),
	description: C().nullish(),
	domainUid: C(),
	ebone: D({
		domainGuid: C(),
		domainRoleGuid: C()
	}).passthrough().nullish(),
	isAdmin: T(),
	modifiedAt: C().datetime({ offset: !0 }),
	name: C(),
	policy: k(D({
		key: C(),
		scope: j([
			"None",
			"User",
			"Organization",
			"OrganizationGroup",
			"Domain"
		])
	}).passthrough()),
	readonly: T(),
	roleUid: C(),
	securityDescriptors: E(D({
		audience: j([
			"*",
			"ebone",
			"esa"
		]),
		privilege: j([
			"ALL",
			"CREATE",
			"UPDATE",
			"READ",
			"DELETE",
			"APPROVE",
			"REJECT",
			"MERGE",
			"ACTIVATE"
		]),
		resource: j([
			"*",
			"domains",
			"organizations",
			"users",
			"files",
			"invitations",
			"member_applicants",
			"plans",
			"roles",
			"partner_applicants",
			"partners"
		]),
		scope: j([
			"None",
			"User",
			"Organization",
			"OrganizationGroup",
			"Domain"
		])
	}).passthrough())
}).passthrough(), ea = D({
	createdAt: C().datetime({ offset: !0 }),
	defaultOrganizationUid: C().nullish(),
	denwaList: E(D({
		denwaNumber: C(),
		denwaNumberShubetsu: C()
	}).passthrough()),
	domainUid: C(),
	ebone: D({
		domainGuid: C(),
		domainRoleGuid: C(),
		enableEntryFeature: T(),
		organizationGuids: E(C()),
		userGuid: C()
	}).passthrough().nullish(),
	email: C().nullish(),
	emailNotify: D({
		createdAt: C().datetime({ offset: !0 }),
		enabled: T(),
		enabledMessenger: T().nullish(),
		modifiedAt: C().datetime({ offset: !0 })
	}).passthrough(),
	emailVerified: T().nullish(),
	enableEntryFeature: T(),
	enableIntegrationFeature: T(),
	enableMfa: T(),
	grantedFeatures: k(E(C())),
	ipAddressList: E(C()),
	ipRestrictionEnforced: T(),
	lastLoginDatetime: C().datetime({ offset: !0 }).nullish(),
	mfaExemptedUntil: C().datetime({ offset: !0 }).nullish(),
	modifiedAt: C().datetime({ offset: !0 }),
	name: C(),
	organizationUids: E(C()),
	providerUserUid: C().nullish(),
	publicName: C().nullish(),
	role: D({
		comment: C().nullish(),
		createdAt: C().datetime({ offset: !0 }),
		description: C().nullish(),
		domainUid: C(),
		ebone: D({
			domainGuid: C(),
			domainRoleGuid: C()
		}).passthrough().nullish(),
		isAdmin: T(),
		modifiedAt: C().datetime({ offset: !0 }),
		name: C(),
		policy: k(D({
			key: C(),
			scope: j([
				"None",
				"User",
				"Organization",
				"OrganizationGroup",
				"Domain"
			])
		}).passthrough()),
		readonly: T(),
		roleUid: C(),
		securityDescriptors: E(D({
			audience: j([
				"*",
				"ebone",
				"esa"
			]),
			privilege: j([
				"ALL",
				"CREATE",
				"UPDATE",
				"READ",
				"DELETE",
				"APPROVE",
				"REJECT",
				"MERGE",
				"ACTIVATE"
			]),
			resource: j([
				"*",
				"domains",
				"organizations",
				"users",
				"files",
				"invitations",
				"member_applicants",
				"plans",
				"roles",
				"partner_applicants",
				"partners"
			]),
			scope: j([
				"None",
				"User",
				"Organization",
				"OrganizationGroup",
				"Domain"
			])
		}).passthrough())
	}).passthrough(),
	roleUid: C(),
	userUid: C()
}).passthrough(), ta = D({
	email: C(),
	providerUserUid: C()
}).passthrough(), na = D({
	createdAt: C().datetime({ offset: !0 }),
	email: C(),
	emailChangeTicketUid: C(),
	expires: C().datetime({ offset: !0 }),
	modifiedAt: C().datetime({ offset: !0 }),
	providerUserUid: C()
}).passthrough(), ra = D({ providerUserUid: C() }).passthrough(), ia = D({
	items: E(D({
		createdAt: C().datetime({ offset: !0 }),
		esaLicenseUid: C(),
		modifiedAt: C().datetime({ offset: !0 }),
		name: C()
	}).passthrough()),
	itemsPerPage: w().int(),
	startIndex: w().int(),
	totalCounts: w().int()
}).passthrough(), aa = D({ name: C() }).passthrough(), oa = D({
	createdAt: C().datetime({ offset: !0 }),
	esaLicenseUid: C(),
	modifiedAt: C().datetime({ offset: !0 }),
	name: C()
}).passthrough(), sa = D({
	items: E(D({
		createdAt: C().datetime({ offset: !0 }),
		defaultGranted: T(),
		description: C(),
		featureGrantUid: C(),
		key: C(),
		modifiedAt: C().datetime({ offset: !0 })
	}).passthrough()),
	itemsPerPage: w().int(),
	startIndex: w().int(),
	totalCounts: w().int()
}).passthrough(), ca = D({
	defaultGranted: T(),
	description: C(),
	key: C()
}).passthrough(), la = D({
	createdAt: C().datetime({ offset: !0 }),
	defaultGranted: T(),
	description: C(),
	featureGrantUid: C(),
	key: C(),
	modifiedAt: C().datetime({ offset: !0 })
}).passthrough(), ua = D({
	defaultGranted: T().nullable(),
	description: C().nullable()
}).partial().passthrough(), da = D({
	domain: D({
		autoApproval: D({
			emailDomains: E(C()),
			enabled: T()
		}).passthrough(),
		denwaList: E(D({
			denwaNumber: C(),
			denwaNumberShubetsu: C()
		}).passthrough()),
		isPhoneVerified: T(),
		name: C(),
		phoneVerification: D({ enabled: T() }).passthrough(),
		takkenLicense: D({
			licensor: C(),
			number: C(),
			updateCount: C()
		}).passthrough().nullish()
	}).passthrough(),
	organization: D({
		businessName: C().nullish(),
		denwaList: E(D({
			denwaNumber: C(),
			denwaNumberShubetsu: C()
		}).passthrough()),
		isPublic: T(),
		jusho: D({
			gaikuGoto: C().nullish(),
			isDirectInput: T(),
			jushoCode: C().nullish(),
			jushoText: C(),
			nokoriJusho: C().nullish(),
			yubinNumber: C()
		}).passthrough(),
		kameiDantaiList: E(D({ name: C().nullable() }).partial().passthrough()),
		name: C(),
		partnerAutoApproval: D({ enabled: T() }).passthrough()
	}).passthrough(),
	user: D({
		denwaList: E(D({
			denwaNumber: C(),
			denwaNumberShubetsu: C()
		}).passthrough()).nullish(),
		emailNotify: D({
			enabled: T(),
			enabledMessenger: T().nullish()
		}).passthrough().nullish(),
		name: C(),
		providerUserUid: C()
	}).passthrough()
}).passthrough(), fa = D({
	domain: D({
		autoApproval: D({
			createdAt: C().datetime({ offset: !0 }),
			emailDomains: E(C()),
			enabled: T(),
			modifiedAt: C().datetime({ offset: !0 })
		}).passthrough(),
		corporateNumber: C().nullish(),
		createdAt: C().datetime({ offset: !0 }),
		denwaList: E(D({
			denwaNumber: C(),
			denwaNumberShubetsu: C()
		}).passthrough()),
		domainUid: C(),
		ebone: D({
			customerId: w().int().nullish(),
			domainGuid: C(),
			enableEntryFeature: T(),
			synced: T()
		}).passthrough().nullish(),
		enableEntryFeature: T(),
		enableIntegrationFeature: T(),
		enablePasskey: T(),
		enableTotp: T(),
		grantedFeatures: k(E(C())),
		isPhoneVerified: T(),
		licenses: E(D({
			endDateTime: C().datetime({ offset: !0 }),
			name: A("Mfa"),
			startDateTime: C().datetime({ offset: !0 })
		}).passthrough()),
		logoImage: D({
			fileUid: C(),
			url: C()
		}).passthrough().nullish(),
		mfaState: j([
			"disabled",
			"enabled",
			"enforced"
		]),
		modifiedAt: C().datetime({ offset: !0 }),
		name: C(),
		nativeAppIpRestrictionEnforced: T(),
		phoneVerification: D({
			createdAt: C().datetime({ offset: !0 }),
			enabled: T(),
			modifiedAt: C().datetime({ offset: !0 })
		}).passthrough(),
		takkenLicense: D({
			licensor: C(),
			number: C(),
			updateCount: C()
		}).passthrough().nullish(),
		takkenLicenseImage: D({
			createdAt: C().datetime({ offset: !0 }),
			fileUid: C(),
			modifiedAt: C().datetime({ offset: !0 }),
			url: C()
		}).passthrough().nullish(),
		webAppIpRestrictionEnforced: T()
	}).passthrough(),
	organization: D({
		businessName: C().nullish(),
		createdAt: C().datetime({ offset: !0 }),
		denwaList: E(D({
			denwaNumber: C(),
			denwaNumberShubetsu: C()
		}).passthrough()),
		domainUid: C(),
		ebone: D({
			customerId: w().int().nullish(),
			domainGuid: C(),
			organizationGuid: C()
		}).passthrough().nullish(),
		isPublic: T(),
		jusho: D({
			azaChoume: C().nullish(),
			cityName: C().nullish(),
			gaikuGoto: C().nullish(),
			isDirectInput: T(),
			jushoCode: C(),
			jushoText: C(),
			nokoriJusho: C().nullish(),
			ooazaTsuushou: C().nullish(),
			prefectureName: C().nullish(),
			yubinNumber: C()
		}).passthrough().nullish(),
		kameiDantaiList: E(D({ name: C().nullable() }).partial().passthrough()),
		modifiedAt: C().datetime({ offset: !0 }),
		name: C(),
		organizationExternalCode: C(),
		organizationUid: C(),
		partnerAutoApproval: D({
			createdAt: C().datetime({ offset: !0 }),
			enabled: T(),
			modifiedAt: C().datetime({ offset: !0 })
		}).passthrough(),
		partnerCount: w().int().nullish()
	}).passthrough(),
	user: D({
		createdAt: C().datetime({ offset: !0 }),
		defaultOrganizationUid: C().nullish(),
		denwaList: E(D({
			denwaNumber: C(),
			denwaNumberShubetsu: C()
		}).passthrough()),
		domainUid: C(),
		ebone: D({
			domainGuid: C(),
			domainRoleGuid: C(),
			enableEntryFeature: T(),
			organizationGuids: E(C()),
			userGuid: C()
		}).passthrough().nullish(),
		email: C().nullish(),
		emailNotify: D({
			createdAt: C().datetime({ offset: !0 }),
			enabled: T(),
			enabledMessenger: T().nullish(),
			modifiedAt: C().datetime({ offset: !0 })
		}).passthrough(),
		emailVerified: T().nullish(),
		enableEntryFeature: T(),
		enableIntegrationFeature: T(),
		enableMfa: T(),
		grantedFeatures: k(E(C())),
		ipAddressList: E(C()),
		ipRestrictionEnforced: T(),
		lastLoginDatetime: C().datetime({ offset: !0 }).nullish(),
		mfaExemptedUntil: C().datetime({ offset: !0 }).nullish(),
		modifiedAt: C().datetime({ offset: !0 }),
		name: C(),
		organizationUids: E(C()),
		providerUserUid: C().nullish(),
		publicName: C().nullish(),
		role: D({
			comment: C().nullish(),
			createdAt: C().datetime({ offset: !0 }),
			description: C().nullish(),
			domainUid: C(),
			ebone: D({
				domainGuid: C(),
				domainRoleGuid: C()
			}).passthrough().nullish(),
			isAdmin: T(),
			modifiedAt: C().datetime({ offset: !0 }),
			name: C(),
			policy: k(D({
				key: C(),
				scope: j([
					"None",
					"User",
					"Organization",
					"OrganizationGroup",
					"Domain"
				])
			}).passthrough()),
			readonly: T(),
			roleUid: C(),
			securityDescriptors: E(D({
				audience: j([
					"*",
					"ebone",
					"esa"
				]),
				privilege: j([
					"ALL",
					"CREATE",
					"UPDATE",
					"READ",
					"DELETE",
					"APPROVE",
					"REJECT",
					"MERGE",
					"ACTIVATE"
				]),
				resource: j([
					"*",
					"domains",
					"organizations",
					"users",
					"files",
					"invitations",
					"member_applicants",
					"plans",
					"roles",
					"partner_applicants",
					"partners"
				]),
				scope: j([
					"None",
					"User",
					"Organization",
					"OrganizationGroup",
					"Domain"
				])
			}).passthrough())
		}).passthrough(),
		roleUid: C(),
		userUid: C()
	}).passthrough()
}).passthrough(), pa = D({
	defaultOrganizationUid: C(),
	domainUid: C(),
	email: C(),
	name: C(),
	organizationUids: E(C()),
	roleUid: C()
}).passthrough(), ma = D({
	createdAt: C().datetime({ offset: !0 }),
	defaultOrganizationUid: C(),
	domainUid: C(),
	email: C(),
	expires: C().datetime({ offset: !0 }),
	invitationUid: C(),
	modifiedAt: C().datetime({ offset: !0 }),
	name: C(),
	organizationUids: E(C()),
	roleUid: C()
}).passthrough(), ha = D({
	defaultOrganizationUid: C().nullable(),
	domainUid: C().nullable(),
	email: C().nullable(),
	name: C().nullable(),
	organizationUids: E(C()).nullable(),
	roleUid: C().nullable()
}).partial().passthrough(), ga = D({ callbackUrl: C() }).passthrough(), _a = D({
	domainName: C(),
	isCollaborator: T(),
	takkenLicense: D({
		licensor: C(),
		number: C(),
		updateCount: C()
	}).passthrough().nullish()
}).passthrough(), va = D({
	accounts: E(D({
		accountUID: C().nullish(),
		createdAt: C().nullish(),
		emailAddress: C().nullish(),
		emailNotifyEnabled: T().nullish(),
		emailVerified: T().nullish(),
		idProvider: C().nullish(),
		idProviderUID: C().nullish(),
		isAgreeTerms: T().nullish(),
		lastLoginDatetime: C().nullish(),
		modifiedAt: C().nullish(),
		name: C(),
		primaryDomainUID: C().nullish(),
		primaryOrganizationUID: C().nullish(),
		signUpReferrer: C().nullish(),
		status: w().int().nullish(),
		telNumber: C().nullish()
	}).passthrough()),
	nextPageToken: C().nullish()
}).passthrough(), ya = D({
	domains: E(D({
		accountAdministrators: E(C()),
		autoApprovalEmailDomains: E(C()).nullish(),
		autoApprovalEnabled: T().nullish(),
		autoApprovalModifiedAt: C().nullish(),
		createdAt: C().nullish(),
		domainUID: C(),
		faxNumber: C().nullish(),
		isRegistered: T(),
		licenseImageURL: C().nullish(),
		licenseNumber: C().nullish(),
		licenseUpdateCount: C().nullish(),
		licensorName: C().nullish(),
		logoImageURL: C().nullish(),
		modifiedAt: C().nullish(),
		myNumber: C().nullish(),
		name: C(),
		phoneAuthEnabled: T(),
		telNumber: C().nullish()
	}).passthrough()),
	nextPageToken: C().nullish()
}).passthrough(), ba = D({
	nextPageToken: C().nullish(),
	organizations: E(D({
		address: C().nullish(),
		associationName: C().nullish(),
		azaChoume: C().nullish(),
		businessName: C().nullish(),
		cityName: C().nullish(),
		createdAt: C().nullish(),
		domainUID: C(),
		faxNumber: C().nullish(),
		isAddressDirectInput: T().nullish(),
		modifiedAt: C().nullish(),
		name: C(),
		nokoriJusho: C().nullish(),
		ooazaTsuushou: C().nullish(),
		organizationUID: C(),
		prefectureName: C().nullish(),
		telNumber: C().nullish(),
		zipCode: C().nullish(),
		zipCodeOfAddress: C().nullish()
	}).passthrough())
}).passthrough(), xa = D({
	clientIp: C().nullish(),
	currentUserUid: C().nullish(),
	defaultUserUid: C().nullish(),
	email: C(),
	isAgreeTerms: T(),
	providerUserUid: C(),
	restrictedUserUids: E(C()),
	users: E(D({
		createdAt: C().datetime({ offset: !0 }),
		defaultOrganizationUid: C().nullish(),
		denwaList: E(D({
			denwaNumber: C(),
			denwaNumberShubetsu: C()
		}).passthrough()),
		domainUid: C(),
		ebone: D({
			domainGuid: C(),
			domainRoleGuid: C(),
			enableEntryFeature: T(),
			organizationGuids: E(C()),
			userGuid: C()
		}).passthrough().nullish(),
		email: C().nullish(),
		emailNotify: D({
			createdAt: C().datetime({ offset: !0 }),
			enabled: T(),
			enabledMessenger: T().nullish(),
			modifiedAt: C().datetime({ offset: !0 })
		}).passthrough(),
		emailVerified: T().nullish(),
		enableEntryFeature: T(),
		enableIntegrationFeature: T(),
		enableMfa: T(),
		grantedFeatures: k(E(C())),
		ipAddressList: E(C()),
		ipRestrictionEnforced: T(),
		lastLoginDatetime: C().datetime({ offset: !0 }).nullish(),
		mfaExemptedUntil: C().datetime({ offset: !0 }).nullish(),
		modifiedAt: C().datetime({ offset: !0 }),
		name: C(),
		organizationUids: E(C()),
		providerUserUid: C().nullish(),
		publicName: C().nullish(),
		role: D({
			comment: C().nullish(),
			createdAt: C().datetime({ offset: !0 }),
			description: C().nullish(),
			domainUid: C(),
			ebone: D({
				domainGuid: C(),
				domainRoleGuid: C()
			}).passthrough().nullish(),
			isAdmin: T(),
			modifiedAt: C().datetime({ offset: !0 }),
			name: C(),
			policy: k(D({
				key: C(),
				scope: j([
					"None",
					"User",
					"Organization",
					"OrganizationGroup",
					"Domain"
				])
			}).passthrough()),
			readonly: T(),
			roleUid: C(),
			securityDescriptors: E(D({
				audience: j([
					"*",
					"ebone",
					"esa"
				]),
				privilege: j([
					"ALL",
					"CREATE",
					"UPDATE",
					"READ",
					"DELETE",
					"APPROVE",
					"REJECT",
					"MERGE",
					"ACTIVATE"
				]),
				resource: j([
					"*",
					"domains",
					"organizations",
					"users",
					"files",
					"invitations",
					"member_applicants",
					"plans",
					"roles",
					"partner_applicants",
					"partners"
				]),
				scope: j([
					"None",
					"User",
					"Organization",
					"OrganizationGroup",
					"Domain"
				])
			}).passthrough())
		}).passthrough(),
		roleUid: C(),
		userUid: C()
	}).passthrough())
}).passthrough(), Sa = D({
	audience: C(),
	clientId: C()
}).passthrough(), Ca = D({
	items: E(D({
		comment: C(),
		createdAt: C().datetime({ offset: !0 }),
		domainName: C(),
		domainUid: C(),
		email: C(),
		memberApplicantUid: C(),
		modifiedAt: C().datetime({ offset: !0 }),
		providerUserUid: C(),
		requestedOrganizationName: C(),
		userName: C()
	}).passthrough()),
	itemsPerPage: w().int(),
	startIndex: w().int(),
	totalCounts: w().int()
}).passthrough(), wa = D({
	comment: C(),
	data: D({}).partial().passthrough(),
	domainUid: C(),
	providerUserUid: C(),
	userName: C()
}).passthrough(), Ta = D({
	comment: C(),
	createdAt: C().datetime({ offset: !0 }),
	domainName: C(),
	domainUid: C(),
	email: C(),
	memberApplicantUid: C(),
	modifiedAt: C().datetime({ offset: !0 }),
	providerUserUid: C(),
	requestedOrganizationName: C(),
	userName: C()
}).passthrough(), Ea = D({
	organizationUid: C(),
	roleUid: C()
}).passthrough(), Da = D({ userUid: C() }).passthrough(), Oa = D({ cancelComment: C() }).passthrough(), ka = D({
	sendMail: T().nullish(),
	userUid: C()
}).passthrough(), Aa = D({ url: C() }).passthrough(), ja = D({
	items: E(D({
		businessName: C().nullish(),
		createdAt: C().datetime({ offset: !0 }),
		denwaList: E(D({
			denwaNumber: C(),
			denwaNumberShubetsu: C()
		}).passthrough()),
		domainUid: C(),
		ebone: D({
			customerId: w().int().nullish(),
			domainGuid: C(),
			organizationGuid: C()
		}).passthrough().nullish(),
		isPublic: T(),
		jusho: D({
			azaChoume: C().nullish(),
			cityName: C().nullish(),
			gaikuGoto: C().nullish(),
			isDirectInput: T(),
			jushoCode: C(),
			jushoText: C(),
			nokoriJusho: C().nullish(),
			ooazaTsuushou: C().nullish(),
			prefectureName: C().nullish(),
			yubinNumber: C()
		}).passthrough().nullish(),
		kameiDantaiList: E(D({ name: C().nullable() }).partial().passthrough()),
		modifiedAt: C().datetime({ offset: !0 }),
		name: C(),
		organizationExternalCode: C(),
		organizationUid: C(),
		partnerAutoApproval: D({
			createdAt: C().datetime({ offset: !0 }),
			enabled: T(),
			modifiedAt: C().datetime({ offset: !0 })
		}).passthrough(),
		partnerCount: w().int().nullish()
	}).passthrough()),
	itemsPerPage: w().int(),
	startIndex: w().int(),
	totalCounts: w().int()
}).passthrough(), Ma = D({
	businessName: C().nullish(),
	denwaList: E(D({
		denwaNumber: C(),
		denwaNumberShubetsu: C()
	}).passthrough()),
	domainUid: C(),
	ebone: D({
		customerId: w().int().nullish(),
		domainGuid: C(),
		organizationGuid: C()
	}).passthrough().nullish(),
	isPublic: T(),
	jusho: D({
		azaChoume: C().nullish(),
		cityName: C().nullish(),
		gaikuGoto: C().nullish(),
		isDirectInput: T(),
		jushoCode: C(),
		jushoText: C(),
		nokoriJusho: C().nullish(),
		ooazaTsuushou: C().nullish(),
		prefectureName: C().nullish(),
		yubinNumber: C()
	}).passthrough().nullish(),
	kameiDantaiList: E(D({ name: C().nullable() }).partial().passthrough()),
	name: C(),
	partnerAutoApproval: D({ enabled: T() }).passthrough()
}).passthrough(), Na = D({
	businessName: C().nullable(),
	denwaList: E(D({
		denwaNumber: C(),
		denwaNumberShubetsu: C()
	}).passthrough()).nullable(),
	domainUid: C().nullable(),
	ebone: D({
		customerId: w().int().nullish(),
		domainGuid: C(),
		organizationGuid: C()
	}).passthrough().nullable(),
	isPublic: T().nullable(),
	jusho: D({
		azaChoume: C().nullish(),
		cityName: C().nullish(),
		gaikuGoto: C().nullish(),
		isDirectInput: T(),
		jushoCode: C(),
		jushoText: C(),
		nokoriJusho: C().nullish(),
		ooazaTsuushou: C().nullish(),
		prefectureName: C().nullish(),
		yubinNumber: C()
	}).passthrough().nullable(),
	kameiDantaiList: E(D({ name: C().nullable() }).partial().passthrough()).nullable(),
	name: C().nullable(),
	partnerAutoApproval: D({ enabled: T() }).passthrough().nullable()
}).partial().passthrough(), Pa = D({
	items: E(D({
		approvalComment: C().nullish(),
		cancellationComment: C().nullish(),
		comment: C().nullish(),
		createdAt: C().datetime({ offset: !0 }),
		domain: D({
			domainUid: C(),
			logoImage: D({
				fileUid: C(),
				url: C()
			}).passthrough().nullish(),
			name: C(),
			takkenLicense: D({
				licensor: C(),
				number: C(),
				updateCount: C()
			}).passthrough().nullish()
		}).passthrough().nullish(),
		domainUid: C(),
		email: C().nullish(),
		modifiedAt: C().datetime({ offset: !0 }),
		organization: D({
			businessName: C().nullish(),
			denwaList: E(D({
				denwaNumber: C(),
				denwaNumberShubetsu: C()
			}).passthrough()),
			domainUid: C(),
			ebone: D({
				customerId: w().int().nullish(),
				domainGuid: C(),
				organizationGuid: C()
			}).passthrough().nullish(),
			jusho: D({
				azaChoume: C().nullish(),
				cityName: C().nullish(),
				gaikuGoto: C().nullish(),
				isDirectInput: T(),
				jushoCode: C(),
				jushoText: C(),
				nokoriJusho: C().nullish(),
				ooazaTsuushou: C().nullish(),
				prefectureName: C().nullish(),
				yubinNumber: C()
			}).passthrough().nullish(),
			kameiDantaiList: E(D({ name: C().nullable() }).partial().passthrough()),
			name: C(),
			organizationUid: C(),
			partnerCount: w().int().nullish()
		}).passthrough().nullish(),
		organizationUid: C(),
		partnerApplicantUid: C(),
		partnerDomain: D({
			domainUid: C(),
			logoImage: D({
				fileUid: C(),
				url: C()
			}).passthrough().nullish(),
			name: C(),
			takkenLicense: D({
				licensor: C(),
				number: C(),
				updateCount: C()
			}).passthrough().nullish()
		}).passthrough().nullish(),
		partnerDomainUid: C(),
		partnerOrganization: D({
			businessName: C().nullish(),
			denwaList: E(D({
				denwaNumber: C(),
				denwaNumberShubetsu: C()
			}).passthrough()),
			domainUid: C(),
			ebone: D({
				customerId: w().int().nullish(),
				domainGuid: C(),
				organizationGuid: C()
			}).passthrough().nullish(),
			jusho: D({
				azaChoume: C().nullish(),
				cityName: C().nullish(),
				gaikuGoto: C().nullish(),
				isDirectInput: T(),
				jushoCode: C(),
				jushoText: C(),
				nokoriJusho: C().nullish(),
				ooazaTsuushou: C().nullish(),
				prefectureName: C().nullish(),
				yubinNumber: C()
			}).passthrough().nullish(),
			kameiDantaiList: E(D({ name: C().nullable() }).partial().passthrough()),
			name: C(),
			organizationUid: C(),
			partnerCount: w().int().nullish()
		}).passthrough().nullish(),
		partnerOrganizationUid: C(),
		rejectionComment: C().nullish(),
		state: j([
			"approved",
			"rejected",
			"cancelled",
			"standby"
		]),
		userName: C().nullish()
	}).passthrough()),
	itemsPerPage: w().int(),
	startIndex: w().int(),
	totalCounts: w().int()
}).passthrough(), Fa = D({
	items: E(D({
		createdAt: C().datetime({ offset: !0 }),
		domainUid: C(),
		modifiedAt: C().datetime({ offset: !0 }),
		organizationUid: C(),
		partnerDomain: D({
			domainUid: C(),
			logoImage: D({
				fileUid: C(),
				url: C()
			}).passthrough().nullish(),
			name: C(),
			takkenLicense: D({
				licensor: C(),
				number: C(),
				updateCount: C()
			}).passthrough().nullish()
		}).passthrough().nullish(),
		partnerDomainUid: C(),
		partnerOrganization: D({
			businessName: C().nullish(),
			denwaList: E(D({
				denwaNumber: C(),
				denwaNumberShubetsu: C()
			}).passthrough()),
			domainUid: C(),
			ebone: D({
				customerId: w().int().nullish(),
				domainGuid: C(),
				organizationGuid: C()
			}).passthrough().nullish(),
			jusho: D({
				azaChoume: C().nullish(),
				cityName: C().nullish(),
				gaikuGoto: C().nullish(),
				isDirectInput: T(),
				jushoCode: C(),
				jushoText: C(),
				nokoriJusho: C().nullish(),
				ooazaTsuushou: C().nullish(),
				prefectureName: C().nullish(),
				yubinNumber: C()
			}).passthrough().nullish(),
			kameiDantaiList: E(D({ name: C().nullable() }).partial().passthrough()),
			name: C(),
			organizationUid: C(),
			partnerCount: w().int().nullish()
		}).passthrough().nullish(),
		partnerOrganizationUid: C(),
		partnerUid: C()
	}).passthrough()),
	itemsPerPage: w().int(),
	startIndex: w().int(),
	totalCounts: w().int()
}).passthrough(), Ia = D({
	items: E(D({
		email: C(),
		emailNotify: D({
			createdAt: C().datetime({ offset: !0 }),
			enabled: T(),
			enabledMessenger: T().nullish(),
			modifiedAt: C().datetime({ offset: !0 })
		}).passthrough(),
		isAdmin: T(),
		userUid: C()
	}).passthrough()),
	itemsPerPage: w().int(),
	startIndex: w().int()
}).passthrough(), La = D({
	items: E(D({
		approvalComment: C().nullish(),
		cancellationComment: C().nullish(),
		comment: C().nullish(),
		createdAt: C().datetime({ offset: !0 }),
		domain: D({
			domainUid: C(),
			logoImage: D({
				fileUid: C(),
				url: C()
			}).passthrough().nullish(),
			name: C(),
			takkenLicense: D({
				licensor: C(),
				number: C(),
				updateCount: C()
			}).passthrough().nullish()
		}).passthrough().nullish(),
		domainUid: C(),
		email: C().nullish(),
		modifiedAt: C().datetime({ offset: !0 }),
		organization: D({
			businessName: C().nullish(),
			denwaList: E(D({
				denwaNumber: C(),
				denwaNumberShubetsu: C()
			}).passthrough()),
			domainUid: C(),
			ebone: D({
				customerId: w().int().nullish(),
				domainGuid: C(),
				organizationGuid: C()
			}).passthrough().nullish(),
			jusho: D({
				azaChoume: C().nullish(),
				cityName: C().nullish(),
				gaikuGoto: C().nullish(),
				isDirectInput: T(),
				jushoCode: C(),
				jushoText: C(),
				nokoriJusho: C().nullish(),
				ooazaTsuushou: C().nullish(),
				prefectureName: C().nullish(),
				yubinNumber: C()
			}).passthrough().nullish(),
			kameiDantaiList: E(D({ name: C().nullable() }).partial().passthrough()),
			name: C(),
			organizationUid: C(),
			partnerCount: w().int().nullish()
		}).passthrough().nullish(),
		organizationUid: C(),
		partnerApplicantUid: C(),
		partnerDomain: D({
			domainUid: C(),
			logoImage: D({
				fileUid: C(),
				url: C()
			}).passthrough().nullish(),
			name: C(),
			takkenLicense: D({
				licensor: C(),
				number: C(),
				updateCount: C()
			}).passthrough().nullish()
		}).passthrough().nullish(),
		partnerDomainUid: C(),
		partnerOrganization: D({
			businessName: C().nullish(),
			denwaList: E(D({
				denwaNumber: C(),
				denwaNumberShubetsu: C()
			}).passthrough()),
			domainUid: C(),
			ebone: D({
				customerId: w().int().nullish(),
				domainGuid: C(),
				organizationGuid: C()
			}).passthrough().nullish(),
			jusho: D({
				azaChoume: C().nullish(),
				cityName: C().nullish(),
				gaikuGoto: C().nullish(),
				isDirectInput: T(),
				jushoCode: C(),
				jushoText: C(),
				nokoriJusho: C().nullish(),
				ooazaTsuushou: C().nullish(),
				prefectureName: C().nullish(),
				yubinNumber: C()
			}).passthrough().nullish(),
			kameiDantaiList: E(D({ name: C().nullable() }).partial().passthrough()),
			name: C(),
			organizationUid: C(),
			partnerCount: w().int().nullish()
		}).passthrough().nullish(),
		partnerOrganizationUid: C(),
		rejectionComment: C().nullish(),
		state: j([
			"approved",
			"rejected",
			"cancelled",
			"standby"
		]),
		userName: C().nullish()
	}).passthrough()),
	itemsPerPage: w().int(),
	startIndex: w().int(),
	totalCounts: w().int()
}).passthrough(), Ra = D({
	approvalComment: C().nullish(),
	cancellationComment: C().nullish(),
	comment: C().nullish(),
	organizationUid: C(),
	partnerOrganizationUid: C(),
	rejectionComment: C().nullish()
}).passthrough(), za = D({
	approvalComment: C().nullish(),
	cancellationComment: C().nullish(),
	comment: C().nullish(),
	createdAt: C().datetime({ offset: !0 }),
	domain: D({
		domainUid: C(),
		logoImage: D({
			fileUid: C(),
			url: C()
		}).passthrough().nullish(),
		name: C(),
		takkenLicense: D({
			licensor: C(),
			number: C(),
			updateCount: C()
		}).passthrough().nullish()
	}).passthrough().nullish(),
	domainUid: C(),
	email: C().nullish(),
	modifiedAt: C().datetime({ offset: !0 }),
	organization: D({
		businessName: C().nullish(),
		denwaList: E(D({
			denwaNumber: C(),
			denwaNumberShubetsu: C()
		}).passthrough()),
		domainUid: C(),
		ebone: D({
			customerId: w().int().nullish(),
			domainGuid: C(),
			organizationGuid: C()
		}).passthrough().nullish(),
		jusho: D({
			azaChoume: C().nullish(),
			cityName: C().nullish(),
			gaikuGoto: C().nullish(),
			isDirectInput: T(),
			jushoCode: C(),
			jushoText: C(),
			nokoriJusho: C().nullish(),
			ooazaTsuushou: C().nullish(),
			prefectureName: C().nullish(),
			yubinNumber: C()
		}).passthrough().nullish(),
		kameiDantaiList: E(D({ name: C().nullable() }).partial().passthrough()),
		name: C(),
		organizationUid: C(),
		partnerCount: w().int().nullish()
	}).passthrough().nullish(),
	organizationUid: C(),
	partnerApplicantUid: C(),
	partnerDomain: D({
		domainUid: C(),
		logoImage: D({
			fileUid: C(),
			url: C()
		}).passthrough().nullish(),
		name: C(),
		takkenLicense: D({
			licensor: C(),
			number: C(),
			updateCount: C()
		}).passthrough().nullish()
	}).passthrough().nullish(),
	partnerDomainUid: C(),
	partnerOrganization: D({
		businessName: C().nullish(),
		denwaList: E(D({
			denwaNumber: C(),
			denwaNumberShubetsu: C()
		}).passthrough()),
		domainUid: C(),
		ebone: D({
			customerId: w().int().nullish(),
			domainGuid: C(),
			organizationGuid: C()
		}).passthrough().nullish(),
		jusho: D({
			azaChoume: C().nullish(),
			cityName: C().nullish(),
			gaikuGoto: C().nullish(),
			isDirectInput: T(),
			jushoCode: C(),
			jushoText: C(),
			nokoriJusho: C().nullish(),
			ooazaTsuushou: C().nullish(),
			prefectureName: C().nullish(),
			yubinNumber: C()
		}).passthrough().nullish(),
		kameiDantaiList: E(D({ name: C().nullable() }).partial().passthrough()),
		name: C(),
		organizationUid: C(),
		partnerCount: w().int().nullish()
	}).passthrough().nullish(),
	partnerOrganizationUid: C(),
	rejectionComment: C().nullish(),
	state: j([
		"approved",
		"rejected",
		"cancelled",
		"standby"
	]),
	userName: C().nullish()
}).passthrough(), Ba = D({ approvalComment: C().nullable() }).partial().passthrough(), Va = D({ cancellationComment: C().nullable() }).partial().passthrough(), Ha = D({ rejectionComment: C().nullable() }).partial().passthrough(), Ua = D({
	items: E(D({
		createdAt: C().datetime({ offset: !0 }),
		domainUid: C(),
		modifiedAt: C().datetime({ offset: !0 }),
		organizationUid: C(),
		partnerDomain: D({
			domainUid: C(),
			logoImage: D({
				fileUid: C(),
				url: C()
			}).passthrough().nullish(),
			name: C(),
			takkenLicense: D({
				licensor: C(),
				number: C(),
				updateCount: C()
			}).passthrough().nullish()
		}).passthrough().nullish(),
		partnerDomainUid: C(),
		partnerOrganization: D({
			businessName: C().nullish(),
			denwaList: E(D({
				denwaNumber: C(),
				denwaNumberShubetsu: C()
			}).passthrough()),
			domainUid: C(),
			ebone: D({
				customerId: w().int().nullish(),
				domainGuid: C(),
				organizationGuid: C()
			}).passthrough().nullish(),
			jusho: D({
				azaChoume: C().nullish(),
				cityName: C().nullish(),
				gaikuGoto: C().nullish(),
				isDirectInput: T(),
				jushoCode: C(),
				jushoText: C(),
				nokoriJusho: C().nullish(),
				ooazaTsuushou: C().nullish(),
				prefectureName: C().nullish(),
				yubinNumber: C()
			}).passthrough().nullish(),
			kameiDantaiList: E(D({ name: C().nullable() }).partial().passthrough()),
			name: C(),
			organizationUid: C(),
			partnerCount: w().int().nullish()
		}).passthrough().nullish(),
		partnerOrganizationUid: C(),
		partnerUid: C()
	}).passthrough()),
	itemsPerPage: w().int(),
	startIndex: w().int(),
	totalCounts: w().int()
}).passthrough(), Wa = D({
	createdAt: C().datetime({ offset: !0 }),
	domainUid: C(),
	modifiedAt: C().datetime({ offset: !0 }),
	organizationUid: C(),
	partnerDomain: D({
		domainUid: C(),
		logoImage: D({
			fileUid: C(),
			url: C()
		}).passthrough().nullish(),
		name: C(),
		takkenLicense: D({
			licensor: C(),
			number: C(),
			updateCount: C()
		}).passthrough().nullish()
	}).passthrough().nullish(),
	partnerDomainUid: C(),
	partnerOrganization: D({
		businessName: C().nullish(),
		denwaList: E(D({
			denwaNumber: C(),
			denwaNumberShubetsu: C()
		}).passthrough()),
		domainUid: C(),
		ebone: D({
			customerId: w().int().nullish(),
			domainGuid: C(),
			organizationGuid: C()
		}).passthrough().nullish(),
		jusho: D({
			azaChoume: C().nullish(),
			cityName: C().nullish(),
			gaikuGoto: C().nullish(),
			isDirectInput: T(),
			jushoCode: C(),
			jushoText: C(),
			nokoriJusho: C().nullish(),
			ooazaTsuushou: C().nullish(),
			prefectureName: C().nullish(),
			yubinNumber: C()
		}).passthrough().nullish(),
		kameiDantaiList: E(D({ name: C().nullable() }).partial().passthrough()),
		name: C(),
		organizationUid: C(),
		partnerCount: w().int().nullish()
	}).passthrough().nullish(),
	partnerOrganizationUid: C(),
	partnerUid: C()
}).passthrough(), Ga = D({ userUid: C() }).passthrough(), Ka = D({ url: C() }).passthrough(), qa = D({ plans: E(D({
	createdAt: C().datetime({ offset: !0 }),
	dormantThresholdAt: C().datetime({ offset: !0 }),
	executedAt: C().datetime({ offset: !0 }).nullish(),
	modifiedAt: C().datetime({ offset: !0 }),
	passwordInvalidationPlanUid: C(),
	state: j([
		"planned",
		"executing",
		"cancelled",
		"completed",
		"partially_failed"
	]),
	taskCount: w().int()
}).passthrough()) }).passthrough(), Ja = D({
	createdAt: C().datetime({ offset: !0 }),
	dormantThresholdAt: C().datetime({ offset: !0 }),
	executedAt: C().datetime({ offset: !0 }).nullish(),
	modifiedAt: C().datetime({ offset: !0 }),
	passwordInvalidationPlanUid: C(),
	state: j([
		"planned",
		"executing",
		"cancelled",
		"completed",
		"partially_failed"
	]),
	taskCount: w().int()
}).passthrough(), Ya = D({
	items: E(D({
		createdAt: C().datetime({ offset: !0 }),
		denwaNumber: C(),
		expires: C().datetime({ offset: !0 }),
		modifiedAt: C().datetime({ offset: !0 }),
		officeAddress: C(),
		officeName: C(),
		officeZipCode: C(),
		passcode: C(),
		phoneVerificationTicketUid: C(),
		takkenLicenseNumber: C(),
		takkenLicensorName: C().nullish()
	}).passthrough()),
	itemsPerPage: w().int(),
	startIndex: w().int()
}).passthrough(), Xa = D({
	data: D({}).partial().passthrough(),
	domainUid: C().nullish(),
	name: C(),
	operations: E(D({
		data: D({}).partial().passthrough(),
		state: j([
			"success",
			"standby",
			"progress"
		])
	}).passthrough())
}).passthrough(), Za = D({
	createdAt: C().datetime({ offset: !0 }),
	data: D({}).partial().passthrough(),
	domainUid: C().nullish(),
	modifiedAt: C().datetime({ offset: !0 }),
	name: C(),
	operations: E(D({
		createdAt: C().datetime({ offset: !0 }),
		data: D({}).partial().passthrough(),
		idx: w().int(),
		modifiedAt: C().datetime({ offset: !0 }),
		operationUid: C(),
		state: j([
			"success",
			"standby",
			"progress"
		])
	}).passthrough()),
	planUid: C(),
	state: j([
		"success",
		"failure",
		"progress",
		"standby"
	])
}).passthrough(), Qa = D({
	data: D({}).partial().passthrough().nullable(),
	domainUid: C().nullable(),
	name: C().nullable(),
	operations: E(D({
		data: D({}).partial().passthrough(),
		state: j([
			"success",
			"standby",
			"progress"
		])
	}).passthrough()).nullable()
}).partial().passthrough(), $a = D({
	items: E(D({
		createdAt: C().datetime({ offset: !0 }),
		defaultScope: j([
			"None",
			"User",
			"Organization",
			"OrganizationGroup",
			"Domain"
		]),
		isEsa: T(),
		isEsaEbone: T(),
		key: C(),
		modifiedAt: C().datetime({ offset: !0 }),
		scopes: E(j([
			"None",
			"User",
			"Organization",
			"OrganizationGroup",
			"Domain"
		])),
		securityDescriptors: E(D({
			audience: j([
				"*",
				"ebone",
				"esa"
			]),
			createdAt: C().datetime({ offset: !0 }),
			defaultScope: j([
				"None",
				"User",
				"Organization",
				"OrganizationGroup",
				"Domain"
			]),
			modifiedAt: C().datetime({ offset: !0 }),
			privilege: j([
				"ALL",
				"CREATE",
				"UPDATE",
				"READ",
				"DELETE",
				"APPROVE",
				"REJECT",
				"MERGE",
				"ACTIVATE"
			]),
			resource: j([
				"*",
				"domains",
				"organizations",
				"users",
				"files",
				"invitations",
				"member_applicants",
				"plans",
				"roles",
				"partner_applicants",
				"partners"
			]),
			securityDescriptorUid: C()
		}).passthrough()),
		syncEbone: T()
	}).passthrough()),
	itemsPerPage: w().int(),
	startIndex: w().int(),
	totalCounts: w().int()
}).passthrough(), eo = D({
	createdAt: C().datetime({ offset: !0 }),
	defaultScope: j([
		"None",
		"User",
		"Organization",
		"OrganizationGroup",
		"Domain"
	]),
	isEsa: T(),
	isEsaEbone: T(),
	key: C(),
	modifiedAt: C().datetime({ offset: !0 }),
	scopes: E(j([
		"None",
		"User",
		"Organization",
		"OrganizationGroup",
		"Domain"
	])),
	securityDescriptors: E(D({
		audience: j([
			"*",
			"ebone",
			"esa"
		]),
		createdAt: C().datetime({ offset: !0 }),
		defaultScope: j([
			"None",
			"User",
			"Organization",
			"OrganizationGroup",
			"Domain"
		]),
		modifiedAt: C().datetime({ offset: !0 }),
		privilege: j([
			"ALL",
			"CREATE",
			"UPDATE",
			"READ",
			"DELETE",
			"APPROVE",
			"REJECT",
			"MERGE",
			"ACTIVATE"
		]),
		resource: j([
			"*",
			"domains",
			"organizations",
			"users",
			"files",
			"invitations",
			"member_applicants",
			"plans",
			"roles",
			"partner_applicants",
			"partners"
		]),
		securityDescriptorUid: C()
	}).passthrough()),
	syncEbone: T()
}).passthrough(), to = D({
	items: E(D({
		createdAt: C().datetime({ offset: !0 }),
		currentUserUid: C().nullish(),
		defaultUserUid: C().nullish(),
		ebone: D({
			domainGuid: C(),
			domainRoleGuid: C(),
			enableEntryFeature: T(),
			organizationGuids: E(C()),
			userGuid: C()
		}).passthrough().nullish(),
		email: C(),
		emailModifiedAt: C().datetime({ offset: !0 }),
		emailVerified: T(),
		isAgreeTerms: T(),
		modifiedAt: C().datetime({ offset: !0 }),
		providerUserUid: C(),
		users: E(D({
			createdAt: C().datetime({ offset: !0 }),
			defaultOrganizationUid: C().nullish(),
			denwaList: E(D({
				denwaNumber: C(),
				denwaNumberShubetsu: C()
			}).passthrough()),
			domainUid: C(),
			ebone: D({
				domainGuid: C(),
				domainRoleGuid: C(),
				enableEntryFeature: T(),
				organizationGuids: E(C()),
				userGuid: C()
			}).passthrough().nullish(),
			email: C().nullish(),
			emailNotify: D({
				createdAt: C().datetime({ offset: !0 }),
				enabled: T(),
				enabledMessenger: T().nullish(),
				modifiedAt: C().datetime({ offset: !0 })
			}).passthrough(),
			emailVerified: T().nullish(),
			enableEntryFeature: T(),
			enableIntegrationFeature: T(),
			enableMfa: T(),
			grantedFeatures: k(E(C())),
			ipAddressList: E(C()),
			ipRestrictionEnforced: T(),
			lastLoginDatetime: C().datetime({ offset: !0 }).nullish(),
			mfaExemptedUntil: C().datetime({ offset: !0 }).nullish(),
			modifiedAt: C().datetime({ offset: !0 }),
			name: C(),
			organizationUids: E(C()),
			providerUserUid: C().nullish(),
			publicName: C().nullish(),
			role: D({
				comment: C().nullish(),
				createdAt: C().datetime({ offset: !0 }),
				description: C().nullish(),
				domainUid: C(),
				ebone: D({
					domainGuid: C(),
					domainRoleGuid: C()
				}).passthrough().nullish(),
				isAdmin: T(),
				modifiedAt: C().datetime({ offset: !0 }),
				name: C(),
				policy: k(D({
					key: C(),
					scope: j([
						"None",
						"User",
						"Organization",
						"OrganizationGroup",
						"Domain"
					])
				}).passthrough()),
				readonly: T(),
				roleUid: C(),
				securityDescriptors: E(D({
					audience: j([
						"*",
						"ebone",
						"esa"
					]),
					privilege: j([
						"ALL",
						"CREATE",
						"UPDATE",
						"READ",
						"DELETE",
						"APPROVE",
						"REJECT",
						"MERGE",
						"ACTIVATE"
					]),
					resource: j([
						"*",
						"domains",
						"organizations",
						"users",
						"files",
						"invitations",
						"member_applicants",
						"plans",
						"roles",
						"partner_applicants",
						"partners"
					]),
					scope: j([
						"None",
						"User",
						"Organization",
						"OrganizationGroup",
						"Domain"
					])
				}).passthrough())
			}).passthrough(),
			roleUid: C(),
			userUid: C()
		}).passthrough())
	}).passthrough()),
	itemsPerPage: w().int(),
	startIndex: w().int(),
	totalCounts: w().int()
}).passthrough(), no = D({ email: C() }).passthrough(), ro = D({
	currentUserUid: C().nullable(),
	defaultUserUid: C().nullable(),
	email: C().nullable(),
	emailVerified: T().nullable(),
	isAgreeTerms: T().nullable(),
	providerUserUid: C().nullable()
}).partial().passthrough(), io = D({ syncedAt: C().datetime({ offset: !0 }) }).passthrough(), ao = D({ authenticationMethods: E(D({
	authenticatorName: C().nullish(),
	enrolledAt: C().datetime({ offset: !0 }),
	id: C(),
	type: C(),
	userAgent: C().nullish()
}).passthrough()) }).passthrough(), oo = D({ authenticationMethods: E(D({
	authenticatorName: C().nullish(),
	enrolledAt: C().datetime({ offset: !0 }),
	id: C(),
	type: C(),
	userAgent: C().nullish()
}).passthrough()) }).passthrough(), so = D({ authenticationMethods: E(D({
	authenticatorName: C().nullish(),
	enrolledAt: C().datetime({ offset: !0 }),
	id: C(),
	type: C(),
	userAgent: C().nullish()
}).passthrough()) }).passthrough(), co = D({ sources: D({
	auth0: j(["blocked", "unblocked"]),
	esaApi: j(["blocked", "unblocked"])
}).passthrough() }).passthrough(), lo = D({
	items: E(D({
		businessName: C().nullish(),
		customerId: w().int().nullish(),
		name: C(),
		organizationGuid: C(),
		organizationUid: C()
	}).passthrough()),
	totalCounts: w().int()
}).passthrough(), uo = D({ items: E(D({
	identifier: C(),
	ip: C().nullish()
}).passthrough()) }).passthrough(), fo = D({ items: E(D({
	identifier: C(),
	ip: C().nullish()
}).passthrough()) }).passthrough(), po = D({
	emailOtp: j(["required", "none"]),
	mfa: j([
		"required",
		"satisfied",
		"none"
	]),
	mfaClaim: T()
}).passthrough(), mo = D({ result: j(["Success", "Skip"]) }).passthrough(), ho = D({
	items: E(D({
		comment: C(),
		createdAt: C().datetime({ offset: !0 }),
		domainName: C(),
		domainUid: C(),
		email: C(),
		memberApplicantUid: C(),
		modifiedAt: C().datetime({ offset: !0 }),
		providerUserUid: C(),
		requestedOrganizationName: C(),
		userName: C()
	}).passthrough()),
	itemsPerPage: w().int(),
	startIndex: w().int(),
	totalCounts: w().int()
}).passthrough(), _o = D({
	enablePasskey: T(),
	enableTotp: T(),
	ipAddressList: E(C()),
	mfaState: j([
		"disabled",
		"enabled",
		"enforced"
	]),
	nativeAppIpRestrictionEnforced: T(),
	webAppIpRestrictionEnforced: T()
}).passthrough(), vo = D({
	items: E(C()),
	itemsPerPage: w().int(),
	startIndex: w().int()
}).passthrough(), yo = D({
	items: E(D({
		domainUid: C(),
		logoImage: D({
			fileUid: C(),
			url: C()
		}).passthrough().nullish(),
		name: C(),
		takkenLicense: D({
			licensor: C(),
			number: C(),
			updateCount: C()
		}).passthrough().nullish()
	}).passthrough()),
	itemsPerPage: w().int(),
	startIndex: w().int(),
	totalCounts: w().int()
}).passthrough(), bo = D({
	items: E(D({
		businessName: C().nullish(),
		denwaList: E(D({
			denwaNumber: C(),
			denwaNumberShubetsu: C()
		}).passthrough()),
		domainUid: C(),
		ebone: D({
			customerId: w().int().nullish(),
			domainGuid: C(),
			organizationGuid: C()
		}).passthrough().nullish(),
		jusho: D({
			azaChoume: C().nullish(),
			cityName: C().nullish(),
			gaikuGoto: C().nullish(),
			isDirectInput: T(),
			jushoCode: C(),
			jushoText: C(),
			nokoriJusho: C().nullish(),
			ooazaTsuushou: C().nullish(),
			prefectureName: C().nullish(),
			yubinNumber: C()
		}).passthrough().nullish(),
		kameiDantaiList: E(D({ name: C().nullable() }).partial().passthrough()),
		name: C(),
		organizationUid: C(),
		partnerCount: w().int().nullish()
	}).passthrough()),
	itemsPerPage: w().int(),
	startIndex: w().int(),
	totalCounts: w().int()
}).passthrough(), xo = D({
	items: E(D({
		comment: C().nullish(),
		createdAt: C().datetime({ offset: !0 }),
		description: C().nullish(),
		domainUid: C(),
		ebone: D({
			domainGuid: C(),
			domainRoleGuid: C()
		}).passthrough().nullish(),
		isAdmin: T(),
		modifiedAt: C().datetime({ offset: !0 }),
		name: C(),
		policy: k(D({
			key: C(),
			scope: j([
				"None",
				"User",
				"Organization",
				"OrganizationGroup",
				"Domain"
			])
		}).passthrough()),
		readonly: T(),
		roleUid: C(),
		securityDescriptors: E(D({
			audience: j([
				"*",
				"ebone",
				"esa"
			]),
			privilege: j([
				"ALL",
				"CREATE",
				"UPDATE",
				"READ",
				"DELETE",
				"APPROVE",
				"REJECT",
				"MERGE",
				"ACTIVATE"
			]),
			resource: j([
				"*",
				"domains",
				"organizations",
				"users",
				"files",
				"invitations",
				"member_applicants",
				"plans",
				"roles",
				"partner_applicants",
				"partners"
			]),
			scope: j([
				"None",
				"User",
				"Organization",
				"OrganizationGroup",
				"Domain"
			])
		}).passthrough())
	}).passthrough()),
	itemsPerPage: w().int(),
	startIndex: w().int(),
	totalCounts: w().int()
}).passthrough(), So = D({
	comment: C().nullish(),
	description: C().nullish(),
	domainUid: C(),
	ebone: D({
		domainGuid: C(),
		domainRoleGuid: C()
	}).passthrough().nullish(),
	isAdmin: T(),
	name: C(),
	policy: k(D({ scope: j([
		"None",
		"User",
		"Organization",
		"OrganizationGroup",
		"Domain"
	]) }).passthrough()),
	readonly: T(),
	securityDescriptors: E(D({
		audience: j([
			"*",
			"ebone",
			"esa"
		]),
		privilege: j([
			"ALL",
			"CREATE",
			"UPDATE",
			"READ",
			"DELETE",
			"APPROVE",
			"REJECT",
			"MERGE",
			"ACTIVATE"
		]),
		resource: j([
			"*",
			"domains",
			"organizations",
			"users",
			"files",
			"invitations",
			"member_applicants",
			"plans",
			"roles",
			"partner_applicants",
			"partners"
		]),
		scope: j([
			"None",
			"User",
			"Organization",
			"OrganizationGroup",
			"Domain"
		])
	}).passthrough())
}).passthrough(), Co = D({
	comment: C().nullable(),
	description: C().nullable(),
	domainUid: C().nullable(),
	ebone: D({
		domainGuid: C(),
		domainRoleGuid: C()
	}).passthrough().nullable(),
	isAdmin: T().nullable(),
	name: C().nullable(),
	policy: k(D({ scope: j([
		"None",
		"User",
		"Organization",
		"OrganizationGroup",
		"Domain"
	]) }).passthrough()).nullable(),
	readonly: T().nullable(),
	securityDescriptors: E(D({
		audience: j([
			"*",
			"ebone",
			"esa"
		]),
		privilege: j([
			"ALL",
			"CREATE",
			"UPDATE",
			"READ",
			"DELETE",
			"APPROVE",
			"REJECT",
			"MERGE",
			"ACTIVATE"
		]),
		resource: j([
			"*",
			"domains",
			"organizations",
			"users",
			"files",
			"invitations",
			"member_applicants",
			"plans",
			"roles",
			"partner_applicants",
			"partners"
		]),
		scope: j([
			"None",
			"User",
			"Organization",
			"OrganizationGroup",
			"Domain"
		])
	}).passthrough()).nullable()
}).partial().passthrough(), wo = D({
	audience: j([
		"*",
		"ebone",
		"esa"
	]),
	privilege: j([
		"ALL",
		"CREATE",
		"UPDATE",
		"READ",
		"DELETE",
		"APPROVE",
		"REJECT",
		"MERGE",
		"ACTIVATE"
	]),
	resource: j([
		"*",
		"domains",
		"organizations",
		"users",
		"files",
		"invitations",
		"member_applicants",
		"plans",
		"roles",
		"partner_applicants",
		"partners"
	]),
	scope: j([
		"None",
		"User",
		"Organization",
		"OrganizationGroup",
		"Domain"
	])
}).passthrough(), To = D({
	items: E(D({
		audience: j([
			"*",
			"ebone",
			"esa"
		]),
		createdAt: C().datetime({ offset: !0 }),
		defaultScope: j([
			"None",
			"User",
			"Organization",
			"OrganizationGroup",
			"Domain"
		]),
		modifiedAt: C().datetime({ offset: !0 }),
		privilege: j([
			"ALL",
			"CREATE",
			"UPDATE",
			"READ",
			"DELETE",
			"APPROVE",
			"REJECT",
			"MERGE",
			"ACTIVATE"
		]),
		resource: j([
			"*",
			"domains",
			"organizations",
			"users",
			"files",
			"invitations",
			"member_applicants",
			"plans",
			"roles",
			"partner_applicants",
			"partners"
		]),
		securityDescriptorUid: C()
	}).passthrough()),
	itemsPerPage: w().int(),
	startIndex: w().int(),
	totalCounts: w().int()
}).passthrough(), Eo = D({
	audience: j([
		"*",
		"ebone",
		"esa"
	]),
	defaultScope: j([
		"None",
		"User",
		"Organization",
		"OrganizationGroup",
		"Domain"
	]),
	privilege: j([
		"ALL",
		"CREATE",
		"UPDATE",
		"READ",
		"DELETE",
		"APPROVE",
		"REJECT",
		"MERGE",
		"ACTIVATE"
	]),
	resource: j([
		"*",
		"domains",
		"organizations",
		"users",
		"files",
		"invitations",
		"member_applicants",
		"plans",
		"roles",
		"partner_applicants",
		"partners"
	])
}).passthrough(), Do = D({
	audience: j([
		"*",
		"ebone",
		"esa"
	]),
	createdAt: C().datetime({ offset: !0 }),
	defaultScope: j([
		"None",
		"User",
		"Organization",
		"OrganizationGroup",
		"Domain"
	]),
	modifiedAt: C().datetime({ offset: !0 }),
	privilege: j([
		"ALL",
		"CREATE",
		"UPDATE",
		"READ",
		"DELETE",
		"APPROVE",
		"REJECT",
		"MERGE",
		"ACTIVATE"
	]),
	resource: j([
		"*",
		"domains",
		"organizations",
		"users",
		"files",
		"invitations",
		"member_applicants",
		"plans",
		"roles",
		"partner_applicants",
		"partners"
	]),
	securityDescriptorUid: C()
}).passthrough(), Oo = D({
	audience: j([
		"*",
		"ebone",
		"esa"
	]).nullable(),
	defaultScope: j([
		"None",
		"User",
		"Organization",
		"OrganizationGroup",
		"Domain"
	]).nullable(),
	privilege: j([
		"ALL",
		"CREATE",
		"UPDATE",
		"READ",
		"DELETE",
		"APPROVE",
		"REJECT",
		"MERGE",
		"ACTIVATE"
	]).nullable(),
	resource: j([
		"*",
		"domains",
		"organizations",
		"users",
		"files",
		"invitations",
		"member_applicants",
		"plans",
		"roles",
		"partner_applicants",
		"partners"
	]).nullable()
}).partial().passthrough(), ko = D({
	clientId: C().nullish(),
	email: C(),
	markEmailAsVerified: T().nullish(),
	sendEmail: T().nullish(),
	ttlSec: w().int().nullish()
}).passthrough(), Ao = D({
	emailVerified: T(),
	providerUserUid: C(),
	ticketUrl: C().nullish()
}).passthrough(), jo = D({
	items: E(D({
		customerApproval: D({
			approvedOn: C(),
			approver: C(),
			reason: C()
		}).passthrough(),
		domain: D({
			domainUid: C(),
			name: C()
		}).passthrough(),
		expiresAt: C().datetime({ offset: !0 }),
		issuedByEmail: C(),
		providerUser: D({
			createdAt: C().datetime({ offset: !0 }),
			currentUserUid: C().nullish(),
			defaultUserUid: C().nullish(),
			ebone: D({
				domainGuid: C(),
				domainRoleGuid: C(),
				enableEntryFeature: T(),
				organizationGuids: E(C()),
				userGuid: C()
			}).passthrough().nullish(),
			email: C(),
			emailModifiedAt: C().datetime({ offset: !0 }),
			emailVerified: T(),
			isAgreeTerms: T(),
			modifiedAt: C().datetime({ offset: !0 }),
			providerUserUid: C(),
			users: E(D({
				createdAt: C().datetime({ offset: !0 }),
				defaultOrganizationUid: C().nullish(),
				denwaList: E(D({
					denwaNumber: C(),
					denwaNumberShubetsu: C()
				}).passthrough()),
				domainUid: C(),
				ebone: D({
					domainGuid: C(),
					domainRoleGuid: C(),
					enableEntryFeature: T(),
					organizationGuids: E(C()),
					userGuid: C()
				}).passthrough().nullish(),
				email: C().nullish(),
				emailNotify: D({
					createdAt: C().datetime({ offset: !0 }),
					enabled: T(),
					enabledMessenger: T().nullish(),
					modifiedAt: C().datetime({ offset: !0 })
				}).passthrough(),
				emailVerified: T().nullish(),
				enableEntryFeature: T(),
				enableIntegrationFeature: T(),
				enableMfa: T(),
				grantedFeatures: k(E(C())),
				ipAddressList: E(C()),
				ipRestrictionEnforced: T(),
				lastLoginDatetime: C().datetime({ offset: !0 }).nullish(),
				mfaExemptedUntil: C().datetime({ offset: !0 }).nullish(),
				modifiedAt: C().datetime({ offset: !0 }),
				name: C(),
				organizationUids: E(C()),
				providerUserUid: C().nullish(),
				publicName: C().nullish(),
				role: D({
					comment: C().nullish(),
					createdAt: C().datetime({ offset: !0 }),
					description: C().nullish(),
					domainUid: C(),
					ebone: D({
						domainGuid: C(),
						domainRoleGuid: C()
					}).passthrough().nullish(),
					isAdmin: T(),
					modifiedAt: C().datetime({ offset: !0 }),
					name: C(),
					policy: k(D({
						key: C(),
						scope: j([
							"None",
							"User",
							"Organization",
							"OrganizationGroup",
							"Domain"
						])
					}).passthrough()),
					readonly: T(),
					roleUid: C(),
					securityDescriptors: E(D({
						audience: j([
							"*",
							"ebone",
							"esa"
						]),
						privilege: j([
							"ALL",
							"CREATE",
							"UPDATE",
							"READ",
							"DELETE",
							"APPROVE",
							"REJECT",
							"MERGE",
							"ACTIVATE"
						]),
						resource: j([
							"*",
							"domains",
							"organizations",
							"users",
							"files",
							"invitations",
							"member_applicants",
							"plans",
							"roles",
							"partner_applicants",
							"partners"
						]),
						scope: j([
							"None",
							"User",
							"Organization",
							"OrganizationGroup",
							"Domain"
						])
					}).passthrough())
				}).passthrough(),
				roleUid: C(),
				userUid: C()
			}).passthrough())
		}).passthrough(),
		supportAccountReasonUid: C()
	}).passthrough()),
	itemsPerPage: w().int(),
	startIndex: w().int(),
	totalCounts: w().int()
}).passthrough(), Mo = D({
	domains: E(D({
		autoApproval: D({ isTarget: T() }).passthrough(),
		domainUid: C(),
		ebone: D({
			domainGuid: C(),
			enableEntryFeature: T()
		}).passthrough().nullish(),
		enableEntryFeature: T(),
		name: C(),
		phoneVerification: D({ enabled: T() }).passthrough()
	}).passthrough()),
	offices: E(D({
		address: C(),
		name: C(),
		officeId: C(),
		telNumber: C(),
		traderId: C(),
		zipCode: C()
	}).passthrough()),
	trader: D({
		address: C(),
		licenseNumber: C(),
		licenseUpdateCount: C().nullish(),
		licensorName: C().nullish(),
		name: C(),
		representativeName: C().nullish(),
		telNumber: C(),
		traderId: C(),
		updatedDatetime: C().datetime({ offset: !0 })
	}).passthrough().nullish()
}).passthrough(), No = D({
	items: E(D({
		createdAt: C().datetime({ offset: !0 }),
		defaultOrganizationUid: C().nullish(),
		denwaList: E(D({
			denwaNumber: C(),
			denwaNumberShubetsu: C()
		}).passthrough()),
		domainUid: C(),
		ebone: D({
			domainGuid: C(),
			domainRoleGuid: C(),
			enableEntryFeature: T(),
			organizationGuids: E(C()),
			userGuid: C()
		}).passthrough().nullish(),
		email: C().nullish(),
		emailNotify: D({
			createdAt: C().datetime({ offset: !0 }),
			enabled: T(),
			enabledMessenger: T().nullish(),
			modifiedAt: C().datetime({ offset: !0 })
		}).passthrough(),
		emailVerified: T().nullish(),
		enableEntryFeature: T(),
		enableIntegrationFeature: T(),
		enableMfa: T(),
		grantedFeatures: k(E(C())),
		ipAddressList: E(C()),
		ipRestrictionEnforced: T(),
		lastLoginDatetime: C().datetime({ offset: !0 }).nullish(),
		mfaExemptedUntil: C().datetime({ offset: !0 }).nullish(),
		modifiedAt: C().datetime({ offset: !0 }),
		name: C(),
		organizationUids: E(C()),
		providerUserUid: C().nullish(),
		publicName: C().nullish(),
		role: D({
			comment: C().nullish(),
			createdAt: C().datetime({ offset: !0 }),
			description: C().nullish(),
			domainUid: C(),
			ebone: D({
				domainGuid: C(),
				domainRoleGuid: C()
			}).passthrough().nullish(),
			isAdmin: T(),
			modifiedAt: C().datetime({ offset: !0 }),
			name: C(),
			policy: k(D({
				key: C(),
				scope: j([
					"None",
					"User",
					"Organization",
					"OrganizationGroup",
					"Domain"
				])
			}).passthrough()),
			readonly: T(),
			roleUid: C(),
			securityDescriptors: E(D({
				audience: j([
					"*",
					"ebone",
					"esa"
				]),
				privilege: j([
					"ALL",
					"CREATE",
					"UPDATE",
					"READ",
					"DELETE",
					"APPROVE",
					"REJECT",
					"MERGE",
					"ACTIVATE"
				]),
				resource: j([
					"*",
					"domains",
					"organizations",
					"users",
					"files",
					"invitations",
					"member_applicants",
					"plans",
					"roles",
					"partner_applicants",
					"partners"
				]),
				scope: j([
					"None",
					"User",
					"Organization",
					"OrganizationGroup",
					"Domain"
				])
			}).passthrough())
		}).passthrough(),
		roleUid: C(),
		userUid: C()
	}).passthrough()),
	itemsPerPage: w().int(),
	startIndex: w().int(),
	totalCounts: w().int()
}).passthrough(), Po = D({
	defaultOrganizationUid: C().nullish(),
	denwaList: E(D({
		denwaNumber: C(),
		denwaNumberShubetsu: C()
	}).passthrough()),
	domainUid: C(),
	ebone: D({
		domainGuid: C(),
		domainRoleGuid: C(),
		userGuid: C()
	}).passthrough().nullish(),
	email: C().nullish(),
	emailNotify: D({
		enabled: T(),
		enabledMessenger: T().nullish()
	}).passthrough(),
	enableMfa: T(),
	ipAddressList: E(C()),
	lastLoginDatetime: C().datetime({ offset: !0 }).nullish(),
	mfaExemptedUntil: C().datetime({ offset: !0 }).nullish(),
	name: C(),
	organizationUids: E(C()),
	providerUserUid: C().nullish(),
	publicName: C().nullish(),
	roleUid: C()
}).passthrough(), Fo = D({
	defaultOrganizationUid: C().nullable(),
	denwaList: E(D({
		denwaNumber: C(),
		denwaNumberShubetsu: C()
	}).passthrough()).nullable(),
	domainUid: C().nullable(),
	ebone: D({
		domainGuid: C(),
		domainRoleGuid: C(),
		userGuid: C()
	}).passthrough().nullable(),
	email: C().nullable(),
	emailNotify: D({
		enabled: T(),
		enabledMessenger: T().nullish()
	}).passthrough().nullable(),
	enableMfa: T().nullable(),
	ipAddressList: E(C()).nullable(),
	lastLoginDatetime: C().datetime({ offset: !0 }).nullable(),
	mfaExemptedUntil: C().datetime({ offset: !0 }).nullable(),
	name: C().nullable(),
	organizationUids: E(C()).nullable(),
	providerUserUid: C().nullable(),
	publicName: C().nullable(),
	roleUid: C().nullable()
}).partial().passthrough(), Io = D({ mfaExemptedUntil: C().datetime({ offset: !0 }).nullable() }).partial().passthrough(), Lo = D({
	items: E(D({
		createdAt: C().datetime({ offset: !0 }),
		domainUid: C(),
		modifiedAt: C().datetime({ offset: !0 }),
		organizationUid: C(),
		partnerDomain: D({
			domainUid: C(),
			logoImage: D({
				fileUid: C(),
				url: C()
			}).passthrough().nullish(),
			name: C(),
			takkenLicense: D({
				licensor: C(),
				number: C(),
				updateCount: C()
			}).passthrough().nullish()
		}).passthrough().nullish(),
		partnerDomainUid: C(),
		partnerOrganization: D({
			businessName: C().nullish(),
			denwaList: E(D({
				denwaNumber: C(),
				denwaNumberShubetsu: C()
			}).passthrough()),
			domainUid: C(),
			ebone: D({
				customerId: w().int().nullish(),
				domainGuid: C(),
				organizationGuid: C()
			}).passthrough().nullish(),
			jusho: D({
				azaChoume: C().nullish(),
				cityName: C().nullish(),
				gaikuGoto: C().nullish(),
				isDirectInput: T(),
				jushoCode: C(),
				jushoText: C(),
				nokoriJusho: C().nullish(),
				ooazaTsuushou: C().nullish(),
				prefectureName: C().nullish(),
				yubinNumber: C()
			}).passthrough().nullish(),
			kameiDantaiList: E(D({ name: C().nullable() }).partial().passthrough()),
			name: C(),
			organizationUid: C(),
			partnerCount: w().int().nullish()
		}).passthrough().nullish(),
		partnerOrganizationUid: C(),
		partnerUid: C()
	}).passthrough()),
	itemsPerPage: w().int(),
	startIndex: w().int(),
	totalCounts: w().int()
}).passthrough(), Ro = D({
	items: E(D({
		auth: D({}).partial().passthrough(),
		contentType: j(["application/x-www-form-urlencoded", "application/json"]),
		createdAt: C().datetime({ offset: !0 }),
		hookEvents: E(j([
			"preDeleteUserForB2b",
			"preDeleteUser",
			"deleteUser",
			"preMergeDomain",
			"mergeDomain",
			"mergeOrganizations",
			"moveOrganizations",
			"approvePartnerApplicant",
			"deletePartners"
		])),
		method: A("POST"),
		modifiedAt: C().datetime({ offset: !0 }),
		pushType: j(["notify", "verify"]),
		url: C(),
		webhookUid: C()
	}).passthrough()),
	itemsPerPage: w().int(),
	startIndex: w().int(),
	totalCounts: w().int()
}).passthrough(), zo = D({
	auth: D({}).partial().passthrough(),
	contentType: j(["application/x-www-form-urlencoded", "application/json"]),
	hookEvents: E(j([
		"preDeleteUserForB2b",
		"preDeleteUser",
		"deleteUser",
		"preMergeDomain",
		"mergeDomain",
		"mergeOrganizations",
		"moveOrganizations",
		"approvePartnerApplicant",
		"deletePartners"
	])),
	method: A("POST"),
	pushType: j(["notify", "verify"]),
	url: C()
}).passthrough(), Bo = D({
	auth: D({}).partial().passthrough(),
	contentType: j(["application/x-www-form-urlencoded", "application/json"]),
	createdAt: C().datetime({ offset: !0 }),
	hookEvents: E(j([
		"preDeleteUserForB2b",
		"preDeleteUser",
		"deleteUser",
		"preMergeDomain",
		"mergeDomain",
		"mergeOrganizations",
		"moveOrganizations",
		"approvePartnerApplicant",
		"deletePartners"
	])),
	method: A("POST"),
	modifiedAt: C().datetime({ offset: !0 }),
	pushType: j(["notify", "verify"]),
	url: C(),
	webhookUid: C()
}).passthrough(), Vo = D({
	auth: D({}).partial().passthrough().nullable(),
	contentType: j(["application/x-www-form-urlencoded", "application/json"]).nullable(),
	hookEvents: E(j([
		"preDeleteUserForB2b",
		"preDeleteUser",
		"deleteUser",
		"preMergeDomain",
		"mergeDomain",
		"mergeOrganizations",
		"moveOrganizations",
		"approvePartnerApplicant",
		"deletePartners"
	])).nullable(),
	method: A("POST").nullable(),
	pushType: j(["notify", "verify"]).nullable(),
	url: C().nullable()
}).partial().passthrough(), Ho = D({ event: j([
	"preDeleteUserForB2b",
	"preDeleteUser",
	"deleteUser",
	"preMergeDomain",
	"mergeDomain",
	"mergeOrganizations",
	"moveOrganizations",
	"approvePartnerApplicant",
	"deletePartners"
]) }).passthrough(), Uo = D({
	detail: C().nullish(),
	errorCode: j(/* @__PURE__ */ "Auth.Config::FailedGetEnvVar.Config::FailedParseBoolEnvVar.Config::FailedParseIntEnvVar.Config::InvalidHexEnvVar.Config::InvalidEnvVar.EboneClient.EsaDbClient::Orm.EsaDbClient::Entity.EsaDbClient::CreateDomain::Failed.EsaDbClient::CreateDomain::NotFoundFile.EsaDbClient::GetDomain::NotFound.EsaDbClient::GetDomain::NotFoundGuid.EsaDbClient::GetDomain::NotFoundCustomerId.EsaDbClient::GetDomain::NotFoundProviderUser.EsaDbClient::GetDomainAutoApproval::NotFound.EsaDbClient::UpdateDomain::NotFound.EsaDbClient::UpdateDomain::NotFoundFile.EsaDbClient::DeleteDomain::NotFound.EsaDbClient::CreateOrganization::Failed.EsaDbClient::CreateOrganization::NotFoundDomain.EsaDbClient::GetOrganization::NotFound.EsaDbClient::GetOrganization::NotFoundGuid.EsaDbClient::GetOrganization::NotFoundDomain.EsaDbClient::UpdateOrganization::NotFound.EsaDbClient::UpdateOrganization::NotFoundDomain.EsaDbClient::DeleteOrganization::NotFound.EsaDbClient::DeleteOrganization::NotFoundDomain.EsaDbClient::CreateUser::Failed.EsaDbClient::CreateUser::NotFoundDomain.EsaDbClient::CreateUser::NotFoundOrganization.EsaDbClient::CreateUser::NotFoundProviderUser.EsaDbClient::CreateUser::NotFoundRole.EsaDbClient::GetUser::NotFound.EsaDbClient::GetUser::NotFoundGuid.EsaDbClient::GetUser::NotFoundDomain.EsaDbClient::GetUser::NotFoundRole.EsaDbClient::GetUser::NotFoundOrganization.EsaDbClient::UpdateUser::NotFound.EsaDbClient::UpdateUser::NotFoundDomain.EsaDbClient::UpdateUser::NotFoundProviderUser.EsaDbClient::UpdateUser::NotFoundRole.EsaDbClient::UpdateUser::NotFoundOrganization.EsaDbClient::DeleteUser::NotFound.EsaDbClient::CreateProviderUser::Failed.EsaDbClient::GetProviderUser::NotFound.EsaDbClient::GetProviderUser::NotFoundEmail.EsaDbClient::UpdateProviderUser::NotFound.EsaDbClient::DeleteProviderUser::NotFound.EsaDbClient::CreateProviderUserAuthMethod::NotFoundProviderUser.EsaDbClient::GetProviderUserAuthMethod::NotFoundProviderUser.EsaDbClient::DeleteProviderAuthMethodUser::NotFoundProviderUser.EsaDbClient::UpsertProviderUserAuth0EventSync::NotFoundProviderUser.EsaDbClient::UpsertProviderUserAuthMethodSync::NotFoundProviderUser.EsaDbClient::UpsertProviderUserLoginNetwork::NotFoundProviderUser.EsaDbClient::CreateSecurityDescriptor::Failed.EsaDbClient::GetSecurityDescriptor::NotFound.EsaDbClient::UpdateSecurityDescriptor::NotFound.EsaDbClient::DeleteSecurityDescriptor::NotFound.EsaDbClient::CreateSupportAccount::NotFoundProviderUser.EsaDbClient::CreateSupportAccount::NotFoundDomain.EsaDbClient::CreateSupportAccount::NotFoundSupportAccountReason.EsaDbClient::CreateSupportAccount::ProhibitedDomain.EsaDbClient::CreateSupportAccount::ClosedSupportAccountReason.EsaDbClient::GetSupportAccount::NotFound.EsaDbClient::CreateSupportAccountReason::NotFoundDomain.EsaDbClient::CreateSupportAccountReason::NotFoundOrganization.EsaDbClient::CreateSupportAccountReason::NotFoundRole.EsaDbClient::CreateSupportAccountReason::UnrestrictedWithAllowedUids.EsaDbClient::GetSupportAccountReason::NotFound.EsaDbClient::UpsertSupportAccountProhibition::NotFoundDomain.EsaDbClient::UpsertDomainMemo::NotFoundDomain.EsaDbClient::CreatePolicy::Failed.EsaDbClient::CreatePolicy::NotFoundSecurityDescriptor.EsaDbClient::GetPolicy::NotFound.EsaDbClient::UpdatePolicy::NotFound.EsaDbClient::UpdatePolicy::NotFoundSecurityDescriptor.EsaDbClient::DeletePolicy::NotFound.EsaDbClient::CreateRole::Failed.EsaDbClient::CreateRole::NotFoundDomain.EsaDbClient::CreateRole::NotFoundPolicy.EsaDbClient::GetRole::NotFound.EsaDbClient::GetRole::NotFoundGuid.EsaDbClient::GetRole::NotFoundDomain.EsaDbClient::UpdateRole::NotFound.EsaDbClient::UpdateRole::NotFoundDomain.EsaDbClient::UpdateRole::NotFoundPolicy.EsaDbClient::DeleteRole::NotFound.EsaDbClient::CreateFile::Failed.EsaDbClient::CreateFile::NotFoundDomain.EsaDbClient::CreateFile::NotFoundUser.EsaDbClient::GetFile::NotFound.EsaDbClient::GetFile::NotFoundGuid.EsaDbClient::GetFile::NotFoundDomain.EsaDbClient::UpdateFile::NotFound.EsaDbClient::UpdateFile::NotFoundDomain.EsaDbClient::UpdateFile::NotFoundUser.EsaDbClient::DeleteFile::NotFound.EsaDbClient::CreateInvitation::Failed.EsaDbClient::CreateInvitation::NotFoundDomain.EsaDbClient::CreateInvitation::NotFoundOrganization.EsaDbClient::CreateInvitation::NotFoundRole.EsaDbClient::GetInvitation::NotFound.EsaDbClient::GetInvitation::NotFoundDomain.EsaDbClient::UpdateInvitation::NotFound.EsaDbClient::UpdateInvitation::NotFoundDomain.EsaDbClient::UpdateInvitation::NotFoundRole.EsaDbClient::UpdateInvitation::NotFoundOrganization.EsaDbClient::DeleteInvitation::NotFound.EsaDbClient::CreatePlan::Failed.EsaDbClient::CreatePlan::NotFoundDomain.EsaDbClient::CreatePlan::NotFoundOrganization.EsaDbClient::CreatePlan::NotFoundProviderPlan.EsaDbClient::CreatePlan::NotFoundRole.EsaDbClient::GetPlan::NotFound.EsaDbClient::GetPlan::NotFoundDomain.EsaDbClient::UpdatePlan::NotFound.EsaDbClient::UpdatePlan::NotFoundDomain.EsaDbClient::DeletePlan::NotFound.EsaDbClient::CreateDefaultRole::Failed.EsaDbClient::CreateDefaultRole::NotFoundPolicy.EsaDbClient::GetDefaultRole::NotFound.EsaDbClient::GetDefaultRole::NotFoundDomain.EsaDbClient::UpdateDefaultRole::NotFound.EsaDbClient::UpdateDefaultRole::NotFoundDomain.EsaDbClient::UpdateDefaultRole::NotFoundPolicy.EsaDbClient::DeleteDefaultRole::NotFound.EsaDbClient::CreateActivationTicket::Failed.EsaDbClient::CreateActivationTicket::NotFoundCustomer.EsaDbClient::GetActivationTicket::NotFound.EsaDbClient::GetActivationTicket::NotFoundCustomerId.EsaDbClient::GetActivationTicket::NotFoundCustomer.EsaDbClient::UpdateActivationTicket::NotFound.EsaDbClient::UpdateActivationTicket::NotFoundCustomer.EsaDbClient::DeleteActivationTicket::NotFound.EsaDbClient::CreateCollaborator::Failed.EsaDbClient::CreateCollaborator::DuplicateProviderUserUid.EsaDbClient::GetCollaborator::NotFound.EsaDbClient::GetCollaborator::NotFoundByProviderUserUid.EsaDbClient::DeleteCollaborator::NotFound.EsaDbClient::CreateCollaboratorInvitation::Failed.EsaDbClient::CreateCollaboratorInvitation::NotFoundCollaboratorTeam.EsaDbClient::GetCollaboratorInvitation::NotFound.EsaDbClient::UpdateCollaboratorInvitation::NotFound.EsaDbClient::CreateDomainInvitation::Failed.EsaDbClient::GetDomainInvitation::NotFound.EsaDbClient::CreateCollaboratorTeam::Failed.EsaDbClient::CreateCollaboratorTeam::AddMembershipFailed.EsaDbClient::GetCollaboratorTeam::NotFound.EsaDbClient::CreateCustomer::Failed.EsaDbClient::CreateCustomer::NotFoundCustomer.EsaDbClient::GetCustomer::NotFound.EsaDbClient::UpdateCustomer::NotFound.EsaDbClient::DeleteCustomer::NotFound.EsaDbClient::CreateEmailChangeTicket::Failed.EsaDbClient::CreateEmailChangeTicket::NotFoundProviderUser.EsaDbClient::GetEmailChangeTicket::NotFound.EsaDbClient::UpdateEmailChangeTicket::NotFound.EsaDbClient::UpdateEmailChangeTicket::NotFoundProviderUser.EsaDbClient::DeleteEmailChangeTicket::NotFound.EsaDbClient::CreateEsaLicense::Failed.EsaDbClient::GetEsaLicense::NotFound.EsaDbClient::UpdateEsaLicense::NotFound.EsaDbClient::DeleteEsaLicense::NotFound.EsaDbClient::CreateMemberApplicant::Failed.EsaDbClient::CreateMemberApplicant::NotFoundDomain.EsaDbClient::CreateMemberApplicant::NotFoundProviderUser.EsaDbClient::GetMemberApplicant::NotFound.EsaDbClient::GetMemberApplicant::NotFoundDomain.EsaDbClient::GetMemberApplicant::NotFoundProviderUser.EsaDbClient::UpdateMemberApplicant::NotFound.EsaDbClient::UpdateMemberApplicant::NotFoundDomain.EsaDbClient::UpdateMemberApplicant::NotFoundProviderUser.EsaDbClient::DeleteMemberApplicant::NotFound.EsaDbClient::CreatePhoneVerificationTicket::Failed.EsaDbClient::GetPhoneVerificationTicket::NotFound.EsaDbClient::UpdatePhoneVerificationTicket::NotFound.EsaDbClient::DeletePhoneVerificationTicket::NotFound.EsaDbClient::CreateWebhook::Failed.EsaDbClient::GetWebhook::NotFound.EsaDbClient::GetWebhook::NotFoundGuid.EsaDbClient::GetWebhook::NotFoundDomain.EsaDbClient::UpdateWebhook::NotFound.EsaDbClient::DeleteWebhook::NotFound.EsaDbClient::GetOperation::NotFound.EsaDbClient::GetOperation::NotFoundPlan.EsaDbClient::UpdateOperation::NotFound.EsaDbClient::DeleteOperation::NotFound.EsaDbClient::CreatePartner::Failed.EsaDbClient::CreatePartner::NotFoundOrganization.EsaDbClient::GetPartner::NotFound.EsaDbClient::GetPartner::NotFoundGuid.EsaDbClient::GetPartner::NotFoundDomain.EsaDbClient::UpdatePartner::NotFound.EsaDbClient::UpdatePartner::NotFoundOrganization.EsaDbClient::DeletePartner::NotFound.EsaDbClient::CreatePartnerApplicant::Failed.EsaDbClient::CreatePartnerApplicant::NotFoundDomain.EsaDbClient::CreatePartnerApplicant::NotFoundOrganization.EsaDbClient::GetPartnerApplicant::NotFound.EsaDbClient::UpdatePartnerApplicant::NotFound.EsaDbClient::UpdatePartnerApplicant::NotFoundOrganization.EsaDbClient::DeletePartnerApplicant::NotFound.EsaDbClient::CreatePasswordInvalidationPlan::Failed.EsaDbClient::CreatePasswordInvalidationPlan::UnfinishedPlanExists.EsaDbClient::CreatePasswordInvalidationPlan::Db.EsaDbClient::UpdatePasswordInvalidationPlan::NotFound.EsaDbClient::DeletePasswordInvalidationPlan::NotFound.EsaDbClient::UpdatePasswordInvalidationTask::NotFound.EsaDbClient::UpdateDomainTakkenLicense::NotFound.EsaDbClient::UpdateDomainTakkenLicense::MismatchedTakkenLicense.EsaDbClient::UpdateDomainTakkenLicense::NotFoundTakkenLicense.EsaDbClient::GetCorporateNumberCorporation::NotFound.EsaDbClient::CreateFeatureGrant::AlreadyExists.EsaDbClient::GetFeatureGrant::NotFound.EsaDbClient::SyncFeatureGrant::NotFoundFeatureGrant.ProxyClient::Validation::StartIndexMustBeGreaterThanZero.ProxyClient::Validation::StartIndexExceedsBounds.ProxyClient::Validation::ItemsPerPageExceedsBounds.ProxyClient::Validation::ItemsPerPageExceedsLimit.ProxyClient::ActivateActivationTicket::Forbidden.ProxyClient::ActivateActivationTicket::AlreadyJoinedEbone.ProxyClient::ActivateActivationTicket::NotFoundAdminRole.ProxyClient::ActivateActivationTicket::NotFoundOrganization.ProxyClient::ActivateActivationTicket::NotAdminUser.ProxyClient::ActivationPlan::Forbidden.ProxyClient::ActivationPlan::InvalidState.ProxyClient::ActivationPlan::ForbiddenUpdateTakkenLicense.ProxyClient::ActivationPlan::PlanInProgress.ProxyClient::CreateDomainInvitation::InvalidDomainName.ProxyClient::CreateDomainInvitation::InvalidCorporateNumber.ProxyClient::CreateDomainInvitation::NotFoundCorporateNumber.ProxyClient::CreateDomainInvitation::ClosedCorporateNumber.ProxyClient::CreateDomainInvitation::InvalidEmail.ProxyClient::CreateDomainInvitation::InvalidDisplayName.ProxyClient::CreateDomainInvitation::DisplayNameRequired.ProxyClient::CreateDomainInvitation::InvitedByDomainRequired.ProxyClient::CreateDomainInvitation::InvitedByOrganizationDomainMismatch.ProxyClient::CreateDomainInvitation::DuplicatePendingInvitation.ProxyClient::CreateDomainInvitationActivation::Forbidden.ProxyClient::CreateDomainInvitationActivation::Expired.ProxyClient::CreateDomainInvitationActivation::AlreadyAccepted.ProxyClient::CreateDomainInvitationActivation::Cancelled.ProxyClient::CreateDomainInvitationActivation::InvalidDisplayName.ProxyClient::CreateDomainInvitationActivation::NotFoundMemberRole.ProxyClient::CreateDomainInvitationActivation::NotFoundDomainOrganization.ProxyClient::CreateCollaboratorInvitation::NotFoundUserInLoginContext.ProxyClient::CreateCollaboratorInvitation::Forbidden.ProxyClient::CreateCollaboratorInvitation::InvalidTeamName.ProxyClient::CreateCollaboratorInvitation::InvalidCorporateNumber.ProxyClient::CreateCollaboratorInvitation::NotFoundCorporateNumber.ProxyClient::CreateCollaboratorInvitation::ClosedCorporateNumber.ProxyClient::CreateCollaboratorInvitation::InvalidEmail.ProxyClient::CreateCollaboratorInvitation::InvalidDisplayName.ProxyClient::CreateCollaboratorInvitation::DisplayNameRequired.ProxyClient::CreateCollaboratorInvitation::InvitedByDomainRequired.ProxyClient::CreateCollaboratorInvitation::InvitedByOrganizationDomainMismatch.ProxyClient::CreateCollaboratorInvitation::DuplicateDomainPendingInvitation.ProxyClient::CreateCollaboratorInvitation::AlreadyMember.ProxyClient::CreateCollaboratorInvitation::AlreadyMemberOfAnotherTeam.ProxyClient::CreateCollaboratorInvitation::DuplicateTeamPendingInvitation.ProxyClient::CreateCollaboratorInvitation::NoTeam.ProxyClient::CreateProviderUserBlock::RedisConnection.ProxyClient::CreateProviderUserBlock::CacheClient.ProxyClient::DeleteProviderUserBlock::RedisConnection.ProxyClient::DeleteProviderUserBlock::CacheClient.ProxyClient::DeleteProviderUserBlock::BlockedAccountListNotReturned.ProxyClient::CreateCollaboratorInvitationActivation::Forbidden.ProxyClient::CreateCollaboratorInvitationActivation::Expired.ProxyClient::CreateCollaboratorInvitationActivation::AlreadyAccepted.ProxyClient::CreateCollaboratorInvitationActivation::Cancelled.ProxyClient::CreateCollaboratorInvitationActivation::InvalidDisplayName.ProxyClient::CreateCollaboratorInvitationActivation::MissingTeamName.ProxyClient::CreateCollaboratorInvitationActivation::MissingCorporateNumber.ProxyClient::CreateCollaboratorInvitationActivation::AlreadyMemberOfAnotherTeam.ProxyClient::CreatePhoneVerificationTicket::NotFoundOffices.ProxyClient::CreatePhoneVerificationTicket::CreatePhoneVerificationTicketBadRequest.ProxyClient::CreatePhoneVerificationTicket::TakkenClient.ProxyClient::CreatePhoneVerificationTicket::EsaDbClient.ProxyClient::CreatePhoneVerificationTicket::TwiMl.ProxyClient::CreateOrganization::Forbidden.ProxyClient::CreateOrganization::DuplicateName.ProxyClient::CreateOrganization::InvalidRequest.ProxyClient::CreateOrganization::CreateEbone.ProxyClient::CreatePlan::Forbidden.ProxyClient::CreatePlan::InvalidPlanOperations.ProxyClient::CreateProviderUser::DuplicateProviderUser.ProxyClient::CreateRole::Forbidden.ProxyClient::CreateSupportAccount::NotFoundIssuerEmail.ProxyClient::CreateSupportAccount::InvalidIssuerEmail.ProxyClient::CreateSupportAccount::InvalidExpiresInHours.ProxyClient::CreateSupportAccount::ProhibitedSupportAccount.ProxyClient::CreateSupportAccount::NotFoundSupportAccountReason.ProxyClient::CreateSupportAccount::ClosedSupportAccountReason.ProxyClient::CreateSupportAccount::NotAllowedByReason.ProxyClient::CreateSupportAccount::DuplicateSupportAccountEmail.ProxyClient::CreateSupportAccount::DuplicateSupportAccountIssuer.ProxyClient::CreateSupportAccount::NotFoundRole.ProxyClient::CreateSupportAccount::NotFoundRoleEbone.ProxyClient::CreateSupportAccount::NotFoundOrganization.ProxyClient::CreateSupportAccount::InvalidOrganization.ProxyClient::CreateSupportAccount::NotFoundOrganizationEbone.ProxyClient::CreateSupportAccountReason::NotFoundRegistrantEmail.ProxyClient::CreateSupportAccountReason::InvalidCustomerApproval.ProxyClient::CreateSupportAccountReason::ProhibitedSupportAccount.ProxyClient::CreateSupportAccountReason::InvalidAllowedOrganizations.ProxyClient::CreateSupportAccountReason::InvalidAllowedRoles.ProxyClient::CreateUser::Forbidden.ProxyClient::CreateUser::NotFoundOrganization.ProxyClient::CreateUser::InvalidOrganization.ProxyClient::CreateUser::NotFoundOrganizationEbone.ProxyClient::CreateUser::NotFoundRoleEbone.ProxyClient::CreateUser::InvalidRequest.ProxyClient::CreateInvitation::Forbidden.ProxyClient::CreateInvitation::DuplicateUserEmail.ProxyClient::CreateInvitation::DuplicateInvitationEmail.ProxyClient::CreateInvitation::NotFoundUserInLoginContext.ProxyClient::CreateInvitation::DuplicateEboneUserEmail.ProxyClient::CreateInvitationActivation::Forbidden.ProxyClient::CreateInvitationActivation::Expired.ProxyClient::CreateInvitationActivation::DuplicateUserEmail.ProxyClient::CreateInvitationActivation::NotFoundRole.ProxyClient::CreateInvitationActivation::DuplicateEboneUserEmail.ProxyClient::CreateMemberApplicant::Forbidden.ProxyClient::CreateMemberApplicant::AlreadyJoined.ProxyClient::CreateMemberApplicant::AlreadyJoinedEbone.ProxyClient::CreateMemberApplicant::InvalidRequestData.ProxyClient::CreateMemberApplicant::ExpiredPhoneVerificationTicket.ProxyClient::CreateMemberApplicant::NotEmailVerified.ProxyClient::CreateMemberApplicant::NotFoundRole.ProxyClient::CreateMemberApplicant::IsSyncedEbone.ProxyClient::CreateMemberApplicant::DuplicateEboneUserEmail.ProxyClient::CreateMemberApplicantApproval::Forbidden.ProxyClient::CreateMemberApplicantApproval::AlreadyJoined.ProxyClient::CreateMemberApplicantApproval::NotFoundUserInLoginContext.ProxyClient::CreateMemberApplicantApproval::NonAdministratorCreatesAdministrator.ProxyClient::CreateMemberApplicantApproval::DomainUidMismatch.ProxyClient::CreateMemberApplicantApproval::DuplicateEboneUserEmail.ProxyClient::CreateMemberApplicantRejection::Forbidden.ProxyClient::CreateMemberApplicantRejection::NotFoundUserInLoginContext.ProxyClient::CreateMemberApplicantCancellation::Forbidden.ProxyClient::CreateEsaData::Forbidden.ProxyClient::CreateEsaData::FailedParseClientSecurityRole.ProxyClient::CreateEsaData::NotFoundAdminRole.ProxyClient::CreateInitialRoles::NotFoundAdminRole.ProxyClient::CreateInitialData::Forbidden.ProxyClient::CreateInitialData::InvalidRequest.ProxyClient::CreateInitialData::NotEmailVerified.ProxyClient::CreateInitialData::NotFoundTakkenLicense.ProxyClient::CreateDomainFile::Forbidden.ProxyClient::CreateDomainFile::UnexpectedContentType.ProxyClient::CreateDomainFile::ExceededBytesLimit.ProxyClient::CreateEboneOrganization::FailedSerializeBukkenJishaKokai.ProxyClient::CreateEboneUser::FailedSerializeNotificationSettings.ProxyClient::CreateMfaEnrollmentTicket::Forbidden.ProxyClient::CreateMfaEnrollmentTicket::Auth0UserNotFound.ProxyClient::CreateEmailChangeTicket::Forbidden.ProxyClient::CreateEmailChangeTicket::DuplicateAuth0UserEmail.ProxyClient::CreateEmailChangeTicket::DuplicateEboneUserEmail.ProxyClient::CreateEmailChangeTicketActivation::Forbidden.ProxyClient::CreateEmailChangeTicketActivation::Expired.ProxyClient::CreateEmailChangeTicketActivation::DuplicateAuth0UserEmail.ProxyClient::CreateEmailChangeTicketActivation::DuplicateEboneUserEmail.ProxyClient::CreatePasswordChangeTicket::Forbidden.ProxyClient::CreatePasswordChangeTicket::Auth0UserNotFound.ProxyClient::CreatePasswordInvalidationPlanCancellation::NotFound.ProxyClient::CreatePasswordInvalidationPlanCancellation::InvalidState.ProxyClient::CreateProviderUserLog::ProviderUserUidMismatch.ProxyClient::CreateLog::NotFoundRequiredParam.ProxyClient::CreatePartnerApplicant::Forbidden.ProxyClient::CreatePartnerApplicant::DuplicateOrganizationUid.ProxyClient::CreatePartnerApplicant::AlreadyPartner.ProxyClient::CreatePartnerApplicant::AlreadyExistsOppositeSidePartnerApplicant.ProxyClient::CreatePartnerApplicant::AlreadyExistsActivePartnerApplicant.ProxyClient::CreatePartnerApplicantApproval::Forbidden.ProxyClient::CreatePartnerApplicantApproval::InvalidState.ProxyClient::CreatePartnerApplicantCancellation::Forbidden.ProxyClient::CreatePartnerApplicantCancellation::InvalidState.ProxyClient::CreatePartnerApplicantRejection::Forbidden.ProxyClient::CreatePartnerApplicantRejection::InvalidState.ProxyClient::UpdateProviderUser::ProviderUserUidMismatch.ProxyClient::UpdateProviderUser::Forbidden.ProxyClient::UpdateProviderUser::ProhibitedChangeToValidEmail.ProxyClient::UpdateProviderUser::DuplicateAuth0UserEmail.ProxyClient::UpdateRole::RoleUidMismatch.ProxyClient::UpdateRole::Forbidden.ProxyClient::UpdateSecurityDescriptor::SecurityDescriptorUidMismatch.ProxyClient::UpdateUser::UserUidMismatch.ProxyClient::UpdateUser::Forbidden.ProxyClient::UpdateUser::NoAdministratorExists.ProxyClient::UpdateUser::InvalidRequest.ProxyClient::UpdateUser::DefaultOrganizationNotInOrganizations.ProxyClient::UpdateUserMfaExemption::Forbidden.ProxyClient::UpdateUserMfaExemption::MfaNotEnforced.ProxyClient::UpdateUserMfaExemption::MfaEnforcedInOtherDomain.ProxyClient::UpdateUserMfaExemption::AuthenticationMethodsNotDeleted.ProxyClient::DeleteUserMfaExemption::Forbidden.ProxyClient::CreateVerificationEmailJob::Forbidden.ProxyClient::CreateVerificationEmailJob::Auth0UserNotFound.ProxyClient::UpsertEboneClientSecurityRole::FailedSerializeClientSecurityRole.ProxyClient::UpsertEboneClientSecurityRole::FailedUpsertClientSecurityRole.ProxyClient::UpdateOrganization::OrganizationUidMismatch.ProxyClient::UpdateOrganization::Forbidden.ProxyClient::UpdateOrganization::DuplicateName.ProxyClient::UpdateOrganization::InvalidRequest.ProxyClient::UpdateOrganization::RenameContractedOrganization.ProxyClient::UpdateOrganization::UpdateEbone.ProxyClient::UpdatePlan::PlanUidMismatch.ProxyClient::UpdatePlan::Forbidden.ProxyClient::UpdatePlan::InvalidPlanOperations.ProxyClient::UpdateDomain::DomainUidMismatch.ProxyClient::UpdateDomain::Forbidden.ProxyClient::UpdateDomain::ForbiddenTakkenLicenseImage.ProxyClient::UpdateDomain::ForbiddenLogoLicenseImage.ProxyClient::UpdateDomain::InvalidRequest.ProxyClient::GetDomainTakkenLicense::Forbidden.ProxyClient::UpdateDomainMfaState::Forbidden.ProxyClient::UpdateDomainMfaState::MfaDeviceNotEnrolled.ProxyClient::UpdateDomainMfaState::AuthMethodNotEnabled.ProxyClient::UpdateDomainMfaState::TotpRequired.ProxyClient::UpdateDomainTakkenLicense::Forbidden.ProxyClient::UpdateDomainTakkenLicense::ExpiredPasscode.ProxyClient::UpdateEboneRole::FailedDeserializeClientSecurityRole.ProxyClient::UpdateEboneRole::FailedSerializeClientSecurityRole.ProxyClient::UpdateInvitation::InvitationUidMismatch.ProxyClient::UpdateInvitation::Forbidden.ProxyClient::UpdateDefaultRole::DefaultRoleUidMismatch.ProxyClient::UpdateWebhook::WebhookUidMismatch.ProxyClient::UpdateWebhook::Forbidden.ProxyClient::GetCollaborator::Forbidden.ProxyClient::GetCollaboratorInvitation::NotFoundUserInLoginContext.ProxyClient::GetCollaboratorInvitation::Forbidden.ProxyClient::DeleteCollaboratorInvitation::AlreadyAccepted.ProxyClient::DeleteCollaboratorInvitation::Forbidden.ProxyClient::GetCollaboratorTeamInvitations::Forbidden.ProxyClient::GetCollaboratorTeamMembers::Forbidden.ProxyClient::UpdateCollaboratorTeamMember::Forbidden.ProxyClient::UpdateCollaboratorTeamMember::NotFound.ProxyClient::UpdateCollaboratorTeamMember::InvalidDisplayName.ProxyClient::UpdateCollaboratorTeamMember::InvalidRole.ProxyClient::UpdateCollaboratorTeamMember::LastAdmin.ProxyClient::DeleteCollaboratorTeamMember::Forbidden.ProxyClient::DeleteCollaboratorTeamMember::NotFound.ProxyClient::DeleteCollaboratorTeamMember::LastAdmin.ProxyClient::CheckCollaboratorInvitation::Forbidden.ProxyClient::CheckCollaboratorInvitation::Expired.ProxyClient::CheckCollaboratorInvitation::AlreadyAccepted.ProxyClient::CheckCollaboratorInvitation::Cancelled.ProxyClient::CheckCollaboratorInvitation::MissingTeamName.ProxyClient::CheckCollaboratorInvitation::AlreadyMemberOfAnotherTeam.ProxyClient::CheckDomainInvitation::Forbidden.ProxyClient::CheckDomainInvitation::Expired.ProxyClient::CheckDomainInvitation::Cancelled.ProxyClient::GetRole::Forbidden.ProxyClient::GetRoleSecurityDescriptors::Forbidden.ProxyClient::GetTakkenData::NotFound.ProxyClient::GetUser::Forbidden.ProxyClient::GetDomain::Forbidden.ProxyClient::GetDomainMfaState::Forbidden.ProxyClient::GetOrganization::Forbidden.ProxyClient::GetPartnerApplicant::Forbidden.ProxyClient::SearchDomains::Forbidden.ProxyClient::SearchDomains::InvalidQueryValue.ProxyClient::SearchOrganizations::Forbidden.ProxyClient::GetPlan::Forbidden.ProxyClient::SearchPartners::Forbidden.ProxyClient::SearchPartnerApplicants::Forbidden.ProxyClient::SearchPartnerApplicants::UnexpectedState.ProxyClient::SearchOrganizationPartners::Forbidden.ProxyClient::SearchOrganizationPartnerApplicants::Forbidden.ProxyClient::GetProviderUser::Forbidden.ProxyClient::SearchProviderUsers::Forbidden.ProxyClient::SearchProviderUsers::LastLoginDaysOutOfRange.ProxyClient::SearchProviderUserPartnerOrganizationGuids::Forbidden.ProxyClient::SearchUsers::Forbidden.ProxyClient::SearchUserPartners::Forbidden.ProxyClient::SearchRoles::Forbidden.ProxyClient::GetProviderUserBlock::RedisConnection.ProxyClient::GetProviderUserBlock::CacheClient.ProxyClient::GetProviderUserDomains::Forbidden.ProxyClient::GetProviderUserEboneOrganizations::Forbidden.ProxyClient::GetProviderUserMemberApplicants::Forbidden.ProxyClient::GetProviderUserLoginPolicy::Forbidden.ProxyClient::GetProviderUserLoginPolicy::InvalidLoginAttempt.ProxyClient::GetProviderUserMfaState::Forbidden.ProxyClient::GetFile::Forbidden.ProxyClient::GetFile::NotFoundFile.ProxyClient::GetInvitation::Forbidden.ProxyClient::GetInvitingDomain::Expired.ProxyClient::GetInvitingDomain::Forbidden.ProxyClient::GetLegacyAccounts::NotFoundPageToken.ProxyClient::GetLegacyDomains::NotFoundPageToken.ProxyClient::GetLegacyOrganizations::NotFoundPageToken.ProxyClient::GetCurrentUserProfile::Forbidden.ProxyClient::GetMemberApplicant::Forbidden.ProxyClient::GetCurrentUser::NotRegisteredDefaultAndCurrentUser.ProxyClient::GetCurrentUser::NotFoundCurrentUser.ProxyClient::GetCustomer::NotFoundCustomer.ProxyClient::GetCustomerContracts::NotBelongingCustomer.ProxyClient::GetCustomerContracts::AdminRoleRequired.ProxyClient::GetCustomerProfile::NotFoundZuoraAccount.ProxyClient::GetCustomerProfile::MultipleZuoraAccountsFound.ProxyClient::GetCustomerProfile::MultipleOrganizationsFound.ProxyClient::GetCustomerProfile::NotBelongingCustomer.ProxyClient::GetCustomerProfile::AdminRoleRequired.ProxyClient::GetCustomerSubscriptions::FailedParseCustomerId.ProxyClient::DeactivateCustomer::AlreadyDeactivated.ProxyClient::GetDomainPlans::Forbidden.ProxyClient::GetDomainPlanSummaries::Forbidden.ProxyClient::GetDomainRoles::Forbidden.ProxyClient::GetDomainVegaLicenses::Forbidden.ProxyClient::GetDomainVegaLicenses::NotFoundEbone.ProxyClient::GetDomainVegaLicenses::NotFoundCustomerId.ProxyClient::GetDomainVegaLicenses::NotFoundCustomer.ProxyClient::GetDomainTakkenLicenseImage::Forbidden.ProxyClient::GetDomainTakkenLicenseImage::NotFound.ProxyClient::GetDomainTakkenLicenseImage::NotFoundFile.ProxyClient::GetDomainUserAuthenticationMethods::Forbidden.ProxyClient::GetDomainUsers::Forbidden.ProxyClient::GetDomainUsersExport::CSV.ProxyClient::GetDomainUsersExport::CSVIntoInner.ProxyClient::GetDomainUsersExport::StringFromUtf8.ProxyClient::GetDomainUsersExport::Forbidden.ProxyClient::GetDomainOperationHistories::Forbidden.ProxyClient::GetDomainOperationHistories::InvalidRange.ProxyClient::GetDomainOperationHistories::UnknownOperation.ProxyClient::GetEboneClientSecurityRole::FailedParseClientSecurityRole.ProxyClient::GetDomainOrganizations::Forbidden.ProxyClient::GetSupportAccounts::NotFoundIssuerEmail.ProxyClient::GetPhoneVerificationTickets::Forbidden.ProxyClient::GetDomainInvitations::Forbidden.ProxyClient::GetDomainLogoImage::NotFound.ProxyClient::GetDomainLogoImage::NotFoundFile.ProxyClient::GetDomainMemberApplicants::Forbidden.ProxyClient::DeleteOrganization::Forbidden.ProxyClient::DeleteOrganization::ExistsUsersWhoBelongByDefault.ProxyClient::DeleteOrganization::DeleteContractedOrganization.ProxyClient::DeletePlan::Forbidden.ProxyClient::DeleteRole::Forbidden.ProxyClient::DeleteRole::ExistsUsersAssociatedWithRoles.ProxyClient::DeleteUser::Forbidden.ProxyClient::DeleteUser::RequiredAtLeastOneAdmin.ProxyClient::DeleteInvitation::Forbidden.ProxyClient::DeleteMemberApplicant::Forbidden.ProxyClient::DeleteDomain::ForbiddenToDeleteEboneDomain.ProxyClient::DeleteDomain::Forbidden.ProxyClient::DeleteEsaOrganization::NotFound.ProxyClient::DeletePartner::Forbidden.ProxyClient::DeletePasswordInvalidationPlan::NotFound.ProxyClient::DeletePasswordInvalidationPlan::InvalidState.ProxyClient::DeleteSupportAccount::NotSupportAccount.ProxyClient::DeleteSupportAccount::NotIssuer.ProxyClient::CreateSupportAccountPasswordReset::NotFoundResetByEmail.ProxyClient::CreateSupportAccountPasswordReset::NotSupportAccount.ProxyClient::CreateSupportAccountPasswordReset::NotIssuer.ProxyClient::CreateSupportAccountPasswordReset::ExpiredSupportAccount.ProxyClient::CreateSupportAccountPasswordReset::ProhibitedSupportAccount.ProxyClient::DeleteDomainSupportAccountProhibition::NotFound.ProxyClient::PutDomainSupportAccountProhibition::NotFoundRegistrantEmail.ProxyClient::PutDomainSupportAccountProhibition::InvalidReason.ProxyClient::DeleteDomainMemo::NotFound.ProxyClient::PutDomainMemo::NotFoundRegistrantEmail.ProxyClient::PutDomainMemo::InvalidContent.ProxyClient::CreateFeatureGrant::InvalidKey.ProxyClient::CreateFeatureGrant::ReservedNamespace.ProxyClient::CreateFeatureGrant::BlankDescription.ProxyClient::DeleteFeatureGrant::ReservedNamespace.ProxyClient::DeleteFeatureGrant::Assigned.ProxyClient::UpdateFeatureGrant::ReservedNamespace.ProxyClient::UpdateFeatureGrant::BlankDescription.ProxyClient::UpdateFeatureGrant::NoChange.ProxyClient::InvalidatePasswords::PlanIsGone.ProxyClient::InvalidatePasswords::PlanLeftUnfinished.ProxyClient::InvalidatePasswords::FailedTasksLeft.ProxyClient::InvalidatePasswords::AbortedByConsecutiveFailures.ProxyClient::InvalidatePasswords::AbortedByRunDeadline.ProxyClient::PlanPasswordInvalidations::UnfinishedPlanExists.ProxyClient::PlanPasswordInvalidations::NotFoundConnection.ProxyClient::PlanPasswordInvalidations::InvalidExportJob.ProxyClient::PlanPasswordInvalidations::ExportJobFailed.ProxyClient::PlanPasswordInvalidations::ExportJobWithoutLocation.ProxyClient::PlanPasswordInvalidations::ExportJobTimedOut.ProxyClient::PlanPasswordInvalidations::FailedDownloadExportedUsers.ProxyClient::PlanPasswordInvalidations::FailedParseExportedUser.ProxyClient::PlanPasswordInvalidations::MissingExportedField.ProxyClient::PlanPasswordInvalidations::TooManyTasks.ProxyClient::ExecutePlan::Forbidden.ProxyClient::ExecutePlan::NotInProgress.ProxyClient::ArchiveOperationHistories::ArchiveNotConfigured.ProxyClient::MergeDomain::Forbidden.ProxyClient::MergeDomain::ForbiddenToSpecifyEboneDomainInSrc.ProxyClient::MergeDomain::NotExistRolesInDestDomain.ProxyClient::MoveInvitation::Forbidden.ProxyClient::MoveMemberApplicant::Forbidden.ProxyClient::MoveOrganization::Forbidden.ProxyClient::MoveOrganization::ForbiddenToMoveEboneOrganization.ProxyClient::MovePlan::Forbidden.ProxyClient::MoveRole::Forbidden.ProxyClient::MoveRole::ForbiddenToMoveEboneRole.ProxyClient::MoveUser::Forbidden.ProxyClient::MoveUser::ForbiddenToMoveEboneUser.ProxyClient::MoveUser::NotFoundRoleEbone.ProxyClient::MoveUser::AlreadyExistsEmailInEbone.ProxyClient::NotifyActivation::NotCompanyCustomer.ProxyClient::NotifyActivation::NotFoundAuth0User.ProxyClient::NotifyActivation::NotFoundEmail.ProxyClient::NotifyActivation::NotFoundDomainName.ProxyClient::IsSync::NotFoundEsaDomain.ProxyClient::IsSync::NotFoundEboneInEsaDomain.ProxyClient::IsAutoApprovalTarget::InvalidMail.ProxyClient::ResendDomainInvitation::AlreadyAccepted.ProxyClient::ResendDomainInvitation::AlreadyClosed.ProxyClient::DeleteDomainInvitation::AlreadyAccepted.ProxyClient::ResendCollaboratorInvitation::AlreadyAccepted.ProxyClient::ResendCollaboratorInvitation::AlreadyClosed.ProxyClient::ResendCollaboratorInvitation::NotFoundUserInLoginContext.ProxyClient::ResendCollaboratorInvitation::Forbidden.ProxyClient::ResendCollaboratorInvitation::ForbiddenCollaborator.ProxyClient::ResendCollaboratorInvitation::MissingTeamName.ProxyClient::ResendInvitation::Forbidden.ProxyClient::ResendInvitation::NotFoundUserInLoginContext.ProxyClient::SignUpProviderUser::DuplicateProviderUser.ProxyClient::SignUpProviderUser::InvalidParameterCombination.ProxyClient::SyncCollaboratorTeamDomain::NotCollaboratorDomain.ProxyClient::SyncCollaboratorTeamDomain::CorporateNumberMismatch.ProxyClient::SyncCollaboratorTeamDomain::UserInAnotherDomain.ProxyClient::SyncCollaboratorTeamDomain::UserOfAnotherAccount.ProxyClient::SyncCollaboratorTeamDomain::JoinedAsAnotherUser.ProxyClient::SyncCollaboratorTeamDomain::EmailUsedByAnotherAccount.ProxyClient::SyncCollaboratorTeamDomain::InitialRoleNotFound.ProxyClient::SyncCollaboratorTeamDomain::OrganizationNotFound.ProxyClient::SyncCustomer::CustomerIdMismatch.ProxyClient::SyncCustomer::UnexpectedSyncEvent.ProxyClient::SyncCustomer::MismatchEventAndPayload.ProxyClient::SyncCustomer::FailedToSetTimeZone.ProxyClient::SyncCustomer::FailedToParseCustomerId.ProxyClient::SyncDomainLicenses::FailedToSetTimeZone.ProxyClient::SyncEboneAll::NotFound.ProxyClient::SyncEboneDomain::NotFound.ProxyClient::SyncEboneDomain::CreatingDomainClearedIsInvalid.ProxyClient::SyncEboneOrganization::AlreadyDeleted.ProxyClient::SyncEboneOrganization::NotFoundDomain.ProxyClient::SyncEboneRole::AlreadyDeleted.ProxyClient::SyncEboneRole::NotFoundDomain.ProxyClient::SyncEboneUser::NotFoundAuth0User.ProxyClient::SyncEboneUser::AlreadyDeleted.ProxyClient::SyncEboneUser::NotFoundDomain.ProxyClient::SyncEsaFile::NotFoundDomain.ProxyClient::SyncEsaFile::NotFoundEbone.ProxyClient::SyncEsaFile::NotFoundFile.ProxyClient::SyncEsaFile::UnexpectedContentType.ProxyClient::SyncEsaOrganization::NotFoundEbone.ProxyClient::SyncEsaRole::NotFoundEbone.ProxyClient::SyncEsaUser::NotFoundEbone.ProxyClient::SyncEsaUser::NotFoundRoleEbone.ProxyClient::SyncProviderUser::Forbidden.ProxyClient::ValidateActivationTicketToken::InvalidActivationTicket.ProxyClient::ValidateRolePermission::NotFoundUserInLoginContext.ProxyClient::ValidateRolePermission::NonAdministratorOperateAdministrator.ProxyClient::ValidateRolePermission::DomainUidMismatch.ProxyClient::ValidateRolePermission::CannotAssignRoleStrongerThanItself.ProxyClient::MoveOrganizationPartners::Forbidden.ProxyClient::MoveOrganizationPartnerApplicants::Forbidden.ProxyClient::GetProviderUserAuthenticationMethods::Forbidden.ProxyClient::DeleteProviderUserAuthenticationMethod::Forbidden.ProxyClient::DeleteProviderUserAuthenticationMethod::AuthenticationMethodNotFound.ProxyClient::DeleteProviderUserAuthenticationMethods::Forbidden.ProxyClient::DeleteProviderUserAuthenticationMethods::TypesNotSpecified.ProxyClient::DeleteProviderUserAuthenticationMethods::TypeNotDeletable.ProxyClient::CreateProviderUserAuthenticationMethodSync::Forbidden.ProxyClient::CreateProviderUserAuthenticationMethodSync::NotRecorded.ProxyClient::SyncAuth0Event::StaleFetchedAuthenticationMethods.ProxyClient::SyncTakkenLicenseExistence::AllLicensesFailed.ProxyClient::UpdateDomainTakkenLicenseVerification::InvalidRequest.Convert::LicensorConvert::FailedCompileRegex.Convert::RoleConvert::ResToCreate.Convert::RoleConvert::ResToRead.Convert::RoleConvert::ResToUpdate.SendGridClient::FailedBuildClient.SendGridClient::SendGridMail.MailClient::FailedBuildClient.MailClient::SendGridClient::FailedBuildClient.MailClient::SendGridClient::SendGridMail.MailClient::SendActivatedCustomer::SendGridClient.MailClient::SendApprovedMemberApplicant::SendGridClient.MailClient::SendApprovedMemberApplicantToAdmin::SendGridClient.MailClient::SendCanceledMemberApplicantToAdmin::SendGridClient.MailClient::SendCanceledPartnerApplicant::SendGridClient.MailClient::SendCollaboratorInvitation::SendGridClient.MailClient::SendCollaboratorLinked::SendGridClient.MailClient::SendCreatedEmailChangeTicket::SendGridClient.MailClient::SendCreatedMemberApplicant::SendGridClient.MailClient::SendCreatedMemberApplicantToAdmin::SendGridClient.MailClient::SendCreatedPartner::SendGridClient.MailClient::SendCreatedPartnerApplicant::SendGridClient.MailClient::SendCreatedPasswordChangeTicket::SendGridClient.MailClient::SendInvitation::SendGridClient.MailClient::SendRegistration::SendGridClient.MailClient::SendRejectedMemberApplicant::SendGridClient.MailClient::SendRejectedMemberApplicantToAdmin::SendGridClient.MailClient::SendRejectedPartnerApplicant::SendGridClient.Auth0ManagementClient::FailedBuildClient.Auth0ManagementClient::GetAuth0AuthClient::FailedBuildClient.Auth0ManagementClient::GetAuth0AuthClient::CreateAuth0AccessToken::Network.Auth0ManagementClient::GetAuth0AuthClient::CreateAuth0AccessToken::FailedRequest.Auth0ManagementClient::GetAuth0AuthClient::CreateAuth0AccessToken::FailedReadResponse.Auth0ManagementClient::GetAuth0AuthClient::CreateAuth0AccessToken::FailedParseResponse.Auth0ManagementClient::GetAuth0AuthClient::CreateAuth0AccessToken::CacheClient::FailedBuildClient.Auth0ManagementClient::GetAuth0AuthClient::CreateAuth0AccessToken::CacheClient::RedisCacheClient::Serde.Auth0ManagementClient::GetAuth0AuthClient::CreateAuth0AccessToken::CacheClient::RedisCacheClient::Redis.Auth0ManagementClient::GetAuth0AuthClient::CreateAuth0AccessToken::CacheClient::RedisCacheClient::Timeout.Auth0ManagementClient::GetAuth0AuthClient::CreateAuth0AccessToken::DecodeJwt.Auth0ManagementClient::CreateExportUsersJob::Network.Auth0ManagementClient::CreateExportUsersJob::FailedRequest.Auth0ManagementClient::CreateExportUsersJob::FailedReadResponse.Auth0ManagementClient::CreateExportUsersJob::FailedParseResponse.Auth0ManagementClient::CreateAuth0User::Network.Auth0ManagementClient::CreateAuth0User::FailedRequest.Auth0ManagementClient::CreateAuth0User::FailedReadResponse.Auth0ManagementClient::CreateAuth0User::FailedParseResponse.Auth0ManagementClient::DeleteAuth0User::Network.Auth0ManagementClient::DeleteAuth0User::FailedRequest.Auth0ManagementClient::GetConnections::Network.Auth0ManagementClient::GetConnections::FailedRequest.Auth0ManagementClient::GetConnections::FailedReadResponse.Auth0ManagementClient::GetConnections::FailedParseResponse.Auth0ManagementClient::GetJob::Network.Auth0ManagementClient::GetJob::FailedRequest.Auth0ManagementClient::GetJob::FailedReadResponse.Auth0ManagementClient::GetJob::FailedParseResponse.Auth0ManagementClient::GetAuth0User::Network.Auth0ManagementClient::GetAuth0User::FailedRequest.Auth0ManagementClient::GetAuth0User::FailedReadResponse.Auth0ManagementClient::GetAuth0User::FailedParseResponse.Auth0ManagementClient::CreatePasswordChangeTicket::Network.Auth0ManagementClient::CreatePasswordChangeTicket::FailedRequest.Auth0ManagementClient::CreatePasswordChangeTicket::FailedReadResponse.Auth0ManagementClient::CreatePasswordChangeTicket::FailedParseResponse.Auth0ManagementClient::UpdateAuth0UserEmail::BadRequest.Auth0ManagementClient::UpdateAuth0UserEmail::Network.Auth0ManagementClient::UpdateAuth0UserEmail::FailedRequest.Auth0ManagementClient::UpdateAuth0UserEmail::FailedReadResponse.Auth0ManagementClient::UpdateAuth0UserEmail::FailedParseResponse.Auth0ManagementClient::UpdateAuth0UserBlocked::Network.Auth0ManagementClient::UpdateAuth0UserBlocked::FailedRequest.Auth0ManagementClient::UpdateAuth0UserBlocked::FailedReadResponse.Auth0ManagementClient::UpdateAuth0UserBlocked::FailedParseResponse.Auth0ManagementClient::UpdateAuth0UserPassword::Network.Auth0ManagementClient::UpdateAuth0UserPassword::FailedRequest.Auth0ManagementClient::SearchUsersByEmail::Network.Auth0ManagementClient::SearchUsersByEmail::FailedRequest.Auth0ManagementClient::SearchUsersByEmail::FailedReadResponse.Auth0ManagementClient::SearchUsersByEmail::FailedParseResponse.Auth0ManagementClient::CreateVerificationEmailJob::Network.Auth0ManagementClient::CreateVerificationEmailJob::FailedRequest.Auth0ManagementClient::CreateVerificationEmailJob::FailedReadResponse.Auth0ManagementClient::CreateVerificationEmailJob::FailedParseResponse.Auth0ManagementClient::DeleteBlocks::Network.Auth0ManagementClient::DeleteBlocks::FailedRequest.Auth0ManagementClient::DeleteBlocks::FailedReadResponse.Auth0ManagementClient::DeleteBlocks::FailedParseResponse.Auth0ManagementClient::GetBlocks::Network.Auth0ManagementClient::GetBlocks::FailedRequest.Auth0ManagementClient::GetBlocks::FailedReadResponse.Auth0ManagementClient::GetBlocks::FailedParseResponse.Auth0ManagementClient::CreateMfaEnrollmentTicket::Network.Auth0ManagementClient::CreateMfaEnrollmentTicket::FailedRequest.Auth0ManagementClient::CreateMfaEnrollmentTicket::FailedReadResponse.Auth0ManagementClient::CreateMfaEnrollmentTicket::FailedParseResponse.Auth0ManagementClient::GetAuth0UserAuthenticationMethods::Network.Auth0ManagementClient::GetAuth0UserAuthenticationMethods::FailedRequest.Auth0ManagementClient::GetAuth0UserAuthenticationMethods::FailedReadResponse.Auth0ManagementClient::GetAuth0UserAuthenticationMethods::FailedParseResponse.Auth0ManagementClient::DeletAuth0UserAuthenticationMethods::Network.Auth0ManagementClient::DeletAuth0UserAuthenticationMethods::FailedRequest.Auth0ManagementClient::DeleteAuth0UserAuthenticationMethod::Network.Auth0ManagementClient::DeleteAuth0UserAuthenticationMethod::FailedRequest.Auth0ManagementClient::DeleteAuth0UserSessions::Network.Auth0ManagementClient::DeleteAuth0UserSessions::FailedRequest.Auth0ManagementClient::DeleteAuth0UserRefreshTokens::Network.Auth0ManagementClient::DeleteAuth0UserRefreshTokens::FailedRequest.Auth0ManagementClient::LinkAuth0UserAccount::Network.Auth0ManagementClient::LinkAuth0UserAccount::FailedRequest.Auth0ManagementClient::LinkAuth0UserAccount::FailedReadResponse.Auth0ManagementClient::LinkAuth0UserAccount::FailedParseResponse.Auth0ManagementClient::UnlinkAuth0UserIdentity::Network.Auth0ManagementClient::UnlinkAuth0UserIdentity::FailedRequest.Auth0ManagementClient::UnlinkAuth0UserIdentity::FailedReadResponse.Auth0ManagementClient::UnlinkAuth0UserIdentity::FailedParseResponse.TakkenClient::FailedBuildClient.TakkenClient::GetAuth0AuthClient::FailedBuildClient.TakkenClient::GetAuth0AuthClient::CreateAuth0AccessToken::Network.TakkenClient::GetAuth0AuthClient::CreateAuth0AccessToken::FailedRequest.TakkenClient::GetAuth0AuthClient::CreateAuth0AccessToken::FailedReadResponse.TakkenClient::GetAuth0AuthClient::CreateAuth0AccessToken::FailedParseResponse.TakkenClient::GetAuth0AuthClient::CreateAuth0AccessToken::CacheClient::FailedBuildClient.TakkenClient::GetAuth0AuthClient::CreateAuth0AccessToken::CacheClient::RedisCacheClient::Serde.TakkenClient::GetAuth0AuthClient::CreateAuth0AccessToken::CacheClient::RedisCacheClient::Redis.TakkenClient::GetAuth0AuthClient::CreateAuth0AccessToken::CacheClient::RedisCacheClient::Timeout.TakkenClient::GetAuth0AuthClient::CreateAuth0AccessToken::DecodeJwt.TakkenClient::GetOffices::Network.TakkenClient::GetOffices::FailedRequest.TakkenClient::GetOffices::FailedReadResponse.TakkenClient::GetOffices::FailedParseResponse.TakkenClient::GetTrader::Network.TakkenClient::GetTrader::FailedRequest.TakkenClient::GetTrader::FailedReadResponse.TakkenClient::GetTrader::FailedParseResponse.TakkenClient::GetTraderOffices::Network.TakkenClient::GetTraderOffices::FailedRequest.TakkenClient::GetTraderOffices::FailedReadResponse.TakkenClient::GetTraderOffices::FailedParseResponse.TakkenClient::GetTraders::Network.TakkenClient::GetTraders::FailedRequest.TakkenClient::GetTraders::FailedReadResponse.TakkenClient::GetTraders::FailedParseResponse.TakkenClient::TraderLicense::InvalidLicense.VegaClient::FailedBuildClient.VegaClient::GetAuth0AuthClient::FailedBuildClient.VegaClient::GetAuth0AuthClient::CreateAuth0AccessToken::Network.VegaClient::GetAuth0AuthClient::CreateAuth0AccessToken::FailedRequest.VegaClient::GetAuth0AuthClient::CreateAuth0AccessToken::FailedReadResponse.VegaClient::GetAuth0AuthClient::CreateAuth0AccessToken::FailedParseResponse.VegaClient::GetAuth0AuthClient::CreateAuth0AccessToken::CacheClient::FailedBuildClient.VegaClient::GetAuth0AuthClient::CreateAuth0AccessToken::CacheClient::RedisCacheClient::Serde.VegaClient::GetAuth0AuthClient::CreateAuth0AccessToken::CacheClient::RedisCacheClient::Redis.VegaClient::GetAuth0AuthClient::CreateAuth0AccessToken::CacheClient::RedisCacheClient::Timeout.VegaClient::GetAuth0AuthClient::CreateAuth0AccessToken::DecodeJwt.VegaClient::GetVegaContainer::Network.VegaClient::GetVegaContainer::FailedRequest.VegaClient::GetVegaContainer::FailedReadResponse.VegaClient::GetVegaContainer::FailedParseResponse.FileClient::FsFileClient::IO.FileClient::FsFileClient::NotFound.FileClient::FsFileClient::FailedSerialize.FileClient::FsFileClient::FailedDeserialize.FileClient::GcsFileClient::NotFound.FileClient::GcsFileClient::FailedAuth.FileClient::GcsFileClient::FailedCreate.FileClient::GcsFileClient::FailedRead.FileClient::GcsFileClient::FailedDelete.ArchiveClient::FailedAuth.ArchiveClient::FailedHttpClient.ArchiveClient::FailedList.ArchiveClient::FailedDownload.ArchiveClient::FailedUpload.ArchiveClient::FailedSign.ArchiveClient::FailedIo.PubsubClient::GcsPubsubClient::FailedAuth.PubsubClient::GcsPubsubClient::FailedBuildClient.PubsubClient::GcsPubsubClient::FailedSerializeMessage.PubsubClient::GcsPubsubClient::FailedCreateTopic.PubsubClient::GcsPubsubClient::FailedConfirmExistsTopic.PubsubClient::GcsPubsubClient::FailedPublishMessage.PubsubClient::MessageDeserialize::FailedBase64Decode.PubsubClient::MessageDeserialize::FailedDeserialize.WebhookClient::FailedBuildClient.WebhookClient::GetAuth0AuthClient::FailedBuildClient.WebhookClient::GetAuth0AuthClient::CreateAuth0AccessToken::Network.WebhookClient::GetAuth0AuthClient::CreateAuth0AccessToken::FailedRequest.WebhookClient::GetAuth0AuthClient::CreateAuth0AccessToken::FailedReadResponse.WebhookClient::GetAuth0AuthClient::CreateAuth0AccessToken::FailedParseResponse.WebhookClient::GetAuth0AuthClient::CreateAuth0AccessToken::CacheClient::FailedBuildClient.WebhookClient::GetAuth0AuthClient::CreateAuth0AccessToken::CacheClient::RedisCacheClient::Serde.WebhookClient::GetAuth0AuthClient::CreateAuth0AccessToken::CacheClient::RedisCacheClient::Redis.WebhookClient::GetAuth0AuthClient::CreateAuth0AccessToken::CacheClient::RedisCacheClient::Timeout.WebhookClient::GetAuth0AuthClient::CreateAuth0AccessToken::DecodeJwt.WebhookClient::FailedVerifyWithNetwork.WebhookClient::FailedVerify.WebhookClient::Serde.IO.Deadpool.MasterClient::GetAddress::Network.MasterClient::GetAddress::FailedRequest.MasterClient::GetAddress::FailedReadResponse.MasterClient::GetAddress::FailedParseResponse.MasterClient::ParseAddress::Network.MasterClient::ParseAddress::FailedRequest.MasterClient::ParseAddress::FailedReadResponse.MasterClient::ParseAddress::FailedParseResponse.MasterClient::FailedBuildClient.MasterClient::GetAuth0AuthClient::FailedBuildClient.MasterClient::GetAuth0AuthClient::CreateAuth0AccessToken::Network.MasterClient::GetAuth0AuthClient::CreateAuth0AccessToken::FailedRequest.MasterClient::GetAuth0AuthClient::CreateAuth0AccessToken::FailedReadResponse.MasterClient::GetAuth0AuthClient::CreateAuth0AccessToken::FailedParseResponse.MasterClient::GetAuth0AuthClient::CreateAuth0AccessToken::CacheClient::FailedBuildClient.MasterClient::GetAuth0AuthClient::CreateAuth0AccessToken::CacheClient::RedisCacheClient::Serde.MasterClient::GetAuth0AuthClient::CreateAuth0AccessToken::CacheClient::RedisCacheClient::Redis.MasterClient::GetAuth0AuthClient::CreateAuth0AccessToken::CacheClient::RedisCacheClient::Timeout.MasterClient::GetAuth0AuthClient::CreateAuth0AccessToken::DecodeJwt.ValidateAccessAvailable::Unavailable.ValidateAccess::ValidateIp::InvalidIpFormat.ValidateAccess::ValidateIp::FailedParseForwardedFor.ValidateAccess::ValidateIp::NotApplicableIpList.ValidateAccess::ValidateIp::NotFoundIp.ValidateAccess::ValidateIp::NotFoundIpInXForwardedFor.ValidateIp::InvalidIpFormat.ValidateIp::FailedParseForwardedFor.ValidateIp::NotApplicableIpList.ValidateIp::NotFoundIp.ValidateIp::NotFoundIpInXForwardedFor.Serde.HealthCheck.DeleteM2MTokenCache::RedisConnection.DeleteM2MTokenCache::RedisCacheClient.Middleware::ValidateAuth::UnexpectedAuthorizationHeader.Middleware::ValidateAuth::NotFoundBearer.Entity::Convert.Entity::ParseEnum.Entity::Var.Entity::ExternalCodeOutOfRange.Entity::InvalidExternalCode.Entity::ExternalCodeCipher.Db.FailedDbTransaction.SplunkClient::FailedBuildClient.SplunkClient::SendEvents::Network.SplunkClient::SendEvents::FailedSerialize.SplunkClient::SendEvents::FailedRequest.ZuoraClient::FailedBuildClient.ZuoraClient::CreateAccessToken::Network.ZuoraClient::CreateAccessToken::FailedRequest.ZuoraClient::CreateAccessToken::FailedReadResponse.ZuoraClient::CreateAccessToken::FailedParseResponse.ZuoraClient::GetV1Account::Network.ZuoraClient::GetV1Account::FailedRequest.ZuoraClient::GetV1Account::FailedReadResponse.ZuoraClient::GetV1Account::FailedParseResponse.ZuoraClient::Query::Network.ZuoraClient::Query::FailedRequest.ZuoraClient::Query::FailedReadResponse.ZuoraClient::Query::FailedParseResponse.ZuoraClient::Query::IncompleteResponse.ZuoraClient::ObjectQuery::Network.ZuoraClient::ObjectQuery::FailedRequest.ZuoraClient::ObjectQuery::FailedReadResponse.ZuoraClient::ObjectQuery::FailedParseResponse.ZuoraClient::ObjectQuery::TooManyPages.ZuoraClient::ObjectQuery::UnscopedQuery.ZohoClient::FailedBuildClient.ZohoClient::CreateAccessToken::Network.ZohoClient::CreateAccessToken::FailedRequest.ZohoClient::CreateAccessToken::FailedReadResponse.ZohoClient::CreateAccessToken::FailedParseResponse.ZohoClient::CreateAccounts::Network.ZohoClient::CreateAccounts::FailedRequest.ZohoClient::CreateAccounts::FailedReadResponse.ZohoClient::CreateAccounts::FailedParseResponse.ZohoClient::CreateContacts::Network.ZohoClient::CreateContacts::FailedRequest.ZohoClient::CreateContacts::FailedReadResponse.ZohoClient::CreateContacts::FailedParseResponse.ZohoClient::SearchAccounts::Network.ZohoClient::SearchAccounts::FailedRequest.ZohoClient::SearchAccounts::FailedReadResponse.ZohoClient::SearchAccounts::FailedParseResponse.ZohoClient::SearchContacts::Network.ZohoClient::SearchContacts::FailedRequest.ZohoClient::SearchContacts::FailedReadResponse.ZohoClient::SearchContacts::FailedParseResponse.ZohoClient::UpdateAccounts::Network.ZohoClient::UpdateAccounts::FailedRequest.ZohoClient::UpdateAccounts::FailedReadResponse.ZohoClient::UpdateAccounts::FailedParseResponse.ZohoClient::UpdateContacts::Network.ZohoClient::UpdateContacts::FailedRequest.ZohoClient::UpdateContacts::FailedReadResponse.ZohoClient::UpdateContacts::FailedParseResponse".split(".")),
	raw: C().nullish()
}).passthrough(), X = j([
	"mergeDomain",
	"updateDomain",
	"updateTakkenLicense",
	"updateOrganization",
	"updateUser",
	"updateInvitation",
	"updateRole",
	"deleteOrganization",
	"deleteUser",
	"deleteInvitation",
	"deleteMemberApplicant",
	"deleteRole",
	"moveOrganization",
	"moveUser",
	"moveInvitation",
	"moveMemberApplicant",
	"moveRole"
]), Wo = j([
	"standby",
	"progress",
	"success",
	"failure"
]), Go = D({ type: A(Wo.enum.success) }), Ko = D({
	type: A(Wo.enum.failure),
	code: C()
}), qo = D({ type: A(Wo.enum.standby) }), Jo = D({ type: A(Wo.enum.progress) }), Yo = O("type", [
	Go,
	Ko,
	qo,
	Jo
]), Xo = D({
	type: A(X.enum.updateDomain),
	domain: Dn,
	domainUid: H.shape.domainUid
}), Zo = D({
	type: A(X.enum.updateTakkenLicense),
	domainUid: H.shape.domainUid,
	takkenLicense: fn
}), Qo = D({
	type: A(X.enum.updateOrganization),
	organization: Ln,
	organizationUid: Pn.shape.organizationUid
}), $o = D({
	type: A(X.enum.updateUser),
	user: lr,
	userUid: q.shape.userUid
}), es = D({
	type: A(X.enum.updateInvitation),
	invitation: fr,
	invitationUid: dr.shape.invitationUid
}), ts = D({
	type: A(X.enum.updateRole),
	role: Jn,
	roleUid: K.shape.roleUid
}), ns = D({
	type: A(X.enum.mergeDomain),
	srcDomainUid: H.shape.domainUid,
	destDomainUid: H.shape.domainUid
}), rs = D({
	type: A(X.enum.deleteOrganization),
	organizationUid: In.shape.organizationUid
}), is = D({
	type: A(X.enum.deleteUser),
	userUid: J.innerType().shape.userUid
}), as = D({
	type: A(X.enum.deleteInvitation),
	invitationUid: dr.shape.invitationUid
}), os = D({
	type: A(X.enum.deleteMemberApplicant),
	memberApplicantUid: gr.shape.memberApplicantUid
}), ss = D({
	type: A(X.enum.deleteRole),
	roleUid: K.shape.roleUid
}), cs = D({
	type: A(X.enum.moveOrganization),
	organizationUid: C().describe("組織UID"),
	to: D({ domainUid: C().describe("法人UID") })
}), ls = D({
	type: A(X.enum.moveUser),
	userUid: C().describe("組織UID"),
	to: D({
		domainUid: C().describe("法人UID"),
		defaultOrganizationUid: C().nullable().describe("デフォルト組織UID"),
		organizationUids: C().array().describe("所属組織UID"),
		roleUid: C().describe("ロールUID")
	})
}), us = D({
	type: A(X.enum.moveInvitation),
	invitationUid: C().describe("招待UID"),
	to: D({
		domainUid: C().describe("法人UID"),
		defaultOrganizationUid: C().describe("デフォルト組織UID"),
		organizationUids: C().array().describe("所属組織UID"),
		roleUid: C().describe("ロールUID")
	})
}), ds = D({
	type: A(X.enum.moveMemberApplicant),
	memberApplicantUid: C().describe("会社所属リクエストUID"),
	to: D({ domainUid: C().describe("法人UID") })
}), fs = D({
	type: A(X.enum.moveRole),
	roleUid: C().describe("ロールUID"),
	to: D({ domainUid: C().describe("法人UID") })
}), ps = O("type", [
	ns,
	Xo,
	Zo,
	Qo,
	$o,
	es,
	ts,
	rs,
	is,
	as,
	os,
	ss,
	cs,
	ls,
	us,
	ds,
	fs
]), ms = D({
	state: Yo,
	data: ps
}), hs = j(["integration", "userBulkUpdate"]), gs = D({
	type: A(hs.enum.integration),
	targetDomainUid: H.shape.domainUid
}), _s = D({ type: A(hs.enum.userBulkUpdate) }), vs = O("type", [gs, _s]), ys = D({
	planUid: C().describe("プランUID"),
	domainUid: C().describe("法人UID"),
	name: C().describe("名前"),
	operations: E(ms),
	data: vs,
	state: Za.shape.state
}), bs = ys.merge(V), xs = U.extend({ items: bs.array() }), Ss = D({
	standby: w(),
	progress: w(),
	success: w(),
	failure: w()
}), Cs = ys.omit({ operations: !0 }).extend({ operationCounts: Ss }).merge(V), ws = ys.omit({
	planUid: !0,
	state: !0
}), Ts = D({
	planUid: C().describe("プランUID"),
	domainUid: C().optional().describe("法人UID"),
	name: C().optional().describe("名前"),
	operations: E(ms).optional()
}), Es = D({
	planActivationUid: C(),
	domainUid: C(),
	planUid: C(),
	completed: T()
}).merge(V), Ds = En.pick({
	name: !0,
	isPhoneVerified: !0,
	takkenLicense: !0,
	takkenLicenseImage: !0,
	denwaList: !0,
	phoneVerification: !0,
	autoApproval: !0
}), Os = In.pick({
	name: !0,
	businessName: !0,
	denwaList: !0,
	kameiDantaiList: !0,
	isPublic: !0,
	partnerAutoApproval: !0
}).merge(D({ jusho: Dt })), ks = sr.pick({
	providerUserUid: !0,
	name: !0
}), As = D({
	domain: Ds,
	organization: Os,
	user: ks
}), js = D({
	address: C().describe("所在地"),
	name: C().describe("名称"),
	officeId: C().describe("事務所ID"),
	telNumber: xt,
	traderId: C().describe("業者ID"),
	zipCode: C().describe("郵便番号")
}).describe("事務所情報"), Ms = D({ enabled: sn.shape.enabled }), Ns = D({ isTarget: T().describe("現在のユーザが自動承認対象かどうか") }), Ps = D({
	phoneVerification: Ms,
	autoApproval: Ns,
	ebone: rn.omit({
		customerId: !0,
		synced: !0
	}).nullable().describe("One側の法人情報"),
	enableEntryFeature: H.shape.enableEntryFeature
}).merge(H.pick({
	domainUid: !0,
	name: !0
})).describe("法人公開情報"), Fs = D({
	address: C().describe("主たる事務所の所在地"),
	licenseNumber: cn,
	licenseUpdateCount: ln,
	licensorName: dn,
	name: C().describe("商号又は名称"),
	telNumber: xt,
	traderId: C().describe("業者ID"),
	updatedDatetime: B.describe("更新日")
}).describe("業者情報"), Is = Fs.omit({ telNumber: !0 }).extend({ telNumber: C().describe("電話番号") }), Ls = D({
	domains: E(Ps).describe("宅建免許に紐づく法人公開情報の一覧"),
	offices: E(js),
	trader: De(Fs)
}).describe("宅建免許に紐づく各種情報");
//#endregion
//#region lib/models/PhoneVerificationContext.ts
setErrorMap(customErrorMap);
var Rs = /^\d{6}$/, zs = C().length(6, { message: "6ケタの半角数字で入力してください" }).superRefine((e, t) => {
	Rs.test(e) || t.addIssue({
		code: l.custom,
		message: "6ケタの半角数字で入力してください"
	});
}).describe("電話番号による在籍確認コード"), Bs = j([
	"request",
	"autoApprovalSelectOrganization",
	"autoApprovalCreateOrganization",
	"phoneVerification"
]), Vs = 255, Hs = D({
	type: A(Bs.enum.request),
	organizationName: C().max(Vs, { message: `${Vs}文字以内で入力してください` }).describe("希望する所属組織名")
}), Us = D({
	type: A(Bs.enum.autoApprovalSelectOrganization),
	organizationUid: In.shape.organizationUid
}), Ws = D({
	type: A(Bs.enum.autoApprovalCreateOrganization),
	organization: Rn
}), Gs = D({
	type: A(Bs.enum.phoneVerification),
	takkenLicensorName: C(),
	takkenLicenseNumber: C(),
	passcode: zs
}), Ks = O("type", [
	Hs,
	Us,
	Ws,
	Gs
]), qs = D({ userName: J.innerType().shape.name }).merge(H.pick({ domainUid: !0 })).merge(gr.pick({
	comment: !0,
	providerUserUid: !0
})), Js = D({ data: Ks }).merge(qs), Ys = j(["created", "approved"]), Xs = D({
	type: A(Ys.enum.created),
	memberApplicant: gr
}), Zs = D({
	type: A(Ys.enum.approved),
	user: J
}), Qs = O("type", [Xs, Zs]), $s = D({ cancelComment: C() });
//#endregion
//#region lib/models/phoneVerificationTicket/index.ts
setErrorMap(customErrorMap);
var ec = D({
	phoneVerificationTicketUid: C().describe("電話番号確認チケットUID"),
	denwaNumber: xt,
	expires: B.describe("有効期限"),
	passcode: zs,
	officeName: js.shape.name,
	officeZipCode: js.shape.zipCode,
	officeAddress: js.shape.address
}).merge(V).merge(H.pick({ domainUid: !0 })), tc = U.extend({ items: ec.array() });
//#endregion
//#region lib/models/master/Address.ts
setErrorMap(customErrorMap);
var nc = D({
	aza_choume: C(),
	city_name: C(),
	full_address: C(),
	jis_code: C(),
	ooaza_tsuushou: C(),
	prefecture_name: C(),
	zip_code: C()
}), rc = D({ results: E(nc) }), toJushoText = (e) => e.prefecture_name + e.city_name + e.ooaza_tsuushou + e.aza_choume, ic = D({ callbackUrl: C().url().describe("招待有効化後のコールバック先 URL") }), ac = "admin", oc = "member", sc = D({
	collaboratorTeamMemberUid: C().describe("協力会社グループ所属 UID"),
	collaboratorTeamUid: C().describe("協力会社グループ UID"),
	name: C().describe("協力会社グループ名"),
	role: C().describe("協力会社グループ内のロール")
}).describe("協力会社ユーザの所属"), cc = D({
	collaboratorUid: C().describe("協力会社ユーザ UID"),
	email: C().describe("メールアドレス"),
	displayName: C().describe("表示名"),
	teamMembers: E(sc).describe("協力会社ユーザの所属一覧"),
	termsAccepted: T().describe("利用規約同意フラグ")
}).describe("協力会社ユーザログインコンテキスト"), isCollaboratorTeamAdmin = (e) => e?.role === ac, lc = D({ name: C().describe("協力会社グループ名") }).describe("協力会社招待に紐づくグループ"), uc = j(["pending", "accepted"]).describe("招待の状態 (受諾済みは連携完了の表示に振り分ける。取消・期限切れはエラーで返る)"), dc = {
	invitingDomainName: C().nullable().describe("招待元の法人名"),
	invitingOrganizationName: C().nullable().describe("招待元の組織名")
}, fc = O("status", [D({
	status: A("pending"),
	...dc,
	email: C().describe("招待先メールアドレス"),
	displayName: C().describe("招待元が付けた表示名"),
	team: lc.describe("招待に紐づくグループ (会社名)"),
	displayNameRequired: T().describe("受諾で表示名が要るか (招待先のメールアドレスで協力会社アカウントが未作成なら true。true なら受諾確認ではなく作成フォームを出す)"),
	passwordSetupRequired: T().describe("受諾したあとパスワード設定へ進むか")
}), D({
	status: A("accepted"),
	...dc,
	accountCreatedOnAcceptance: T().describe("受諾でアカウントが新規作成されたか (招待より後にアカウントが作られていれば true)。true なら連携完了の表示にパスワード設定の再開案内を出す")
})]).describe("協力会社招待の事前確認レスポンス"), pc = {
	invitingDomainName: C().nullable().describe("招待元の法人名"),
	invitingOrganizationName: C().nullable().describe("招待元の組織名")
}, mc = O("status", [D({
	status: A("pending"),
	...pc,
	email: C().describe("招待先メールアドレス"),
	displayName: C().describe("招待元が付けた表示名"),
	joiningDomainName: C().describe("受諾で参加する法人の名前 (名寄せ先があればその法人の名前)"),
	displayNameRequired: T().describe("受諾で表示名が要るか (true なら受諾確認ではなく作成フォームを出す)"),
	passwordSetupRequired: T().describe("受諾したあとパスワード設定へ進むか")
}), D({
	status: A("accepted"),
	...pc,
	accountCreatedOnAcceptance: T().describe("受諾でアカウントが新規作成されたか。true なら連携完了の表示にパスワード設定の再開案内を出す")
})]).describe("法人間招待の事前確認レスポンス"), hc = D({
	collaboratorInvitationUid: C().describe("協力会社招待 UID"),
	email: C().describe("招待先メールアドレス"),
	displayName: C().describe("表示名"),
	expires: C().describe("招待メールの有効期限"),
	createdAt: C().describe("招待日時")
}).describe("協力会社招待"), gc = D({
	collaboratorTeamMemberUid: C().describe("協力会社チームメンバー UID"),
	collaboratorUid: C().describe("協力会社ユーザ UID"),
	displayName: C().describe("表示名"),
	email: C().describe("メールアドレス"),
	role: C().describe("協力会社グループ内のロール")
}).describe("協力会社チームメンバー"), _c = D({
	prd: D({
		status: C().describe("ステータス"),
		from: C().describe("メンテナンス開始時刻"),
		to: C().describe("メンテナンス終了時刻")
	}).describe("One API"),
	inside: D({
		status: C().describe("ステータス"),
		from: C().describe("メンテナンス開始時刻"),
		to: C().describe("メンテナンス終了時刻")
	}).describe("取込API")
}).describe("メンテナンススケジュール"), vc = D({
	prd: D({ isMaintenance: T().describe("メンテナンス中かどうか") }).describe("One API"),
	inside: D({ isMaintenance: T().describe("メンテナンス中かどうか") }).describe("取込API")
}).describe("メンテナンス状況"), yc = D({
	status: C().describe("ステータス"),
	from: C().describe("メンテナンス開始時刻"),
	to: C().describe("メンテナンス終了時刻")
}).describe("メンテナンススケジュール"), bc = D({ isMaintenance: T().describe("メンテナンス中かどうか") }).describe("メンテナンス状況"), xc = Uo.shape.errorCode, Sc = D({
	customerId: w().int(),
	domainName: C().nullable(),
	personName: C().nullable(),
	email: C().nullable()
}), Cc = {
	OPERATIONAL: 100,
	MAINTENANCE: 200,
	DEGRADEDPERFORMANCE: 300,
	PARTIALSERVICEDISRUPTION: 400,
	SERVICEDISRUPTION: 500,
	SECURITYEVENT: 600
}, wc = {
	INVESTIGATING: 100,
	IDENTIFIED: 200,
	MONITORING: 300,
	RESOLVED: 400
}, Tc = {
	SCHEDULED: 100,
	ACTIVE: 200,
	COMPLETED: 300
}, Ec = D({
	updated: C(),
	status: C(),
	status_code: w()
}), Dc = D({
	id: C(),
	name: C(),
	updated: C(),
	status: C(),
	status_code: w(),
	containers: D({
		id: C(),
		name: C(),
		updated: C(),
		status: C(),
		status_code: w()
	}).array()
}).array(), Oc = D({
	name: C(),
	_id: C(),
	datetime_open: C(),
	messages: D({
		details: C(),
		state: w(),
		status: w(),
		datetime: C()
	}).array(),
	containers_affected: D({
		name: C(),
		_id: C()
	}).array(),
	components_affected: D({
		name: C(),
		_id: C()
	}).array()
}).array(), kc = D({
	name: C(),
	_id: C(),
	datetime_open: C(),
	datetime_planned_start: C(),
	datetime_planned_end: C(),
	messages: D({
		details: C(),
		state: w(),
		status: w(),
		datetime: C()
	}).array(),
	containers_affected: D({
		name: C(),
		_id: C()
	}).array(),
	components_affected: D({
		name: C(),
		_id: C()
	}).array()
}).array(), Ac = D({ result: D({
	status_overall: Ec,
	status: Dc,
	incidents: Oc,
	maintenance: D({
		active: kc,
		upcoming: kc
	})
}) }).describe("Statusioから得られる情報"), jc = D({
	id: C(),
	name: C(),
	unitOfMeasure: C().nullable(),
	quantity: w(),
	startDate: C().nullable(),
	endDate: C().nullable(),
	chargeType: C(),
	chargeModel: C(),
	price: w(),
	salesPrice: w()
}), Mc = D({
	id: C(),
	name: C(),
	productName: C(),
	removed: T(),
	items: E(jc)
}), Nc = D({
	id: C(),
	customerId: w().int(),
	accountName: C(),
	status: C(),
	plans: E(Mc)
}), Pc = D({
	type: Ee([
		A("Totp"),
		A("Passkey"),
		D({ Other: C() })
	]).describe("認証の種類"),
	createdAt: B.describe("作成日時")
}), Fc = D({
	authenticators: Pc.array().describe("認証方法"),
	userUid: C().describe("アカウントUid")
}), Ic = D({
	id: C().describe("認証方式ID"),
	type: C().describe("認証の種類"),
	enrolledAt: B.describe("登録日時"),
	userAgent: C().nullable().default(null).describe("登録時のユーザエージェント"),
	authenticatorName: C().nullable().default(null).describe("登録した認証器の名前")
}), Lc = D({ authenticationMethods: Ic.array().describe("認証方式") }), Rc = "passkey", zc = "不明なデバイス", Bc = " / ", Vc = /\s(\d+)(?:\.\d+)+$/, Hc = /\s[\d._]+$/, toDeviceLabel = (e) => {
	if (e == null || e.trim() === "") return zc;
	let t = e.indexOf(Bc);
	return t < 0 ? e.replace(Vc, " $1") : `${e.slice(0, t).replace(Vc, " $1")}${Bc}${e.slice(t + 3).replace(Hc, "")}`;
}, toPasskeys = (e) => Lc.parse(e).authenticationMethods.filter(({ type: e }) => e === Rc).map(({ id: e, enrolledAt: t, userAgent: n, authenticatorName: r }) => ({
	authMethodId: e,
	authenticator: r == null ? { kind: "unidentified" } : {
		kind: "identified",
		name: r
	},
	deviceLabel: toDeviceLabel(n),
	enrolledAt: t
})).sort((e, t) => t.enrolledAt.getTime() - e.enrolledAt.getTime()), Uc = D({
	licenseName: C(),
	licenseAttributeMap: k(C(), C())
}), Wc = D({
	company: T().describe("法人かどうかのフラグ"),
	customerId: w(),
	domainName: C(),
	licenses: E(Uc)
}), Gc = Ei, Kc = Gc.shape.items.element, qc = Kc.shape.operation, Jc = Kc.shape.operator, Yc = Kc.shape.usages.element, Xc = Di, Zc = Oi, Qc = ki, $c = Ai, el = D({
	fcName: C(),
	pcLogo: C().optional(),
	smpLogo: C().optional()
}), tl = D({
	licensor: C().nullable(),
	updateCount: C().nullable(),
	number: C().nullable()
}), nl = D({
	lastName: C().nullable(),
	firstName: C().nullable(),
	email: C().nullable(),
	tel: C().nullable(),
	zipCode: C().nullable(),
	prefecture: C().nullable(),
	city: C().nullable(),
	address1: C().nullable(),
	address2: C().nullable()
}), rl = D({
	email: T().nullable(),
	print: T().nullable()
}), il = {
	paymentMethod: C().nullable(),
	invoiceDelivery: rl,
	invoiceMailAddress: C().nullable(),
	additionalMailAddresses: E(C()),
	contactName: C().nullable()
}, al = D({
	type: A("own"),
	name: C().nullable(),
	...il
}), ol = D({
	type: A("otherCompany"),
	accountName: C().nullable(),
	...il
}), sl = O("type", [al, ol]), cl = D({
	organizationUid: C().nullable(),
	name: C().nullable(),
	documentDisplayName: C().nullable(),
	notificationMailAddress: C().nullable(),
	zipCode: C().nullable(),
	prefecture: C().nullable(),
	city: C().nullable(),
	address1: C().nullable(),
	address2: C().nullable(),
	tel: C().nullable()
}), ll = D({
	documentDisplayName: C().nullable(),
	representativeName: C().nullable(),
	takkenLicense: tl,
	notificationMailAddress: C().nullable(),
	zipCode: C().nullable(),
	prefecture: C().nullable(),
	city: C().nullable(),
	address1: C().nullable(),
	address2: C().nullable(),
	tel: C().nullable(),
	primaryContact: nl,
	organizations: E(cl),
	billingDestinations: E(sl)
}), ul = D({
	quantity: w(),
	unit: C()
}), dl = D({
	name: C().nullable(),
	unit: C().nullable()
}), fl = D({
	serviceName: C().nullable(),
	planName: C().nullable(),
	quantities: E(ul),
	usageCharges: E(dl)
}), pl = D({
	organizationUid: C().nullable(),
	contracts: E(fl)
}), ml = D({
	contracts: E(fl),
	organizations: E(pl)
}), contentKeyOf = (e) => JSON.stringify([
	e.serviceName,
	e.planName,
	e.quantities.map((e) => [e.quantity, e.unit]),
	e.usageCharges.map((e) => [e.name, e.unit])
]), mergeCustomerContracts = (e) => {
	let t = /* @__PURE__ */ new Map();
	return e.forEach((e) => {
		let n = contentKeyOf(e), r = t.get(n);
		if (r) {
			r.count += 1;
			return;
		}
		t.set(n, {
			...e,
			count: 1
		});
	}), [...t.values()];
}, hl = D({
	licensor: C().nullable(),
	updateCount: C().nullable(),
	number: C().nullable()
}), gl = D({
	email: T().nullable(),
	print: T().nullable()
}), _l = D({
	type: A("own"),
	name: C().nullable(),
	paymentMethod: C().nullable(),
	invoiceDelivery: gl,
	invoiceMailAddress: C().nullable(),
	additionalMailAddresses: E(C()),
	contactName: C().nullable()
}), vl = D({ type: A("otherCompany") }), yl = O("type", [_l, vl]), bl = D({
	organizationUid: C().nullable(),
	name: C().nullable(),
	documentDisplayName: C().nullable(),
	notificationMailAddress: C().nullable(),
	zipCode: C().nullable(),
	prefecture: C().nullable(),
	city: C().nullable(),
	address1: C().nullable(),
	address2: C().nullable(),
	tel: C().nullable()
}), xl = D({
	documentDisplayName: C().nullable(),
	representativeName: C().nullable(),
	takkenLicense: hl,
	notificationMailAddress: C().nullable(),
	zipCode: C().nullable(),
	prefecture: C().nullable(),
	city: C().nullable(),
	address1: C().nullable(),
	address2: C().nullable(),
	tel: C().nullable(),
	organizations: E(bl),
	billingDestinations: E(yl)
}), getMockAdminCustomerProfile = (e) => ({
	documentDisplayName: "テスト法人株式会社",
	representativeName: "代表 太郎",
	takkenLicense: {
		licensor: "東京都知事",
		updateCount: "2",
		number: "123456"
	},
	notificationMailAddress: "notify@example.com",
	zipCode: "100-0001",
	prefecture: "東京都",
	city: "千代田区",
	address1: "千代田1-1",
	address2: "テストビル2F",
	tel: "03-0000-0000",
	primaryContact: {
		lastName: "取引",
		firstName: "次郎",
		email: "primary@example.com",
		tel: "03-1111-1111",
		zipCode: "100-0002",
		prefecture: "東京都",
		city: "中央区",
		address1: "中央2-2",
		address2: null
	},
	organizations: [{
		organizationUid: "22222222-2222-2222-2222-222222222222",
		name: "横浜店",
		documentDisplayName: "テスト法人株式会社 横浜支店",
		notificationMailAddress: "yokohama@example.com",
		zipCode: "220-0011",
		prefecture: "神奈川県",
		city: "横浜市西区",
		address1: "高島2-2",
		address2: "テスト横浜ビル3F",
		tel: "045-000-0000"
	}],
	billingDestinations: [{
		type: "own",
		name: "テスト法人株式会社",
		paymentMethod: "BankTransfer",
		invoiceDelivery: {
			email: !0,
			print: !1
		},
		invoiceMailAddress: "billing@example.com",
		additionalMailAddresses: ["invoice1@example.com", "invoice2@example.com"],
		contactName: "請求 花子"
	}, {
		type: "otherCompany",
		accountName: "他法人株式会社",
		paymentMethod: "CreditCard",
		invoiceDelivery: {
			email: !0,
			print: !1
		},
		invoiceMailAddress: "other-billing@example.com",
		additionalMailAddresses: [],
		contactName: "他法人 三郎"
	}],
	...e
}), getMockCustomer = (e) => ({
	customerId: 111111,
	domainName: "法人名",
	personName: "顧客名",
	email: "atsuki.omura@e-seikatsu.co.jp",
	...e
}), getMockCustomerContracts = (e) => ({
	contracts: [
		{
			serviceName: "いい生活賃貸クラウド One",
			planName: "基本サービス",
			quantities: [{
				quantity: 500,
				unit: "戸・区画"
			}, {
				quantity: 2,
				unit: "店舗"
			}],
			usageCharges: []
		},
		{
			serviceName: "いい生活賃貸クラウド One",
			planName: "電子契約オプション",
			quantities: [],
			usageCharges: [{
				name: "電子契約送信料",
				unit: "通"
			}]
		},
		{
			serviceName: "いい生活Home",
			planName: "基本サービス",
			quantities: [],
			usageCharges: [{
				name: "有効入居者数超過金",
				unit: "人"
			}, {
				name: "SMS送信従量料金",
				unit: "通"
			}]
		},
		{
			serviceName: "いい生活ウェブサイト Flex",
			planName: "基本サービス Advanced",
			quantities: [],
			usageCharges: []
		},
		{
			serviceName: "いい生活ウェブサイト Flex",
			planName: "基本サービス Advanced",
			quantities: [],
			usageCharges: []
		}
	],
	organizations: [{
		organizationUid: "22222222-2222-2222-2222-222222222222",
		contracts: [{
			serviceName: "いい生活賃貸クラウド One",
			planName: "基本サービス",
			quantities: [{
				quantity: 100,
				unit: "戸・区画"
			}],
			usageCharges: []
		}, {
			serviceName: "いい生活ウェブサイト Flex",
			planName: "基本サービス Standard",
			quantities: [],
			usageCharges: []
		}]
	}],
	...e
}), getMockCustomerProfile = (e) => ({
	documentDisplayName: "テスト法人株式会社",
	representativeName: "代表 太郎",
	takkenLicense: {
		licensor: "東京都知事",
		updateCount: "2",
		number: "123456"
	},
	notificationMailAddress: "notify@example.com",
	zipCode: "100-0001",
	prefecture: "東京都",
	city: "千代田区",
	address1: "千代田1-1",
	address2: "テストビル2F",
	tel: "03-0000-0000",
	organizations: [{
		organizationUid: "22222222-2222-2222-2222-222222222222",
		name: "横浜店",
		documentDisplayName: "テスト法人株式会社 横浜支店",
		notificationMailAddress: "yokohama@example.com",
		zipCode: "220-0011",
		prefecture: "神奈川県",
		city: "横浜市西区",
		address1: "高島2-2",
		address2: "テスト横浜ビル3F",
		tel: "045-000-0000"
	}],
	billingDestinations: [{
		type: "own",
		name: "テスト法人株式会社",
		paymentMethod: "BankTransfer",
		invoiceDelivery: {
			email: !0,
			print: !1
		},
		invoiceMailAddress: "billing@example.com",
		additionalMailAddresses: ["invoice1@example.com", "invoice2@example.com"],
		contactName: "請求 花子"
	}, { type: "otherCompany" }],
	...e
}), Sl = 365.2425, Cl = 6048e5, wl = 864e5, Tl = 6e4, El = 36e5, Dl = 86400;
Dl * 7, Dl * Sl / 12 * 3;
var Ol = Symbol.for("constructDateFrom");
//#endregion
//#region ../../../node_modules/.pnpm/date-fns@4.4.0/node_modules/date-fns/constructFrom.js
function constructFrom(e, t) {
	return typeof e == "function" ? e(t) : e && typeof e == "object" && Ol in e ? e[Ol](t) : e instanceof Date ? new e.constructor(t) : new Date(t);
}
//#endregion
//#region ../../../node_modules/.pnpm/date-fns@4.4.0/node_modules/date-fns/toDate.js
function toDate$1(e, t) {
	return constructFrom(t || e, e);
}
__name(toDate$1, "toDate");
//#endregion
//#region ../../../node_modules/.pnpm/date-fns@4.4.0/node_modules/date-fns/_lib/defaultOptions.js
var kl = {};
function getDefaultOptions$1() {
	return kl;
}
__name(getDefaultOptions$1, "getDefaultOptions");
//#endregion
//#region ../../../node_modules/.pnpm/date-fns@4.4.0/node_modules/date-fns/startOfWeek.js
function startOfWeek(e, t) {
	let n = getDefaultOptions$1(), r = t?.weekStartsOn ?? t?.locale?.options?.weekStartsOn ?? n.weekStartsOn ?? n.locale?.options?.weekStartsOn ?? 0, i = toDate$1(e, t?.in), a = i.getDay(), o = (a < r ? 7 : 0) + a - r;
	return i.setDate(i.getDate() - o), i.setHours(0, 0, 0, 0), i;
}
//#endregion
//#region ../../../node_modules/.pnpm/date-fns@4.4.0/node_modules/date-fns/startOfISOWeek.js
function startOfISOWeek(e, t) {
	return startOfWeek(e, {
		...t,
		weekStartsOn: 1
	});
}
//#endregion
//#region ../../../node_modules/.pnpm/date-fns@4.4.0/node_modules/date-fns/getISOWeekYear.js
function getISOWeekYear(e, t) {
	let n = toDate$1(e, t?.in), r = n.getFullYear(), i = constructFrom(n, 0);
	i.setFullYear(r + 1, 0, 4), i.setHours(0, 0, 0, 0);
	let a = startOfISOWeek(i), o = constructFrom(n, 0);
	o.setFullYear(r, 0, 4), o.setHours(0, 0, 0, 0);
	let s = startOfISOWeek(o);
	return n.getTime() >= a.getTime() ? r + 1 : n.getTime() >= s.getTime() ? r : r - 1;
}
//#endregion
//#region ../../../node_modules/.pnpm/date-fns@4.4.0/node_modules/date-fns/_lib/getTimezoneOffsetInMilliseconds.js
function getTimezoneOffsetInMilliseconds$1(e) {
	let t = toDate$1(e), n = new Date(Date.UTC(t.getFullYear(), t.getMonth(), t.getDate(), t.getHours(), t.getMinutes(), t.getSeconds(), t.getMilliseconds()));
	return n.setUTCFullYear(t.getFullYear()), +e - n;
}
__name(getTimezoneOffsetInMilliseconds$1, "getTimezoneOffsetInMilliseconds");
//#endregion
//#region ../../../node_modules/.pnpm/date-fns@4.4.0/node_modules/date-fns/_lib/normalizeDates.js
function normalizeDates(e, ...t) {
	let n = constructFrom.bind(null, e || t.find((e) => typeof e == "object"));
	return t.map(n);
}
//#endregion
//#region ../../../node_modules/.pnpm/date-fns@4.4.0/node_modules/date-fns/startOfDay.js
function startOfDay(e, t) {
	let n = toDate$1(e, t?.in);
	return n.setHours(0, 0, 0, 0), n;
}
//#endregion
//#region ../../../node_modules/.pnpm/date-fns@4.4.0/node_modules/date-fns/differenceInCalendarDays.js
function differenceInCalendarDays(e, t, n) {
	let [r, i] = normalizeDates(n?.in, e, t), a = startOfDay(r), o = startOfDay(i), s = +a - getTimezoneOffsetInMilliseconds$1(a), c = +o - getTimezoneOffsetInMilliseconds$1(o);
	return Math.round((s - c) / wl);
}
//#endregion
//#region ../../../node_modules/.pnpm/date-fns@4.4.0/node_modules/date-fns/startOfISOWeekYear.js
function startOfISOWeekYear(e, t) {
	let n = getISOWeekYear(e, t), r = constructFrom(t?.in || e, 0);
	return r.setFullYear(n, 0, 4), r.setHours(0, 0, 0, 0), startOfISOWeek(r);
}
//#endregion
//#region ../../../node_modules/.pnpm/date-fns@4.4.0/node_modules/date-fns/isDate.js
function isDate(e) {
	return e instanceof Date || typeof e == "object" && Object.prototype.toString.call(e) === "[object Date]";
}
//#endregion
//#region ../../../node_modules/.pnpm/date-fns@4.4.0/node_modules/date-fns/isValid.js
function isValid(e) {
	return !(!isDate(e) && typeof e != "number" || isNaN(+toDate$1(e)));
}
//#endregion
//#region ../../../node_modules/.pnpm/date-fns@4.4.0/node_modules/date-fns/startOfYear.js
function startOfYear(e, t) {
	let n = toDate$1(e, t?.in);
	return n.setFullYear(n.getFullYear(), 0, 1), n.setHours(0, 0, 0, 0), n;
}
//#endregion
//#region ../../../node_modules/.pnpm/date-fns@4.4.0/node_modules/date-fns/locale/en-US/_lib/formatDistance.js
var Al = {
	lessThanXSeconds: {
		one: "less than a second",
		other: "less than {{count}} seconds"
	},
	xSeconds: {
		one: "1 second",
		other: "{{count}} seconds"
	},
	halfAMinute: "half a minute",
	lessThanXMinutes: {
		one: "less than a minute",
		other: "less than {{count}} minutes"
	},
	xMinutes: {
		one: "1 minute",
		other: "{{count}} minutes"
	},
	aboutXHours: {
		one: "about 1 hour",
		other: "about {{count}} hours"
	},
	xHours: {
		one: "1 hour",
		other: "{{count}} hours"
	},
	xDays: {
		one: "1 day",
		other: "{{count}} days"
	},
	aboutXWeeks: {
		one: "about 1 week",
		other: "about {{count}} weeks"
	},
	xWeeks: {
		one: "1 week",
		other: "{{count}} weeks"
	},
	aboutXMonths: {
		one: "about 1 month",
		other: "about {{count}} months"
	},
	xMonths: {
		one: "1 month",
		other: "{{count}} months"
	},
	aboutXYears: {
		one: "about 1 year",
		other: "about {{count}} years"
	},
	xYears: {
		one: "1 year",
		other: "{{count}} years"
	},
	overXYears: {
		one: "over 1 year",
		other: "over {{count}} years"
	},
	almostXYears: {
		one: "almost 1 year",
		other: "almost {{count}} years"
	}
}, formatDistance = (e, t, n) => {
	let r, i = Al[e];
	return r = typeof i == "string" ? i : t === 1 ? i.one : i.other.replace("{{count}}", t.toString()), n?.addSuffix ? n.comparison && n.comparison > 0 ? "in " + r : r + " ago" : r;
};
//#endregion
//#region ../../../node_modules/.pnpm/date-fns@4.4.0/node_modules/date-fns/locale/_lib/buildFormatLongFn.js
function buildFormatLongFn(e) {
	return (t = {}) => {
		let n = t.width ? String(t.width) : e.defaultWidth;
		return e.formats[n] || e.formats[e.defaultWidth];
	};
}
var jl = {
	date: buildFormatLongFn({
		formats: {
			full: "EEEE, MMMM do, y",
			long: "MMMM do, y",
			medium: "MMM d, y",
			short: "MM/dd/yyyy"
		},
		defaultWidth: "full"
	}),
	time: buildFormatLongFn({
		formats: {
			full: "h:mm:ss a zzzz",
			long: "h:mm:ss a z",
			medium: "h:mm:ss a",
			short: "h:mm a"
		},
		defaultWidth: "full"
	}),
	dateTime: buildFormatLongFn({
		formats: {
			full: "{{date}} 'at' {{time}}",
			long: "{{date}} 'at' {{time}}",
			medium: "{{date}}, {{time}}",
			short: "{{date}}, {{time}}"
		},
		defaultWidth: "full"
	})
}, Ml = {
	lastWeek: "'last' eeee 'at' p",
	yesterday: "'yesterday at' p",
	today: "'today at' p",
	tomorrow: "'tomorrow at' p",
	nextWeek: "eeee 'at' p",
	other: "P"
}, formatRelative = (e, t, n, r) => Ml[e];
//#endregion
//#region ../../../node_modules/.pnpm/date-fns@4.4.0/node_modules/date-fns/locale/_lib/buildLocalizeFn.js
function buildLocalizeFn(e) {
	return (t, n) => {
		let r = n?.context ? String(n.context) : "standalone", i;
		if (r === "formatting" && e.formattingValues) {
			let t = e.defaultFormattingWidth || e.defaultWidth, r = n?.width ? String(n.width) : t;
			i = e.formattingValues[r] || e.formattingValues[t];
		} else {
			let t = e.defaultWidth, r = n?.width ? String(n.width) : e.defaultWidth;
			i = e.values[r] || e.values[t];
		}
		let a = e.argumentCallback ? e.argumentCallback(t) : t;
		return i[a];
	};
}
//#endregion
//#region ../../../node_modules/.pnpm/date-fns@4.4.0/node_modules/date-fns/locale/en-US/_lib/localize.js
var Nl = {
	narrow: ["B", "A"],
	abbreviated: ["BC", "AD"],
	wide: ["Before Christ", "Anno Domini"]
}, Pl = {
	narrow: [
		"1",
		"2",
		"3",
		"4"
	],
	abbreviated: [
		"Q1",
		"Q2",
		"Q3",
		"Q4"
	],
	wide: [
		"1st quarter",
		"2nd quarter",
		"3rd quarter",
		"4th quarter"
	]
}, Fl = {
	narrow: [
		"J",
		"F",
		"M",
		"A",
		"M",
		"J",
		"J",
		"A",
		"S",
		"O",
		"N",
		"D"
	],
	abbreviated: [
		"Jan",
		"Feb",
		"Mar",
		"Apr",
		"May",
		"Jun",
		"Jul",
		"Aug",
		"Sep",
		"Oct",
		"Nov",
		"Dec"
	],
	wide: [
		"January",
		"February",
		"March",
		"April",
		"May",
		"June",
		"July",
		"August",
		"September",
		"October",
		"November",
		"December"
	]
}, Il = {
	narrow: [
		"S",
		"M",
		"T",
		"W",
		"T",
		"F",
		"S"
	],
	short: [
		"Su",
		"Mo",
		"Tu",
		"We",
		"Th",
		"Fr",
		"Sa"
	],
	abbreviated: [
		"Sun",
		"Mon",
		"Tue",
		"Wed",
		"Thu",
		"Fri",
		"Sat"
	],
	wide: [
		"Sunday",
		"Monday",
		"Tuesday",
		"Wednesday",
		"Thursday",
		"Friday",
		"Saturday"
	]
}, Ll = {
	narrow: {
		am: "a",
		pm: "p",
		midnight: "mi",
		noon: "n",
		morning: "morning",
		afternoon: "afternoon",
		evening: "evening",
		night: "night"
	},
	abbreviated: {
		am: "AM",
		pm: "PM",
		midnight: "midnight",
		noon: "noon",
		morning: "morning",
		afternoon: "afternoon",
		evening: "evening",
		night: "night"
	},
	wide: {
		am: "a.m.",
		pm: "p.m.",
		midnight: "midnight",
		noon: "noon",
		morning: "morning",
		afternoon: "afternoon",
		evening: "evening",
		night: "night"
	}
}, Rl = {
	narrow: {
		am: "a",
		pm: "p",
		midnight: "mi",
		noon: "n",
		morning: "in the morning",
		afternoon: "in the afternoon",
		evening: "in the evening",
		night: "at night"
	},
	abbreviated: {
		am: "AM",
		pm: "PM",
		midnight: "midnight",
		noon: "noon",
		morning: "in the morning",
		afternoon: "in the afternoon",
		evening: "in the evening",
		night: "at night"
	},
	wide: {
		am: "a.m.",
		pm: "p.m.",
		midnight: "midnight",
		noon: "noon",
		morning: "in the morning",
		afternoon: "in the afternoon",
		evening: "in the evening",
		night: "at night"
	}
}, ordinalNumber = (e, t) => {
	let n = Number(e), r = n % 100;
	if (r > 20 || r < 10) switch (r % 10) {
		case 1: return n + "st";
		case 2: return n + "nd";
		case 3: return n + "rd";
	}
	return n + "th";
}, zl = {
	ordinalNumber,
	era: buildLocalizeFn({
		values: Nl,
		defaultWidth: "wide"
	}),
	quarter: buildLocalizeFn({
		values: Pl,
		defaultWidth: "wide",
		argumentCallback: (e) => e - 1
	}),
	month: buildLocalizeFn({
		values: Fl,
		defaultWidth: "wide"
	}),
	day: buildLocalizeFn({
		values: Il,
		defaultWidth: "wide"
	}),
	dayPeriod: buildLocalizeFn({
		values: Ll,
		defaultWidth: "wide",
		formattingValues: Rl,
		defaultFormattingWidth: "wide"
	})
};
//#endregion
//#region ../../../node_modules/.pnpm/date-fns@4.4.0/node_modules/date-fns/locale/_lib/buildMatchFn.js
function buildMatchFn(e) {
	return (t, n = {}) => {
		let r = n.width, i = r && e.matchPatterns[r] || e.matchPatterns[e.defaultMatchWidth], a = t.match(i);
		if (!a) return null;
		let o = a[0], s = r && e.parsePatterns[r] || e.parsePatterns[e.defaultParseWidth], c = Array.isArray(s) ? findIndex(s, (e) => e.test(o)) : findKey(s, (e) => e.test(o)), l;
		l = e.valueCallback ? e.valueCallback(c) : c, l = n.valueCallback ? n.valueCallback(l) : l;
		let u = t.slice(o.length);
		return {
			value: l,
			rest: u
		};
	};
}
function findKey(e, t) {
	for (let n in e) if (Object.prototype.hasOwnProperty.call(e, n) && t(e[n])) return n;
}
function findIndex(e, t) {
	for (let n = 0; n < e.length; n++) if (t(e[n])) return n;
}
//#endregion
//#region ../../../node_modules/.pnpm/date-fns@4.4.0/node_modules/date-fns/locale/_lib/buildMatchPatternFn.js
function buildMatchPatternFn(e) {
	return (t, n = {}) => {
		let r = t.match(e.matchPattern);
		if (!r) return null;
		let i = r[0], a = t.match(e.parsePattern);
		if (!a) return null;
		let o = e.valueCallback ? e.valueCallback(a[0]) : a[0];
		o = n.valueCallback ? n.valueCallback(o) : o;
		let s = t.slice(i.length);
		return {
			value: o,
			rest: s
		};
	};
}
//#endregion
//#region ../../../node_modules/.pnpm/date-fns@4.4.0/node_modules/date-fns/locale/en-US.js
var Bl = {
	code: "en-US",
	formatDistance,
	formatLong: jl,
	formatRelative,
	localize: zl,
	match: {
		ordinalNumber: buildMatchPatternFn({
			matchPattern: /^(\d+)(th|st|nd|rd)?/i,
			parsePattern: /\d+/i,
			valueCallback: (e) => parseInt(e, 10)
		}),
		era: buildMatchFn({
			matchPatterns: {
				narrow: /^(b|a)/i,
				abbreviated: /^(b\.?\s?c\.?|b\.?\s?c\.?\s?e\.?|a\.?\s?d\.?|c\.?\s?e\.?)/i,
				wide: /^(before christ|before common era|anno domini|common era)/i
			},
			defaultMatchWidth: "wide",
			parsePatterns: { any: [/^b/i, /^(a|c)/i] },
			defaultParseWidth: "any"
		}),
		quarter: buildMatchFn({
			matchPatterns: {
				narrow: /^[1234]/i,
				abbreviated: /^q[1234]/i,
				wide: /^[1234](th|st|nd|rd)? quarter/i
			},
			defaultMatchWidth: "wide",
			parsePatterns: { any: [
				/1/i,
				/2/i,
				/3/i,
				/4/i
			] },
			defaultParseWidth: "any",
			valueCallback: (e) => e + 1
		}),
		month: buildMatchFn({
			matchPatterns: {
				narrow: /^[jfmasond]/i,
				abbreviated: /^(jan|feb|mar|apr|may|jun|jul|aug|sep|oct|nov|dec)/i,
				wide: /^(january|february|march|april|may|june|july|august|september|october|november|december)/i
			},
			defaultMatchWidth: "wide",
			parsePatterns: {
				narrow: [
					/^j/i,
					/^f/i,
					/^m/i,
					/^a/i,
					/^m/i,
					/^j/i,
					/^j/i,
					/^a/i,
					/^s/i,
					/^o/i,
					/^n/i,
					/^d/i
				],
				any: [
					/^ja/i,
					/^f/i,
					/^mar/i,
					/^ap/i,
					/^may/i,
					/^jun/i,
					/^jul/i,
					/^au/i,
					/^s/i,
					/^o/i,
					/^n/i,
					/^d/i
				]
			},
			defaultParseWidth: "any"
		}),
		day: buildMatchFn({
			matchPatterns: {
				narrow: /^[smtwf]/i,
				short: /^(su|mo|tu|we|th|fr|sa)/i,
				abbreviated: /^(sun|mon|tue|wed|thu|fri|sat)/i,
				wide: /^(sunday|monday|tuesday|wednesday|thursday|friday|saturday)/i
			},
			defaultMatchWidth: "wide",
			parsePatterns: {
				narrow: [
					/^s/i,
					/^m/i,
					/^t/i,
					/^w/i,
					/^t/i,
					/^f/i,
					/^s/i
				],
				any: [
					/^su/i,
					/^m/i,
					/^tu/i,
					/^w/i,
					/^th/i,
					/^f/i,
					/^sa/i
				]
			},
			defaultParseWidth: "any"
		}),
		dayPeriod: buildMatchFn({
			matchPatterns: {
				narrow: /^(a|p|mi|n|(in the|at) (morning|afternoon|evening|night))/i,
				any: /^([ap]\.?\s?m\.?|midnight|noon|(in the|at) (morning|afternoon|evening|night))/i
			},
			defaultMatchWidth: "any",
			parsePatterns: { any: {
				am: /^a/i,
				pm: /^p/i,
				midnight: /^mi/i,
				noon: /^no/i,
				morning: /morning/i,
				afternoon: /afternoon/i,
				evening: /evening/i,
				night: /night/i
			} },
			defaultParseWidth: "any"
		})
	},
	options: {
		weekStartsOn: 0,
		firstWeekContainsDate: 1
	}
};
//#endregion
//#region ../../../node_modules/.pnpm/date-fns@4.4.0/node_modules/date-fns/getDayOfYear.js
function getDayOfYear(e, t) {
	let n = toDate$1(e, t?.in);
	return differenceInCalendarDays(n, startOfYear(n)) + 1;
}
//#endregion
//#region ../../../node_modules/.pnpm/date-fns@4.4.0/node_modules/date-fns/getISOWeek.js
function getISOWeek(e, t) {
	let n = toDate$1(e, t?.in), r = +startOfISOWeek(n) - startOfISOWeekYear(n);
	return Math.round(r / Cl) + 1;
}
//#endregion
//#region ../../../node_modules/.pnpm/date-fns@4.4.0/node_modules/date-fns/getWeekYear.js
function getWeekYear(e, t) {
	let n = toDate$1(e, t?.in), r = n.getFullYear(), i = getDefaultOptions$1(), a = t?.firstWeekContainsDate ?? t?.locale?.options?.firstWeekContainsDate ?? i.firstWeekContainsDate ?? i.locale?.options?.firstWeekContainsDate ?? 1, o = constructFrom(t?.in || e, 0);
	o.setFullYear(r + 1, 0, a), o.setHours(0, 0, 0, 0);
	let s = startOfWeek(o, t), c = constructFrom(t?.in || e, 0);
	c.setFullYear(r, 0, a), c.setHours(0, 0, 0, 0);
	let l = startOfWeek(c, t);
	return +n >= +s ? r + 1 : +n >= +l ? r : r - 1;
}
//#endregion
//#region ../../../node_modules/.pnpm/date-fns@4.4.0/node_modules/date-fns/startOfWeekYear.js
function startOfWeekYear(e, t) {
	let n = getDefaultOptions$1(), r = t?.firstWeekContainsDate ?? t?.locale?.options?.firstWeekContainsDate ?? n.firstWeekContainsDate ?? n.locale?.options?.firstWeekContainsDate ?? 1, i = getWeekYear(e, t), a = constructFrom(t?.in || e, 0);
	return a.setFullYear(i, 0, r), a.setHours(0, 0, 0, 0), startOfWeek(a, t);
}
//#endregion
//#region ../../../node_modules/.pnpm/date-fns@4.4.0/node_modules/date-fns/getWeek.js
function getWeek(e, t) {
	let n = toDate$1(e, t?.in), r = +startOfWeek(n, t) - startOfWeekYear(n, t);
	return Math.round(r / Cl) + 1;
}
//#endregion
//#region ../../../node_modules/.pnpm/date-fns@4.4.0/node_modules/date-fns/_lib/addLeadingZeros.js
function addLeadingZeros$1(e, t) {
	return (e < 0 ? "-" : "") + Math.abs(e).toString().padStart(t, "0");
}
__name(addLeadingZeros$1, "addLeadingZeros");
//#endregion
//#region ../../../node_modules/.pnpm/date-fns@4.4.0/node_modules/date-fns/_lib/format/lightFormatters.js
var Z = {
	y(e, t) {
		let n = e.getFullYear(), r = n > 0 ? n : 1 - n;
		return addLeadingZeros$1(t === "yy" ? r % 100 : r, t.length);
	},
	M(e, t) {
		let n = e.getMonth();
		return t === "M" ? String(n + 1) : addLeadingZeros$1(n + 1, 2);
	},
	d(e, t) {
		return addLeadingZeros$1(e.getDate(), t.length);
	},
	a(e, t) {
		let n = e.getHours() / 12 >= 1 ? "pm" : "am";
		switch (t) {
			case "a":
			case "aa": return n.toUpperCase();
			case "aaa": return n;
			case "aaaaa": return n[0];
			default: return n === "am" ? "a.m." : "p.m.";
		}
	},
	h(e, t) {
		return addLeadingZeros$1(e.getHours() % 12 || 12, t.length);
	},
	H(e, t) {
		return addLeadingZeros$1(e.getHours(), t.length);
	},
	m(e, t) {
		return addLeadingZeros$1(e.getMinutes(), t.length);
	},
	s(e, t) {
		return addLeadingZeros$1(e.getSeconds(), t.length);
	},
	S(e, t) {
		let n = t.length, r = e.getMilliseconds();
		return addLeadingZeros$1(Math.trunc(r * 10 ** (n - 3)), t.length);
	}
}, Q = {
	am: "am",
	pm: "pm",
	midnight: "midnight",
	noon: "noon",
	morning: "morning",
	afternoon: "afternoon",
	evening: "evening",
	night: "night"
}, Vl = {
	G: function(e, t, n) {
		let r = +(e.getFullYear() > 0);
		switch (t) {
			case "G":
			case "GG":
			case "GGG": return n.era(r, { width: "abbreviated" });
			case "GGGGG": return n.era(r, { width: "narrow" });
			default: return n.era(r, { width: "wide" });
		}
	},
	y: function(e, t, n) {
		if (t === "yo") {
			let t = e.getFullYear(), r = t > 0 ? t : 1 - t;
			return n.ordinalNumber(r, { unit: "year" });
		}
		return Z.y(e, t);
	},
	Y: function(e, t, n, r) {
		let i = getWeekYear(e, r), a = i > 0 ? i : 1 - i;
		return t === "YY" ? addLeadingZeros$1(a % 100, 2) : t === "Yo" ? n.ordinalNumber(a, { unit: "year" }) : addLeadingZeros$1(a, t.length);
	},
	R: function(e, t) {
		return addLeadingZeros$1(getISOWeekYear(e), t.length);
	},
	u: function(e, t) {
		return addLeadingZeros$1(e.getFullYear(), t.length);
	},
	Q: function(e, t, n) {
		let r = Math.ceil((e.getMonth() + 1) / 3);
		switch (t) {
			case "Q": return String(r);
			case "QQ": return addLeadingZeros$1(r, 2);
			case "Qo": return n.ordinalNumber(r, { unit: "quarter" });
			case "QQQ": return n.quarter(r, {
				width: "abbreviated",
				context: "formatting"
			});
			case "QQQQQ": return n.quarter(r, {
				width: "narrow",
				context: "formatting"
			});
			default: return n.quarter(r, {
				width: "wide",
				context: "formatting"
			});
		}
	},
	q: function(e, t, n) {
		let r = Math.ceil((e.getMonth() + 1) / 3);
		switch (t) {
			case "q": return String(r);
			case "qq": return addLeadingZeros$1(r, 2);
			case "qo": return n.ordinalNumber(r, { unit: "quarter" });
			case "qqq": return n.quarter(r, {
				width: "abbreviated",
				context: "standalone"
			});
			case "qqqqq": return n.quarter(r, {
				width: "narrow",
				context: "standalone"
			});
			default: return n.quarter(r, {
				width: "wide",
				context: "standalone"
			});
		}
	},
	M: function(e, t, n) {
		let r = e.getMonth();
		switch (t) {
			case "M":
			case "MM": return Z.M(e, t);
			case "Mo": return n.ordinalNumber(r + 1, { unit: "month" });
			case "MMM": return n.month(r, {
				width: "abbreviated",
				context: "formatting"
			});
			case "MMMMM": return n.month(r, {
				width: "narrow",
				context: "formatting"
			});
			default: return n.month(r, {
				width: "wide",
				context: "formatting"
			});
		}
	},
	L: function(e, t, n) {
		let r = e.getMonth();
		switch (t) {
			case "L": return String(r + 1);
			case "LL": return addLeadingZeros$1(r + 1, 2);
			case "Lo": return n.ordinalNumber(r + 1, { unit: "month" });
			case "LLL": return n.month(r, {
				width: "abbreviated",
				context: "standalone"
			});
			case "LLLLL": return n.month(r, {
				width: "narrow",
				context: "standalone"
			});
			default: return n.month(r, {
				width: "wide",
				context: "standalone"
			});
		}
	},
	w: function(e, t, n, r) {
		let i = getWeek(e, r);
		return t === "wo" ? n.ordinalNumber(i, { unit: "week" }) : addLeadingZeros$1(i, t.length);
	},
	I: function(e, t, n) {
		let r = getISOWeek(e);
		return t === "Io" ? n.ordinalNumber(r, { unit: "week" }) : addLeadingZeros$1(r, t.length);
	},
	d: function(e, t, n) {
		return t === "do" ? n.ordinalNumber(e.getDate(), { unit: "date" }) : Z.d(e, t);
	},
	D: function(e, t, n) {
		let r = getDayOfYear(e);
		return t === "Do" ? n.ordinalNumber(r, { unit: "dayOfYear" }) : addLeadingZeros$1(r, t.length);
	},
	E: function(e, t, n) {
		let r = e.getDay();
		switch (t) {
			case "E":
			case "EE":
			case "EEE": return n.day(r, {
				width: "abbreviated",
				context: "formatting"
			});
			case "EEEEE": return n.day(r, {
				width: "narrow",
				context: "formatting"
			});
			case "EEEEEE": return n.day(r, {
				width: "short",
				context: "formatting"
			});
			default: return n.day(r, {
				width: "wide",
				context: "formatting"
			});
		}
	},
	e: function(e, t, n, r) {
		let i = e.getDay(), a = (i - r.weekStartsOn + 8) % 7 || 7;
		switch (t) {
			case "e": return String(a);
			case "ee": return addLeadingZeros$1(a, 2);
			case "eo": return n.ordinalNumber(a, { unit: "day" });
			case "eee": return n.day(i, {
				width: "abbreviated",
				context: "formatting"
			});
			case "eeeee": return n.day(i, {
				width: "narrow",
				context: "formatting"
			});
			case "eeeeee": return n.day(i, {
				width: "short",
				context: "formatting"
			});
			default: return n.day(i, {
				width: "wide",
				context: "formatting"
			});
		}
	},
	c: function(e, t, n, r) {
		let i = e.getDay(), a = (i - r.weekStartsOn + 8) % 7 || 7;
		switch (t) {
			case "c": return String(a);
			case "cc": return addLeadingZeros$1(a, t.length);
			case "co": return n.ordinalNumber(a, { unit: "day" });
			case "ccc": return n.day(i, {
				width: "abbreviated",
				context: "standalone"
			});
			case "ccccc": return n.day(i, {
				width: "narrow",
				context: "standalone"
			});
			case "cccccc": return n.day(i, {
				width: "short",
				context: "standalone"
			});
			default: return n.day(i, {
				width: "wide",
				context: "standalone"
			});
		}
	},
	i: function(e, t, n) {
		let r = e.getDay(), i = r === 0 ? 7 : r;
		switch (t) {
			case "i": return String(i);
			case "ii": return addLeadingZeros$1(i, t.length);
			case "io": return n.ordinalNumber(i, { unit: "day" });
			case "iii": return n.day(r, {
				width: "abbreviated",
				context: "formatting"
			});
			case "iiiii": return n.day(r, {
				width: "narrow",
				context: "formatting"
			});
			case "iiiiii": return n.day(r, {
				width: "short",
				context: "formatting"
			});
			default: return n.day(r, {
				width: "wide",
				context: "formatting"
			});
		}
	},
	a: function(e, t, n) {
		let r = e.getHours() / 12 >= 1 ? "pm" : "am";
		switch (t) {
			case "a":
			case "aa": return n.dayPeriod(r, {
				width: "abbreviated",
				context: "formatting"
			});
			case "aaa": return n.dayPeriod(r, {
				width: "abbreviated",
				context: "formatting"
			}).toLowerCase();
			case "aaaaa": return n.dayPeriod(r, {
				width: "narrow",
				context: "formatting"
			});
			default: return n.dayPeriod(r, {
				width: "wide",
				context: "formatting"
			});
		}
	},
	b: function(e, t, n) {
		let r = e.getHours(), i;
		switch (i = r === 12 ? Q.noon : r === 0 ? Q.midnight : r / 12 >= 1 ? "pm" : "am", t) {
			case "b":
			case "bb": return n.dayPeriod(i, {
				width: "abbreviated",
				context: "formatting"
			});
			case "bbb": return n.dayPeriod(i, {
				width: "abbreviated",
				context: "formatting"
			}).toLowerCase();
			case "bbbbb": return n.dayPeriod(i, {
				width: "narrow",
				context: "formatting"
			});
			default: return n.dayPeriod(i, {
				width: "wide",
				context: "formatting"
			});
		}
	},
	B: function(e, t, n) {
		let r = e.getHours(), i;
		switch (i = r >= 17 ? Q.evening : r >= 12 ? Q.afternoon : r >= 4 ? Q.morning : Q.night, t) {
			case "B":
			case "BB":
			case "BBB": return n.dayPeriod(i, {
				width: "abbreviated",
				context: "formatting"
			});
			case "BBBBB": return n.dayPeriod(i, {
				width: "narrow",
				context: "formatting"
			});
			default: return n.dayPeriod(i, {
				width: "wide",
				context: "formatting"
			});
		}
	},
	h: function(e, t, n) {
		if (t === "ho") {
			let t = e.getHours() % 12;
			return t === 0 && (t = 12), n.ordinalNumber(t, { unit: "hour" });
		}
		return Z.h(e, t);
	},
	H: function(e, t, n) {
		return t === "Ho" ? n.ordinalNumber(e.getHours(), { unit: "hour" }) : Z.H(e, t);
	},
	K: function(e, t, n) {
		let r = e.getHours() % 12;
		return t === "Ko" ? n.ordinalNumber(r, { unit: "hour" }) : addLeadingZeros$1(r, t.length);
	},
	k: function(e, t, n) {
		let r = e.getHours();
		return r === 0 && (r = 24), t === "ko" ? n.ordinalNumber(r, { unit: "hour" }) : addLeadingZeros$1(r, t.length);
	},
	m: function(e, t, n) {
		return t === "mo" ? n.ordinalNumber(e.getMinutes(), { unit: "minute" }) : Z.m(e, t);
	},
	s: function(e, t, n) {
		return t === "so" ? n.ordinalNumber(e.getSeconds(), { unit: "second" }) : Z.s(e, t);
	},
	S: function(e, t) {
		return Z.S(e, t);
	},
	X: function(e, t, n) {
		let r = e.getTimezoneOffset();
		if (r === 0) return "Z";
		switch (t) {
			case "X": return formatTimezoneWithOptionalMinutes$1(r);
			case "XXXX":
			case "XX": return formatTimezone$1(r);
			default: return formatTimezone$1(r, ":");
		}
	},
	x: function(e, t, n) {
		let r = e.getTimezoneOffset();
		switch (t) {
			case "x": return formatTimezoneWithOptionalMinutes$1(r);
			case "xxxx":
			case "xx": return formatTimezone$1(r);
			default: return formatTimezone$1(r, ":");
		}
	},
	O: function(e, t, n) {
		let r = e.getTimezoneOffset();
		switch (t) {
			case "O":
			case "OO":
			case "OOO": return "GMT" + formatTimezoneShort$1(r, ":");
			default: return "GMT" + formatTimezone$1(r, ":");
		}
	},
	z: function(e, t, n) {
		let r = e.getTimezoneOffset();
		switch (t) {
			case "z":
			case "zz":
			case "zzz": return "GMT" + formatTimezoneShort$1(r, ":");
			default: return "GMT" + formatTimezone$1(r, ":");
		}
	},
	t: function(e, t, n) {
		return addLeadingZeros$1(Math.trunc(e / 1e3), t.length);
	},
	T: function(e, t, n) {
		return addLeadingZeros$1(+e, t.length);
	}
};
function formatTimezoneShort$1(e, t = "") {
	let n = e > 0 ? "-" : "+", r = Math.abs(e), i = Math.trunc(r / 60), a = r % 60;
	return a === 0 ? n + String(i) : n + String(i) + t + addLeadingZeros$1(a, 2);
}
__name(formatTimezoneShort$1, "formatTimezoneShort");
function formatTimezoneWithOptionalMinutes$1(e, t) {
	return e % 60 == 0 ? (e > 0 ? "-" : "+") + addLeadingZeros$1(Math.abs(e) / 60, 2) : formatTimezone$1(e, t);
}
__name(formatTimezoneWithOptionalMinutes$1, "formatTimezoneWithOptionalMinutes");
function formatTimezone$1(e, t = "") {
	let n = e > 0 ? "-" : "+", r = Math.abs(e), i = addLeadingZeros$1(Math.trunc(r / 60), 2), a = addLeadingZeros$1(r % 60, 2);
	return n + i + t + a;
}
__name(formatTimezone$1, "formatTimezone");
//#endregion
//#region ../../../node_modules/.pnpm/date-fns@4.4.0/node_modules/date-fns/_lib/format/longFormatters.js
var dateLongFormatter = (e, t) => {
	switch (e) {
		case "P": return t.date({ width: "short" });
		case "PP": return t.date({ width: "medium" });
		case "PPP": return t.date({ width: "long" });
		default: return t.date({ width: "full" });
	}
}, timeLongFormatter = (e, t) => {
	switch (e) {
		case "p": return t.time({ width: "short" });
		case "pp": return t.time({ width: "medium" });
		case "ppp": return t.time({ width: "long" });
		default: return t.time({ width: "full" });
	}
}, dateTimeLongFormatter = (e, t) => {
	let n = e.match(/(P+)(p+)?/) || [], r = n[1], i = n[2];
	if (!i) return dateLongFormatter(e, t);
	let a;
	switch (r) {
		case "P":
			a = t.dateTime({ width: "short" });
			break;
		case "PP":
			a = t.dateTime({ width: "medium" });
			break;
		case "PPP":
			a = t.dateTime({ width: "long" });
			break;
		default: a = t.dateTime({ width: "full" });
	}
	return a.replace("{{date}}", dateLongFormatter(r, t)).replace("{{time}}", timeLongFormatter(i, t));
}, Hl = {
	p: timeLongFormatter,
	P: dateTimeLongFormatter
}, Ul = /^D+$/, Wl = /^Y+$/, Gl = [
	"D",
	"DD",
	"YY",
	"YYYY"
];
function isProtectedDayOfYearToken(e) {
	return Ul.test(e);
}
function isProtectedWeekYearToken(e) {
	return Wl.test(e);
}
function warnOrThrowProtectedError(e, t, n) {
	let r = message(e, t, n);
	if (console.warn(r), Gl.includes(e)) throw RangeError(r);
}
function message(e, t, n) {
	let r = e[0] === "Y" ? "years" : "days of the month";
	return `Use \`${e.toLowerCase()}\` instead of \`${e}\` (in \`${t}\`) for formatting ${r} to the input \`${n}\`; see: https://github.com/date-fns/date-fns/blob/master/docs/unicodeTokens.md`;
}
//#endregion
//#region ../../../node_modules/.pnpm/date-fns@4.4.0/node_modules/date-fns/format.js
var Kl = /[yYQqMLwIdDecihHKkms]o|(\w)\1*|''|'(''|[^'])+('|$)|./g, ql = /P+p+|P+|p+|''|'(''|[^'])+('|$)|./g, Jl = /^'([^]*?)'?$/, Yl = /''/g, Xl = /[a-zA-Z]/;
function format$1(e, t, n) {
	let r = getDefaultOptions$1(), i = n?.locale ?? r.locale ?? Bl, a = n?.firstWeekContainsDate ?? n?.locale?.options?.firstWeekContainsDate ?? r.firstWeekContainsDate ?? r.locale?.options?.firstWeekContainsDate ?? 1, o = n?.weekStartsOn ?? n?.locale?.options?.weekStartsOn ?? r.weekStartsOn ?? r.locale?.options?.weekStartsOn ?? 0, s = toDate$1(e, n?.in);
	if (!isValid(s)) throw RangeError("Invalid time value");
	let c = t.match(ql).map((e) => {
		let t = e[0];
		if (t === "p" || t === "P") {
			let n = Hl[t];
			return n(e, i.formatLong);
		}
		return e;
	}).join("").match(Kl).map((e) => {
		if (e === "''") return {
			isToken: !1,
			value: "'"
		};
		let t = e[0];
		if (t === "'") return {
			isToken: !1,
			value: cleanEscapedString(e)
		};
		if (Vl[t]) return {
			isToken: !0,
			value: e
		};
		if (t.match(Xl)) throw RangeError("Format string contains an unescaped latin alphabet character `" + t + "`");
		return {
			isToken: !1,
			value: e
		};
	});
	i.localize.preprocessor && (c = i.localize.preprocessor(s, c));
	let l = {
		firstWeekContainsDate: a,
		weekStartsOn: o,
		locale: i
	};
	return c.map((r) => {
		if (!r.isToken) return r.value;
		let a = r.value;
		(!n?.useAdditionalWeekYearTokens && isProtectedWeekYearToken(a) || !n?.useAdditionalDayOfYearTokens && isProtectedDayOfYearToken(a)) && warnOrThrowProtectedError(a, t, String(e));
		let o = Vl[a[0]];
		return o(s, a, i.localize, l);
	}).join("");
}
__name(format$1, "format");
function cleanEscapedString(e) {
	let t = e.match(Jl);
	return t ? t[1].replace(Yl, "'") : e;
}
//#endregion
//#region ../../../node_modules/.pnpm/date-fns@4.4.0/node_modules/date-fns/getDefaultOptions.js
function getDefaultOptions() {
	return Object.assign({}, getDefaultOptions$1());
}
//#endregion
//#region ../../../node_modules/.pnpm/date-fns@4.4.0/node_modules/date-fns/parseISO.js
function parseISO(e, t) {
	let invalidDate = () => constructFrom(t?.in, NaN), n = t?.additionalDigits ?? 2, r = splitDateString$1(e), i;
	if (r.date) {
		let e = parseYear$1(r.date, n);
		i = parseDate$1(e.restDateString, e.year);
	}
	if (!i || isNaN(+i)) return invalidDate();
	let a = +i, o = 0, s;
	if (r.time && (o = parseTime$1(r.time), isNaN(o))) return invalidDate();
	if (r.timezone) {
		if (s = parseTimezone(r.timezone), isNaN(s)) return invalidDate();
	} else {
		let e = new Date(a + o), n = toDate$1(0, t?.in);
		return n.setFullYear(e.getUTCFullYear(), e.getUTCMonth(), e.getUTCDate()), n.setHours(e.getUTCHours(), e.getUTCMinutes(), e.getUTCSeconds(), e.getUTCMilliseconds()), n;
	}
	return toDate$1(a + o + s, t?.in);
}
var Zl = {
	dateTimeDelimiter: /[T ]/,
	timeZoneDelimiter: /[Z ]/i,
	timezone: /([Z+-].*)$/
}, Ql = /^-?(?:(\d{3})|(\d{2})(?:-?(\d{2}))?|W(\d{2})(?:-?(\d{1}))?|)$/, $l = /^(\d{2}(?:[.,]\d*)?)(?::?(\d{2}(?:[.,]\d*)?))?(?::?(\d{2}(?:[.,]\d*)?))?$/, eu = /^([+-])(\d{2})(?::?(\d{2}))?$/;
function splitDateString$1(e) {
	let t = {}, n = e.split(Zl.dateTimeDelimiter), r;
	if (n.length > 2) return t;
	if (/:/.test(n[0]) ? r = n[0] : (t.date = n[0], r = n[1], Zl.timeZoneDelimiter.test(t.date) && (t.date = e.split(Zl.timeZoneDelimiter)[0], r = e.substr(t.date.length, e.length))), r) {
		let e = Zl.timezone.exec(r);
		e ? (t.time = r.replace(e[1], ""), t.timezone = e[1]) : t.time = r;
	}
	return t;
}
__name(splitDateString$1, "splitDateString");
function parseYear$1(e, t) {
	let n = RegExp("^(?:(\\d{4}|[+-]\\d{" + (4 + t) + "})|(\\d{2}|[+-]\\d{" + (2 + t) + "})$)"), r = e.match(n);
	if (!r) return {
		year: NaN,
		restDateString: ""
	};
	let i = r[1] ? parseInt(r[1]) : null, a = r[2] ? parseInt(r[2]) : null;
	return {
		year: a === null ? i : a * 100,
		restDateString: e.slice((r[1] || r[2]).length)
	};
}
__name(parseYear$1, "parseYear");
function parseDate$1(e, t) {
	if (t === null) return /* @__PURE__ */ new Date(NaN);
	let n = e.match(Ql);
	if (!n) return /* @__PURE__ */ new Date(NaN);
	let r = !!n[4], i = parseDateUnit(n[1]), a = parseDateUnit(n[2]) - 1, o = parseDateUnit(n[3]), s = parseDateUnit(n[4]), c = parseDateUnit(n[5]) - 1;
	if (r) return validateWeekDate$1(t, s, c) ? dayOfISOWeekYear$1(t, s, c) : /* @__PURE__ */ new Date(NaN);
	{
		let e = /* @__PURE__ */ new Date(0);
		return !validateDate$1(t, a, o) || !validateDayOfYearDate$1(t, i) ? /* @__PURE__ */ new Date(NaN) : (e.setUTCFullYear(t, a, Math.max(i, o)), e);
	}
}
__name(parseDate$1, "parseDate");
function parseDateUnit(e) {
	return e ? parseInt(e) : 1;
}
function parseTime$1(e) {
	let t = e.match($l);
	if (!t) return NaN;
	let n = parseTimeUnit(t[1]), r = parseTimeUnit(t[2]), i = parseTimeUnit(t[3]);
	return validateTime$1(n, r, i) ? n * El + r * Tl + i * 1e3 : NaN;
}
__name(parseTime$1, "parseTime");
function parseTimeUnit(e) {
	return e && parseFloat(e.replace(",", ".")) || 0;
}
function parseTimezone(e) {
	if (e === "Z") return 0;
	let t = e.match(eu);
	if (!t) return 0;
	let n = t[1] === "+" ? -1 : 1, r = parseInt(t[2]), i = t[3] && parseInt(t[3]) || 0;
	return validateTimezone$1(r, i) ? n * (r * El + i * Tl) : NaN;
}
function dayOfISOWeekYear$1(e, t, n) {
	let r = /* @__PURE__ */ new Date(0);
	r.setUTCFullYear(e, 0, 4);
	let i = r.getUTCDay() || 7, a = (t - 1) * 7 + n + 1 - i;
	return r.setUTCDate(r.getUTCDate() + a), r;
}
__name(dayOfISOWeekYear$1, "dayOfISOWeekYear");
var tu = [
	31,
	null,
	31,
	30,
	31,
	30,
	31,
	31,
	30,
	31,
	30,
	31
];
function isLeapYearIndex$1(e) {
	return e % 400 == 0 || e % 4 == 0 && e % 100 != 0;
}
__name(isLeapYearIndex$1, "isLeapYearIndex");
function validateDate$1(e, t, n) {
	return t >= 0 && t <= 11 && n >= 1 && n <= (tu[t] || (isLeapYearIndex$1(e) ? 29 : 28));
}
__name(validateDate$1, "validateDate");
function validateDayOfYearDate$1(e, t) {
	return t >= 1 && t <= (isLeapYearIndex$1(e) ? 366 : 365);
}
__name(validateDayOfYearDate$1, "validateDayOfYearDate");
function validateWeekDate$1(e, t, n) {
	return t >= 1 && t <= 53 && n >= 0 && n <= 6;
}
__name(validateWeekDate$1, "validateWeekDate");
function validateTime$1(e, t, n) {
	return e === 24 ? t === 0 && n === 0 : n >= 0 && n < 60 && t >= 0 && t < 60 && e >= 0 && e < 25;
}
__name(validateTime$1, "validateTime");
function validateTimezone$1(e, t) {
	return t >= 0 && t <= 59;
}
__name(validateTimezone$1, "validateTimezone");
//#endregion
//#region lib/mock/getDomain.ts
var getMockDomain = (e) => ({
	domainUid: "B834HVdEctliaT06",
	name: "（株）いい生活",
	isPhoneVerified: !0,
	takkenLicense: {
		licensor: "国土交通大臣",
		updateCount: "99",
		number: "123456"
	},
	takkenLicenseImage: {
		fileUid: "a2439667-2d41-441a-8aef-844682980838",
		url: "https://www.e-seikatsu.info/material/img/logo.png"
	},
	logoImage: {
		fileUid: "oz9ZXb8Y",
		url: "https://www.e-seikatsu.info/material/img/logo.png"
	},
	autoApproval: {
		enabled: !0,
		emailDomains: ["e-seikatsu.co.jp"],
		modifiedAt: parseISO("2022-04-18T09:49:36+09:00")
	},
	phoneVerification: {
		enabled: !0,
		modifiedAt: parseISO("2022-04-18T14:49:36.386Z")
	},
	denwaList: [{
		denwaNumberShubetsu: "電話",
		denwaNumber: "0354237825"
	}, {
		denwaNumberShubetsu: "FAX",
		denwaNumber: "0354237842"
	}],
	nativeAppIpRestrictionEnforced: !1,
	webAppIpRestrictionEnforced: !1,
	mfaState: "enabled",
	enablePasskey: !1,
	enableTotp: !0,
	ebone: null,
	corporateNumber: null,
	createdAt: parseISO("2022-04-18T09:49:36+09:00"),
	modifiedAt: parseISO("2022-04-18T09:49:36+09:00"),
	enableIntegrationFeature: !1,
	enableEntryFeature: !0,
	grantedFeatures: { esa: ["entry"] },
	...e
}), getMockRole = (e) => K.parse({
	domainUid: "xxx",
	roleUid: "xxx",
	name: "管理者",
	comment: null,
	description: "",
	isAdmin: !0,
	readonly: !0,
	securityDescriptors: [],
	policy: {
		edit_esa_domain: { scope: "DOMAIN" },
		edit_esa_organization: { scope: "DOMAIN" },
		edit_esa_user: { scope: "DOMAIN" },
		add_esa_user: { scope: "DOMAIN" },
		edit_authority: { scope: "DOMAIN" },
		edit_kokyaku: { scope: "DOMAIN" },
		view_chinshaku_bukken: { scope: "DOMAIN" },
		edit_chinshaku_bukken: { scope: "DOMAIN" },
		publish_chinshaku_bukken: { scope: "ORGANIZATION" },
		view_baikyaku_bukken: { scope: "DOMAIN" },
		edit_baikyaku_bukken: { scope: "DOMAIN" },
		publish_baikyaku_bukken: { scope: "ORGANIZATION" }
	},
	ebone: null,
	createdAt: parseISO("2022-04-18T09:49:36+09:00"),
	modifiedAt: parseISO("2022-04-18T09:49:36+09:00"),
	...e
}), getMockRoles = (e) => [...Array(e)].map((e, t) => getMockRole({
	roleUid: `role_uid_${t}`,
	name: `いい生活 権限クラス${t}`
})), getMockUser = (e) => J.parse({
	userUid: "7eq0cmFVw5F8mXxi",
	providerUserUid: "auth0|test",
	domainUid: "B834HVdEctliaT06",
	roleUid: "xxx",
	organizationUids: ["HmyPgS1XyB22qviA", "TOHNaCKSTjXt6oUW"],
	defaultOrganizationUid: "HmyPgS1XyB22qviA",
	name: "いい生活 太郎",
	publicName: "いい生活 太郎",
	ipAddressList: [],
	email: "example.test@e-seikatsu.co.jp",
	lastLoginDatetime: parseISO("2022-04-18T09:49:36+09:00"),
	mfaExemptedUntil: null,
	emailNotify: {
		enabled: !0,
		enabledMessenger: !0,
		modifiedAt: parseISO("2022-04-18T09:49:36+09:00")
	},
	ebone: {
		domainGuid: "caf85c53-5b4d-4762-88f3-fe928af2b249",
		userGuid: "2ae5eb76-2e67-4a8a-a202-5af270329d0e",
		organizationGuids: ["2a8e8e60-1461-4bc2-8f9d-fd3631ec60fd", "69997b93-1f87-44d4-8762-b3f5a682e50c"]
	},
	denwaList: [{
		denwaNumberShubetsu: "電話",
		denwaNumber: "001-000-0000"
	}, {
		denwaNumberShubetsu: "FAX",
		denwaNumber: "011-111-1111"
	}],
	role: getMockRole(),
	enableEntryFeature: !0,
	grantedFeatures: { esa: ["entry"] },
	createdAt: parseISO("2022-04-18T09:49:36+09:00"),
	modifiedAt: parseISO("2022-04-18T09:49:36+09:00"),
	...e
}), getMockUsers = (e, t) => [...Array(e)].map((e, n) => getMockUser({
	name: `いい生活 太郎${n}`,
	email: `example.test.${n}@e-seikatsu.co.jp`,
	userUid: `7eq0cmFVw5F8mXxi|${n}`,
	providerUserUid: `auth0|test${n}`,
	domainUid: t?.isDomainUidSerial === !0 ? `B834HVdEctliaT06-${n}` : "B834HVdEctliaT06"
})), getLoginContext = () => Sr.parse({
	providerUserUid: "pjYGu0rqTn",
	email: "example.test@e-seikatsu.co.jp",
	defaultUserUid: "7eq0cmFVw5F8mXxi",
	currentUserUid: "7eq0cmFVw5F8mXxi",
	isAgreeTerms: !1,
	users: getMockUsers(3, { isDomainUidSerial: !0 }),
	clientIp: "127.0.0.1",
	restrictedUserUids: []
}), getMockOrganization = ({ organizationUid: e, name: t, businessName: n } = {
	organizationUid: "HmyPgS1XyB22qviA",
	name: "店舗名",
	businessName: "屋号"
}) => In.parse({
	domainUid: "B834HVdEctliaT06",
	organizationUid: e,
	name: t,
	businessName: n,
	jusho: {
		yubinNumber: "1060047",
		jushoText: "東京都港区南麻布5丁目",
		nokoriJusho: "2番32号",
		gaikuGoto: "興和広尾ビル3F",
		jushoCode: "131030C6000",
		isDirectInput: !1
	},
	ebone: null,
	kameiDantaiList: [],
	partnerAutoApproval: { enabled: !1 },
	denwaList: [{
		denwaNumberShubetsu: "電話",
		denwaNumber: "0354237825"
	}, {
		denwaNumberShubetsu: "FAX",
		denwaNumber: "0354237842"
	}],
	isPublic: !0,
	createdAt: parseISO("2022-04-18T09:49:36+09:00"),
	modifiedAt: parseISO("2022-04-18T09:49:36+09:00")
}), getMockOrganizations = (e = 1) => [...Array(e)].map((e, t) => getMockOrganization({
	organizationUid: `TOHNaCKSTjXt6oUW${t + 1}`,
	name: `店舗${t + 1}`,
	businessName: `${t + 1}店舗目`
})), nu = getMockDomain(), { domainUid: ru } = nu, [iu, au] = getMockOrganizations(2).map((e) => ({
	...e,
	domainUid: ru
})), [ou, su] = getMockUsers(2).map((e) => ({
	...e,
	domainUid: ru
})), getUpdateDomainOperation = (e) => ({
	type: X.enum.updateDomain,
	domainUid: ru,
	domain: convertDomainReadToUpdate({
		...nu,
		...e
	})
}), getUpdateOrganizationOperation = (e) => ({
	type: X.enum.updateOrganization,
	organizationUid: "xxx",
	organization: {
		...iu,
		...e
	}
}), getUpdateUserOperation = (e) => ({
	type: X.enum.updateUser,
	userUid: "xxx",
	user: {
		...ou,
		...e
	}
}), getMoveOrganizationOperation = () => ({
	type: X.enum.moveOrganization,
	organizationUid: au.organizationUid,
	to: { domainUid: ru }
}), getMoveUserOperation = () => ({
	type: X.enum.moveUser,
	userUid: su.userUid,
	to: {
		domainUid: ru,
		defaultOrganizationUid: "xxx",
		organizationUids: [],
		roleUid: "xxx"
	}
}), getMockPlan = () => ({
	planUid: "5-Zy18Db-d",
	domainUid: "zJqb3-4F",
	name: "テスト計画",
	operations: [],
	data: {
		type: "integration",
		targetDomainUid: "xxx"
	},
	state: "standby",
	createdAt: parseISO("2022-04-18T09:49:36+09:00"),
	modifiedAt: parseISO("2022-04-18T09:49:36+09:00")
}), getMockPolicy = (e) => zn.parse({
	key: "edit_domain",
	scopes: [
		"NONE",
		"USER",
		"ORGANIZATION",
		"GROUP",
		"DOMAIN"
	],
	defaultScope: "DOMAIN",
	isEsa: !0,
	isEsaEbone: !0,
	...e
}), getMockPolicies = () => [
	getMockPolicy({ key: "edit_esa_domain" }),
	getMockPolicy({ key: "edit_esa_organization" }),
	getMockPolicy({ key: "edit_esa_user" }),
	getMockPolicy({ key: "add_esa_user" }),
	getMockPolicy({ key: "edit_authority" }),
	getMockPolicy({
		key: "edit_kokyaku",
		scopes: [
			"USER",
			"ORGANIZATION",
			"GROUP",
			"DOMAIN"
		],
		defaultScope: "DOMAIN",
		isEsa: !1
	}),
	getMockPolicy({
		key: "view_chinshaku_bukken",
		scopes: [
			"USER",
			"ORGANIZATION",
			"DOMAIN"
		],
		defaultScope: "DOMAIN",
		isEsa: !1
	}),
	getMockPolicy({
		key: "edit_chinshaku_bukken",
		scopes: [
			"USER",
			"ORGANIZATION",
			"DOMAIN"
		],
		defaultScope: "DOMAIN",
		isEsa: !1
	}),
	getMockPolicy({
		key: "publish_chinshaku_bukken",
		scopes: ["NONE", "ORGANIZATION"],
		defaultScope: "ORGANIZATION",
		isEsa: !1
	}),
	getMockPolicy({
		key: "view_baikyaku_bukken",
		scopes: [
			"USER",
			"ORGANIZATION",
			"DOMAIN"
		],
		defaultScope: "DOMAIN",
		isEsa: !1
	}),
	getMockPolicy({
		key: "edit_baikyaku_bukken",
		scopes: [
			"USER",
			"ORGANIZATION",
			"DOMAIN"
		],
		defaultScope: "DOMAIN",
		isEsa: !1
	}),
	getMockPolicy({
		key: "publish_baikyaku_bukken",
		scopes: ["NONE", "ORGANIZATION"],
		defaultScope: "ORGANIZATION",
		isEsa: !1
	})
], getMockProviderUser = () => Y.parse({
	providerUserUid: "pjYGu0rqTn",
	email: "example.test@e-seikatsu.co.jp",
	defaultUserUid: "7eq0cmFVw5F8mXxi",
	currentUserUid: "7eq0cmFVw5F8mXxi",
	isAgreeTerms: !1,
	ebone: null,
	users: getMockUsers(3),
	createdAt: parseISO("2022-04-18T09:49:36+09:00"),
	modifiedAt: parseISO("2022-04-18T09:49:36+09:00")
}), getMockMemberApplicant = (e) => ({
	memberApplicantUid: "xxx",
	comment: "コメント",
	requestedOrganizationName: "希望組織名",
	domainUid: "B834HVdEctliaT06",
	domainName: "（株）いい生活",
	providerUserUid: "zzz",
	userName: "いい所属リクエスト 次郎",
	email: "example.test.request@e-seikatsu.co.jp",
	createdAt: parseISO("2022-04-18T09:49:36+09:00"),
	modifiedAt: parseISO("2022-04-18T09:49:36+09:00"),
	...e
}), getMockTotpAuthenticator = () => ({
	type: "Totp",
	createdAt: parseISO("2022-04-18T09:49:36+09:00")
}), cu = {
	APPLICATION_ERROR: "esa-0001",
	CLIENT_ERROR: "esa-0002",
	NOT_FOUND_ERROR: "esa-0003",
	SERVER_ERROR: "esa-1001",
	NETWORK_ERROR: "esa-1002",
	AUTHORIZATION_ERROR: "esa-2001",
	INVALID_DATA_ERROR: "esa-3001"
}, ensureError = (e) => {
	if (e instanceof Error) return e;
	let t = "[Unable to stringify the thrown value]";
	try {
		t = String(e);
	} catch {}
	return /* @__PURE__ */ Error(`This value was thrown as is: ${t}`);
}, AppError = class extends Error {
	description;
	payload;
	cause;
	errorCode;
	constructor(e, t, n, r = cu.APPLICATION_ERROR) {
		super(), this.description = e, this.payload = t, this.cause = n, this.errorCode = r, this.name = new.target.name;
	}
	get message() {
		return `${this.description}\n${JSON.stringify(this.payload, null, 2)}`;
	}
}, Preparing = class extends AppError {
	payload;
	cause;
	constructor(e, t) {
		super("Preparing", e, t), this.payload = e, this.cause = t, this.name = new.target.name;
	}
}, InvalidOperation = class extends AppError {
	payload;
	cause;
	constructor(e, t) {
		super("InvalidOperation", e, t, cu.CLIENT_ERROR), this.payload = e, this.cause = t, this.name = new.target.name;
	}
}, UnreachableCodeError = class extends AppError {
	payload;
	cause;
	constructor(e, t) {
		super("UnreachableCode", e, t), this.payload = e, this.cause = t, this.name = new.target.name;
	}
}, NetworkError = class extends AppError {
	payload;
	cause;
	constructor(e, t) {
		super("NetworkError", e, t, cu.NETWORK_ERROR), this.payload = e, this.cause = t, this.name = new.target.name;
	}
}, AuthorizationError = class extends AppError {
	payload;
	cause;
	constructor(e, t) {
		super("AuthorizationError", e, t, cu.AUTHORIZATION_ERROR), this.payload = e, this.cause = t, this.name = new.target.name;
	}
};
//#endregion
//#region ../../../node_modules/.pnpm/date-fns-tz@3.2.0_date-fns@4.4.0/node_modules/date-fns-tz/dist/esm/_lib/tzIntlTimeZoneName/index.js
function tzIntlTimeZoneName(e, t, n) {
	let r = getDefaultOptions(), i = getDTF(e, n.timeZone, n.locale ?? r.locale);
	return "formatToParts" in i ? partsTimeZone(i, t) : hackyTimeZone(i, t);
}
function partsTimeZone(e, t) {
	let n = e.formatToParts(t);
	for (let e = n.length - 1; e >= 0; --e) if (n[e].type === "timeZoneName") return n[e].value;
}
function hackyTimeZone(e, t) {
	let n = e.format(t).replace(/\u200E/g, ""), r = / [\w-+ ]+$/.exec(n);
	return r ? r[0].substr(1) : "";
}
function getDTF(e, t, n) {
	return new Intl.DateTimeFormat(n ? [n.code, "en-US"] : void 0, {
		timeZone: t,
		timeZoneName: e
	});
}
//#endregion
//#region ../../../node_modules/.pnpm/date-fns-tz@3.2.0_date-fns@4.4.0/node_modules/date-fns-tz/dist/esm/_lib/tzTokenizeDate/index.js
function tzTokenizeDate(e, t) {
	let n = getDateTimeFormat(t);
	return "formatToParts" in n ? partsOffset(n, e) : hackyOffset(n, e);
}
var lu = {
	year: 0,
	month: 1,
	day: 2,
	hour: 3,
	minute: 4,
	second: 5
};
function partsOffset(e, t) {
	try {
		let n = e.formatToParts(t), r = [];
		for (let e = 0; e < n.length; e++) {
			let t = lu[n[e].type];
			t !== void 0 && (r[t] = parseInt(n[e].value, 10));
		}
		return r;
	} catch (e) {
		if (e instanceof RangeError) return [NaN];
		throw e;
	}
}
function hackyOffset(e, t) {
	let n = e.format(t), r = /(\d+)\/(\d+)\/(\d+),? (\d+):(\d+):(\d+)/.exec(n);
	return [
		parseInt(r[3], 10),
		parseInt(r[1], 10),
		parseInt(r[2], 10),
		parseInt(r[4], 10),
		parseInt(r[5], 10),
		parseInt(r[6], 10)
	];
}
var uu = {}, du = new Intl.DateTimeFormat("en-US", {
	hourCycle: "h23",
	timeZone: "America/New_York",
	year: "numeric",
	month: "2-digit",
	day: "2-digit",
	hour: "2-digit",
	minute: "2-digit",
	second: "2-digit"
}).format(/* @__PURE__ */ new Date("2014-06-25T04:00:00.123Z")), fu = du === "06/25/2014, 00:00:00" || du === "‎06‎/‎25‎/‎2014‎ ‎00‎:‎00‎:‎00";
function getDateTimeFormat(e) {
	return uu[e] || (uu[e] = fu ? new Intl.DateTimeFormat("en-US", {
		hourCycle: "h23",
		timeZone: e,
		year: "numeric",
		month: "numeric",
		day: "2-digit",
		hour: "2-digit",
		minute: "2-digit",
		second: "2-digit"
	}) : new Intl.DateTimeFormat("en-US", {
		hour12: !1,
		timeZone: e,
		year: "numeric",
		month: "numeric",
		day: "2-digit",
		hour: "2-digit",
		minute: "2-digit",
		second: "2-digit"
	})), uu[e];
}
//#endregion
//#region ../../../node_modules/.pnpm/date-fns-tz@3.2.0_date-fns@4.4.0/node_modules/date-fns-tz/dist/esm/_lib/newDateUTC/index.js
function newDateUTC(e, t, n, r, i, a, o) {
	let s = /* @__PURE__ */ new Date(0);
	return s.setUTCFullYear(e, t, n), s.setUTCHours(r, i, a, o), s;
}
//#endregion
//#region ../../../node_modules/.pnpm/date-fns-tz@3.2.0_date-fns@4.4.0/node_modules/date-fns-tz/dist/esm/_lib/tzParseTimezone/index.js
var pu = 36e5, mu = 6e4, hu = {
	timezone: /([Z+-].*)$/,
	timezoneZ: /^(Z)$/,
	timezoneHH: /^([+-]\d{2})$/,
	timezoneHHMM: /^([+-])(\d{2}):?(\d{2})$/
};
function tzParseTimezone(e, t, n) {
	if (!e) return 0;
	let r = hu.timezoneZ.exec(e);
	if (r) return 0;
	let i, a;
	if (r = hu.timezoneHH.exec(e), r) return i = parseInt(r[1], 10), validateTimezone(i) ? -(i * pu) : NaN;
	if (r = hu.timezoneHHMM.exec(e), r) {
		i = parseInt(r[2], 10);
		let e = parseInt(r[3], 10);
		return validateTimezone(i, e) ? (a = Math.abs(i) * pu + e * mu, r[1] === "+" ? -a : a) : NaN;
	}
	if (isValidTimezoneIANAString(e)) {
		t = new Date(t || Date.now());
		let r = calcOffset(n ? t : toUtcDate(t), e);
		return -(n ? r : fixOffset(t, r, e));
	}
	return NaN;
}
function toUtcDate(e) {
	return newDateUTC(e.getFullYear(), e.getMonth(), e.getDate(), e.getHours(), e.getMinutes(), e.getSeconds(), e.getMilliseconds());
}
function calcOffset(e, t) {
	let n = tzTokenizeDate(e, t), r = newDateUTC(n[0], n[1] - 1, n[2], n[3] % 24, n[4], n[5], 0).getTime(), i = e.getTime(), a = i % 1e3;
	return i -= a >= 0 ? a : 1e3 + a, r - i;
}
function fixOffset(e, t, n) {
	let r = e.getTime() - t, i = calcOffset(new Date(r), n);
	if (t === i) return t;
	r -= i - t;
	let a = calcOffset(new Date(r), n);
	return i === a ? i : Math.max(i, a);
}
function validateTimezone(e, t) {
	return -23 <= e && e <= 23 && (t == null || 0 <= t && t <= 59);
}
var gu = {};
function isValidTimezoneIANAString(e) {
	if (gu[e]) return !0;
	try {
		return new Intl.DateTimeFormat(void 0, { timeZone: e }), gu[e] = !0, !0;
	} catch {
		return !1;
	}
}
//#endregion
//#region ../../../node_modules/.pnpm/date-fns-tz@3.2.0_date-fns@4.4.0/node_modules/date-fns-tz/dist/esm/format/formatters/index.js
var _u = 6e4, vu = {
	X: function(e, t, n) {
		let r = getTimeZoneOffset(n.timeZone, e);
		if (r === 0) return "Z";
		switch (t) {
			case "X": return formatTimezoneWithOptionalMinutes(r);
			case "XXXX":
			case "XX": return formatTimezone(r);
			default: return formatTimezone(r, ":");
		}
	},
	x: function(e, t, n) {
		let r = getTimeZoneOffset(n.timeZone, e);
		switch (t) {
			case "x": return formatTimezoneWithOptionalMinutes(r);
			case "xxxx":
			case "xx": return formatTimezone(r);
			default: return formatTimezone(r, ":");
		}
	},
	O: function(e, t, n) {
		let r = getTimeZoneOffset(n.timeZone, e);
		switch (t) {
			case "O":
			case "OO":
			case "OOO": return "GMT" + formatTimezoneShort(r, ":");
			default: return "GMT" + formatTimezone(r, ":");
		}
	},
	z: function(e, t, n) {
		switch (t) {
			case "z":
			case "zz":
			case "zzz": return tzIntlTimeZoneName("short", e, n);
			default: return tzIntlTimeZoneName("long", e, n);
		}
	}
};
function getTimeZoneOffset(e, t) {
	let n = e ? tzParseTimezone(e, t, !0) / _u : t?.getTimezoneOffset() ?? 0;
	if (Number.isNaN(n)) throw RangeError("Invalid time zone specified: " + e);
	return n;
}
function addLeadingZeros(e, t) {
	let n = e < 0 ? "-" : "", r = Math.abs(e).toString();
	for (; r.length < t;) r = "0" + r;
	return n + r;
}
function formatTimezone(e, t = "") {
	let n = e > 0 ? "-" : "+", r = Math.abs(e), i = addLeadingZeros(Math.floor(r / 60), 2), a = addLeadingZeros(Math.floor(r % 60), 2);
	return n + i + t + a;
}
function formatTimezoneWithOptionalMinutes(e, t) {
	return e % 60 == 0 ? (e > 0 ? "-" : "+") + addLeadingZeros(Math.abs(e) / 60, 2) : formatTimezone(e, t);
}
function formatTimezoneShort(e, t = "") {
	let n = e > 0 ? "-" : "+", r = Math.abs(e), i = Math.floor(r / 60), a = r % 60;
	return a === 0 ? n + String(i) : n + String(i) + t + addLeadingZeros(a, 2);
}
//#endregion
//#region ../../../node_modules/.pnpm/date-fns-tz@3.2.0_date-fns@4.4.0/node_modules/date-fns-tz/dist/esm/_lib/getTimezoneOffsetInMilliseconds/index.js
function getTimezoneOffsetInMilliseconds(e) {
	let t = new Date(Date.UTC(e.getFullYear(), e.getMonth(), e.getDate(), e.getHours(), e.getMinutes(), e.getSeconds(), e.getMilliseconds()));
	return t.setUTCFullYear(e.getFullYear()), +e - t;
}
//#endregion
//#region ../../../node_modules/.pnpm/date-fns-tz@3.2.0_date-fns@4.4.0/node_modules/date-fns-tz/dist/esm/_lib/tzPattern/index.js
var yu = /(Z|[+-]\d{2}(?::?\d{2})?| UTC| [a-zA-Z]+\/[a-zA-Z_]+(?:\/[a-zA-Z_]+)?)$/, bu = 36e5, xu = 6e4, Su = 2, $ = {
	dateTimePattern: /^([0-9W+-]+)(T| )(.*)/,
	datePattern: /^([0-9W+-]+)(.*)/,
	plainTime: /:/,
	YY: /^(\d{2})$/,
	YYY: [
		/^([+-]\d{2})$/,
		/^([+-]\d{3})$/,
		/^([+-]\d{4})$/
	],
	YYYY: /^(\d{4})/,
	YYYYY: [
		/^([+-]\d{4})/,
		/^([+-]\d{5})/,
		/^([+-]\d{6})/
	],
	MM: /^-(\d{2})$/,
	DDD: /^-?(\d{3})$/,
	MMDD: /^-?(\d{2})-?(\d{2})$/,
	Www: /^-?W(\d{2})$/,
	WwwD: /^-?W(\d{2})-?(\d{1})$/,
	HH: /^(\d{2}([.,]\d*)?)$/,
	HHMM: /^(\d{2}):?(\d{2}([.,]\d*)?)$/,
	HHMMSS: /^(\d{2}):?(\d{2}):?(\d{2}([.,]\d*)?)$/,
	timeZone: yu
};
function toDate(e, t = {}) {
	if (arguments.length < 1) throw TypeError("1 argument required, but only " + arguments.length + " present");
	if (e === null) return /* @__PURE__ */ new Date(NaN);
	let n = t.additionalDigits == null ? Su : Number(t.additionalDigits);
	if (n !== 2 && n !== 1 && n !== 0) throw RangeError("additionalDigits must be 0, 1 or 2");
	if (e instanceof Date || typeof e == "object" && Object.prototype.toString.call(e) === "[object Date]") return new Date(e.getTime());
	if (typeof e == "number" || Object.prototype.toString.call(e) === "[object Number]") return new Date(e);
	if (Object.prototype.toString.call(e) !== "[object String]") return /* @__PURE__ */ new Date(NaN);
	let r = splitDateString(e), { year: i, restDateString: a } = parseYear(r.date, n), o = parseDate(a, i);
	if (o === null || isNaN(o.getTime())) return /* @__PURE__ */ new Date(NaN);
	if (o) {
		let e = o.getTime(), n = 0, i;
		if (r.time && (n = parseTime(r.time), n === null || isNaN(n))) return /* @__PURE__ */ new Date(NaN);
		if (r.timeZone || t.timeZone) {
			if (i = tzParseTimezone(r.timeZone || t.timeZone, new Date(e + n)), isNaN(i)) return /* @__PURE__ */ new Date(NaN);
		} else i = getTimezoneOffsetInMilliseconds(new Date(e + n)), i = getTimezoneOffsetInMilliseconds(new Date(e + n + i));
		return new Date(e + n + i);
	}
	return /* @__PURE__ */ new Date(NaN);
}
function splitDateString(e) {
	let t = {}, n = $.dateTimePattern.exec(e), r;
	if (n ? (t.date = n[1], r = n[3]) : (n = $.datePattern.exec(e), n ? (t.date = n[1], r = n[2]) : (t.date = null, r = e)), r) {
		let e = $.timeZone.exec(r);
		e ? (t.time = r.replace(e[1], ""), t.timeZone = e[1].trim()) : t.time = r;
	}
	return t;
}
function parseYear(e, t) {
	if (e) {
		let n = $.YYY[t], r = $.YYYYY[t], i = $.YYYY.exec(e) || r.exec(e);
		if (i) {
			let t = i[1];
			return {
				year: parseInt(t, 10),
				restDateString: e.slice(t.length)
			};
		}
		if (i = $.YY.exec(e) || n.exec(e), i) {
			let t = i[1];
			return {
				year: parseInt(t, 10) * 100,
				restDateString: e.slice(t.length)
			};
		}
	}
	return { year: null };
}
function parseDate(e, t) {
	if (t === null) return null;
	let n, r, i;
	if (!e || !e.length) return n = /* @__PURE__ */ new Date(0), n.setUTCFullYear(t), n;
	let a = $.MM.exec(e);
	if (a) return n = /* @__PURE__ */ new Date(0), r = parseInt(a[1], 10) - 1, validateDate(t, r) ? (n.setUTCFullYear(t, r), n) : /* @__PURE__ */ new Date(NaN);
	if (a = $.DDD.exec(e), a) {
		n = /* @__PURE__ */ new Date(0);
		let e = parseInt(a[1], 10);
		return validateDayOfYearDate(t, e) ? (n.setUTCFullYear(t, 0, e), n) : /* @__PURE__ */ new Date(NaN);
	}
	if (a = $.MMDD.exec(e), a) {
		n = /* @__PURE__ */ new Date(0), r = parseInt(a[1], 10) - 1;
		let e = parseInt(a[2], 10);
		return validateDate(t, r, e) ? (n.setUTCFullYear(t, r, e), n) : /* @__PURE__ */ new Date(NaN);
	}
	if (a = $.Www.exec(e), a) return i = parseInt(a[1], 10) - 1, validateWeekDate(i) ? dayOfISOWeekYear(t, i) : /* @__PURE__ */ new Date(NaN);
	if (a = $.WwwD.exec(e), a) {
		i = parseInt(a[1], 10) - 1;
		let e = parseInt(a[2], 10) - 1;
		return validateWeekDate(i, e) ? dayOfISOWeekYear(t, i, e) : /* @__PURE__ */ new Date(NaN);
	}
	return null;
}
function parseTime(e) {
	let t, n, r = $.HH.exec(e);
	if (r) return t = parseFloat(r[1].replace(",", ".")), validateTime(t) ? t % 24 * bu : NaN;
	if (r = $.HHMM.exec(e), r) return t = parseInt(r[1], 10), n = parseFloat(r[2].replace(",", ".")), validateTime(t, n) ? t % 24 * bu + n * xu : NaN;
	if (r = $.HHMMSS.exec(e), r) {
		t = parseInt(r[1], 10), n = parseInt(r[2], 10);
		let e = parseFloat(r[3].replace(",", "."));
		return validateTime(t, n, e) ? t % 24 * bu + n * xu + e * 1e3 : NaN;
	}
	return null;
}
function dayOfISOWeekYear(e, t, n) {
	t ||= 0, n ||= 0;
	let r = /* @__PURE__ */ new Date(0);
	r.setUTCFullYear(e, 0, 4);
	let i = r.getUTCDay() || 7, a = t * 7 + n + 1 - i;
	return r.setUTCDate(r.getUTCDate() + a), r;
}
var Cu = [
	31,
	28,
	31,
	30,
	31,
	30,
	31,
	31,
	30,
	31,
	30,
	31
], wu = [
	31,
	29,
	31,
	30,
	31,
	30,
	31,
	31,
	30,
	31,
	30,
	31
];
function isLeapYearIndex(e) {
	return e % 400 == 0 || e % 4 == 0 && e % 100 != 0;
}
function validateDate(e, t, n) {
	if (t < 0 || t > 11) return !1;
	if (n != null) {
		if (n < 1) return !1;
		let r = isLeapYearIndex(e);
		if (r && n > wu[t] || !r && n > Cu[t]) return !1;
	}
	return !0;
}
function validateDayOfYearDate(e, t) {
	if (t < 1) return !1;
	let n = isLeapYearIndex(e);
	return !(n && t > 366 || !n && t > 365);
}
function validateWeekDate(e, t) {
	return !(e < 0 || e > 52 || t != null && (t < 0 || t > 6));
}
function validateTime(e, t, n) {
	return !(e < 0 || e >= 25 || t != null && (t < 0 || t >= 60) || n != null && (n < 0 || n >= 60));
}
//#endregion
//#region ../../../node_modules/.pnpm/date-fns-tz@3.2.0_date-fns@4.4.0/node_modules/date-fns-tz/dist/esm/format/index.js
var Tu = /([xXOz]+)|''|'(''|[^'])+('|$)/g;
function format(e, t, n = {}) {
	t = String(t);
	let r = t.match(Tu);
	if (r) {
		let i = toDate(n.originalDate || e, n);
		t = r.reduce(function(e, t) {
			if (t[0] === "'") return e;
			let r = e.indexOf(t), a = e[r - 1] === "'", o = e.replace(t, "'" + vu[t[0]](i, t, n) + "'");
			return a ? o.substring(0, r - 1) + o.substring(r + 1) : o;
		}, t);
	}
	return format$1(e, t, n);
}
//#endregion
//#region ../../../node_modules/.pnpm/date-fns-tz@3.2.0_date-fns@4.4.0/node_modules/date-fns-tz/dist/esm/toZonedTime/index.js
function toZonedTime(e, t, n) {
	e = toDate(e, n);
	let r = tzParseTimezone(t, e, !0), i = new Date(e.getTime() - r), a = /* @__PURE__ */ new Date(0);
	return a.setFullYear(i.getUTCFullYear(), i.getUTCMonth(), i.getUTCDate()), a.setHours(i.getUTCHours(), i.getUTCMinutes(), i.getUTCSeconds(), i.getUTCMilliseconds()), a;
}
//#endregion
//#region lib/format/date.ts
var formatDate = (e, t = {}) => {
	let n = t.timeZone ?? "Asia/Tokyo", r = t.format ?? "yyyy/MM/dd HH:mm";
	return format(toZonedTime(e, n), r, { timeZone: n });
}, isNonBlankText = (e) => e != null && e.trim() !== "", orHyphen = (e) => e ?? "-", joinNonNull = (e) => {
	let t = e.filter((e) => e != null).join(" ");
	return t === "" ? "-" : t;
}, formatTakkenLicense = (e) => {
	if (e == null) return "-";
	let { licensor: t, updateCount: n, number: r } = e;
	return !isNonBlankText(t) || !isNonBlankText(n) || !isNonBlankText(r) ? "-" : `${t}（${n}）第${r}号`;
}, formatTraderTakkenLicense = (e) => formatTakkenLicense({
	licensor: e.licensorName,
	updateCount: e.licenseUpdateCount,
	number: e.licenseNumber
}), Eu = {
	ApplePay: "Apple Pay",
	BankTransfer: "口座振替",
	Cash: "現金",
	Check: "小切手",
	CreditCard: "クレジットカード",
	CreditCardReferenceTransaction: "クレジットカード（参照取引）",
	DebitCard: "デビットカード",
	GooglePay: "Google Pay",
	Other: "その他",
	WireTransfer: "銀行振込"
}, formatPaymentMethod = (e) => e == null ? "-" : Eu[e] ?? e, formatInvoiceDelivery = ({ email: e, print: t }) => {
	let n = [e === !0 ? "メール" : null, t === !0 ? "郵送" : null].filter((e) => e != null);
	return n.length === 0 ? "-" : n.join("・");
}, Du = "名称未登録の請求先", Ou = "名称未登録の店舗", formatBillingDestinationName = (e) => isNonBlankText(e) ? e : Du, formatOrganizationName = (e) => isNonBlankText(e) ? e : Ou, formatZipCode = (e) => {
	if (!isNonBlankText(e)) return null;
	let t = e.replace(/[^0-9]/g, "");
	return `〒${t.length === 7 ? `${t.slice(0, 3)}-${t.slice(3)}` : e}`;
};
//#endregion
export { nc as Address, rc as AddressListResponse, xc as ApiErrorCode, AppError, AuthorizationError, Yt as AutoApproval, Jt as AutoApprovalEmailDomains, br as BlockSourceStatus, ac as COLLABORATOR_ROLE_ADMIN, oc as COLLABORATOR_ROLE_MEMBER, Gt as Cidr, hc as CollaboratorInvitation, fc as CollaboratorInvitationCheck, uc as CollaboratorInvitationCheckStatus, lc as CollaboratorInvitationCheckTeam, cc as CollaboratorLoginContext, gc as CollaboratorTeamMember, sc as CollaboratorTeamMembership, Rn as CreateOrganization, ws as CreatePlan, qn as CreateRole, as as DeleteInvitationOperation, os as DeleteMemberApplicantOperation, rs as DeleteOrganization, ss as DeleteRoleOperation, is as DeleteUserOperation, $t as Denwa, En as DomainBase, mc as DomainInvitationCheck, en as DomainMfaState, xn as DomainTakkenLicense, an as DomainUsage, Wc as DomainVegaLicenses, cu as ERROR_CODE, rn as Ebone, vc as EboneMaintenance, _c as EboneSchedule, er as EboneUser, Ft as Email, Qn as EmailNotifyEnabled, Cr as EmailVerify, Uo as ErrorResponse, bc as EsaMaintenance, yc as EsaSchedule, el as FcLicense, on as GrantedFeatures, wc as INCIDENT_STATE_CODES, Cc as INCIDENT_STATUS_CODES, Sn as ImageFile, As as InitialData, Ds as InitialDomain, Os as InitialOrganization, ks as InitialUser, gs as Integration, InvalidOperation, ic as InvitationActivationResponse, pr as InvitationListResponse, wr as InvitationMailCreation, mr as InvitationTicket, hr as InvitingDomain, or as IpAddressList, Dt as Jusho, Sr as LoginContext, wn as LogoImage, Tc as MAINTENANCE_STATUS_CODES, gr as MemberApplicant, Zs as MemberApplicantApproved, Ws as MemberApplicantAutoApprovalCreateOrganization, Us as MemberApplicantAutoApprovalSelectOrganization, qs as MemberApplicantBase, $s as MemberApplicantCancellation, Xs as MemberApplicantCreated, Js as MemberApplicantCreation, Ks as MemberApplicantCreationData, Bs as MemberApplicantCreationDataTypeEnum, Qs as MemberApplicantCreationResponse, Ys as MemberApplicantCreationResponseTypeEnum, _r as MemberApplicantListResponse, Gs as MemberApplicantPhoneVerification, Hs as MemberApplicantRequest, ns as MergeDomainOperation, us as MoveInvitationOperation, ds as MoveMemberApplicantOperation, cs as MoveOrganizationOperation, fs as MoveRoleOperation, ls as MoveUserOperation, NetworkError, js as Office, ms as Operation, Ss as OperationCounts, ps as OperationData, Ko as OperationFailureState, Kc as OperationHistory, Xc as OperationHistoryFacets, qc as OperationHistoryOperation, Gc as OperationHistoryPage, Jc as OperationHistoryPerson, Zc as OperationHistorySettings, Yc as OperationHistoryUsage, $c as OperationHistoryWeek, Qc as OperationHistoryWeeks, Jo as OperationProgressState, qo as OperationStandbyState, Yo as OperationState, Wo as OperationStateTypeEnum, Go as OperationSuccessState, X as OperationTypeEnum, In as Organization, Fn as OrganizationListResponse, Rc as PASSKEY_AUTHENTICATION_TYPE, Eu as PAYMENT_METHOD_LABELS, B as ParsableDate, sn as PhoneVerification, zs as PhoneVerificationCode, ec as PhoneVerificationTicket, tc as PhoneVerificationTicketListResponse, bs as Plan, Es as PlanActivation, vs as PlanData, xs as PlanListResponse, Cs as PlanSummary, hs as PlanTypeEnum, Preparing, Y as ProviderUser, xr as ProviderUserBlockSources, yr as ProviderUserLockout, Ns as PublicAutoApproval, Ps as PublicDomain, ir as PublicName, Ms as PublicPhoneVerification, ll as ReadAdminCustomerProfile, sl as ReadAdminCustomerProfileBillingDestination, nl as ReadAdminCustomerProfileContact, rl as ReadAdminCustomerProfileInvoiceDelivery, cl as ReadAdminCustomerProfileOrganization, ol as ReadAdminCustomerProfileOtherCompanyBillingDestination, al as ReadAdminCustomerProfileOwnBillingDestination, tl as ReadAdminCustomerProfileTakkenLicense, Ic as ReadAuthenticationMethod, Pc as ReadAuthenticator, Xt as ReadAutoApproval, Sc as ReadCustomer, fl as ReadCustomerContract, pl as ReadCustomerContractOrganization, ul as ReadCustomerContractQuantity, dl as ReadCustomerContractUsageCharge, ml as ReadCustomerContracts, xl as ReadCustomerProfile, yl as ReadCustomerProfileBillingDestination, gl as ReadCustomerProfileInvoiceDelivery, bl as ReadCustomerProfileOrganization, vl as ReadCustomerProfileOtherCompanyBillingDestination, _l as ReadCustomerProfileOwnBillingDestination, hl as ReadCustomerProfileTakkenLicense, Qt as ReadDenwa, H as ReadDomain, tn as ReadDomainMfaState, Fc as ReadDomainUserAuthenticationMethods, dr as ReadInvitation, Ct as ReadJusho, Pn as ReadOrganization, zn as ReadPolicy, Lc as ReadProviderUserAuthenticationMethods, K as ReadRole, Ac as ReadStatusioStatus, Nc as ReadSubscription, jc as ReadSubscriptionItem, Mc as ReadSubscriptionPlan, pn as ReadTakkenLicense, yn as ReadTakkenLicenseWithChecks, bn as ReadTakkenLicenseWithLatestUpdateCount, Is as ReadTrader, q as ReadUser, ur as ReadUserMfaExemption, G as RolePolicy, Bn as RolePolicyMap, W as ScopeTypeEnum, Oc as StatusioIncidents, kc as StatusioMaintenances, Dc as StatusioStatus, Ec as StatusioStatusOverall, Ls as TakkenData, fn as TakkenLicense, hn as TakkenLicenseExistence, _n as TakkenLicenseExistenceCheck, Cn as TakkenLicenseImage, cn as TakkenLicenseNumber, ln as TakkenLicenseUpdateCount, gn as TakkenLicenseVerification, vn as TakkenLicenseVerificationCheck, dn as TakkenLicensor, mn as TakkenTrader, xt as TelNumber, Fs as Trader, UnreachableCodeError, Dn as UpdateDomain, nn as UpdateDomainMfaState, Xo as UpdateDomainOperation, fr as UpdateInvitation, es as UpdateInvitationOperation, Ln as UpdateOrganization, Qo as UpdateOrganizationOperation, Ts as UpdatePlan, vr as UpdateProviderUser, Jn as UpdateRole, ts as UpdateRoleOperation, Zo as UpdateTakkenLicenseOperation, lr as UpdateUser, $o as UpdateUserOperation, J as User, sr as UserBase, _s as UserBulkUpdate, cr as UserListResponse, nr as UserName, Uc as VegaLicense, St as YubinNumber, Ae as ZipCode, compareScope, convertDomainReadToUpdate, convertUserReadToUpdate, createErrorMessages, customErrorMap, Zt as denwaNumberShubetsu, ensureError, formatBillingDestinationName, formatDate, formatInvoiceDelivery, formatOrganizationName, formatPaymentMethod, formatTakkenLicense, formatTraderTakkenLicense, formatZipCode, getJushoFulltext, getMockAdminCustomerProfile, getMockCustomer, getMockCustomerContracts, getMockCustomerProfile, getMockDomain, getLoginContext as getMockLoginContext, getMockMemberApplicant, getMockOrganization, getMockOrganizations, getMockPlan, getMockPolicies, getMockPolicy, getMockProviderUser, getMockRole, getMockRoles, getMockTotpAuthenticator, getMockUser, getMockUsers, getMoveOrganizationOperation, getMoveUserOperation, getUpdateDomainOperation, getUpdateOrganizationOperation, getUpdateUserOperation, getUserRoleTitle, isCollaboratorTeamAdmin, isEsaFeatureGranted, isEsaPolicy, isIpRestricted, isLocalIp, isMfaExempted, isNonBlankText, joinNonNull, ar as maxIpAddressListLength, Mn as maxKameiDantaiNameLength, mergeCustomerContracts, orHyphen, Tr as primitive, un as takkenLicensorList, toCidr, toDenwa, toDeviceLabel, toEditableDenwaList, toJushoText, toPasskeys, Yn as userCountLowerLimit, Xn as userCountUpperLimit, Zn as userRoleTitles, ke as zipCodeLength };

//# sourceMappingURL=esa-core.mjs.map